//#region Imports
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
//MUI
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/Error";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import InfoIcon from "@mui/icons-material/Info";
import PrintIcon from "@mui/icons-material/Print";
import { Formik, Form, Field } from "formik";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  FormHelperText,
  Modal,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { FileUploadOutlined as FileUploadIcon } from "@mui/icons-material";
import Backdrop from "@mui/material/Backdrop";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import ProcessingSummaryTableForCoa from "../../../components/processingSummaryTable/processingSummaryTableForCoa";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useCallback } from "react";
import mepcologo from "../../../images/mepcoLogo.png";
import pdfIcon from "../../../images/pdfIcon.png";
import MEPCOWaterMark from "../../../images/DiscosWater/mepcco-watermark.png";
import LESCOWaterMark from "../../../images/DiscosWater/lescowatermark.png";
import IESCOWaterMark from "../../../images/DiscosWater/iescowatermark.png";
import FESCOWaterMark from "../../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../../images/DiscosWater/hesco-watermark.png";
import TESCOWaterMark from "../../../images/DiscosWater/tesco-watermark.png";
import SEPCOWaterMark from "../../../images/DiscosWater/sepco-watermark.png";
import PESCOWaterMark from "../../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../../images/DiscosWater/qesco-watermark.png";
import IESCODDLOGO from "../../../images/discologos/iesco logo.png";
import FESCODDLOGO from "../../../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../../../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../../../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../../../images/discologos/hesco logo.png";
import LESCODDLOGO from "../../../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../../../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../../../images/discologos/pesco1.jpg";
import PITCDDLOGO from "../../../images/discologos/pitc11-removebg-preview.png";
import QESCODDLOGO from "../../../images/discologos/qesco.png";
import SEPCODDLOGO from "../../../images/discologos/sepco.jpg";
import TESCODDLOGO from "../../../images/discologos/tesco.jpg";
//components
// import StatusBar from '../../../components/statusbar/statusbar';
import Base64Image from "../../../components/Base64Image/Base64Image";
import ProcessingSummaryTable from "../../../components/processingSummaryTable/processingSummaryTable";
import tickicon from "../../../images/Accept.png";
import pencilIcon from "../../../images/pencil.png";
import crossIcon from "../../../images/remove.png";
import InfoImage from "../../../images/informationButton.png";
import {
  applicationName,
  companyName,
  companyShortName,
  convertDate,
  convertDateDDMMYY,
  convertDatewithTime,
  convertDatewithTimeWithoutSecond,
  dBillAPI,
  divisionName,
  documentValidation,
  downloadBill,
  filterOptions as filterOptionsCityDistrict,
  getPhase,
  handleFileUpload,
  isImage,
  isOneYearOld,
  isPdf,
  numberFormatting,
  printStamp,
  sodowo,
  subdivisionName,
  paymentDetails,
  discMeterDetails,
  rcoMeterProfile,
  numberFormattingForRCO,
} from "../../../services/Functions";
//scss
import "../../../style/common.scss";
//Yup
import * as Yup from "yup";
//formik
import { useFormik } from "formik";
//urls
import { cfpBaseUrl } from "../../../network/urls";
// use scan detection
import useScanDetection from "use-scan-detection";
// authorization
import CheckPermissions from "../../../authorization/authorization";
// Services
import { openBase64Image } from "../../../services/OpenBase64Image";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import StepProgressBar from "../../../components/StepProgressBar/StepProgressBar";
import OpenBase64ImageInPopup from "../../../services/OpenBase64ImageInPopup";
import { tableStyle, tableStyleOverDue } from "../../../style/common";
//pdfjs
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import autoTable from "jspdf-autotable";
import { useDispatch, useSelector } from "react-redux";
import ActionsCell from "../../../components/actionCell/ActionCell";
import ServiceDashboardTables from "../../../components/ServiceDashboardTables/ServiceDashboardTables";
import Error from "../../../components/error/error";
import { signOut } from "../../../features/authentication/authenticationSlice";
import { resetState as resetStateDueDate } from "../../../features/billingAndCollection/dueDateExtensionNormalSlice";
import { resetState as resetStateInstallmentsNormal } from "../../../features/billingAndCollection/installmentsNormalSlice";
import { resetState as resetStateInstallmentsOverdue } from "../../../features/billingAndCollection/installmentsOverdueSlice";
import { resetOverallPerformanceState } from "../../../features/dashboard/overallPerformance";
import { resetState as resetStateColNormal } from "../../../features/generalServices/colNormalSlice";
import { resetState as resetStateColOverdue } from "../../../features/generalServices/colOverdueSlice";
import { resetState as resetStateConNormal } from "../../../features/generalServices/coaNormalSlice";
import { resetState as resetStateConOverdue } from "../../../features/generalServices/coaOverdueSlice";
import { resetState as resetStateCotNormal } from "../../../features/generalServices/cotNormalSlice";
import { resetState as resetStateCotOverdue } from "../../../features/generalServices/cotOverdueSlice";
import {
  fetchPaginatedReconnectionNormal,
  filterDateFrom as filterDateFromNormal,
  filterDateTo as filterDateToNormal,
  filterObjectionStatus as filterObjectionStatusNormal,
  filterProgressId as filterProgressIdNormal,
  firstPage as firstPageNormal,
  lastPage as lastPageNormal,
  nextPage as nextPageNormal,
  previousPage as prePageNormal,
  resetDateFilter as resetDateFilterNormal,
  resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
  resetProgressIdFilter as resetProgressIdFilterNormal,
  resetState as resetStateRcNormal,
} from "../../../features/generalServices/rcNormalSlice";
import {
  fetchPaginatedReconnectionOverdue,
  filterDateFrom as filterDateFromOverdue,
  filterDateTo as filterDateToOverdue,
  filterObjectionStatus as filterObjectionStatusOverdue,
  filterProgressId as filterProgressIdOverdue,
  firstPage as firstPageOverdue,
  lastPage as lastPageOverdue,
  nextPage as nextPageOverdue,
  previousPage as prePageOverdue,
  resetDateFilter as resetDateFilterOverdue,
  resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
  resetProgressIdFilter as resetProgressIdFilterOverdue,
  resetState as resetStateRcOverdue,
} from "../../../features/generalServices/rcOverdueSlice";
import { resetFeederStatusState } from "../../../features/geoJson/feedersStatus";
import { resetGeoJsonState } from "../../../features/geoJson/geoJson";
import { removeStats } from "../../../features/stats/statsSlice";
import useFetchData from "../../../hooks/fetchData";
import { SearchIndividualApplication } from "../../../network/APIs/APIs";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import batchIcon from "../../../images/batchWarning.png";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import {
  getFieldStaffDesignations,
  getWorkforceData,
} from "../../../network/APIs/APIs";
import { Token } from "@mui/icons-material";
//#endregion

const Reconnectiontable = forwardRef((props, ref) => {
  //#region paginatedlogic
  const dispatch = useDispatch();
  const {
    currentPage: currentPageNormal,
    data: dataNormal,
    pageSize: pageSizeNormal,
    totalPages: totalPagesNormal,
    totalRecords: totalRecordsNormal,
    dateFrom: dateFromNormal,
    dateTo: dateToNormal,
    loadFrom: loadFromNormal,
    loadTo: loadToNormal,
    applicationProgressId: applicationProgressIdNormal,
    objectionStatus: objectionStatusNormal,
    error: rcNormalError,
    isLoading: isLoad,
  } = useSelector((state) => state.rcNormalPaginated);
  const {
    currentPage: currentPageOverdue,
    data: dataOverdue,
    pageSize: pageSizeOverdue,
    totalPages: totalPagesOverdue,
    totalRecords: totalRecordsOverdue,
    dateFrom: dateFromOverdue,
    dateTo: dateToOverdue,
    loadFrom: loadFromOverdue,
    loadTo: loadToOverdue,
    applicationProgressId: applicationProgressIdOverdue,
    objectionStatus: objectionStatusOverdue,
    error: rcOverdueError,
    isLoading: isLoadd,
  } = useSelector((state) => state.rcOverduePaginated);
  const {
    token,
    userId,
    hierarchy,
    roleId,
    roleName,
    permissions,
    roleTypeId,
    code,
    companyCode
  } = useSelector((state) => state.auth);
  let userCompany = code.slice(0, 2);
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };

  const myHeaders = new Headers();
  myHeaders.append("Authorization", token);

  const RequestOptions = (method, myHeaders) => {
    return {
      method: method,
      headers: myHeaders,
      redirect: "follow",
    };
  };

  let requestOptions = RequestOptions("GET", myHeaders);
  const {
    data: cities,
    loading: citiesLoading,
    error: citiesError,
  } = useFetchData(
    cfpBaseUrl + "electricityNewConnection/citiesList",
    requestOptions,
  );

  // useEffect(() => {
  //   if ((rcNormalError && rcNormalError === "Failed to fetch") || (rcOverdueError && rcOverdueError === "Failed to fetch")) {
  //     alert("Network issue! NCAPIE")
  //     dispatch(resetStateRcNormal());
  //     dispatch(resetStateRcOverdue());
  //     dispatch(resetStateConNormal());
  //     dispatch(resetStateConOverdue());
  //     dispatch(resetStateColNormal());
  //     dispatch(resetStateColOverdue());
  //     dispatch(resetStateCotNormal());
  //     dispatch(resetStateCotOverdue());
  //     dispatch(resetStateDueDate());
  //     dispatch(resetStateInstallmentsNormal())
  //     dispatch(resetStateInstallmentsOverdue())
  //     dispatch(removeStats());
  //     dispatch(resetOverallPerformanceState());
  //     dispatch(resetFeederStatusState());
  //     dispatch(resetGeoJsonState());
  //     dispatch(signOut())
  //   }
  // }, [rcNormalError, rcOverdueError])

  const handleNextPageNormal = () => {
    setViewBackdrop(true);
    dispatch(nextPageNormal());
  };

  const handleDateFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromNormal(value));
    }
  };

  const handleDateToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToNormal(value));
    }
  };

  const handleResetDateFilterNormal = () => {
    dispatch(resetDateFilterNormal());
  };

  const handleProgressIdFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterProgressIdNormal(value));
    }
  };

  const handleResetProgressIdFilterNormal = () => {
    dispatch(resetProgressIdFilterNormal());
  };

  const handleObjectionStatusFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusNormal(value));
    }
  };

  const handleResetObjectionStatusFilterNormal = () => {
    dispatch(resetObjectionStatusFilterNormal());
  };

  const handlePreviousPageNormal = () => {
    setViewBackdrop(true);
    dispatch(prePageNormal());
  };

  const handleFirstPageNormal = () => {
    dispatch(firstPageNormal());
  };

  const handleLastPageNormal = () => {
    dispatch(lastPageNormal(totalPagesNormal)); // Replace '2' with actual value
  };
  function getTariffsForValue(value, tariffs) {
    return tariffs.filter((tariff) => {
      const from = parseInt(tariff.from, 10);
      const to = parseInt(tariff.to, 10);
      return value >= from && value <= to;
    });
  }

  // useEffect(() => {
  //    if (props.showTable && currentPath == "/reconnection-table") {
  //   setViewBackdrop(true);

  //     dispatch(
  //       fetchPaginatedReconnectionNormal({
  //         page: currentPageNormal,
  //         pageSize: pageSizeNormal,
  //         dateFrom: dateFromNormal,
  //         dateTo: dateToNormal,
  //         loadFrom: loadFromNormal,
  //         loadTo: loadToNormal,
  //         applicationProgressId: applicationProgressIdNormal,
  //         objectionStatus: objectionStatusNormal,
  //       })
  //     );
  //   }
  // }, []);

  //   useEffect(() => {
  //    if (props.showTable && currentPath == "/reconnection-table") {
  //   setViewBackdrop(true);

  //     dispatch(
  //       fetchPaginatedReconnectionOverdue({
  //         page: currentPageOverdue,
  //         pageSize: pageSizeOverdue,
  //         dateFrom: dateFromOverdue,
  //         dateTo: dateToOverdue,
  //         loadFrom: loadFromOverdue,
  //         loadTo: loadToOverdue,
  //         applicationProgressId: applicationProgressIdOverdue,
  //         objectionStatus: objectionStatusOverdue,
  //       })
  //     );
  //   }
  // }, []);

  useEffect(() => {
    if (dataNormal) {
      setReconnectionApplications(dataNormal);
      setViewBackdrop(false);
    }
  }, [dataNormal]);

  const handleNextPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(nextPageOverdue());
  };

  const downloadRCOSCOStylePDF = async (application, rcoDets) => {
    try {
      const applicationId = application.applicationId;
      const DiscoCode = application.companyCode.toString();
      const pageWidth = 210;
      const pageHeight = 297;
      const doc = new jsPDF({ compressPdf: true });
      const padding = 10;
      let height = 10;

      // Add logo
      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      // Add barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
      doc.addImage(barcodeDataURL, "PNG", pageWidth - 50, 5, 40, 20);

      height = 25;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(16);
      doc.text("RCO Details Report", pageWidth / 2, height, { align: "center" });

      height += 10;
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      const row = (label, value) => {
        doc.text(label + ":", padding, height);
        doc.text(String(value ?? "-"), padding + 70, height);
        height += 6;
      };

      const conditionalRow = (label, value) => {
        const hasValue =
          value !== undefined &&
          value !== null &&
          String(value).trim() !== "" &&
          String(value).trim() !== "-" &&
          String(value).trim() !== "---";

        if (hasValue) {
          row(label, value);
        }
      };

      // Display RCO details
      conditionalRow("RCO ID", rcoDets.rcoId);
      conditionalRow("Application ID", rcoDets.applicationId);
      conditionalRow("Sanction Load", rcoDets.sanctionLoad ? `${rcoDets.sanctionLoad} kW` : "");
      conditionalRow("Installed Transformer Capacity", rcoDets.installedTransformerCapacity);
      conditionalRow("Meter ID", rcoDets.meterId);
      conditionalRow("Meter No", rcoDets.meterNo);
      conditionalRow("Meter Reading", rcoDets.meterReading);
      conditionalRow("Location Code", rcoDets.locationCode);
      conditionalRow("Meter Code 1", rcoDets.meterCode1);
      conditionalRow("Meter Code 2", rcoDets.meterCode2);
      conditionalRow("Manufacturer Code", rcoDets.manufacturerCode);
      conditionalRow("Multiplying Factor", rcoDets.multiplyingFactor);
      conditionalRow("Meter Range", rcoDets.meterRange);
      conditionalRow("Date of Reconnection", rcoDets.dateOfReConnection ? convertDate(rcoDets.dateOfReConnection) : "");
      conditionalRow("SIM ID", rcoDets.simId);
      conditionalRow("SIM Number", rcoDets.simNumber);
      conditionalRow("Transformer Ref No", rcoDets.transformerRefNo);

      height += 8;

      const officeCode = application.subDivisionCode
        ? application.subDivisionCode.toString()
        : "-";
      const officeName = application.subDivisionCode
        ? subdivisionName(parseInt(application.subDivisionCode), subDivisions)
        : "-";
      const rcoP2ApprovedBy = rcoDets.rcoP2ApprovedBy
        ? rcoDets.rcoP2ApprovedBy
        : "---";
      const rcoP2ApprovedByDesignation = rcoDets.rcoP2ApprovedByDesignation
        ? rcoDets.rcoP2ApprovedByDesignation
        : "Role";
      const rcoP2ApprovalDate = rcoDets.rcoP2ApprovalDate
        ? convertDate(rcoDets.rcoP2ApprovalDate)
        : "---";
      const stampData = printStamp(
        officeCode,
        officeName,
        rcoP2ApprovedBy,
        rcoP2ApprovedByDesignation,
        rcoP2ApprovalDate,
      );

      if (rcoDets.rcoP2ApprovedBy) {
        doc.addImage(stampData, "PNG", 145, 70, 55, 40);
      }

      // Add meter image
      if (rcoDets.installedMeterImage && height < 250) {
        doc.setFont("helvetica", "bold");
        doc.text("Installed Meter Image", padding, height);
        height += 8;

        try {
          const imageData = rcoDets.installedMeterImage;
          let imageFormat = "JPEG";
          if (imageData.includes("data:image/png")) imageFormat = "PNG";

          doc.addImage(imageData, imageFormat, padding + 5, height, 180, 60);
          height += 65;
        } catch (imgErr) {
          console.error("Error  adding meter image:", imgErr);
        }
      }

      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(getWaterMarkLogo(DiscoCode), "PNG", 0, 0, pageWidth, pageHeight);
        doc.setFontSize(8);
        doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, { align: "center" });
      }

      const pdfBlob = doc.output("blob");
      const fileName = `${applicationId}-CP138.pdf`;
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL + '#' + fileName, fileName);
    } catch (err) {
      console.error("Error in downloadRCOSCOStylePDF:", err);
    }
  };

  const handleDateFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromOverdue(value));
    }
  };

  const handleDateToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToOverdue(value));
    }
  };
  const handleResetDateFilterOverdue = () => {
    dispatch(resetDateFilterOverdue());
  };
  const handleProgressIdFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterProgressIdOverdue(value));
    }
  };

  const handleResetProgressIdFilterOverdue = () => {
    dispatch(resetProgressIdFilterOverdue());
  };

  const handleObjectionStatusFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusOverdue(value));
    }
  };

  const handleResetObjectionStatusFilterOverdue = () => {
    dispatch(resetObjectionStatusFilterOverdue());
  };

  const handlePreviousPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(prePageOverdue());
  };

  const handleFirstPageOverdue = () => {
    dispatch(firstPageOverdue());
  };

  const handleLastPageOverdue = () => {
    dispatch(lastPageOverdue(totalPagesOverdue)); // Replace '2' with actual value
  };

  useEffect(() => {
    if (dataOverdue) {
      setReconnectionApplicationsOverDue(dataOverdue);
      setViewBackdrop(false);
    }
  }, [dataOverdue]);

  const referenceApi = async (dialogRowData) => {
    try {
      setViewBackdrop(true);

      const customerId = dialogRowData?.customerId;
      if (!customerId) return;

      const setPaymentInfo = (status, amount = "", month = "") => {
        setPaymentStatus(status);
        setArrearAmount(amount);
        setBillMonth(month);
      };

      const companyCode = customerId.slice(1, 3);
      const apiResponse = await paymentDetails(
        customerId,
        companyCode,
        token,
        code,
      );
      const row = Array.isArray(apiResponse?.rows) ? apiResponse.rows[0] : null;

      if (apiResponse?.status === "400") {
        setPaymentInfo("No arrear exists");
        return;
      }

      if (apiResponse?.status === "200" && row) {
        setPaymentInfo(
          "Arrear exists",
          row?.TOTAL_PAYMENT || "",
          row?.BILL_MONTH || "",
        );
        return;
      }

      setPaymentInfo("No arrear exists");
    } catch (error) {
      console.log("ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Error fetching billing details:", error);
    } finally {
      setViewBackdrop(false);
    }
  };

  const formatAmountOrNA = (value) => {
    if (value === null || value === undefined || value === "") return "N/A";
    return numberFormatting(Math.round(Number(value) || 0));
  };

  const formatNegativeAmountOrNA = (value) => {
    if (value === null || value === undefined || value === "") return "N/A";
    return `-${numberFormatting(Math.round(Math.abs(Number(value) || 0)))}`;
  };

  //#endregion

  //#region initial values
  const initialValues = {
    iv_objection_Type: "No Issue",
    iv_objection_Descripton: "",

    //arrears fields
    iv_property_reference_no: "",

    //arears paid bill document field
    iv_arear_paid_bill_document: "",
    iv_arear_paid_bill_date: "",

    //applied load fields
    iv_applied_load: "",

    iv_generate_demand_notice: 0,
    iv_dn_for: 0,
    iv_no_of_default_meters: 1,

    //dn fields
    iv_distance: 1,
    iv_estimated_distance: 41,
    iv_sketch_diagram: "",
    iv_coverage_area: "3",
    iv_default_meters_ref_no_array: "",
    iv_tariff_to_allot: "",
    iv_surveyed_by: "",
    iv_survey_date: "",
    iv_batch: "",
    iv_reference_to_allot: "",
    iv_industry_factory_type: "",
    iv_bank_name: "",
    iv_connection_account_no: "",
    iv_grid_sharing_cost: 0,
    iv_feeder_rehab_charges: 0,
    iv_civil_work_charges: 0,
    iv_fixed_charges_of_metering: 0,
    iv_miscellaneous_charges: 0,
    iv_less_the_cost: 0,

    // boq fields
    iv_fieldItemId: "",
    iv_fieldItemQty: "",
    iv_fieldItemRate: "",
    iv_fieldItemUnit: "",
    iv_fieldItemAmount: "",
    iv_items_array: "",

    // payment verification fields
    iv_payment_date: "",
    iv_receipt_image: "",
    iv_is_rco_fee_voucher_paid: "",
    iv_is_bill_paid: "",
    iv_bill_payment_date: "",

    // rco fee payment verification fields
    iv_rco_fee_payment_date: "",
    iv_rco_fee_receipt_image: "",

    iv_dn_receipt_image: "",
    iv_dn_fee_payment_date: null,

    //rco fields
    iv_fata_pata: "",
    iv_rural_urban: "U",
    iv_feeder_no: "",
    iv_sub_batch: "",
    iv_fgovt: "",
    iv_cantonment_board: "",
    iv_pgovt: "",
    iv_govt_dept_code: "",
    iv_local_bodies: "",
    iv_authorized_by_name: "",
    iv_date_of_authorization: "",
    iv_store_requisition_no: "",
    iv_store_requisition_date: "",
    iv_sanctioned_load: "",
    iv_seasonal_flag: 1,
    iv_no_of_acs: 0,
    iv_no_of_meters: 0,
    iv_no_of_meter_sets: 0,
    iv_no_of_sub_sets: 0,
    iv_no_ofsupply_points: 0,
    iv_transformer_code: "",
    iv_meter_id: "",
    iv_meter_serial_no: "",
    iv_location_code: "P",
    iv_meter_code1: "",
    iv_meter_code2: "",
    iv_manufacturer_code: "",
    iv_multiplying_factor: 1,
    iv_meter_range: 4,
    iv_meter_reading: "",
    iv_date_of_connection: "",
    iv_cp_78_item_no: "",
    iv_tie_up_non_tie_up: 1,
    iv_seal_on_meter: "",
    iv_seal_on_box: "",
    iv_security_slip_or_price_bond_no: "",
    iv_connection_installer_name: "",
    iv_meter_type: 0,
    iv_meter_reading_off_peak_kwh: "",
    iv_meter_reading_peak_kwh: "",
    iv_meter_reading_off_peak_kvarh: "",
    iv_meter_reading_peak_kvarh: "",
    iv_ct: "",
    iv_ct_nom: "1",
    iv_ct_denom: "1",
    iv_pt: "",
    iv_pt_nom: "1",
    iv_pt_denom: "1",
    iv_mf: "",
    iv_mdi: "",
    iv_no_of_mdi_resets: "",

    // master data fields
    iv_govt_dept: 0,
    iv_ed_code: "",
    iv_standard_classification_code: "",
    iv_income_tax: 0,

    //basic info update fields
    iv_applicant_name: "",
    iv_applicant_cnic: "",
    iv_applicant_phone: "",
    iv_applicant_email: "",
    iv_address: "",
    iv_relative_name: "",
    iv_owner_name: "",
    iv_owner_cnic: "",
    iv_owner_phone: "",
    iv_owner_email: "",
    iv_city_district: "",
    iv_meter_installed: 0,
    iv_town_tehsil: "",
    iv_chak_street: "",
    // Urban
    iv_house: "",
    iv_street: "",
    iv_sector_block_phase_mohala: "",
    // Rural
    iv_chak_street: "",
    iv_village: "",

    iv_refer_to_subdivision: 0,
    iv_exempt_rco_fee: 0,
    iv_tariff_desc: "",
    installedMeterRefNos: [],

    iv_store_requisition_no: "",
    iv_store_requisition_date: "",
    iv_sanctioned_load: "",
    iv_seasonal_flag: 0,
    iv_meter_range: 4,
    iv_meter_code1: "",
    iv_meter_code2: "",
    iv_transformer_code: "",
    iv_transformer_refNo: "",
    iv_location_code: "P",
    iv_manufacturer_code: "",
    iv_meter_serial_no: "",
    iv_sim_number: "",
    iv_sim_ID: "",
    iv_meter_reading: "",
    iv_meter_reading_off_peak_kwh: "",
    iv_meter_reading_peak_kwh: "",
    iv_meter_reading_off_peak_kvarh: "",
    iv_meter_reading_peak_kvarh: "",
    iv_date_of_connection: "",
    iv_connection_installer_name: "",
    iv_installed_meter_image: "",
    iv_meter_typee: 1,
    iv_ct_nom: "1",
    iv_ct_denom: "1",
    iv_pt_nom: "1",
    iv_pt_denom: "1",
    iv_mdi: "",
    iv_no_of_mdi_resets: "",
  };

  //#endregion

  //#region get item local storage
  const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));
  //#endregion

  //#region states
  const [allTariffList, setAllTariffList] = useState();
  const [allFeedersList, setAllFeedersList] = useState([]);
  const [allMaterialList, setAllMaterialList] = useState([]);
  const [standardClassificationCodes, setStandardClassificationCodes] =
    useState([]);
  const [sketchDiagram, setSketchDiagram] = useState();
  const [sketchDiagramThumbnail, setSketchDiagramThumbnail] = useState("");
  const [sketchDiagramError, setSketchDiagramError] = useState();
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [alreadyInstalledRefNos, setAlreadyInstalledRefNos] = useState([]);
  const [alreadyInstalledRefNosErrors, setAlreadyInstalledRefNosErrors] =
    useState([]);
  const [scoDetails, setScoDetails] = useState({
    scoId: "",
    applicationId: "",
    scoCreationDate: "",
    urbanRural: "",
    fataPata: "",
    refNo: "",
    feederNo: "",
    batch: "",
    subBatch: "",
    fGovt: "",
    cantonmentBoard: "",
    pGovt: "",
    localBodies: "",
    scoP1FilledBy: "",
    scoP1FillingDate: "",
    scoP1FillFlag: "",
    authorizedByName: "",
    dateOfAuthorization: "",
    scoP1ApprovedFlag: "",
    storeRequisitionNo: "",
    storeRequisitionDate: "",
    seasonalFlag: "",
    senctionLoad: "",
    noOfACs: "",
    noOfMeters: "",
    noOfMeterSets: "",
    noOfSubSets: "",
    noOfSupplyPoints: "",
    installedTransformerCapacity: "",
    meterId: "",
    meterNo: "",
    locationCode: "",
    meterCode: "",
    manufacturerCode: "",
    multiplyingFactor: "",
    meterRange: "",
    meterReading: "",
    dateOfConnection: "",
    cp78ItemNo: "",
    tieUpNonTieUp: "",
    sealOnMeter: "",
    sealOnBox: "",
    securitySlipOrPriceBondNo: "",
    connectionInstallerName: "",
    scoP2FilledBy: "",
    scoP2FillingDate: "",
    scoP2FillFlag: "",
    scoP2ApprovedBy: "",
    scoP2ApprovalDate: "",
    scoP2ApprovalFlag: "",
    installedMeterImage: "",
    meterType: null,
    threePhasePeak: null,
    threePhaseOffPeak: null,
    mdi: null,
    noOfMDIreset: null,
    cT: "",
    pT: "",
    threePhasePeakKVARH: "",
    threePhaseOffPeakKVARH: "",
    threePhasePeakKWH: "",
    threePhaseOffPeakKWH: "",
  });
  const [meterTypeValueForCheck, setMeterTypeValueForCheck] = useState("0");
  const [dnRejectModalOpen, setDnRejectModalOpen] = useState(false);
  const [arrearFlag, setArrearFlag] = useState(0);
  const [arrearsDetailsRefno, setArrearsDetailsRefno] = useState({
    arrearsAmount: "",
    meterStatus: "",
    tariffDesc: "",
    meterType: "",
    phase: "",
    consumerName: "",
    consumerNo: "",
    consumerAddress: "",
    consumerEmail: "",
  });
  const companies = [
    { code: "11", name: "LESCO", logo: LESCODDLOGO },
    { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
    { code: "13", name: "FESCO", logo: FESCODDLOGO },
    { code: "14", name: "IESCO", logo: IESCODDLOGO },
    { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
    { code: "26", name: "PESCO", logo: PESCODDLOGO },
    { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
    { code: "37", name: "HESCO", logo: HESCODDLOGO },
    { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
    { code: "48", name: "QESCO", logo: QESCODDLOGO },
    { code: "59", name: "TESCO", logo: TESCODDLOGO },
  ];

  // Selected officeCode state
  const [selectedOfficeCode, setSelectedOfficeCode] = useState("15");
  const [paidRCOFeeVoucherImg, setPaidRCOFeeVoucherImg] = useState(null);
  const [paidDNVoucherImg, setPaidDNVoucherImg] = useState(null);
  const [installedMeterImg, setInstalledMeterImg] = useState(null);
  const [batchError, setBatchError] = useState("");
  const [wrongBatchPopup, setWrongBatchPopup] = useState(false);
  const [phase, setPhase] = useState();
  const [tariff, setTariff] = useState();
  const [refNoAlreadyAllocatedError, setRefNoAlreadyAllocatedError] =
    useState("");
  const [viewDropBackForEfile, setViewDropBackForEfile] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState(inputValue);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseMessageError, setResponseMessageError] = useState("");
  const [showCP138ButtonInResponseModal, setShowCP138ButtonInResponseModal] =
    useState(false);
  const [responseType, setResponseType] = useState("");
  const [errormessageBoqEstimation, setErrormessageBoqEstimation] =
    useState("");
  const [arrearAmount, setArrearAmount] = useState("");
  const [billMonth, setBillMonth] = useState("");
  const [frontImg, setFrontImg] = useState(null);
  const [backImg, setBackImg] = useState(null);
  const [popUpfrontImg, setPopUpfrontImg] = useState(null);
  const [popUpBackImg, setPopUpBackImg] = useState(null);
  const [paidArrearImg, setPaidArrearImg] = useState(null);
  const [paidRCOFeeImg, setPaidRCOFeeImg] = useState(null);
  const [dnPaymentImg, setDnPaymentImg] = useState(null);
  const [reInstalledMeterImg, setReInstalledMeterImg] = useState(null);
  const [arrearPaidReceiptImageThumbnail, setArrearPaidReceiptImageThumbnail] =
    useState();
  const [installedMeterImgThumbnail, setInstalledMeterImgThumbnail] =
    useState();
  const [selectedStaffId, setSelectedStaffId] = useState("");
  const manufacturesList = [
    { code: 1, name: "General Electric" },
    { code: 10, name: "Climax" },
    { code: 11, name: "Ercorts" },
    { code: 12, name: "Schlumburger France" },
    { code: 13, name: "CHINA" },
    { code: 14, name: "TIP" },
    { code: 15, name: "RUSSIAN" },
    { code: 16, name: "BULGARIA" },
    { code: 17, name: "BRAZIL" },
    { code: 18, name: "GANZ" },
    { code: 19, name: "BELGIUM" },
    { code: 2, name: "Westinghouse" },
    { code: 20, name: "SWITZERLAND" },
    { code: 21, name: "KRIZIK" },
    { code: 22, name: "HITACHI" },
    { code: 23, name: "ISKARA" },
    { code: 24, name: "ELGMA(TOU)" },
    { code: 25, name: "USA(TOD)" },
    { code: 26, name: "SABEECO" },
    { code: 27, name: "MICRO TECH" },
    { code: 28, name: "ETHOPIA" },
    { code: 29, name: "LETHIANIA" },
    { code: 3, name: "Landis & Gyr" },
    { code: 30, name: "M.T.I Micro Tech" },
    { code: 31, name: "SBEEC" },
    { code: 32, name: "Hexing(China)" },
    { code: 33, name: "Creative Electronics" },
    { code: 34, name: "Elektromed" },
    { code: 35, name: "J n P" },
    { code: 36, name: "TRANSFAB" },
    { code: 37, name: "HAMEED" },
    { code: 38, name: "ELEMATIC" },
    { code: 39, name: "TRANSPAK" },
    { code: 4, name: "Aeg" },
    { code: 40, name: "NECOPE" },
    { code: 41, name: "TRANSFOPOWER" },
    { code: 42, name: "IRAN" },
    { code: 43, name: "ACE INDIGO" },
    { code: 44, name: "PAN POWER" },
    { code: 45, name: "AB AMPERRE" },
    { code: 46, name: "POWER TECH" },
    { code: 47, name: "J.F.INDUSTRIES" },
    { code: 48, name: "KBK" },
    { code: 49, name: "M / S HAMMAD" },
    { code: 5, name: "Siemens" },
    { code: 50, name: "M / S NATIONAL" },
    { code: 51, name: "M / S IMS" },
    { code: 52, name: "ACCURATE COMPANY" },
    { code: 53, name: "VERTEX STATIC" },
    { code: 54, name: "ELSTER" },
    { code: 55, name: "RECLAIMED" },
    { code: 56, name: "KAIFA" },
    { code: 57, name: "XJ" },
    { code: 58, name: "CHINT" },
    { code: 59, name: "PEL" },
    { code: 6, name: "GEC" },
    { code: 7, name: "Ferranti" },
    { code: 8, name: "Mitsubishi" },
    { code: 9, name: "Syed Bhais" },
  ];
  // Debounce the input value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInputValue(inputValue);
    }, 300); // Adjust the debounce delay as needed

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (batchError) {
      setWrongBatchPopup(true);
    } else {
      setWrongBatchPopup(false);
    }
  }, [batchError]);

  useEffect(() => {
    if (props.showTable && currentPath == "/reconnection-table") {
      if (token) {
        setViewBackdrop(true);

        dispatch(
          fetchPaginatedReconnectionNormal({
            page: currentPageNormal,
            pageSize: pageSizeNormal,
            dateFrom: dateFromNormal,
            dateTo: dateToNormal,
            loadFrom: loadFromNormal,
            loadTo: loadToNormal,
            applicationProgressId: applicationProgressIdNormal,
            objectionStatus: objectionStatusNormal,
            officeCode: selectedOfficeCode || code,
          }),
        );
      }
    }
  }, [
    currentPageNormal,
    pageSizeNormal,
    dateFromNormal,
    dateToNormal,
    loadFromNormal,
    loadToNormal,
    applicationProgressIdNormal,
    objectionStatusNormal,
    selectedOfficeCode,
  ]);

  useEffect(() => {
    if (props.showTable && currentPath == "/reconnection-table") {
      if (token) {
        dispatch(
          fetchPaginatedReconnectionOverdue({
            page: currentPageOverdue,
            pageSize: pageSizeOverdue,
            dateFrom: dateFromOverdue,
            dateTo: dateToOverdue,
            loadFrom: loadFromOverdue,
            loadTo: loadToOverdue,
            applicationProgressId: applicationProgressIdOverdue,
            objectionStatus: objectionStatusOverdue,
            officeCode: selectedOfficeCode || code,
          }),
        );
      }
    }
  }, [
    currentPageOverdue,
    pageSizeOverdue,
    dateFromOverdue,
    dateToOverdue,
    loadFromOverdue,
    loadToOverdue,
    applicationProgressIdOverdue,
    objectionStatusOverdue,
    selectedOfficeCode,
  ]);

  const [arrearsDetailsRefnoToDisplay, setArrearsDetailsRefnoToDisplay] =
    useState({
      refNo: "",
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
      paidArearImage: "",
      paidArearDate: "",
    });

  const [isDemandNoteExpired, setIsDemandNoteExpired] = useState(null);
  const [isRcoFeeVoucherExpired, setIsRcoFeeVoucherExpired] = useState(null);
  const [installRefNo, setInstallRefNo] = useState([]);
  const [estimateDistance, setEstimateDistance] = useState("");
  const [meterAlreadyInstalled, setMeterAlreadyInstalled] = useState("");
  const [showBoq, setShowBoq] = React.useState(false);
  const [dnDetails, setDnDetails] = useState({
    demandNoticeNo: "",
    demandNoteExpiryCount: null,
    issueDate: "",
    applicationId: "",
    dueDate: "",
    roOfficeAddress: "",
    consumerAccountNo: "",
    batchNo: "",
    voltage: "",
    tariff: "",
    coverageAreaOfPremises: "",
    bankName: "",
    industryFactoryType: "",
    sketchImage: "",
    isDistance40: "",
    connectionAccountNo: "",
    dnPaymentFlag: "",
    paymentMethod: "",
    dnPaymentVerificationFlag: "",
    // meterRent: "",
    // serviceRent: "",
    sanctionLoad: "",
    surveyedBy: "",
    surveyedDate: "",
    filledBy: "",
    filledDate: "",
    filledFlag: null,
    approvedBy: "",
    approvedDate: "",
    approvedFlag: null,
    paymentDate: "",
    capitalCostAmount: "",
    securityDepositeAmount: "",
  });

  const [rcoFeeVoucherDetails, setRcoFeeVoucherDetails] = useState({
    applicationId: "",
    issueDate: null,
    dueDate: null,
    fixedChargesAmount: null,
    rcoFeeAmount: null,
  });
  const [disconnectedMeterDetails, setDisconnectedMeterDetails] = useState([]);
  const [
    disconnectedMeterDetsForROApproval,
    setDisconnectedMeterDetsForROApproval,
  ] = useState({});
  const [
    disconnectedMeterDetsImgForROApproval,
    setDisconnectedMeterDetsImgForROApproval,
  ] = useState();

  const [rcoDetails, setRcoDetails] = useState({
    rcoId: "",
    applicationId: "",
    rcoCreationDate: "",
    urbanRural: "",
    fataPata: "",
    refNo: "",
    feederNo: "",
    batch: "",
    subBatch: "",
    fGovt: "",
    cantonmentBoard: "",
    pGovt: "",
    localBodies: "",
    rcoP1FilledBy: "",
    rcoP1FillingDate: "",
    rcoP1FillFlag: "",
    authorizedByName: "",
    dateOfAuthorization: "",
    rcoP1ApprovedFlag: "",
    storeRequisitionNo: "",
    storeRequisitionDate: "",
    seasonalFlag: "",
    sanctionedLoad: "",
    noOfACs: "",
    noOfMeters: "",
    noOfMeterSets: "",
    noOfSubSets: "",
    noOfSupplyPoints: "",
    installedTransformerCapacity: "",
    meterId: "",
    meterNo: "",
    locationCode: "",
    meterCode: "",
    manufacturerCode: "",
    multiplyingFactor: "",
    meterRange: "",
    meterReading: "",
    dateOfReConnection: "",
    cp78ItemNo: "",
    tieUpNonTieUp: "",
    sealOnMeter: "",
    sealOnBox: "",
    securitySlipOrPriceBondNo: "",
    connectionInstallerName: "",
    rcoP2FilledBy: "",
    rcoP2FillingDate: "",
    rcoP2FillFlag: "",
    rcoP2ApprovedBy: "",
    rcoP2ApprovalDate: "",
    rcoP2ApprovalFlag: "",
    installedMeterImage: "",
    meterType: null,
    threePhasePeak: null,
    threePhaseOffPeak: null,
    mdi: null,
    noOfMDIreset: null,
    cT: "",
    pT: "",
    threePhasePeakKVARH: "",
    threePhaseOffPeakKVARH: "",
    threePhasePeakKWH: "",
    threePhaseOffPeakKWH: "",
  });

  const [masterDataFormDetails, setMasterDataFormDetails] = useState({
    applicationId: "",
    electricityDuty: "",
    governmentDepartment: "",
    standardClassificationCode: "",
    incomeTax: "",
    reason: "",
    authority: "",
    filledBy: "",
    filledByDate: "",
    filledByFlag: "",
    approvedBy: "",
    approvalDate: "",
    approvalFlag: "",
  });
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [voucherActionType, setVoucherActionType] = useState("");
  const [voucherActionTypeForDN, setVoucherActionTypeForDN] = useState(""); // approve | reject
  const [openVoucherActionModal, setOpenVoucherActionModal] = useState(false);
  const [openVoucherActionModalForDN, setOpenVoucherActionModalForDN] =
    useState(false);
  const [partialValue, setPartialValue] = useState("");
  const noArrears = "Bill status has been updated as paid in IBS.";
  const [flag_applicantCNICFront, setFlag_applicantCNICFront] = useState(null);
  const [flag_applicantCNICBack, setFlag_applicantCNICBack] = useState(null);
  const [flag_paidBillImage, setFlag_paidBillImage] = useState(null);
  const [errormessageCostEstimation, setErrormessageCostEstimation] =
    useState("");
  const [paidBillImageObjectionRemarks, setPaidBillImageObjectionRemarks] =
    useState("");
  const [
    applicantCNICFrontObjectionRemarks,
    setApplicantCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    applicantCNICBackObjectionRemarks,
    setApplicantCNICBackObjectionRemarks,
  ] = useState("");
  const [meterTypeValue, setMeterTypeValue] = useState("");
  const [areaTypeValue, setAreaType] = useState("");
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [urbanRuralValue, setUrbanRural] = useState("");
  const [distance, setDistance] = useState("1");
  const [reconnectionApplications, setReconnectionApplications] = useState([]);
  const [showCostEstimation, setShowCostEstimation] = React.useState(false);
  const [isReferedToFeildSurvey, setIsReferedToFeildSurvey] = useState(false);
  const [
    reconnectionApplicationsToDataGrid,
    setReconnectionApplicationsToDataGrid,
  ] = useState([]);
  const [reconnectionApplicationsOverDue, setReconnectionApplicationsOverDue] =
    useState([]);
  const [
    reconnectionApplicationsOverDueToDataGrid,
    setReconnectionApplicationsOverDueToDataGrid,
  ] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
  const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] =
    React.useState(false);

  const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] =
    useState(false);
  const [paidBillImagePopUp, setPaidBillImagePopUp] = useState(false);
  const [installedMeterImageVerifyPopUp, setInstalledMeterImageVerifyPopUp] =
    useState(false);
  const [workForceData, setWorkForceData] = useState([]);
  const [fieldStaffDesignations, setFieldStaffDesignations] = useState([]);
  const [paidDNImagePopUp, setPaidDNImagePopUp] = useState(false);

  const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
  const [dnPaymentRejectAlert, setDnPaymentRejectAlert] = React.useState(false);
  const [rcoPart1ApproveAlert, setRcoPart1ApproveAlert] = React.useState(false);
  const [rcoPart2ApproveAlert, setRcoPart2ApproveAlert] = React.useState(false);
  const [rejectionRemovalAlert, setRejectionRemovalAlert] =
    React.useState(false);
  const [fieldRejectionRemovalAlert, setFieldRejectionRemovalAlert] =
    React.useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [itemsArray, setItemsArray] = useState([]);
  const [dnReceiptImage, setDnReceiptImage] = useState();
  const [dnReceiptImageThumbnail, setDnReceiptImageThumbnail] = useState();
  const [dnReceiptImageError, setDnReceiptImageError] = useState();
  const [dnApproveStep, setDnApproveStep] = useState([]);
  const [dnDets, setDnDets] = useState([]);
  const [dnImage, setDnImage] = useState();
  const [rcoFeeReceiptImage, setRcoFeeReceiptImage] = useState();
  const [rcoFeeReceiptImageError, setRcoFeeReceiptImageError] = useState();
  const [rcoFeeReceiptImageThumbnail, setRcoFeeReceiptImageThumbnail] =
    useState();
  const [paidBillImage, setPaidBillImage] = useState();
  const [paidBillImageError, setPaidBillImageError] = useState();
  const [paidBillImageThumbnail, setPaidBillImageThumbnail] = useState();
  const [dnNumber, setDnNumber] = useState();
  const [dnPaymentDate, setDnPaymentDate] = useState();
  const [bankName, setBankName] = useState();
  const [itemsAmount, setItemsAmount] = useState(null);
  const [storeCharges, setStoreCharges] = useState(null);
  const [installationCharges, setInstallationCharges] = useState(null);
  const [gridSharingCost, setGridSharingCost] = useState(0);
  const [feederRehabilitationCharges, setFeederRehabilitationCharges] =
    useState(0);
  const [civilWorkCharges, setCivilWorkCharges] = useState(0);
  const [fixedChargesOfMetering, setFixedChargesOfMetering] = useState(0);
  const [miscellaneousCharges, setMiscellaneousCharges] = useState(0);
  const [lessTheCost, setLessTheCost] = useState(0);
  const [totalCharges, setTotalCharges] = useState(0);
  const [grandTotalCharges, setGrandTotalCharges] = useState(0);
  const [standardClassificationCode, setStandardClassificationCode] = useState({
    XCLFM_CODE: "",
    XCLFM_DESC: "",
  });
  const [govtDeptCode, setGovtDeptCode] = useState({
    departmentCode: "",
    departmentName: "",
  });
  const [boqItems, setBoqItems] = useState([]);
  const [govtDeptCodes, setGovtDeptCodes] = useState([]);
  const [manufacturerCode, setManufcaturerCode] = useState({
    code: null,
    name: "",
  });
  const [eFileData, setEFileData] = useState([]);
  const [sketchDiagramUploaded, setSketchDiagramUploaded] = useState();
  const { state } = useLocation();
  const { foundId } = state ? state : "";
  const [foundInNc, setFoundInNc] = useState();
  const [gridFlag, setGridFlag] = useState(false);
  const [feederRehabFlag, setFeederRehabFlag] = useState(false);
  const [industryFlag, setIndustryFlag] = useState(true);
  const [arearPaidBillDocument, setArearPaidBillDocument] = useState("");
  const [arearPaidBillDocumentThumbnail, setArearPaidBillDocumentThumbnail] =
    useState("");
  const [arearPaidBillDocumentError, setArearPaidBillDocumentError] =
    useState("");
  const [installedMeterImage, setInstalledMeterImage] = useState("");
  const [installedMeterImageError, setInstalledMeterImageError] = useState("");
  const [installedMeterImageThumbnail, setInstalledMeterImageThumbnail] =
    useState("");
  const [meterInstallmentError, setMeterInstallmentError] = useState("");
  const [historyData, setHistoryData] = useState(null);
  const [openImgDialog, setOpenImgDialog] = React.useState(false);
  const [openImgDialogDN, setOpenImgDialogDN] = React.useState(false);
  const [ripeAge, setRipeAge] = useState(0);
  const [unripeAge, setUnripeAge] = useState(0);
  const [error, setError] = useState("");
  const [fieldSurveyError, setFieldSurveyError] = useState("");
  const [linemanAllocationSubPopUp, setLinemanAllocationSubPopUp] =
    useState(false);
  const [showUpdateBatchPopup, setShowUpdateBatchPopup] = useState(false);
  const [newConnectionPopup, setNewConnectionPopup] = useState(false);
  const [rcoPopUp, setRcoPopUp] = useState(false);
  const [cpPopUp, setCpPopUp] = useState(false);
  const [costEstimationForNC, setCostEstimationForNC] = React.useState({});
  const [shortListIndustrialTariff, setShortListIndustrialTariff] = useState(
    [],
  );
  const govtDeptCodesFromlocalStorage = JSON.parse(
    localStorage.getItem("govtDeptCodes"),
  );
  const getClassificationCodesFromlocalStorage = JSON.parse(
    localStorage.getItem("govtClassFeCodes"),
  );
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const tableColumnsProcessingSummary = [
    {
      header: "Step Name",
      accessorKey: "stepName",
    },
    {
      header: "Processed By",
      accessorKey: "processedBy",
    },
    {
      header: "Date",
      accessorKey: "date",
    },
    {
      header: "Remarks",
      accessorKey: "remarks",
    },
  ];

  const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState(
    [],
  );

  // Sub Popup states
  const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] =
    useState(false);
  const [applicationSubittedPopUp, setApplicationSubmittedPopUp] =
    useState(false);
  const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
  const [rcoFeeVoucherApprovalSubPopUp, setRcoFeeVoucherApprovalSubPopUp] =
    useState(false);
  const [rcoFeeVoucherSubmissionSubPopUp, setRcoFeeVoucherSubmissionSubPopUp] =
    useState(false);
  const [
    rcoFeeVoucherVerificationSubPopUp,
    setRcoFeeVoucherVerificationSubPopUp,
  ] = useState(false);
  const [meterInstalationSubPopUp, setMeterInstalationSubPopUp] =
    useState(false);
  const [dnApprovalSubPopUp, setDnApprovalSubPopUp] = useState(false);
  const [dnSubmissionSubPopUp, setDnSubmissionSubPopUp] = useState(false);

  const [fieldSurveySubPopUp, setFieldSurveySubPopUp] = useState(false);
  const [forwardToROSubPopUp, setForwardToROSubPopUp] = useState(false);
  const [readyForBillingSubPopUp, setreadyForBillingSubPopUp] = useState(false);
  const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
  const [referenceNoAllocatedSubPopUp, setReferenceNoAllocatedSubPopUp] =
    useState(false);
  const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] =
    useState(false);
  const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] =
    useState(false);
  const [
    serviceConnectionOrderedSubPopUp,
    setServiceConnectionOrderedSubPopUp,
  ] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);

  const [fieldSurveyData, setFieldSurveyData] = useState({
    status: "",
    applicationId: "",
    isLTLWI40Flag: null,
    estDistanceInMeter: null,
    sketchDiagram: "",
    areaMarla: "",
    noOfMeterInstalled: null,
    surveyedBy: "",
    surveyDate: "",
    installedMeterRefNos: [
      {
        installedMeterRefNo: "",
      },
    ],
  });

  const [paidDnImageDetails, setPaidDnImageDetails] = useState({
    id: null,
    applicationId: "",
    demandNoticeNo: "",
    paidDNImage: "",
    uploadedBy: "",
    uploadedAt: "",
    paymentDate: "",
    painDNImageVerification: null,
  });

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDnExpiryPopup, setShowDnExpiryPopup] = useState(false);
  const [showRcoExpiryPopup, setShowRcoExpiryPopup] = useState(false);

  //#endregion

  //#region constants / variables
  const navigate = useNavigate();

  const fieldObjections = [
    "No Issue",
    "Unelectrified area / No network.",
    "Premises / Property is disputed or sub-judice.",
    "Load at site exceeds than applied.",
    "Connection type at site is changed.",
    "Transformer overloaded",
    "Site is shifted.",
    "Arrears exist against other connected meter.",
  ];

  const areaMarla = ["3", "5", "7", "10", "20"];

  let batchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];

  let batchArrayGeneral = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ];

  let batchArrayGeneralString =
    "01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23";

  let batchArrayIndustrial = [
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];

  let batchArrayIndustrialString = "24, 25, 27, 28, 29, 30, 31, 32, 33";

  let subBatchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
  ];

  const tenantStatus = ["tenant", "Tenant"];

  let RCOStatusBarArrayWithArrearsVerificationAndReferedToFieldVerification = [
    {
      title1: "DOCUMENT",
      title2: "SUBMISSION",
    },
    {
      title1: "DOCUMENT",
      title2: "VERIFICATION",
    },

    {
      title1: "RCO FEE",
      title2: "APPROVAL",
    },
    {
      title1: "RCO FEE",
      title2: "SUBMISSION",
    },
    {
      title1: "RCO FEE",
      title2: "VERIFICATION",
    },
    {
      title1: "FIELD SURVEY",
      title2: "& COST EST.",
    },
    {
      title1: "DN",
      title2: "APPROVAL",
    },
    {
      title1: "DN",
      title2: "SUBMISSION",
    },
    {
      title1: "DN PAYMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "METER",
      title2: "INSTALLATION",
    },

    {
      title1: "FORWARD",
      title2: "TO RO",
    },
    {
      title1: "READY FOR",
      title2: "BILLING",
    },
  ];

  const [rcoStatusBarArray, setRcoStatusBarArray] = useState(
    RCOStatusBarArrayWithArrearsVerificationAndReferedToFieldVerification,
  );

  const tblColumns = [
    {
      field: "applicationId",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Application No.",
      align: "center",
      headerStyle: { ...tableStyle.headerStyle, width: "3000px" },
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "creationDate",
      type: "date",
      sortable: false,
      filterable: true,
      headerName: "Date",
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "sanctionedLoad",
      headerName: "Load (kW)",
      sortable: false,
      filterable: false,
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "tariff",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Tariff",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "applicationProgressId",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "RCO Fee Approval",
        "RCO Fee Submission",
        "RCO Fee Verification",
        "Field Survey",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Meter Installation",
        "Forward To RO",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: {
        ...tableStyle.rowCellStyle,
        fontSize: "15px",
        overflow: "visible",
      },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <ActionsCell data={params} serviceKind="reconnection" />;
      },
    },
  ];

  const tblColumnsOverDue = [
    {
      field: "applicationId",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Application No.",
      align: "center",
      headerStyle: { ...tableStyleOverDue.headerStyle, width: "3000px" },
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, marginLeft: "5px" },
    },
    {
      field: "creationDate",
      type: "date",
      headerName: "Date",
      sortable: false,
      filterable: true,
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      disableColumnMenu: true,
      sortable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "sanctionedLoad",
      headerName: "Load (kW)",
      sortable: false,
      filterable: false,
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "tariff",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Tariff",
      align: "left",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "applicationProgressId",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "RCO Fee Approval",
        "RCO Fee Submission",
        "RCO Fee Verification",
        "Field Survey",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Meter Installation",
        "Forward To RO",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "exceededDuration",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Days",
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        color: "red",
        minWidth: "20px",
      },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        fontSize: "15px",
        overflow: "visible",
      },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <ActionsCell data={params} serviceKind="reconnection" theme="overdue" />;
      },
    },
  ];

  const pdfjsLib = window.pdfjsLib;
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

  const pdfToImage = async (base64) => {
    const pdfData = atob(base64.replace("data:application/pdf;base64,", ""));
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({ canvasContext: context, viewport }).promise;
    return canvas.toDataURL("image/png");
  };

  useEffect(() => {
    if (
      dialogRowData?.applicationProgressId === 2 &&
      dialogRowData?.objectionStatus === 1
    ) {
      referenceApi(dialogRowData);
    }
  }, [dialogRowData?.applicationProgressId, dialogRowData?.objectionStatus]);

  useEffect(() => {
    const convert = async () => {
      if (
        dialogRowData.applicantCNICFront?.startsWith("data:application/pdf")
      ) {
        const img = await pdfToImage(dialogRowData.applicantCNICFront);
        setFrontImg(img);
      } else {
        setFrontImg(dialogRowData.applicantCNICFront);
      }

      if (dialogRowData.applicantCNICBack?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(dialogRowData.applicantCNICBack);
        setBackImg(img);
      } else {
        setBackImg(dialogRowData.applicantCNICBack);
      }
    };

    convert();
  }, [dialogRowData.applicantCNICFront, dialogRowData.applicantCNICBack]);

  useEffect(() => {
    const convert = async () => {
      if (
        rcoFeeVoucherDetails.rcoFeePaidImage?.startsWith("data:application/pdf")
      ) {
        const img = await pdfToImage(rcoFeeVoucherDetails.rcoFeePaidImage);
        setPaidRCOFeeVoucherImg(img);
      } else {
        setPaidRCOFeeVoucherImg(rcoFeeVoucherDetails.rcoFeePaidImage);
      }
    };

    convert();
  }, [rcoFeeVoucherDetails.rcoFeePaidImage]);

  useEffect(() => {
    const convert = async () => {
      if (dnApproveStep.paidDNImage?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(dnApproveStep.paidDNImage);
        setPaidDNVoucherImg(img);
      } else {
        setPaidDNVoucherImg(dnApproveStep.paidDNImage);
      }
    };

    convert();
  }, [dnApproveStep.paidDNImage]);

  useEffect(() => {
    const convert = async () => {
      if (
        disconnectedMeterDetsImgForROApproval?.startsWith(
          "data:application/pdf",
        )
      ) {
        const img = await pdfToImage(disconnectedMeterDetsImgForROApproval);
        setInstalledMeterImg(img);
      } else {
        setInstalledMeterImg(disconnectedMeterDetsImgForROApproval);
      }
    };

    convert();
  }, [disconnectedMeterDetsImgForROApproval]);

  useEffect(() => {
    if (!historyData?.paidBillImage) {
      setPaidArrearImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.paidBillImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPaidArrearImg(img);
        } else {
          // Image base64 (jpg/png)
          setPaidArrearImg(file);
        }
      } catch (error) {
        console.error("Error converting paid bill:", error);
        setPaidArrearImg(null);
      }
    };

    convert();
  }, [historyData?.paidBillImage]);

  useEffect(() => {
    if (!historyData?.rcoFeePaidImage) {
      setPaidRCOFeeImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.rcoFeePaidImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPaidRCOFeeImg(img);
        } else {
          // Image base64 (jpg/png)
          setPaidRCOFeeImg(file);
        }
      } catch (error) {
        console.error("Error converting paid bill:", error);
        setPaidRCOFeeImg(null);
      }
    };

    convert();
  }, [historyData?.rcoFeePaidImage]);

  useEffect(() => {
    if (!historyData?.reinstalledMeterImage) {
      setReInstalledMeterImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.reinstalledMeterImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setReInstalledMeterImg(img);
        } else {
          // Image base64 (jpg/png)
          setReInstalledMeterImg(file);
        }
      } catch (error) {
        console.error("Error converting paid bill:", error);
        setReInstalledMeterImg(null);
      }
    };

    convert();
  }, [historyData?.reinstalledMeterImage]);

  useEffect(() => {
    if (!historyData?.applicantCNICFront) {
      setPopUpfrontImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.applicantCNICFront;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPopUpfrontImg(img);
        } else {
          // Image base64 (jpg/png)
          setPopUpfrontImg(file);
        }
      } catch (error) {
        console.error("Error converting paid bill:", error);
        setPopUpfrontImg(null);
      }
    };

    convert();
  }, [historyData?.applicantCNICFront]);

  useEffect(() => {
    if (!historyData?.applicantCNICBack) {
      setPopUpBackImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.applicantCNICBack;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPopUpBackImg(img);
        } else {
          // Image base64 (jpg/png)
          setPopUpBackImg(file);
        }
      } catch (error) {
        console.error("Error converting paid bill:", error);
        setPopUpBackImg(null);
      }
    };

    convert();
  }, [historyData?.applicantCNICBack]);

  useEffect(() => {
    if (!historyData?.pdnPaidDNImage) {
      setDnPaymentImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.pdnPaidDNImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setDnPaymentImg(img);
        } else {
          // Image base64 (jpg/png)
          setDnPaymentImg(file);
        }
      } catch (error) {
        console.error("Error converting paid bill:", error);
        setDnPaymentImg(null);
      }
    };

    convert();
  }, [historyData?.pdnPaidDNImage]);
  //#endregion

  //#region api function

  const callTariffList = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: myHeaders,
    };

    await fetch(
      cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        setAllTariffList(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  const callFeederList = async (feederCode, regCode, gridCode, sDivCode) => {
    var formdata = new FormData();

    formdata.append("feederCode", feederCode);
    formdata.append("rgnCode", regCode);
    formdata.append("gridCode", gridCode);
    formdata.append("sDivCode", sDivCode);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "demandNotice/getFeeders", requestOptions)
      .then((response) => response.json())
      .then((result) => setAllFeedersList(result.data))
      .catch((error) => console.log("error", error));
  };

  const callArrearsVerification = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      let progId = null;
      let objStat = null;
      let remrks = "";

      // if (arrearFlag == 1) {
      //   progId = dialogRowData.applicationProgressId
      //   objStat = 1
      //   remrks = 'Bill status is unpaid in IBS.'
      // } else {
      progId = dialogRowData.applicationProgressId + 1;
      objStat = 0;
      remrks = "Bill status is paid in IBS.";
      // }

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: progId,
        objectionStatus: objStat,
        lastModifiedBy: userId,
        remarks: remrks,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/verifyRCOArrears", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          handleClose();
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log(e);
    }
  };
  const CABLE_ALLOWED_CODES = ["14241", "14252", "14253"];

  const getMaterialItemCode = (item) =>
    String(item?.item_Code ?? item?.Item_Code ?? "").trim();

  const resolveCableOptionCode = (item) => {
    const code = getMaterialItemCode(item);
    if (!code) return "";

    return (
      CABLE_ALLOWED_CODES.find(
        (allowed) => code === allowed || code.endsWith(allowed),
      ) || ""
    );
  };

  const getCableMaterialOptions = (materials = []) =>
    (materials || [])
      .map((item) => ({
        item,
        cableCode: resolveCableOptionCode(item),
      }))
      .filter(({ cableCode }) => cableCode);

  const callMaterials = async (applicationId) => {
    if (!applicationId) {
      return [];
    }

    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        // subDivisionCode: dialogRowData.applicationId.slice(3, 8)
        // subDivisionCode: '15175'
        subDivisionCode: applicationId.slice(3, 8),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        // cfpBaseUrl + "enc/getMaterialDetails",
        "https://eopsapi.pitc.com.pk/enc/getMaterialDetails",
        requestOptions,
      );
      const result = await response.json();
      const materials = Array.isArray(result?.data) ? result.data : [];
      setAllMaterialList(materials);

      return materials;
    } catch (e) {
      console.log("Error in callMaterials:", e);
      return [];
    }
  };

  const callingUpdateDocumentStatusAPI = async () => {
    setViewBackdrop(true);

    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      let progId = null;
      let objStat = null;
      let remrks = "";
      let remarksDetail = "";

      if (flag_applicantCNICFront === -1 || flag_applicantCNICBack === -1) {
        progId = 1;
        objStat = 1;
        remrks = "Documents Rejected.";
        remarksDetail = `Documents Objection in : ${
          flag_applicantCNICFront === -1 ? "CNIC Front, " : ""
        }${flag_applicantCNICBack === -1 ? "CNIC Back" : ""}`;
      } else if (
        flag_applicantCNICFront === 1 &&
        flag_applicantCNICBack === 1
      ) {
        progId = 2;
        objStat = 0;
        remrks = "Documents Verified.";
        remarksDetail = "CNIC Front Verified. CNIC Back Verified.";
      }

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: progId,
        objectionStatus: objStat,
        remarks: remrks,
        remarksDetail: remarksDetail,
        applicantCNICFrontFlag: flag_applicantCNICFront,
        applicantCNICBackFlag: flag_applicantCNICBack,
        paidBillImageFlag: "",
        applicantCNICFrontRemarks: applicantCNICFrontObjectionRemarks,
        applicantCNICBackRemarks: applicantCNICBackObjectionRemarks,
        paidBillImageRemarks: "",
      });

      const response = await fetch(cfpBaseUrl + "rco/verifyRCODocuments", {
        method: "POST",
        headers: myHeaders,
        body: raw,
      });

      const result = await response.json();
      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setViewBackdrop(false); // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒâ€šÃ‚Â¹ loader OFF (always)
    }
  };

  const callChangeProgressIdAPI = async (
    applicationProgressId,
    status,
    remarks,
    remarksDetails = "-",
    id = dialogRowData.applicationId,
  ) => {
    var formdata = new FormData();

    formdata.append("applicationId", id);
    formdata.append("applicationProgressId", applicationProgressId);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "comman/changeProgressId", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          handleClose();
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log("error", error));

    // setOpen(false);
  };

  const callChangeObjectionStatus = async (
    objectionStatus,
    remarks,
    remarksDetails = "-",
  ) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: 5,
      objectionStatus: 0,
      remarks: remarks,
      remarksDetail: remarksDetails,
      submittedThrough: portalName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    await fetch(cfpBaseUrl + "rco/removeRCOFieldSurveyObjecton", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          handleClose();
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log("error", error));

    setRejectionRemovalAlert(false);
    setObjectionPopUpOpen(false);
    setFieldRejectionRemovalAlert(false);
  };

  const callResetObjectionStatus = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      cfpBaseUrl + "electricityNewConnection/resetObjectionStatus",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // setDialogRowData(lclStrdNewConApp[index])
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log("error", error));
  };

  const callRCOFeeVerificationAPI = async (
    applicationId,
    progressId,
    remarks,
  ) => {
    if (applicationId) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      const raw = JSON.stringify({
        applicationId: applicationId,
        applicationProgressId: progressId,
        objectionStatus: 0,
        lastModifiedBy: userId,
        remarks: remarks,
        rcoFeePaymentVerificationFlag: 1,
        paidBillImageFlag: 1,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/verifyOrObjectRCOPayment", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "200") {
            handleClose();
          }
        })
        .catch((error) => console.error(error));
    }
  };

  const callRCOApprovePart1API = async (rcoId) => {
    var formdata = new FormData();
    formdata.append("rcoId", rcoId);
    formdata.append("authorizedByName", userId);
    formdata.append("authorizedByDesignation", roleName);
    formdata.append("rcoP1ApprovedFlag", 1);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/rcoP1Approval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            5,
            "Demand Notice Created",
            "Demand Notice Created",
          );
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log(error));
  };

  const callRCOApprovePart2API = async () => {
    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: dialogRowData.applicationProgressId + 1,
      objectionStatus: 0,
      lastModifiedBy: userId,
      remarks: "Meter Installation Verified",
    });

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      body: raw,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/approveRCOMeterInfo", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callApproveRCOForBilling(
            dialogRowData.applicationId,
            12,
            "RCO Approved for Billing",
          );
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => console.log(error));
  };

  const callApproveRCOForBilling = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks,
    remarksDetails,
  ) => {
    if (!applicationId) return;

    try {
      const response = await fetch(`${cfpBaseUrl}rco/approveRCOMeterProfile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          applicationId,
          applicationProgressId,
          objectionStatus,
          remarks,
          remarksDetail: remarksDetails,
        }),
      });

      const result = await response.json();

      if (result?.status === "200" || result?.status === 200) {
        setSnackbar({
          open: true,
          message: result?.message || "Approved successfully",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result?.message || "Something went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "Server error. Please try again.",
        severity: "error",
      });
    }
  };

  const callPostedToIBSForBilling = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks,
    remarksDetails,
  ) => {
    if (!applicationId) return;

    try {
      const response = await fetch(`${cfpBaseUrl}rco/processReadyForBilling`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          applicationId,
          applicationProgressId,
          objectionStatus,
          remarks,
          remarksDetail: remarksDetails,
        }),
      });

      const result = await response.json();

      if (result?.status === "200" || result?.status === 200) {
        setShowCP138ButtonInResponseModal(false);
        setSnackbar({
          open: true,
          message: result?.message || "Approved successfully",
          severity: "success",
        });
      } else if (result?.status === "400" || result?.status === 400) {
        setResponseMessage("");
        setResponseMessageError(result?.message || "Something went wrong");
        setShowCP138ButtonInResponseModal(true);
        setOpenResponseModal(true);
      } else {
        setShowCP138ButtonInResponseModal(false);
        setSnackbar({
          open: true,
          message: result?.message || "Something went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setShowCP138ButtonInResponseModal(false);
      setSnackbar({
        open: true,
        message: "Server error. Please try again.",
        severity: "error",
      });
    }
  };

  const callGetRCOAPI = async (applicationId, phase) => {
    try {
      let rcoDets = "";
      if (applicationId) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "rco/GetRCOMeterInfo", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setRcoDetails(result.data[0]);
              if (result.data[0].rcoP2FillFlag === 1) {
                rcoPart2Formik.values.iv_store_requisition_no =
                  result.data[0].storeRequisitionNo;
                rcoPart2Formik.values.iv_store_requisition_date =
                  result.data[0].storeRequisitionDate.slice(0, 10);
                rcoPart2Formik.values.iv_seasonal_flag =
                  result.data[0].seasonalFlag;
                rcoPart2Formik.values.iv_no_of_acs = result.data[0].noOfACs;
                rcoPart2Formik.values.iv_no_of_meters =
                  result.data[0].noOfMeters;
                rcoPart2Formik.values.iv_no_of_meter_sets =
                  result.data[0].noOfMeterSets;
                rcoPart2Formik.values.iv_no_of_sub_sets =
                  result.data[0].noOfSubSets;
                rcoPart2Formik.values.iv_no_ofsupply_points =
                  result.data[0].noOfSupplyPoints;
                rcoPart2Formik.values.iv_transformer_code =
                  result.data[0].installedTransformerCapacity;
                rcoPart2Formik.values.iv_meter_id = result.data[0].meterId;
                rcoPart2Formik.values.iv_meter_serial_no =
                  result.data[0].meterNo;
                rcoPart2Formik.values.iv_location_code = result.data[0]
                  .locationCode
                  ? result.data[0].locationCode
                  : "P";
                rcoPart2Formik.values.iv_meter_code1 =
                  result.data[0].meterCode1;
                rcoPart2Formik.values.iv_meter_code2 =
                  result.data[0].meterCode2;
                rcoPart2Formik.values.iv_manufacturer_code =
                  result.data[0].manufacturerCode;
                let mC = manufacturesList.find(
                  (item) => item.code == result.data[0].manufacturerCode,
                );
                setManufcaturerCode(mC);
                rcoPart2Formik.values.iv_multiplying_factor =
                  result.data[0].multiplyingFactor;
                rcoPart2Formik.values.iv_meter_range =
                  result.data[0].meterRange;
                rcoPart2Formik.values.iv_meter_reading =
                  result.data[0].meterReading;
                rcoPart2Formik.values.iv_date_of_connection = new Date(
                  result.data[0].dateOfReConnection,
                );
                rcoPart2Formik.values.iv_cp_78_item_no =
                  result.data[0].cp78ItemNo;
                rcoPart2Formik.values.iv_tie_up_non_tie_up =
                  result.data[0].tieUpNonTieUp;
                rcoPart2Formik.values.iv_seal_on_meter =
                  result.data[0].sealOnMeter;
                rcoPart2Formik.values.iv_seal_on_box = result.data[0].sealOnBox;
                rcoPart2Formik.values.iv_security_slip_or_price_bond_no =
                  result.data[0].securitySlipOrPriceBondNo;
                rcoPart2Formik.values.iv_connection_installer_name =
                  result.data[0].connectionInstallerName;
                rcoPart2Formik.values.iv_installed_meter_image =
                  result.data[0].installedMeterImage;
                rcoPart2Formik.values.iv_meter_type = result.data[0].meterType;
                if (phase == "3 Phase") {
                  rcoPart2Formik.values.iv_meter_reading_peak_kwh =
                    result.data[0].threePhasePeak;
                  rcoPart2Formik.values.iv_meter_reading_off_peak_kwh =
                    result.data[0].threePhaseOffPeak;
                } else {
                  rcoPart2Formik.values.iv_meter_reading_peak_kwh =
                    result.data[0].threePhasePeakKWH;
                  rcoPart2Formik.values.iv_meter_reading_off_peak_kwh =
                    result.data[0].threePhaseOffPeakKWH;
                }
                rcoPart2Formik.values.iv_mdi = result.data[0].mdi;
                rcoPart2Formik.values.iv_no_of_mdi_resets =
                  result.data[0].noOfMDIreset;
                rcoPart2Formik.values.iv_ct = result.data[0].cT;
                rcoPart2Formik.values.iv_pt = result.data[0].pT;
                rcoPart2Formik.values.iv_ct_nom = result.data[0].cTN;
                rcoPart2Formik.values.iv_pt_nom = result.data[0].pTN;
                rcoPart2Formik.values.iv_ct_denom = result.data[0].cTD;
                rcoPart2Formik.values.iv_pt_denom = result.data[0].pTD;
                rcoPart2Formik.values.iv_meter_reading_peak_kvarh =
                  result.data[0].threePhasePeakKVARH;
                rcoPart2Formik.values.iv_meter_reading_off_peak_kvarh =
                  result.data[0].threePhaseOffPeakKVARH;
                setInstalledMeterImageThumbnail(
                  result.data[0].installedMeterImage,
                );
              } else {
              }
              rcoDets = result.data[0];
            } else {
              // console.log("NO RCO")
            }
          })
          .catch((error) => console.log("error", error));
      }
      return rcoDets;
    } catch (e) {
      console.log(e, "Unable to get RCO Details");
    }
  };

  const callGetCP136API = async (applicationId) => {
    try {
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setMasterDataFormDetails(result.data[0]);
            if (result.data[0].filledByFlag === 1) {
              masterDataFormik.values.iv_govt_dept =
                result.data[0].governmentDepartment;
              masterDataFormik.values.iv_ed_code =
                result.data[0].electricityDuty;
              masterDataFormik.values.iv_standard_classification_code =
                result.data[0].standardClassificationCode;
              let sc = standardClassificationCodes.find(
                (item) =>
                  item.XCLFM_CODE === result.data[0].standardClassificationCode,
              );
              setStandardClassificationCode(sc);
              masterDataFormik.values.iv_income_tax = result.data[0].incomeTax;
            }
          }
        })
        .catch((error) => console.log("error", error));
    } catch (e) {
      console.log(e, "Unable to get Master Form Data!");
    }
  };

  const callApproveCP136API = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("approvedBy", userId);
    formdata.append("approvedByDesignation", roleName);
    formdata.append("approvalFlag", 1);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "cpForm136/cpForm136Approval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            10,
            "Application Completed",
            "Application Completed",
          );
          // console.log(result.message)
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const callEfileAPI = async (applicationId, application) => {
    try {
      setViewDropBackForEfile(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationId });

      const response = await fetch(`${cfpBaseUrl}rco/getBasicRCOHistory`, {
        method: "POST",
        headers: myHeaders,
        body: raw,
      });

      const result = await response.json();

      if (result.status === "200" && result.data) {
        let applicationHistory = result.data.history || [];
        let applicationCurrentState = result.data.currentStatus?.[0] || {};

        // sort DESC
        const sortedApplicationHistory = [...applicationHistory].sort(
          (a, b) => {
            return (
              new Date(b.lastModificationDate || 0) -
              new Date(a.lastModificationDate || 0)
            );
          },
        );

        setEFileData(sortedApplicationHistory);

        const dataforTable = sortedApplicationHistory.map((item, index) => {
          const isEarliest = index === sortedApplicationHistory.length - 1;

          return {
            stepName: item.reConProgStatusName,
            processedBy:
              item.lastModifiedBy || applicationCurrentState.createdBy,
            date: item.lastModificationDate
              ? convertDatewithTime(item.lastModificationDate)
              : convertDatewithTime(applicationCurrentState.creationDate),
            remarks: isEarliest
              ? "Application Submitted."
              : item.remarks || "-",
            applicationProgressId: item.applicationProgressId,
            _raw: item,
          };
        });

        // keep for UI
        setTableDataProcessingSummary(dataforTable);

        return dataforTable;
      }

      return [];
    } catch (error) {
      console.error("Error in callEfileAPI:", error);
      return [];
    } finally {
      setViewDropBackForEfile(false);
    }
  };

  const callApproveFieldAPI = async (applicationId) => {
    var formdata = new FormData();

    formdata.append("approvedBy", userId);
    formdata.append("approvedByDesignation", roleName);
    formdata.append("approvedFlag", 1);
    formdata.append("applicationNo", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "PUT",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "demandNotice/approveFeildVerification",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callRCOApprovePart1API(rcoDetails.rcoId);
        } else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const callAsyncDnDetailsAPI = async (applicationId) => {
    try {
      let dnDets = {};
      let boqItems = [];
      let dnExpiryFlag = 0;

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/getDemandNoteData", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setIsDemandNoteExpired(result.data[0].demandNoteExpiryFlag);
            dnDets = result.data[0];
            boqItems = result.BoQitems ? result.BoQitems : [];
            dnExpiryFlag = result.data[0].demandNoteExpiryFlag;
            setDnDetails(result.data[0]);
          }
        })
        .catch((error) => console.log("error", error));
      return { dnDets, boqItems, dnExpiryFlag };
    } catch (e) {
      return { dnDets: {}, boqItems: [] };
    }
  };

  const callAsyncGetRCOAPI = async (applicationId) => {
    try {
      let rcoDets = {};
      if (applicationId) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "rco/GetRCOMeterInfo", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              rcoDets = result.data[0];
              setRcoDetails(result.data[0]);
            }
          })
          .catch((error) => console.log("error", error));
        return rcoDets;
      }
    } catch (e) {
      console.log(e, "Unable to get RCO Details");
    }
  };

  const callAsyncGetCP136API = async (applicationId) => {
    try {
      let cpDets = {};
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            cpDets = result.data[0];
          }
        })
        .catch((error) => console.log("error", error));

      return cpDets;
    } catch (e) {
      console.log(e, "Unable to get Master Form Data!");
    }
  };

  const callAsyncGetDocumentsAPI = async (applicationId) => {
    try {
      let appDocs = {};
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/getRCODocuments", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            appDocs = result.data[0];
          }
        })
        .catch((error) => console.log("error", error));

      return appDocs;
    } catch (e) {
      console.log(e, "Unable to get Master Form Data!");
    }
  };

  const callAsyncGetPaidDnImageAPI = async (applicationId) => {
    try {
      let dnImage = "";
      var formdata = new FormData();

      formdata.append("applicationNo", applicationId);
      formdata.append("demandNoticeNo", "");

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setPaidDnImageDetails(result.data[0]);
            dnImage = result.data[0].paidDNImage;
          }
        })
        .catch((error) => console.log("error", error));
      return dnImage;
    } catch (e) {
      console.log(e, "Error in calling paid dn image");
    }
  };

  const callAsyncFieldSurveyInformation = async (applicationId) => {
    if (applicationId) {
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getFieldSurvey", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            fieldFormik.values.iv_distance = result.isLTLWI40Flag;
            fieldFormik.values.iv_estimated_distance =
              result.estDistanceInMeter;
            setSketchDiagramThumbnail(result.sketchDiagram);
            fieldFormik.values.iv_coverage_area = result.areaMarla;
            fieldFormik.values.iv_no_of_default_meters =
              result.noOfMeterInstalled;
            let existingReferenceNumbers = result.installedMeterRefNos;
            existingReferenceNumbers.map((item) => (item.actualFlag = null));
            setAlreadyInstalledRefNos(existingReferenceNumbers);
            setFieldSurveyData(result);
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  const deleteFieldSurvey = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "demandNotice/deleteFeildSurveyAndDNData",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callDeleteRCOAPI(applicationId);
          callAsyncResetDocsFlags(applicationId);
          callChangeProgressIdAPI(
            1,
            "Reference Number Allocation Objection",
            formik.values.iv_objection_Type,
            formik.values.iv_objection_Type,
          );
          setDnDetails(!dnDetails.filledFlag);
        } else {
          setError(result.message);
        }
      });
  };

  const callDeleteRCOAPI = async (applicationId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/deleteRCO", requestOptions)
      .then((response) => response.json())
      .then((result) => {})
      .catch((error) => console.error(error));
  };

  const updateRco1Flag = async (
    applicationId = dialogRowData.applicationId,
    rcoId = rcoDetails.rcoId,
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("rcoId", rcoId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/updateRCOPart1Flag", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            7,
            "RCO. Part1 Rejected",
            "RCO. Part1 Rejected",
          );
          setRcoDetails(rcoDetails.rcoP1FillFlag === null);
        } else {
          setError(result.message);
        }
      });
  };

  const updateCpFlag = async (applicationId = dialogRowData.applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "cpForm136/updateCP136Flag", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(9, "CP 136 Rejected", "CP 136 Rejection");
          setMasterDataFormDetails(masterDataFormDetails.filledByFlag === null);
        } else {
          setError(result.message);
        }
      });
  };

  const callAsyncResetDocsFlags = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    var formdata = new FormData();
    formdata.append("applicationNo", applicationId);
    formdata.append("ownerNOCFlag", "");
    formdata.append("paidBillImageFlag", "");
    formdata.append("applicantCNICFrontFlag", "");
    formdata.append("applicantCNICBackFlag", "");
    formdata.append("scannedCopyOfNearByElectricityBillFlag", "");
    formdata.append("anyOtherDocumentFlag", "");
    formdata.append("copyOfOwnerCNICFrontFlag", "");
    formdata.append("copyOfOwnerCNICBackFlag", "");
    formdata.append("resolutionFormDescFlag", "");
    formdata.append("certMemoDescFlag", "");
    formdata.append("certFormDescFlag", "");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "electricityNewConnection/updateDocumentFlag",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // setReconnectionApplications(allApplications)
        } else {
          console.log("Application Documents flags reset has been failed!");
        }
      })
      .catch((error) => console.log("error", error));
  };

  const callDemandNoteRenewalAPI = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    try {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
        remarks: "DN Renewed.",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "rco/renewRCOExpiredDN",
        requestOptions,
      );

      const result = await response.json();

      if (result?.status === "200") {
        setSnackbar({
          open: true,
          message: result?.message || "Demand Note Renewed Successfully",
          severity: "success",
        });
        handleClose();
      } else {
        setSnackbar({
          open: true,
          message: result?.message || "Something went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "Something went wrong. Please try again.",
        severity: "error",
      });
    } finally {
      setViewBackdrop(false);
    }
  };

  const callAsyncGetRCOFeeVoucherAPI = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    let rcoFeeVoucherDetails = {
      rcoVoucherDets: {},
      rcoVoucherExpiryFlag: 0,
    };
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/getRCOFeeVoucher", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "200") {
            rcoFeeVoucherDetails.rcoVoucherDets = result.data[0];
            rcoFeeVoucherDetails.rcoVoucherExpiryFlag =
              result.rcoVoucherExpiryFlag ? result.rcoVoucherExpiryFlag : 0;
          }
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log(e, "issue in get rco fee voucher");
    }
    return rcoFeeVoucherDetails;
  };
  //#endregion

  //#region functions

  const updateDocFlag = (documentName, value, remarks) => {
    switch (documentName) {
      case "copyOfApplicantCNIC":
        setFlag_applicantCNICFront(value);
        setFlag_applicantCNICBack(value);
        setApplicantCNICFrontObjectionRemarks(remarks);
        setApplicantCNICBackObjectionRemarks(remarks);
        setCopyOfApplicantCNICVerifyPopUp(false);
        break;
      case "paidBillImage":
        setFlag_paidBillImage(value);
        setPaidBillImageObjectionRemarks(remarks);
        setPaidBillImagePopUp(false);
        break;
      default:
        break;
    }
  };

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, "");
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick(code);
        } else {
          console.warn("Invalid code format:", code);
        }
      }
    },
    minLength: 4, // EAN13
  });

  const SketchDiagram = (event) => {
    fieldFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "sketchDiagram." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setSketchDiagram(renamedFile);
        const reader = new FileReader();

        reader.onload = (e) => {
          // Set the thumbnail image as the data URL
          setSketchDiagramThumbnail(e.target.result);
        };

        reader.readAsDataURL(file);
      } else if (documentValidate === 2) {
        console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
      } else {
        console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
      }
    }
  };

  const clearSketchDiagramSelection = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setSketchDiagram("");
    setSketchDiagramUploaded("");
    setSketchDiagramThumbnail("");
    setSketchDiagramError("");
    fieldFormik.setFieldValue("iv_sketch_diagram", "");
    fieldFormik.setFieldTouched("iv_sketch_diagram", false);

    const sketchInput = document.getElementById("iv_sketch_diagram");
    if (sketchInput) {
      sketchInput.value = "";
    }
  };

  const handleClose = async () => {
    //applied load field
    arrearPaymentReceiptFormik.values.iv_arrear_paid_bill_document = null;
    arrearPaymentReceiptFormik.values.iv_arrear_payment_date = "";
    arrearPaymentReceiptFormik.values.iv_remarks_detail = "";
    rcoFeeReceiptFormik.values.iv_rco_fee_payment_date = "";
    rcoFeeReceiptFormik.values.iv_rco_fee_receipt_image = null;
    arrearPaymentObjectionReceiptFormik.values.iv_obj_arrear_paid_bill_document =
      null;
    dnReceiptFormik.values.iv_dn_receipt_image = null;
    dnReceiptFormik.values.iv_dn_fee_payment_date = null;
    arrearPaymentObjectionReceiptFormik.values.iv__obj_arrear_payment_date = "";
    arrearPaymentObjectionReceiptFormik.values.iv_obj_remarks_detail = "";
    setRcoFeeReceiptImageThumbnail("");
    setRcoFeeReceiptImage("");
    setPaymentStatus("");
    setBillMonth("");
    setDnReceiptImage("");
    setDnReceiptImageThumbnail("");
    setDnReceiptImageError("");
    setArrearAmount("");
    setErrormessageBoqEstimation("");
    setErrormessageCostEstimation("");
    setRcoFeeReceiptImageError("");
    meterInstallationFormik.resetForm();
    scoPart2Formik.resetForm();

    meterInstallationFormik.values.iv_installed_meter_date = "";
    meterInstallationFormik.values.iv_installed_meter_img = null;

    appliedLoadFormik.resetForm();
    appliedLoadFormik.values.iv_applied_load = "";
    //field verification fields
    fieldItemFormik.resetForm();
    fieldFormik.resetForm();
    fieldFormik.values.iv_coverage_area = "";
    fieldFormik.values.iv_sanctioned_load = "";
    fieldFormik.values.iv_batch = "";
    fieldFormik.values.iv_reference_to_allot = "";
    setArrearFlag(0);
    setArearPaidBillDocument("");
    setArearPaidBillDocumentThumbnail("");
    arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
    arearBillDocumentFormik.values.iv_arear_paid_bill_date = "";
    formik.resetForm();
    setAlreadyInstalledRefNos([]);
    setGridFlag(false);
    setFeederRehabFlag(false);
    setFeederRehabFlag(false);
    refNoAllocationFormik.resetForm();
    fieldFormik.values.iv_grid_sharing_cost = 0;
    fieldFormik.values.iv_feeder_rehab_charges = 0;
    fieldFormik.values.iv_tariff_to_allot = "";
    fieldFormik.values.iv_survey_date = "";
    fieldFormik.values.iv_surveyed_by = "";
    dnPymentReceiptFormik.resetForm();
    setDnReceiptImage("");
    setPaymentStatus("");
    setArrearAmount("");
    setBillMonth("");
    setDnReceiptImageThumbnail("");
    refNoAllocationFormik.resetForm();
    refNoAllocationFormik.values.iv_feeder_no = "";
    refNoAllocationFormik.values.iv_cantonment_board = "";
    refNoAllocationFormik.values.iv_fgovt = "";
    refNoAllocationFormik.values.iv_pgovt = "";
    refNoAllocationFormik.values.iv_govt_dept_code = "";
    refNoAllocationFormik.values.iv_local_bodies = "";
    refNoAllocationFormik.values.iv_batch = "";
    refNoAllocationFormik.values.iv_sub_batch = "";
    rcoPart2Formik.resetForm();
    rcoPart2Formik.values.iv_store_requisition_no = "";
    rcoPart2Formik.values.iv_store_requisition_date = "";
    rcoPart2Formik.values.iv_sanctioned_load = "";
    rcoPart2Formik.values.iv_no_of_meters = 0;
    rcoPart2Formik.values.iv_no_of_acs = 0;
    rcoPart2Formik.values.iv_no_of_meter_sets = 0;
    rcoPart2Formik.values.iv_no_of_sub_sets = 0;
    rcoPart2Formik.values.iv_no_ofsupply_points = 0;
    rcoPart2Formik.values.iv_transformer_code = "";
    rcoPart2Formik.values.iv_seasonal_flag = 0;
    rcoPart2Formik.values.iv_meter_id = "";
    rcoPart2Formik.values.iv_meter_serial_no = "";
    rcoPart2Formik.values.iv_location_code = "P";
    rcoPart2Formik.values.iv_meter_code1 = "";
    rcoPart2Formik.values.iv_meter_code2 = "";
    rcoPart2Formik.values.iv_manufacturer_code = "";
    rcoPart2Formik.values.iv_multiplying_factor = 1;
    rcoPart2Formik.values.iv_meter_range = 4;
    rcoPart2Formik.values.iv_meter_reading = "";
    rcoPart2Formik.values.iv_seal_on_meter = "";
    rcoPart2Formik.values.iv_seal_on_box = "";
    rcoPart2Formik.values.iv_ct_nom = "1";
    rcoPart2Formik.values.iv_ct_denom = "1";
    rcoPart2Formik.values.iv_pt_nom = "1";
    rcoPart2Formik.values.iv_pt_denom = "1";
    rcoPart2Formik.values.iv_seal_on_box = "";
    rcoPart2Formik.values.iv_connection_installer_name = "";
    rcoPart2Formik.values.iv_date_of_connection = "";
    rcoPart2Formik.values.iv_cp_78_item_no = "";
    rcoPart2Formik.values.iv_security_slip_or_price_bond_no = "";
    rcoPart2Formik.values.iv_tie_up_non_tie_up = 0;
    rcoPart2Formik.values.iv_meter_reading = "";
    rcoPart2Formik.values.iv_meter_reading_off_peak_kwh = "";
    rcoPart2Formik.values.iv_meter_reading_peak_kwh = "";
    rcoPart2Formik.values.iv_meter_reading_off_peak_kvarh = "";
    rcoPart2Formik.values.iv_meter_reading_peak_kvarh = "";
    setManufcaturerCode({ code: null, name: "" });
    setInstalledMeterImage("");
    setInstalledMeterImageThumbnail("");
    masterDataFormik.resetForm();
    masterDataFormik.values.iv_govt_dept = 0;
    masterDataFormik.values.iv_income_tax = 0;
    masterDataFormik.values.iv_standard_classification_code = "";
    setStandardClassificationCode({ XCLFM_CODE: "", XCLFM_DESC: "" });
    setGovtDeptCode({ departmentCode: null, departmentName: "" });
    setStoreCharges();
    setItemsAmount();
    setSketchDiagram();
    setSketchDiagramUploaded();
    setSketchDiagramThumbnail();
    setInstallationCharges();
    setError("");
    setArrearsDetailsRefno({
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
    });
    setArrearsDetailsRefnoToDisplay({
      refNo: "",
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
      paidArearImage: "",
      paidArearDate: "",
    });
    setDnDetails({
      demandNoticeNo: "",
      issueDate: "",
      applicationId: "",
      dueDate: "",
      roOfficeAddress: "",
      consumerAccountNo: "",
      batchNo: "",
      voltage: "",
      tariff: "",
      coverageAreaOfPremises: "",
      bankName: "",
      industryFactoryType: "",
      sketchImage: "",
      isDistance40: "",
      connectionAccountNo: "",
      dnPaymentFlag: "",
      paymentMethod: "",
      dnPaymentVerificationFlag: "",
      // meterRent: "",
      // serviceRent: "",
      sanctionLoad: "",
      surveyedBy: "",
      surveyedDate: "",
      filledBy: "",
      filledDate: "",
      filledFlag: "",
      approvedBy: "",
      approvedDate: "",
      approvedFlag: "",
      amountOfGridSharing: "",
      amountOfFeederRehab: "",
      paymentDate: "",
      capitalCostAmount: "",
      securityDepositeAmount: "",
    });
    setRcoDetails({
      rcoId: "",
      applicationId: "",
      rcoCreationDate: "",
      urbanRural: "",
      refNo: "",
      fataPata: "",
      feederNo: "",
      batch: "",
      subBatch: "",
      fGovt: "",
      cantonmentBoard: "",
      pGovt: "",
      localBodies: "",
      rcoP1FilledBy: "",
      rcoP1FillingDate: "",
      rcoP1FillFlag: "",
      authorizedByName: "",
      dateOfAuthorization: "",
      rcoP1ApprovedFlag: "",
      storeRequisitionNo: "",
      storeRequisitionDate: "",
      seasonalFlag: "",
      sanctionedLoad: "",
      noOfACs: "",
      noOfMeters: "",
      noOfMeterSets: "",
      noOfSubSets: "",
      noOfSupplyPoints: "",
      installedTransformerCapacity: "",
      meterId: "",
      meterNo: "",
      locationCode: "",
      meterCode: "",
      manufacturerCode: "",
      multiplyingFactor: "",
      meterRange: "",
      meterReading: "",
      dateOfReConnection: "",
      cp78ItemNo: "",
      tieUpNonTieUp: "",
      sealOnMeter: "",
      sealOnBox: "",
      securitySlipOrPriceBondNo: "",
      connectionInstallerName: "",
      rcoP2FilledBy: "",
      rcoP2FillingDate: "",
      rcoP2FillFlag: "",
      rcoP2ApprovedBy: "",
      rcoP2ApprovalDate: "",
      rcoP2ApprovalFlag: "",
      installedMeterImage: "",
    });
    setDialogRowData((prevObject) => ({
      ...prevObject,
      applicantCNICFront: "",
      applicantCNICBack: "",
      paidBillImage: "",
      scannedCopyOfNearByElectricityBill: "",
      anyOtherDocument: "",
      copyOfOwnerCNICFront: "",
      copyOfOwnerCNICBack: "",
      ownerNOC: "",
      resolutionFormDesc: "",
      certFormDesc: "",
      certMemoDesc: "",
    }));
    setTotalCharges(0);
    setItemsArray([]);
    setApplicantCNICFrontObjectionRemarks("");
    setPaidBillImageObjectionRemarks("");
    setBankName();
    setFoundInNc();
    setOpen(false);
    if (!props.showTable && typeof props.onCloseSearchResults === "function") {
      props.onCloseSearchResults();
    }
    setEFileData([]);
    setTableDataProcessingSummary([]);
    dispatch(
      fetchPaginatedReconnectionNormal({
        page: currentPageNormal,
        pageSize: pageSizeNormal,
        dateFrom: dateFromNormal,
        dateTo: dateToNormal,
        loadFrom: loadFromNormal,
        loadTo: loadToNormal,
        applicationProgressId: applicationProgressIdNormal,
        objectionStatus: objectionStatusNormal,
        officeCode: selectedOfficeCode || code,
      }),
    );
    dispatch(
      fetchPaginatedReconnectionOverdue({
        page: currentPageOverdue,
        pageSize: pageSizeOverdue,
        dateFrom: dateFromOverdue,
        dateTo: dateToOverdue,
        loadFrom: loadFromOverdue,
        loadTo: loadToOverdue,
        applicationProgressId: applicationProgressIdOverdue,
        objectionStatus: objectionStatusOverdue,
        officeCode: selectedOfficeCode || code,
      }),
    );
  };

  const showArrearsEntryPopup = () => {
    setArrearsEntryPopUpOpen(true);
  };

  const showObjectionPopup = () => {
    setObjectionPopUpOpen(true);
  };

  const hideObjectionPopup = () => {
    formik.handleReset();
    setObjectionPopUpOpen(false);
  };

  const hideCopyOfApplicantCNICVerifyAlert = (x) => {
    setCopyOfApplicantCNICVerifyPopUp(x);
  };

  const hideInstalledMeterImageVerifyAlert = (x) => {
    setInstalledMeterImageVerifyPopUp(x);
  };

  const hidePropertyDocVerifyAlert = (x) => {
    setPaidBillImagePopUp(x);
  };

  const hidePaidDnImagePopUp = (x) => {
    setPaidDNImagePopUp(x);
  };

  const hideDnPaymentVerifyAlert = () => {
    setDnPaymentVerifyAlert(false);
  };

  const hideDnPaymentRejectAlert = () => {
    setDnPaymentRejectAlert(false);
  };

  const hideRCOPart1ApproveAlert = () => {
    setRcoPart1ApproveAlert(false);
  };

  const hideRCOPart2ApproveAlert = () => {
    setRcoPart2ApproveAlert(false);
  };

  const showRejectionRemovalAlert = () => {
    setRejectionRemovalAlert(true);
  };

  const showFieldRejectionRemovalAlert = () => {
    setFieldRejectionRemovalAlert(true);
  };

  const hideRejectionRemovalAlert = () => {
    setRejectionRemovalAlert(false);
  };

  const hideFieldRejectionRemovalAlert = () => {
    setFieldRejectionRemovalAlert(false);
  };

  const hideArrearsEntryAlert = () => {
    setArrearsEntryPopUpOpen(false);
  };

  const getClassName = (x) => {
    if (x === "Pending") {
      return "pending-button";
    } else if (x === "In Process") {
      return "inprocess-button";
    } else if (x === "Approved") {
      return "approved-button";
    } else if (x === "Completed") {
      return "completed-button";
    } else if (x === "Objection") {
      return "objection-button";
    }
  };

  const filterRCApp = async (applicationId) => {
    const myArray = reconnectionApplications;
    let allApplications = myArray.concat(reconnectionApplicationsOverDue);
    let itemFound = allApplications.find(
      (item) => item.applicationId === applicationId,
    );
    if (itemFound === undefined) {
      itemFound = await SearchIndividualApplication(token, applicationId, "13");
    }

    return itemFound;
  };

  const apiToDataGridConversionNormal = async () => {
    try {
      setViewBackdrop(true);
      const tempArray = [];
      if (reconnectionApplications) {
        reconnectionApplications.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId && item.applicationId.startsWith("RC")) {
            if (
              !item.objectionStatus ||
              item.objectionStatus == 0 ||
              item.objectionStatus == 2
            ) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 13,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressId: progFunc(item.applicationProgressId),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                isDiscAboveAYear: item.isDiscAboveAYear,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadRCOFeePDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadRCOFeePDF(application);
                },
                downloadFixedChargesPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadFixedChargesPDF(application);
                },
                downloadCP138PDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadCP138PDF(application);
                },
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 13,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                applicationProgressId: item.remarks,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadRCOFeePDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadRCOFeePDF(application);
                },
                downloadFixedChargesPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadFixedChargesPDF(application);
                },
                downloadCP138PDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadCP138PDF(application);
                },
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          connectionType: "",
          applicantName: " ",
          applicantCNIC: " ",
          applicationStatusId: statusFunc(" "),
        };
        tempArray.push(dataGridObject);
      }

      setReconnectionApplicationsToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) {
      console.log(e);
    }
  };

  const apiToDataGridConversionOverdue = async () => {
    try {
      setViewBackdrop(true);

      const tempArray = [];
      if (reconnectionApplicationsOverDue) {
        reconnectionApplicationsOverDue.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId && item.applicationId.startsWith("RC")) {
            if (
              !item.objectionStatus ||
              item.objectionStatus == 0 ||
              item.objectionStatus == 2
            ) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 13,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressId: progFunc(item.applicationProgressId),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                isDiscAboveAYear: item.isDiscAboveAYear,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadRCOFeePDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadRCOFeePDF(application);
                },
                downloadFixedChargesPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadFixedChargesPDF(application);
                },
                downloadBill: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadBill(application.referenceNo);
                },
                downloadRCOPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadRCOPDF(application);
                },
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 13,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                applicationProgressId: item.remarks,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadRCOFeePDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadRCOFeePDF(application);
                },
                downloadFixedChargesPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadFixedChargesPDF(application);
                },
                downloadBill: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadBill(application.referenceNo);
                },
                downloadRCOPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadRCOPDF(application);
                },
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          connectionType: "",
          applicantName: " ",
          applicantCNIC: " ",
          applicationStatusId: statusFunc(" "),
        };
        tempArray.push(dataGridObject);
      }

      setReconnectionApplicationsOverDueToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) {
      console.log(e);
    }
  };

  const updateDocumentStatus = () => {
    if (flag_applicantCNICFront !== null && flag_applicantCNICBack !== null) {
      callingUpdateDocumentStatusAPI();
    } else {
      setError("Check all the attached documents before submitting!");
    }
  };

  const statusFunc = (x, objection) => {
    if (objection === 0 || objection === 2) {
      if (x === 0) {
        return "Pending";
      } else if (x > 0 && x < 5) {
        return "In Process";
      } else if (x >= 5 && x < 10) {
        return "Approved";
      } else {
        return "Completed";
      }
    } else {
      return "Objection";
    }
  };

  const progFunc = (x) => {
    if (x === 0) {
      return "Documents Uploading";
    } else if (x === 1) {
      return "Documents Verification";
    } else if (x === 2) {
      return "RCO Fee Approval";
    } else if (x === 3) {
      return "RCO Fee Submission";
    } else if (x === 4) {
      return "RCO Fee Verification";
    } else if (x === 5) {
      return "Field Survey";
    } else if (x === 6) {
      return "DN Approval";
    } else if (x === 7) {
      return "DN Submission";
    } else if (x === 8) {
      return "DN Payment Verification";
    } else if (x === 9) {
      return "Meter Installation";
    } else if (x === 10) {
      return "Forward To RO";
    } else if (x === 11) {
      return "Ready for Billing";
    } else if (x === 12) {
      return "Completed";
    }
  };

  const stepName = (x) => {
    if (x === 0) {
      return "Application Submitted";
    } else if (x === 1) {
      return "Documents Submitted";
    } else if (x === 2) {
      return "Documents Verified";
    } else if (x === 3) {
      return "RCO Fee Approval";
    } else if (x === 4) {
      return "RCO Fee Submission";
    } else if (x === 5) {
      return "RCO Fee Verification";
    } else if (x === 6) {
      return "Field Survey";
    } else if (x === 7) {
      return "DN Approval";
    } else if (x === 8) {
      return "DN Submission";
    } else if (x === 9) {
      return "DN payment Verification";
    } else if (x === 10) {
      return "Meter Installation";
    } else if (x === 11) {
      return "Forward To RO";
    } else if (x === 12) {
      return "Ready For Billing";
    }
  };

  const getWFData = async () => {
    setViewBackdrop(true);
    let wfData = await getWorkforceData(
      token,
      hierarchy == 52 ? code : "15171",
    );
    setWorkForceData(wfData);
    setViewBackdrop(false);
  };

  const callGetSCOAPI = async (applicationId, phase) => {
    try {
      let rcoDets = "";
      if (applicationId) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "rco/getSCODetailsForRCO", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setScoDetails(result.data[0]);
              if (result.data[0].scoP1FillFlag === 1) {
                refNoAllocationFormik.values.iv_feeder_no =
                  result.data[0].feederNo;
                refNoAllocationFormik.values.iv_batch = result.data[0].batch;
                refNoAllocationFormik.values.iv_sub_batch =
                  result.data[0].subBatch;
                refNoAllocationFormik.values.iv_fata_pata =
                  result.data[0].fataPata;
                refNoAllocationFormik.values.iv_rural_urban =
                  result.data[0].urbanRural;
                refNoAllocationFormik.values.iv_fgovt = result.data[0].fGovt;
                refNoAllocationFormik.values.iv_cantonment_board =
                  result.data[0].cantonmentBoard;

                let gdc = govtDeptCodes.find(
                  (item) =>
                    item.departmentCode ==
                    result.data[0].governmentDepartmentCode,
                );
                setGovtDeptCode(gdc);
                refNoAllocationFormik.values.iv_govt_dept_code = parseInt(
                  result.data[0].governmentDepartmentCode,
                );
                refNoAllocationFormik.values.iv_pgovt = result.data[0].pGovt;
                refNoAllocationFormik.values.iv_local_bodies =
                  result.data[0].localBodies;
              } else {
              }
              if (result.data[0].scoP2FillFlag === 1) {
                scoPart2Formik.values.iv_store_requisition_no =
                  result.data[0].storeRequisitionNo;
                scoPart2Formik.values.iv_store_requisition_date =
                  result.data[0].storeRequisitionDate.slice(0, 10);
                scoPart2Formik.values.iv_seasonal_flag =
                  result.data[0].seasonalFlag;
                scoPart2Formik.values.iv_no_of_acs = result.data[0].noOfACs;
                scoPart2Formik.values.iv_no_of_meters =
                  result.data[0].noOfMeters;
                scoPart2Formik.values.iv_no_of_meter_sets =
                  result.data[0].noOfMeterSets;
                scoPart2Formik.values.iv_no_of_sub_sets =
                  result.data[0].noOfSubSets;
                scoPart2Formik.values.iv_no_ofsupply_points =
                  result.data[0].noOfSupplyPoints;
                scoPart2Formik.values.iv_transformer_code =
                  result.data[0].installedTransformerCapacity;
                scoPart2Formik.values.iv_transformer_refNo =
                  result.data[0].transformerRefNo;
                scoPart2Formik.values.iv_meter_id = result.data[0].meterId;
                scoPart2Formik.values.iv_meter_serial_no =
                  result.data[0].meterNo;
                scoPart2Formik.values.iv_sim_ID = result.data[0].simId;
                scoPart2Formik.values.iv_sim_number = result.data[0].simNumber;
                scoPart2Formik.values.iv_location_code = result.data[0]
                  .locationCode
                  ? result.data[0].locationCode
                  : "P";
                scoPart2Formik.values.iv_meter_code1 =
                  result.data[0].meterCode1;
                scoPart2Formik.values.iv_meter_code2 =
                  result.data[0].meterCode2;
                scoPart2Formik.values.iv_manufacturer_code =
                  result.data[0].manufacturerCode;
                let mC = manufacturesList.find(
                  (item) => item.code == result.data[0].manufacturerCode,
                );
                setManufcaturerCode(mC);
                scoPart2Formik.values.iv_multiplying_factor =
                  result.data[0].multiplyingFactor;
                scoPart2Formik.values.iv_meter_range =
                  result.data[0].meterRange;
                scoPart2Formik.values.iv_meter_reading =
                  result.data[0].meterReading;

                scoPart2Formik.values.iv_cp_78_item_no =
                  result.data[0].cp78ItemNo;
                scoPart2Formik.values.iv_tie_up_non_tie_up =
                  result.data[0].tieUpNonTieUp;
                scoPart2Formik.values.iv_seal_on_meter =
                  result.data[0].sealOnMeter;
                scoPart2Formik.values.iv_seal_on_box = result.data[0].sealOnBox;
                scoPart2Formik.values.iv_security_slip_or_price_bond_no =
                  result.data[0].securitySlipOrPriceBondNo;
                scoPart2Formik.values.iv_connection_installer_name =
                  result.data[0].connectionInstallerName;
                scoPart2Formik.values.iv_installed_meter_image =
                  result.data[0].installedMeterImage;
                scoPart2Formik.values.iv_meter_type = result.data[0].meterType;
                setMeterTypeValueForCheck(result.data[0].meterType);
                scoPart2Formik.setFieldValue(
                  "iv_meter_type",
                  result.data[0].meterType,
                );
                if (phase == "3 Phase") {
                  scoPart2Formik.values.iv_meter_reading_peak_kwh =
                    result.data[0].threePhasePeak;
                  scoPart2Formik.values.iv_meter_reading_off_peak_kwh =
                    result.data[0].threePhaseOffPeak;
                } else {
                  scoPart2Formik.values.iv_meter_reading_peak_kwh =
                    result.data[0].threePhasePeakKWH;
                  scoPart2Formik.values.iv_meter_reading_off_peak_kwh =
                    result.data[0].threePhaseOffPeakKWH;
                }
                scoPart2Formik.values.iv_mdi = result.data[0].mdi;
                scoPart2Formik.values.iv_no_of_mdi_resets =
                  result.data[0].noOfMDIreset;
                scoPart2Formik.values.iv_ct = result.data[0].cT;
                scoPart2Formik.values.iv_pt = result.data[0].pT;
                scoPart2Formik.values.iv_ct_nom = result.data[0].cTN;
                scoPart2Formik.values.iv_pt_nom = result.data[0].pTN;
                scoPart2Formik.values.iv_ct_denom = result.data[0].cTD;
                scoPart2Formik.values.iv_pt_denom = result.data[0].pTD;
                scoPart2Formik.values.iv_meter_reading_peak_kvarh =
                  result.data[0].threePhasePeakKVARH;
                scoPart2Formik.values.iv_meter_reading_off_peak_kvarh =
                  result.data[0].threePhaseOffPeakKVARH;
                setInstalledMeterImageThumbnail(
                  result.data[0].installedMeterImage,
                );
              } else {
              }
              rcoDets = result.data[0];
            } else {
              // console.log("NO SCO")
            }
          })
          .catch((error) => console.log("error", error));
      }
      return rcoDets;
    } catch (e) {
      console.log(e, "Unable to get SCO Details");
    }
  };

  const handleRowClick = async (applicationId, event) => {
    setViewBackdrop(true);
    let demandNoticeDetails = "";
    let dnPayDate = "";
    let rcoDets = "";
    if (applicationId) {
      const item = await filterRCApp(applicationId);
      if (item) {
        const connectionType = item.connectionCategory;
        const sanctionedLoad = item.sanctionedLoad;
        const consumerRefNo = item.referenceNo;
        const isReferedToFeildSurvey = item.isReferedToFeildSurvey;
        let phase = getPhase(item.sanctionedLoad);
        setPhase(phase);
        setDialogRowData(item);
        setApplicantCNICFrontObjectionRemarks(item.applicantCNICFrontRemarks);
        setApplicantCNICBackObjectionRemarks(item.applicantCNICBackRemarks);
        setFlag_applicantCNICFront(item.applicantCNICFrontFlag);
        setFlag_applicantCNICBack(item.applicantCNICBackFlag);
        // await callEfileAPI(applicationId, item);

        if (
          item.applicationProgressId === 0 ||
          item.applicationProgressId === 1 ||
          item.applicationProgressId === 4
        ) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");
          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };
          await fetch(cfpBaseUrl + "rco/getRCODocuments", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              setDialogRowData((prevObject) => ({
                ...prevObject,
                paidBillImage: result.data[0].paidBillImage,
                applicantCNICFront: result.data[0].applicantCNICFront,
                applicantCNICBack: result.data[0].applicantCNICBack,
              }));
            })
            .catch((error) => console.log("error", error));
        }

        if (
          item.applicationProgressId === 2 ||
          item.applicationProgressId === 3 ||
          item.applicationProgressId === 4
        ) {
          let rcoVoucherResponse = await callAsyncGetRCOFeeVoucherAPI(
            item.applicationId,
          );
          let rcoDets = rcoVoucherResponse.rcoVoucherDets;
          setRcoFeeVoucherDetails(rcoDets);
        }
        if (item.applicationProgressId === 5) {
          fieldFormik.setFieldValue("iv_tariff_desc", item.tariffDesc);
          fieldFormik.setFieldValue("iv_rural_urban", item.areaType);
          fieldFormik.setFieldValue(
            "iv_meter_type",
            item.meterType === "Smart"
              ? "1"
              : item.meterType === "Normal"
                ? "0"
                : "",
          );
          await callMaterials(item.applicationId);

          await getWFData();
          let fieldStaffDesignations = await getFieldStaffDesignations(token);
          setFieldStaffDesignations(fieldStaffDesignations);

          let subDivisionObject = subDivisions.find(
            (objs) => objs.subDivisionCode === item.subDivisionCode,
          );
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName);
          }
        }
        if (
          item.applicationProgressId === 6 ||
          item.applicationProgressId === 7 ||
          item.applicationProgressId === 8 ||
          item.applicationProgressId === 11
        ) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          await fetch(cfpBaseUrl + "rco/getDemandNoteData", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
                setDnImage(result.data[0].paidDNImage);
                setDnApproveStep(result.data[0]);
                setDnDets(result.data[0]);
              }
            })
            .catch((error) => console.error(error));
        }

        if (
          item.applicationProgressId === 9 &&
          item.isDiscAboveAYear === true
        ) {
          if (phase == "Single Phase") {
            scoPart2Formik.values.iv_meter_code1 = "000002";
          } else if (phase == "3 Phase") {
            scoPart2Formik.values.iv_meter_code1 = "050502";
            scoPart2Formik.values.iv_meter_code2 = "050602";
          }

          if (phase == "MDI (LT)(CT)" || phase == "MDI (HT)(CT/PT)") {
            scoPart2Formik.values.iv_ct_nom = "100";
            scoPart2Formik.values.iv_ct_denom = "5";
          } else {
            scoPart2Formik.values.iv_ct_nom = "1";
            scoPart2Formik.values.iv_ct_denom = "1";
          }

          if (phase == "MDI (HT)(CT/PT)") {
            scoPart2Formik.values.iv_pt_nom = "11000";
            scoPart2Formik.values.iv_pt_denom = "110";
          }

          scoPart2Formik.setFieldValue(
            "iv_sanctioned_load",
            item.sanctionedLoad,
          );
          scoPart2Formik.setFieldValue("iv_connection_installer_name", userId);
          console.log("Meter Type from API: ", item.fsMeterType);
          scoPart2Formik.setFieldValue(
            "iv_meter_typee",
            item?.fsMeterType?.toString() || "",
          );
        }

        if (
          item.applicationProgressId >= 10 &&
          item.isDiscAboveAYear === true
        ) {
          rcoDets = await callGetSCOAPI(item.applicationId, phase);
          scoPart2Formik.values.iv_store_requisition_no =
            rcoDets.storeRequisitionNo;
          scoPart2Formik.values.iv_store_requisition_date =
            rcoDets.storeRequisitionDate.slice(0, 10);
          scoPart2Formik.values.iv_seasonal_flag = rcoDets.seasonalFlag;
          scoPart2Formik.values.iv_no_of_acs = rcoDets.noOfACs;
          scoPart2Formik.values.iv_no_of_meters = rcoDets.noOfMeters;
          scoPart2Formik.values.iv_no_of_meter_sets = rcoDets.noOfMeters;
          scoPart2Formik.values.iv_no_of_sub_sets = rcoDets.noOfSubSets;
          scoPart2Formik.values.iv_no_ofsupply_points =
            rcoDets.noOfSupplyPoints;
          scoPart2Formik.values.iv_transformer_code =
            rcoDets.installedTransformerCapacity;
          scoPart2Formik.values.iv_transformer_refNo = rcoDets.transformerRefNo;
          scoPart2Formik.values.iv_meter_id = rcoDets.meterId;
          scoPart2Formik.values.iv_meter_serial_no = rcoDets.meterNo;
          scoPart2Formik.values.iv_sim_ID = rcoDets.simId;
          scoPart2Formik.values.iv_sim_number = rcoDets.simNumber;
          scoPart2Formik.values.iv_location_code = rcoDets.locationCode
            ? rcoDets.locationCode
            : "P";
          scoPart2Formik.values.iv_meter_code1 = rcoDets.meterCode1;
          scoPart2Formik.values.iv_meter_code2 = rcoDets.meterCode2;
          scoPart2Formik.values.iv_manufacturer_code = rcoDets.manufacturerCode;
          let mC = manufacturesList.find(
            (item) => item.code == rcoDets.manufacturerCode,
          );
          setManufcaturerCode(mC);
          scoPart2Formik.values.iv_multiplying_factor =
            rcoDets.multiplyingFactor;
          scoPart2Formik.values.iv_meter_range = rcoDets.meterRange;
          scoPart2Formik.values.iv_meter_reading = rcoDets.meterReading;

          scoPart2Formik.values.iv_cp_78_item_no = rcoDets.cp78ItemNo;
          scoPart2Formik.values.iv_tie_up_non_tie_up = rcoDets.tieUpNonTieUp;
          scoPart2Formik.values.iv_seal_on_meter = rcoDets.sealOnMeter;
          scoPart2Formik.values.iv_seal_on_box = rcoDets.sealOnBox;
          scoPart2Formik.values.iv_security_slip_or_price_bond_no =
            rcoDets.securitySlipOrPriceBondNo;
          scoPart2Formik.values.iv_connection_installer_name =
            rcoDets.connectionInstallerName;
          scoPart2Formik.values.iv_installed_meter_image =
            rcoDets.installedMeterImage;
          scoPart2Formik.values.iv_meter_type = rcoDets.meterType;
          setMeterTypeValueForCheck(rcoDets.meterType);
          scoPart2Formik.setFieldValue("iv_meter_typee", rcoDets.meterType);
          if (phase == "3 Phase") {
            scoPart2Formik.values.iv_meter_reading_peak_kwh =
              rcoDets.threePhasePeak;
            scoPart2Formik.values.iv_meter_reading_off_peak_kwh =
              rcoDets.threePhaseOffPeak;
          } else {
            scoPart2Formik.values.iv_meter_reading_peak_kwh =
              rcoDets.threePhasePeakKWH;
            scoPart2Formik.values.iv_meter_reading_off_peak_kwh =
              rcoDets.threePhaseOffPeakKWH;
          }
          scoPart2Formik.values.iv_mdi = rcoDets.mdi;
          scoPart2Formik.values.iv_no_of_mdi_resets = rcoDets.noOfMDIreset;
          scoPart2Formik.values.iv_ct = rcoDets.cT;
          scoPart2Formik.values.iv_pt = rcoDets.pT;
          scoPart2Formik.values.iv_ct_nom = rcoDets.cTN;
          scoPart2Formik.values.iv_pt_nom = rcoDets.pTN;
          scoPart2Formik.values.iv_ct_denom = rcoDets.cTD;
          scoPart2Formik.values.iv_pt_denom = rcoDets.pTD;
          scoPart2Formik.values.iv_meter_reading_peak_kvarh =
            rcoDets.threePhasePeakKVARH;
          scoPart2Formik.values.iv_meter_reading_off_peak_kvarh =
            rcoDets.threePhaseOffPeakKVARH;
          scoPart2Formik.values.iv_sanctioned_load = rcoDets.sanctionLoad;
          scoPart2Formik.values.iv_date_of_connection =
            rcoDets.dateOfReConnection;
          setInstalledMeterImageThumbnail(rcoDets.installedMeterImage);
        }
        if (
          item.applicationProgressId === 9 &&
          (item.isDiscAboveAYear === false || item.isSecurityRequired === false)
        ) {
          const disconnectedResponse = await discMeterDetails(item.referenceNo, companyCode , token , code);

          if (disconnectedResponse?.rows?.length) {
            setDisconnectedMeterDetails(disconnectedResponse.rows); 
          } else {
            setDisconnectedMeterDetails([]); // fallback
          }
        }
        if (
          (item.applicationProgressId === 10 ||
            item.applicationProgressId === 11) &&
          item.isDiscAboveAYear === false &&
          item.isSecurityRequired === false
        ) {
          const disconnectedResponse = await rcoMeterProfile(
            token,
            item.applicationId,
          );

          if (
            disconnectedResponse?.status === "200" &&
            disconnectedResponse?.data?.length
          ) {
            setDisconnectedMeterDetsForROApproval(disconnectedResponse);
            setDisconnectedMeterDetsImgForROApproval(
              disconnectedResponse.data[0].reinstalledMeterImage,
            );
          } else {
            setDisconnectedMeterDetsForROApproval({});
            setDisconnectedMeterDetsImgForROApproval("");
          }
        }
        // if (item.applicationProgressId >= 8) {
        //   let rcoVoucherResponse = await callAsyncGetRCOFeeVoucherAPI(
        //     item.applicationId
        //   );
        //   let rcoDets = rcoVoucherResponse.rcoVoucherDets;
        //   setRcoFeeVoucherDetails(rcoDets);
        // }
        // if (item.applicationProgressId >= 10) {
        //   rcoDets = await callGetRCOAPI(item.applicationId, phase);
        //   if (!rcoDets.connectionInstallerName) {
        //     rcoPart2Formik.values.iv_connection_installer_name = userId;
        //   }
        //   if (!rcoDets.rcoP2FilledFlag) {
        //     if (phase == "Single Phase") {
        //       rcoPart2Formik.values.iv_meter_code1 = "000002";
        //       // rcoPart2Formik.values.iv_meter_serial_no = item.meterSerialNo ? item.meterSerialNo.split(' ')[1] : ''
        //       rcoPart2Formik.values.iv_manufacturer_code = item.meterSerialNo
        //         ? rcoPart2Formik.values.iv_meter_serial_no.slice(0, 2)
        //         : "";
        //       rcoPart2Formik.values.iv_meter_range = item.KWH_METER_RANGE
        //         ? parseInt(item.KWH_METER_RANGE)
        //         : 6;
        //     } else if (phase == "3 Phase") {
        //       rcoPart2Formik.values.iv_meter_code1 = "050502";
        //       rcoPart2Formik.values.iv_meter_code2 = "050602";
        //     }

        //     if (phase == "MDI (LT)(CT)" || phase == "MDI (HT)(CT/PT)") {
        //       rcoPart2Formik.values.iv_ct_nom = "100";
        //       rcoPart2Formik.values.iv_ct_denom = "5";
        //     } else {
        //       rcoPart2Formik.values.iv_ct_nom = "1";
        //       rcoPart2Formik.values.iv_ct_denom = "1";
        //     }

        //     if (phase == "MDI (HT)(CT/PT)") {
        //       rcoPart2Formik.values.iv_pt_nom = "11000";
        //       rcoPart2Formik.values.iv_pt_denom = "110";
        //     }
        //   }
        // }
        setViewBackdrop(false);
        setOpen(true);
      }
    }
  };

  useEffect(() => {
    if (dialogRowData && allTariffList) {
      const connectionType = dialogRowData?.connectionType?.toLowerCase() || "";

      const matchedTariffs = allTariffList.filter(
        (tariff) =>
          tariff?.consumerType &&
          tariff.consumerType.toLowerCase() === connectionType,
      );

      const shortlistedTariffs = getTariffsForValue(
        parseInt(dialogRowData?.appliedLoad || 0),
        matchedTariffs,
      );

      setShortListIndustrialTariff(shortlistedTariffs);
    } else {
      setShortListIndustrialTariff([]);
    }
  }, [
    dialogRowData?.connectionType,
    dialogRowData?.appliedLoad,
    allTariffList,
  ]);

  useEffect(() => {
    const callStandardClassificaitionCodesAPI = async () => {
      try {
        var formdata = new FormData();

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "demandNotice/getClassificationCodes",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setStandardClassificationCodes(result.data);
            }
          })
          .catch((error) => console.log("error", error));
      } catch (e) {
        console.log("error calling classification codes API", e);
      }
    };

    callStandardClassificaitionCodesAPI();
  }, []);

  useEffect(() => {
    const callGovtDeptCodesAPI = async () => {
      try {
        var formdata = new FormData();

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "sco/getGovtDepartList", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setGovtDeptCodes(result.data);
            }
          })
          .catch((error) => console.log("error", error));
      } catch (e) {
        console.log("error calling classification codes API", e);
      }
    };
    callGovtDeptCodesAPI();
  }, []);

  const getDocumentBackGroundColor = (flagValue) => {
    switch (flagValue) {
      case null:
        return "white";
      case -1:
        return "#FFCAC9";
      case "-1":
        return "#FFCAC9";
      case 0:
        return "#F3F6FB";
      case 1:
        return "#D6F6D5";
      default:
        return "white";
    }
  };

  // const DnReceiptImage = (event) => {
  //   dnPymentReceiptFormik.handleChange(event);
  //   if (event.target.files.length > 0) {
  //     let file = event.target.files[0];
  //     let fileName = file.name;
  //     let fileNameArray = fileName.split(".");
  //     let extension = fileNameArray[fileNameArray.length - 1];
  //     const maxSize = 2 * 1024 * 1024; // 2MB in bytes
  //     const documentValidate = documentValidation(file, maxSize);
  //     if (documentValidate === 1) {
  //       const newFileName = "dnReceiptImage." + extension;
  //       const renamedFile = new File([file], newFileName, { type: file.type });
  //       setDnReceiptImage(renamedFile);
  //       const reader = new FileReader();
  //       reader.readAsDataURL(file);
  //       reader.onload = () => {
  //         // Set the thumbnail image as the data URL
  //         const base64Image = reader.result;
  //         setDnReceiptImageThumbnail(base64Image);
  //       };
  //     } else if (documentValidate === 2) {
  //       console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
  //     } else {
  //       console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
  //     }
  //   }
  // };

  const RcoFeeReceiptImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "rcoFeeReceiptImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        rcoFeeReceiptFormik.handleChange,
        setRcoFeeReceiptImage,
        setRcoFeeReceiptImageError,
        setRcoFeeReceiptImageThumbnail,
        newFileName,
      );
    }
  };

  const DnReceiptImage = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const newFileName = "dnReceiptImage." + file.name.split(".").pop();

      // Set Formik field value first
      dnReceiptFormik.setFieldValue("iv_dn_receipt_image", file);
      dnReceiptFormik.setFieldTouched("iv_dn_receipt_image", true);

      // Then handle your custom upload logic
      handleFileUpload(
        event,
        dnReceiptFormik.handleChange,
        setDnReceiptImage,
        setDnReceiptImageError,
        setDnReceiptImageThumbnail,
        newFileName,
      );
    }
  };

  const PaidBillImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "paidBillImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        rcoFeeReceiptFormik.handleChange,
        setPaidBillImage,
        setPaidBillImageError,
        setPaidBillImageThumbnail,
        newFileName,
      );
    }
  };

  const deleteItem = (indexToDelete) => {
    const updatedItems = itemsArray.filter((_, i) => i !== indexToDelete);

    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(updatedItems);
    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(updatedItems);

    fieldItemFormik.setFieldValue("iv_items_array", updatedItems);
  };

  const updateItemQtyByDelta = (indexToUpdate, delta) => {
    if (dnDetails && dnDetails.filledFlag === 1) return;

    const updatedItems = [...itemsArray];
    const currentQty = Number(updatedItems[indexToUpdate]?.qty) || 0;
    const nextQty = Math.max(1, currentQty + delta);

    updatedItems[indexToUpdate].qty = nextQty;
    updatedItems[indexToUpdate].amount = Math.round(
      nextQty * (Number(updatedItems[indexToUpdate]?.rate) || 0),
    );

    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(updatedItems);
    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(updatedItems);
    fieldItemFormik.setFieldValue("iv_items_array", updatedItems);
  };

  const getMeterType = (code) => {
    switch (code) {
      case 0:
        return "Normal";
      case "0":
        return "Normal";
      case 1:
        return "Smart";
      case "1":
        return "Smart";
      default:
        return "-";
    }
  };

  const FataPata = (event) => {
    refNoAllocationFormik.handleChange(event);
    refNoAllocationFormik.values.iv_fata_pata = event.target.value;
  };

  const RuralUrban = (event) => {
    refNoAllocationFormik.handleChange(event);
    refNoAllocationFormik.values.iv_rural_urban = event.target.value;
  };

  const SeasonalNonSeasonal = (event) => {
    rcoPart2Formik.handleChange(event);
    rcoPart2Formik.values.iv_seasonal_flag = event.target.value;
    // console.log(value);
  };

  const GovtDept = (event) => {
    masterDataFormik.handleChange(event);
    masterDataFormik.values.iv_govt_dept = event.target.value;
    masterDataFormik.values.iv_ed_code = "";
  };

  const MeterType = (event) => {
    rcoPart2Formik.handleChange(event);
    rcoPart2Formik.values.iv_meter_type = event.target.value;
  };

  const IncomeTax = (event) => {
    masterDataFormik.handleChange(event);
    masterDataFormik.values.iv_income_tax = event.target.value;
  };

  const MeterLine = (event) => {
    fieldFormik.handleChange(event);
    fieldFormik.values.iv_distance = event.target.value;
    setDistance(event.target.value);
    if (event.target.value == "0") {
      setGridFlag(false);
      setFeederRehabFlag(false);
    }
    // if (event.target.value == "1") {
    //   setCivilWorkCharges(0)
    //   setFixedChargesOfMetering(0)
    //   setMiscellaneousCharges(0)
    //   setInstallationCharges('')
    //   setItemsAmount('')
    //   setStoreCharges(0)
    //   setLessTheCost(0)
    //   setGridSharingCost(0)
    //   setFeederRehabilitationCharges('')
    //   SetTotalEstimatedAmnt('')
    //   setBoqItems([])
    //   setItemsArray([])
    //   setGrandTotalCharges(0)

    // } else {
    //   setCivilWorkCharges("")
    //   setItemsArray([])
    //   setFixedChargesOfMetering('')
    //   setMiscellaneousCharges('')
    //   setInstallationCharges('')
    //   setItemsAmount('')
    //   setStoreCharges('')
    //   setLessTheCost('')
    //   setGridSharingCost("")
    //   setFeederRehabilitationCharges('')
    //   SetTotalEstimatedAmnt('')
    //   setBoqItems([])
    //   setGrandTotalCharges('')
    // }
    setCivilWorkCharges(0);
    setFixedChargesOfMetering(0);
    setMiscellaneousCharges(0);
    setInstallationCharges("");
    setItemsAmount("");
    setStoreCharges(0);
    setLessTheCost(0);
    setGridSharingCost(0);
    setFeederRehabilitationCharges("");
    setBoqItems([]);
    setItemsArray([]);
    setGrandTotalCharges(0);
  };

  const ReferToSubdivision = (event) => {
    referToFieldFormik.handleChange(event);
    referToFieldFormik.values.iv_refer_to_subdivision = event.target.value;
  };

  const ExemptRCOFee = (event) => {
    referToFieldFormik.handleChange(event);
    referToFieldFormik.values.iv_exempt_rco_fee = event.target.value;
    if (event.target.value == 1) {
      referToFieldFormik.values.iv_refer_to_subdivision = 0;
    }
  };

  const eFileIcon = () => {
    return <img src={eFileIcon} alt="Efile Icon" height="20" width="25" />;
  };


  const downloadCP138PDF = async (
    application,
    disconnectedMeterDetsForROApproval,
  ) => {
    setViewBackdrop(true);

    try {
      const applicationId = application.applicationId;
      const DiscoCode = application.companyCode.toString();
      // const meterProfile = disconnectedMeterDetsForROApproval?.meterProfile || [];
      const disconnectedResponse = await rcoMeterProfile(
        token,
        application.applicationId,
      );
        if (application.isDiscAboveAYear === true) {
          // Generate RCO SCO style PDF with all details and meter image
          const phase = getPhase(application.sanctionedLoad);
          const rcoDets = await callGetSCOAPI(application.applicationId, phase);
          await downloadRCOSCOStylePDF(application, rcoDets);
          return;
        }

        // Existing meter profile PDF code for false case

      const doc = new jsPDF({ compressPdf: true });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      let height = 10;
      const padding = 10;
      const leftMargin = 50;

      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      height += 15;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 12;
      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");

      const row = (label1, value1, label2, value2) => {
        doc.text(label1, padding, height);
        doc.text(value1 ?? "-", padding + leftMargin, height);
        doc.text(label2, padding + leftMargin * 2, height);
        doc.text(value2 ?? "-", padding + leftMargin * 3, height);
        height += 9;
      };

      row(
        "Applicant Name:",
        application.consumerName,
        "Applicant CNIC:",
        application.consumerCNIC,
      );
      row(
        "Father's Name:",
        application.consumerFatherName,
        "Sanct. Load(kW):",
        application.sanctionedLoad,
      );
      row(
        "Connection Type:",
        application.connectionCategory,
        "Meter Type:",
        application.meterType,
      );
      row(
        "Tariff:",
        application.tariffDesc,
        "Subdivision:",
        subdivisionName(application.subDivisionCode, subDivisions),
      );
      row(
        "Consumer ID:",
        application.customerId,
        "Ref. No.:",
        application.referenceNo,
      );
      row(
        "Phone No.:",
        application.applicantMobileNo,
        "Address:",
        application.consumerAddress,
      );

      // doc.text("Address:", padding, height);
      // doc.text(
      //   application.consumerAddress ?? "-",
      //   padding + leftMargin,
      //   height,
      // );

      height += 8;

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.line(10, height, pageWidth - 10, height);

      height += 10;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("Meter Profile", pageWidth / 2, height, { align: "center" });
      height += 6;

      const tableColumns = [
        "Set No",
        "Meter Type",
        "KVAH / KVARH",
        "Main Subset",
        "Feeder No",
        "Meter No",
        "Location",
        "Manufacturer",
        "Meter Code",
        "MF",
        "Range",
        "Reading",
        "MDI Reset",
        "MDI Cum",
      ];

      const hasData =
        disconnectedResponse?.meterProfile &&
        disconnectedResponse.meterProfile.length > 0;

      const tableRows = hasData
        ? disconnectedResponse.meterProfile.map((row) => [
            row.SET_NO ?? "-",
            row.PHASE ?? "-",
            row.KWH_METER_CODE ?? "-",
            row.TS_NO ?? "-",
            row.FEEDER_CODE ?? "-",
            row.METER_SERIAL_NO ?? "-",
            row.KWH_METER_LOC_CD ?? "-",
            row.KWH_MFG_ID_METER ?? "-",
            row.KWH_METER_CODE ?? "-",
            row.KWH_MF ?? "-",
            row.KWH_METER_RANGE ?? "-",
            row.KWH_READING ?? "-",
            row.MDI_RESET_NO ?? "-",
            row.MDI_CUM_READ ?? "-",
          ])
        : [
            [
              {
                content: "No data found",
                colSpan: tableColumns.length,
                styles: {
                  halign: "center",
                  fontStyle: "bold",
                  textColor: [150, 0, 0],
                },
              },
            ],
          ];

      autoTable(doc, {
        startY: height,
        head: [tableColumns],
        body: tableRows,
        theme: "grid",
        styles: {
          fontSize: 7.5,
          halign: "center",
          valign: "middle",
          cellPadding: 1.5,
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [58, 60, 63],
          textColor: 255,
          fontStyle: "bold",
        },
        margin: { left: 8, right: 8 },
      });

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          pageWidth,
          pageHeight,
        );
        doc.setFontSize(8);
        doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, {
          align: "center",
        });
      }

      try {
       const pdfBlob = doc.output("blob");
      const fileName = `${applicationId}-CP138.pdf`;
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL + '#' + fileName, fileName);
      } catch (downloadErr) {
        console.error("Error downloading CP-138 PDF:", downloadErr);
      }
    } catch (err) {
      console.error("CP-138 PDF generation failed", err);
    } finally {
      setViewBackdrop(false);
    }
  };

  const ArearPaidBillDocument = (event) => {
    arearBillDocumentFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "paidBillArear." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const image = new Image();
        image.src = URL.createObjectURL(renamedFile);

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const waterMarkText = "For MEPCO Use Only";
          ctx.font = "24px Arial";
          ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
          ctx.fillText(waterMarkText, 10, canvas.height - 10);
          const watermarkedBase64 = canvas.toDataURL();
          setArearPaidBillDocument(renamedFile);
          setArearPaidBillDocumentThumbnail(watermarkedBase64);
        };
      } else if (documentValidate === 2) {
        console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
      } else {
        console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
      }
    }
  };

  const InstalledMeterImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "installedMeterImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        rcoPart2Formik.handleChange,
        setInstalledMeterImage,
        setInstalledMeterImageError,
        setInstalledMeterImageThumbnail,
        newFileName,
      );
    }
  };

  const handleInputChange = async (e, index) => {
    const { name, value } = e.target;

    const updatedDataArray = [...alreadyInstalledRefNos];

    let itemToUpdate = updatedDataArray[index];

    if (!itemToUpdate) {
      itemToUpdate = {
        refNo: "",
        actualFlag: null,
      };
    }

    if (value.length === 14) {
      if (value == dialogRowData.referenceNo) {
        let updatedErrorsArray = alreadyInstalledRefNosErrors;
        updatedErrorsArray[index] =
          `Reference no should be different than the one in RCO application.`;
        setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
        itemToUpdate.actualFlag = false;
        itemToUpdate.arrearsAmount = "";
        itemToUpdate.netBillAmount = "";
        itemToUpdate.billingMonth = "";
      } else {
        let apiResponse = await dBillAPI(token, value);
        if (apiResponse.status) {
          if (parseInt(apiResponse.basicInfo.arrear) > 0) {
            itemToUpdate.actualFlag = true;
            itemToUpdate.arrearsAmount = apiResponse.basicInfo.arrear;
            itemToUpdate.netBillAmount = apiResponse.basicInfo.netBill;
            itemToUpdate.billingMonth =
              apiResponse.basicInfo.billMonth.split("T")[0];
            let updatedErrorsArray = alreadyInstalledRefNosErrors;
            updatedErrorsArray[index] = ``;
            setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
          } else {
            let updatedErrorsArray = alreadyInstalledRefNosErrors;
            updatedErrorsArray[index] =
              `No arrears exist against entered reference no.`;
            setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
            itemToUpdate.actualFlag = false;
            itemToUpdate.arrearsAmount = "";
            itemToUpdate.netBillAmount = "";
            itemToUpdate.billingMonth = "";
          }
        } else {
          let updatedErrorsArray = alreadyInstalledRefNosErrors;
          updatedErrorsArray[index] = `RefNo. doesn't exists!`;
          setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
          itemToUpdate.actualFlag = false;
          itemToUpdate.arrearsAmount = "";
          itemToUpdate.netBillAmount = "";
          itemToUpdate.billingMonth = "";
        }
      }
    } else {
      let updatedErrorsArray = alreadyInstalledRefNosErrors;
      updatedErrorsArray[index] = ``;
      setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
      itemToUpdate.actualFlag = false;
      itemToUpdate.arrearsAmount = "";
      itemToUpdate.netBillAmount = "";
      itemToUpdate.billingMonth = "";
    }

    const updatedItem = {
      ...updatedDataArray[index],
      refNo: value,
      actualFlag: itemToUpdate.actualFlag,
    };
    updatedDataArray[index] = updatedItem;
    fieldFormik.values.iv_default_meters_ref_no_array = updatedDataArray;
    setAlreadyInstalledRefNos(updatedDataArray);
  };

  const openDetailsPopUp = async (stepName) => {
    setViewBackdrop(true);

    if (stepName.applicationProgressId != undefined) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        historyId: stepName.historyId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/getDetailByHistoryId", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            setHistoryData(result.data[0]);
            let histDet = result.data[0];
            if (
              histDet.applicationProgressId == 1 &&
              histDet.objectionStatus == 1
            ) {
              setDocumentsVerifiedSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 1 &&
              histDet.objectionStatus == 0
            ) {
              setDocumentsVerifiedSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 2 &&
              histDet.objectionStatus == 0
            ) {
              setDocumentsVerifiedSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 3 &&
              histDet.objectionStatus == 0
            ) {
              setArrearVerifiedSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 3 &&
              histDet.objectionStatus == 1
            ) {
              setRcoFeeVoucherSubmissionSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 2 &&
              histDet.objectionStatus == 1
            ) {
              setArrearVerifiedSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 4 &&
              histDet.objectionStatus == 0
            ) {
              setRcoFeeVoucherSubmissionSubPopUp(true);
            }

            if (
              histDet.applicationProgressId == 5 &&
              histDet.objectionStatus == 0
            ) {
              setFieldSurveySubPopUp(true);
            }

            if (
              histDet.applicationProgressId == 5 &&
              histDet.objectionStatus == 1
            ) {
              setFieldSurveySubPopUp(true);
            }

            if (
              histDet.applicationProgressId == 6 &&
              histDet.objectionStatus == 0
            ) {
              setFieldSurveySubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 7 &&
              histDet.objectionStatus == 0
            ) {
              setDnApprovalSubPopUp(true);
            }

            if (
              histDet.applicationProgressId == 7 &&
              histDet.objectionStatus == 1
            ) {
              setDnSubmissionSubPopUp(true);
            }

            if (
              histDet.applicationProgressId == 8 &&
              histDet.objectionStatus == 0
            ) {
              setDnSubmissionSubPopUp(true);
            }

            if (
              histDet.applicationProgressId == 9 &&
              histDet.objectionStatus == 0
            ) {
              setRcoFeeVoucherVerificationSubPopUp(true);
            }

            if (
              histDet.applicationProgressId == 10 &&
              histDet.objectionStatus == 0
            ) {
              setMeterInstalationSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 11 &&
              histDet.objectionStatus == 0
            ) {
              setForwardToROSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 12 &&
              histDet.objectionStatus == 0
            ) {
              setreadyForBillingSubPopUp(true);
            }
          }
        })
        .catch((error) => console.error(error));
    }
  };

  const FGovt = (event) => {
    if (refNoAllocationFormik.values.iv_fgovt) {
      refNoAllocationFormik.values.iv_fgovt = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.handleChange(event);
      refNoAllocationFormik.values.iv_fgovt = event.target.value;
    }
    refNoAllocationFormik.values.iv_govt_dept_code = "";
    setGovtDeptCode({ departmentCode: null, departmentName: "" });
  };

  const Contanment = (event) => {
    if (refNoAllocationFormik.values.iv_cantonment_board) {
      refNoAllocationFormik.values.iv_cantonment_board = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.handleChange(event);
      refNoAllocationFormik.values.iv_cantonment_board = event.target.value;
    }
  };

  const LocalBodies = (event) => {
    if (refNoAllocationFormik.values.iv_local_bodies) {
      refNoAllocationFormik.values.iv_local_bodies = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.handleChange(event);
      refNoAllocationFormik.values.iv_local_bodies = event.target.value;
    }
  };

  const PGovt = (event) => {
    if (refNoAllocationFormik.values.iv_pgovt) {
      refNoAllocationFormik.values.iv_pgovt = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.values.iv_pgovt = event.target.value;
      refNoAllocationFormik.handleChange(event);
    }
    refNoAllocationFormik.values.iv_govt_dept_code = "";
    setGovtDeptCode({ departmentCode: null, departmentName: "" });
  };

  const getTariffAndMeterType = async (
    appliedLoad,
    connectionType,
    seasonalNonSeasonal,
    tariffs,
    applicationProgressId,
  ) => {
    let phase = "";
    if (connectionType === "Industrial") {
      if (seasonalNonSeasonal == 1) {
        const seasonalTariff = tariffs.find((item) => item.tariffCode === "F");
        // Check if seasonalTariff is found before setting the state
        if (seasonalTariff) {
          setTariff(seasonalTariff.tariffDesc.split(" ")[0] || "");
          if (applicationProgressId === 4) {
            refNoAllocationFormik.values.iv_tariff_to_allot =
              seasonalTariff.tariffDesc.split(" ")[0] || "";
          }
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariff("");
          console.error("Seasonal tariff not found!");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
        let shortListedTariffsArray = tariffs.filter(
          (item) => item.consumerType === connectionType,
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad,
        );
        let selectedTariff = shortListedTariffsArray[0];
        // Check if seasonalTariff is found before setting the state
        if (selectedTariff) {
          setTariff(selectedTariff.tariffDesc.split(" ")[0] || "");
          if (applicationProgressId === 4) {
            refNoAllocationFormik.values.iv_tariff_to_allot =
              selectedTariff.tariffDesc.split(" ")[0] || "";
          }
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariff("");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      }
    } else {
      if (appliedLoad && appliedLoad > 0 && tariffs) {
        let shortListedTariffsArray = tariffs.filter(
          (item) => item.consumerType === connectionType,
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad,
        );
        setTariff(shortListedTariffsArray[0].tariffDesc.split(" ")[0]);
        if (applicationProgressId === 4) {
          refNoAllocationFormik.values.iv_tariff_to_allot =
            shortListedTariffsArray[0].tariffDesc.split(" ")[0] || "";
        }
        if (parseInt(appliedLoad) < 5) {
          setPhase("Single Phase");
          phase = "Single Phase";
        } else if (appliedLoad >= 5 && appliedLoad < 20) {
          setPhase("3 Phase");
          phase = "3 Phase";
        } else if (appliedLoad >= 20 && appliedLoad < 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad >= 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      } else {
        setPhase("");
        phase = "";
        setTariff("");
      }
    }
    return phase;
  };

  const getTariff = (tariffCode, tariffs) => {
    if (tariffs) {
      let tariff = tariffs.find((item) => item.tariffCode == tariffCode);
      return tariff.tariffName;
    } else {
      return "Tariff Name";
    }
  };

  const handleCloses = () => {
    setNewConnectionPopup(false);
  };

  const rcoHandleClose = () => {
    setRcoPopUp(false);
  };

  const cpHandleClose = () => {
    setCpPopUp(false);
  };

  const errorCloses = () => {
    setError("");
    setFieldSurveyError("");
  };

  const filterOptions = (options, { inputValue }, fields = []) => {
    const trimmedInputValue = inputValue.trim().toLowerCase();
    const inputLength = trimmedInputValue.length;
    let count = 0;

    return inputLength === 0
      ? options
      : options.filter((option) => {
          // Dynamically concatenate the specified fields
          const optionLabel = fields
            .map((field) => option[field])
            .join("")
            .toLowerCase();

          const containsInput = optionLabel.includes(trimmedInputValue);
          const match = containsInput && count < 5; // Limit the number of options shown
          if (match) {
            count += 1;
          }
          return match;
        });
  };

  const calculateTotalAmountOfItems = (arrayOfItems) => {
    return arrayOfItems.reduce((total, item) => total + item.amount, 0);
  };

  const calculateCharges = (arrayOfItems) => {
    const totalAmountofItems = calculateTotalAmountOfItems(arrayOfItems);
    const roundedTotalAmountofItems = roundAmountValue(totalAmountofItems);
    const roundedStoreCharges = Math.floor(
      (roundedTotalAmountofItems * 12 + 50) / 100,
    );
    const installationBase = roundedTotalAmountofItems + roundedStoreCharges;
    const roundedInstallationCharges = Math.floor(
      (installationBase * 8 + 50) / 100,
    );
    return {
      totalAmountofItems: roundedTotalAmountofItems,
      store_charges: roundedStoreCharges,
      installation_charges: roundedInstallationCharges,
    };
  };

  const roundAmountValue = (value) => Math.round(Number(value) || 0);

  const sumRoundedAmounts = (values = []) =>
    values.reduce((total, value) => total + roundAmountValue(value), 0);

  const getCapitalSecurityTotal = (capitalCost, securityDeposit) =>
    sumRoundedAmounts([capitalCost, securityDeposit]);

  const handleFieldSurveySubmit = () => {
    fieldFormik.handleSubmit();
  };

  const normalizeDnAmounts = (dnDetails = {}) => {
    const amountFields = [
      "capitalCostAmount",
      "securityDepositeAmount",
      "amountOfGridSharing",
      "amountOfFeederRehab",
      "civilWorkCharges",
      "fixedChargesOfMetering",
      "miscellaneousCharges",
      "lessTheCost",
      "demandNoticeAmount",
    ];

    const normalizedDnDetails = { ...dnDetails };

    amountFields.forEach((field) => {
      const value = dnDetails?.[field];
      if (value !== null && value !== undefined && value !== "") {
        const numericValue = Number(value);
        if (!Number.isNaN(numericValue)) {
          normalizedDnDetails[field] = Math.round(numericValue);
        }
      }
    });

    return normalizedDnDetails;
  };

  //#endregion

  //#region printing functions

  const downloadDNPDF = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "13",
        );
      } catch (e) {
        console.log(e, "error getting Application details");
      }
    }
    try {
      let dnDets;
      let boqItems;
      let dnExpiryFlag;
      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = normalizeDnAmounts(response.dnDets || {});
        boqItems = response.boqItems;
        dnExpiryFlag = response.dnExpiryFlag;
      });
      if (dnExpiryFlag === "1") {
        setDialogRowData(application);
        setShowDnExpiryPopup(true);
      } else {
        //#region text
        // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
        let officeCode = application.subDivisionCode.toString();
        let officeName = subdivisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
        let authorizedByDesignation = dnDets.approvedByDesignation
          ? dnDets.approvedByDesignation
          : "Role";
        let dateToPrint = dnDets.approvedDate
          ? numberFormatting(new Date(dnDets.approvedDate))
          : "---";
        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint,
        );

        const fontSize = 8;
        const doc = new jsPDF({ compressPdf: true });
        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 200, 55, 40); // Add image to PDF (x, y, width, height)
          doc.addImage(stampData, "PNG", 140, 265, 55, 40); // Add image to PDF (x, y, width, height)
        }

        //#region Line 1
        var padding = 10;
        var line2Height = 10;
        var lineHeightIncreament = 5;
        doc.setFontSize(fontSize);
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          companyName(applicationId.slice(3, 5)).concat(
            application.sanctionedLoad < 15
              ? "(" +
                  applicationId.slice(3, 8) +
                  "-" +
                  subdivisionName(
                    parseInt(application.subDivisionCode),
                    subDivisions,
                  ) +
                  ")"
              : "(" +
                  applicationId.slice(3, 7) +
                  "-" +
                  divisionName(
                    parseInt(application.divisionCode),
                    subDivisions,
                  ) +
                  ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Application Type: ";
        var text4 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";
        var text5 = "(New Connection, Reconnection etc.): ";
        var text6 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "New Alloated Reference No.: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = application.applicantMobileNo
          ? application.applicantMobileNo
          : "-";
        var text5 = "Connection type: ";
        var text6 = application.connectionCategory
          ? application.connectionCategory
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 7;
        var text1 =
          "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
        var text2 = "Type of Industry / Factory:";
        var text3 = dnDets.industryFactoryType
          ? dnDets.industryFactoryType
          : "-";

        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        doc.setFontSize(fontSize);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );

        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = dnDets.bankName ? dnDets.bankName : "-";
        var text3 = "Required Load (kW): ";
        var text4 = application.sanctionedLoad
          ? application.sanctionedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "Tariff: ";
        var text4 = dnDets.tariff ? dnDets.tariff : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 9

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(relativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        //#region Line 14
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the department.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 15
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of your payment.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[word1]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;
        var text2 = dnDets.capitalCostAmount
          ? numberFormatting(dnDets.capitalCostAmount)
          : "";
        var text3 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text2, 90, line2Height);
        doc.text(text3, 130, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            dnDets.capitalCostAmount
              ? numberFormatting(dnDets.capitalCostAmount)
              : "",
          );
          lineText = lineText.replace(
            "[securityCost]",
            dnDets.securityDepositeAmount
              ? numberFormatting(dnDets.securityDepositeAmount)
              : "",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }

        //#endregion

        //#region Line 17
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 18
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 19
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfDays]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 20
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `3. Since you have not provided your purchased meter to the department for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 21
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        // //#region Line 24
        // doc.setFontSize(fontSize);
        // var text1 = `Regards`;
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   application.sanctionedLoad < 15
        //     ? "Sub-Division Office " +
        //       applicationId.slice(3, 8) +
        //       "-" +
        //       subdivisionName(
        //         parseInt(application.subDivisionCode),
        //         subDivisions,
        //       ) +
        //       " SDO " +
        //       companyShortName(DiscoCode)
        //     : "Division Office " +
        //       applicationId.slice(3, 7) +
        //       " - " +
        //       divisionName(parseInt(application.divisionCode), subDivisions) +
        //       " XEN MEPCO";
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        // var text2 =
        //   application.sanctionedLoad < 15
        //     ? "Line Superintendent Office" +
        //       "(" +
        //       applicationId.slice(3, 8) +
        //       " - " +
        //       subdivisionName(
        //         parseInt(application.subDivisionCode),
        //         subDivisions,
        //       ) +
        //       ") SDO " +
        //       companyShortName(DiscoCode)
        //     : "Line Superintendent Office" +
        //       "(" +
        //       applicationId.slice(3, 7) +
        //       " - " +
        //       divisionName(parseInt(application.divisionCode), subDivisions) +
        //       ") XEN MEPCO";
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var bankRelationType = application.applicantRelationType;
        var bankRelationTypeText =
          bankRelationType == 1 || bankRelationType == "S/O"
            ? "S/O"
            : bankRelationType == 2 || bankRelationType == "D/O"
              ? "D/O"
              : bankRelationType == 3 || bankRelationType == "W/O"
                ? "W/O"
                : bankRelationType == 4 || bankRelationType == "C/O"
                  ? "C/O"
                  : "";
        var bankRelativePart = application.applicantRelativeName
          ? ` ${bankRelationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(bankRelativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = `Details of paid amount`;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        var text5 = "1. Service Connection:";
        var text6 = dnDets.capitalCostAmount
          ? numberFormatting(dnDets.capitalCostAmount)
          : "-";
        var leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 32
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "3. Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Date: ";
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text5 = "2. Security: ";
        var text6 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "-";
        var leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 33
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "4. Account No. for acquisition connection: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = " ";
        var text4 = " ";
        var text5 = "3. Grid Share / Feeder Rehab. Charges:";
        var text6 = dnDets.amountOfGridSharing
          ? numberFormatting(dnDets.amountOfGridSharing)
              .concat(" / ")
              .concat(
                dnDets.amountOfFeederRehab
                  ? numberFormatting(dnDets.amountOfFeederRehab)
                  : "-",
              )
          : "-"
              .concat(" / ")
              .concat(
                dnDets.amountOfFeederRehab
                  ? numberFormatting(dnDets.amountOfFeederRehab)
                  : "-",
              );
        var leftSpace = 10;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = dnDets.bankName ? dnDets.bankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 =
          application.sanctionedLoad < 15
            ? "                                                                                 "
            : "                                                                                  ";
        // var text1 = application.sanctionedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = "Signature Bank Officer ";
        var leftSpace = 20;
        doc.text(text1, padding, line2Height);
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            numberFormatting(dnDets.capitalCostAmount),
          );
          lineText = lineText.replace(
            "[securityCost]",
            numberFormatting(dnDets.securityDepositeAmount),
          );
          lineText = lineText.replace(
            "[bankName]",
            dnDets.bankName ? dnDets.bankName : "-",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 40
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 41
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 42
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 43
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 44
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Application Id: ";
        var text4 = applicationId ? applicationId : "-";
        var text5 = "Application Form No.: ";
        var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 45
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Amount to be paid: ";
        var text4 =
          dnDets.capitalCostAmount || dnDets.securityDepositeAmount
            ? numberFormatting(
                getCapitalSecurityTotal(
                  dnDets.capitalCostAmount,
                  dnDets.securityDepositeAmount,
                ),
              )
            : "-";
        var text5 = " ";
        var text6 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 46
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament / 2;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = application.sanctionedLoad < 15 ? " " : " ";
        var leftSpace = 110;
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.addImage(
            getWaterMarkLogo(userCompany),
            "PNG",
            0,
            0,
            doc.internal.pageSize.getWidth(),
            doc.internal.pageSize.getHeight(),
          );
        }

        const pdfBlob = doc.output("blob");
      const fileName = `${applicationId}-Demand-Note.pdf`;
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL + '#' + fileName, fileName);

        //#endregion
      }
    } catch (e) {
      console.log("Unable to generate Master Data Form!");
      console.log(e);
    }
    setViewBackdrop(false);
  };

  const downloadRCOFeePDF = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "13",
        );
      } catch (e) {
        console.log(e, "error getting Application details");
      }
    }
    try {
      let rcoVoucherDets;
      let rcoVoucherExpiryFlag;
      await callAsyncGetRCOFeeVoucherAPI(applicationId).then((response) => {
        rcoVoucherDets = response.rcoVoucherDets;
        rcoVoucherExpiryFlag = response.rcoVoucherExpiryFlag;
      });

      if (rcoVoucherExpiryFlag == 1) {
        setShowRcoExpiryPopup(true);
      } else {
        //#region text
        // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
        let officeCode = application.divisionCode.toString();
        let officeName = divisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = rcoVoucherDets.approvedByDesignation;
        let authorizedByDesignation = rcoVoucherDets.rcoFeeVoucherApprovedBy
          ? rcoVoucherDets.rcoFeeVoucherApprovedBy
          : "-";
        let dateToPrint = rcoVoucherDets.issueDate
          ? numberFormatting(new Date(rcoVoucherDets.issueDate))
          : "---";
        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint,
        );

        const fontSize = 8;
        const doc = new jsPDF({ compressPdf: true });
        if (rcoVoucherDets.issueDate) {
          doc.addImage(stampData, "PNG", 20, 100, 55, 40); // Add image to PDF (x, y, width, height)
          doc.addImage(stampData, "PNG", 140, 185, 55, 40); // Add image to PDF (x, y, width, height)
        }

        //#region Line 1
        var padding = 10;
        var line2Height = 10;
        var lineHeightIncreament = 5;
        doc.setFontSize(fontSize);
        doc.text(
          "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          companyName(applicationId.slice(3, 5)).concat(
            application.sanctionedLoad < 15
              ? "(" +
                  applicationId.slice(3, 8) +
                  "-" +
                  subdivisionName(
                    parseInt(application.subDivisionCode),
                    subDivisions,
                  ) +
                  ")"
              : "(" +
                  applicationId.slice(3, 7) +
                  "-" +
                  divisionName(
                    parseInt(application.divisionCode),
                    subDivisions,
                  ) +
                  ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "RCO Voucher Serial No.: ";
        var text2 = rcoVoucherDets.applicationId;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Voucher Issuance Date: ";
        var text2 = rcoVoucherDets.issueDate
          ? convertDate(rcoVoucherDets.issueDate)
          : "-";
        var text3 = "Application Type: ";
        var text4 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";
        var text5 = "(New Connection, Reconnection etc.): ";
        var text6 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "Reference No.: ";
        var text2 = application.referenceNo ? application.referenceNo : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = application.applicantMobileNo
          ? application.applicantMobileNo
          : "-";
        var text5 = "Connection type: ";
        var text6 = application.connectionCategory
          ? application.connectionCategory
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 7;
        var text1 =
          "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
        var text2 = " ";
        var text3 = " ";

        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        doc.setFontSize(fontSize);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );

        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-";
        var text3 = "Sanctioned Load (kW): ";
        var text4 = application.sanctionedLoad
          ? application.sanctionedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "Tariff: ";
        var text4 = application.tariffCode ? application.tariffCode : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "RCO Fee Voucher",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(relativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        //#region Line 14
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `You are hereby informed that your application for reconnection whose particulars are mentioned above has been approved by the system on the following conditions.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 15
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `1. You should deposit the following amounts in the approved bank of the RO Office department within [word1] days from the date of issue of this notice and inform the office with the receipt number and date of your payment.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[word1]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Ree Connection Fee as per CSM ______________ PKR. (this amount is to be deposited in the department's approved bank).`;
        var text2 = rcoVoucherDets.rcoFeeAmount
          ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
          : "0";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text2, 60, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[rcoFeeAmount]",
            rcoVoucherDets.rcoFeeAmount
              ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
              : "0",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the RCO fee voucher within the prescribed period, your application form for reconnection will not be considered with the serial number allotted. RCO Fee Voucher thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        // //#region Line 24
        // doc.setFontSize(fontSize);
        // var text1 = `Regards`;
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   "Revenue Office " +
        //   applicationId.slice(3, 7) +
        //   "-" +
        //   divisionName(parseInt(application.divisionCode), subDivisions);
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        var text2 =
          "Account Section" +
          "(" +
          applicationId.slice(3, 7) +
          " - " +
          divisionName(parseInt(application.divisionCode), subDivisions) +
          ") RO MEPCO";
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the RCO Voucher and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var text2 = application.consumerName
          ? application.consumerName
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = `Details of paid amount`;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        var text5 = "1. Fee Voucher Amount:";
        var text6 = rcoVoucherDets.rcoFeeAmount
          ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
          : "0";
        var leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 32
        doc.setFontSize(fontSize);
        line2Height = line2Height + lineHeightIncreament;

        var lineSpace = 6.6;

        // --- RCO Fee Voucher No ---
        var text1 = "3. RCO Fee Voucher No.: ";
        var text2 = rcoVoucherDets.applicationId
          ? rcoVoucherDets.applicationId
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          padding + doc.getTextWidth(text1) + lineSpace,
          line2Height,
        );
        doc.line(
          padding + doc.getTextWidth(text1),
          line2Height + 1,
          padding +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            lineSpace * 2,
          line2Height + 1,
        );

        // --- Date ---
        var text3 = "Date: ";
        var text4 = rcoVoucherDets.issueDate
          ? convertDate(rcoVoucherDets.issueDate)
          : "-";

        let dateX =
          padding +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          lineSpace * 3;

        doc.text(text3, dateX, line2Height);
        doc.text(
          text4,
          dateX + doc.getTextWidth(text3) + lineSpace,
          line2Height,
        );
        doc.line(
          dateX + doc.getTextWidth(text3),
          line2Height + 1,
          dateX +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 33
doc.setFontSize(fontSize);

// fix: don't redeclare same variable name
line2Height = line2Height + lineHeightIncreament;

const refLabel = "4. Reference No.: ";
const refValue = application.referenceNo ? application.referenceNo : "-";

// print label
doc.text(refLabel, padding, line2Height);

// calculate positions
const startX = doc.getTextWidth(refLabel) + padding;
const valueX = startX + lineSpace;

// print value
doc.text(refValue, valueX, line2Height);

// draw underline only for value
doc.line(
  startX,
  line2Height + 1,
  valueX + doc.getTextWidth(refValue) + lineSpace,
  line2Height + 1
);
//#endregion
        
//#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 =
          application.sanctionedLoad < 15
            ? "                                                                                 "
            : "                                                                                  ";
        // var text1 = application.sanctionedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = "Signature Bank Officer ";
        var leftSpace = 20;
        doc.text(text1, padding, line2Height);
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);

        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;

        // Updated text without fixed charges
        var text1 = `1. I/We have submitted the RCO Fee Voucher of [rcoFeeAmount] only in the department's approved bank [roBankName] by receipt no. _______________________________________ on date _______________________________.`;

        var lines = doc.splitTextToSize(text1, maxWidth);

        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[rcoFeeAmount]",
            rcoVoucherDets.rcoFeeAmount
              ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
              : "0",
          );

          lineText = lineText.replace(
            "[roBankName]",
            rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-",
          );

          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated Fee Voucher, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said application is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.addImage(
            getWaterMarkLogo(userCompany),
            "PNG",
            0,
            0,
            doc.internal.pageSize.getWidth(),
            doc.internal.pageSize.getHeight(),
          );
        }

        const pdfBlob = doc.output("blob");
        const pdfDataUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfDataUrl, "_blank");

        //#endregion
      }
    } catch (e) {
      console.log("Unable to generate Master Data Form!");
      console.log(e);
    }
    setViewBackdrop(false);
  };

  const downloadFixedChargesPDF = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "13",
        );
      } catch (e) {
        console.log(e, "error getting Application details");
      }
    }
    try {
      let rcoVoucherDets;
      let rcoVoucherExpiryFlag;
      await callAsyncGetRCOFeeVoucherAPI(applicationId).then((response) => {
        rcoVoucherDets = response.rcoVoucherDets;
        rcoVoucherExpiryFlag = response.rcoVoucherExpiryFlag;
      });

      if (rcoVoucherExpiryFlag == 1) {
        setShowRcoExpiryPopup(true);
      } else {
        //#region text
        // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
        let officeCode = application.divisionCode.toString();
        let officeName = divisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = rcoVoucherDets.approvedByDesignation;
        let authorizedByDesignation = rcoVoucherDets.rcoFeeVoucherApprovedBy
          ? rcoVoucherDets.rcoFeeVoucherApprovedBy
          : "-";
        let dateToPrint = rcoVoucherDets.issueDate
          ? numberFormatting(new Date(rcoVoucherDets.issueDate))
          : "---";
        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint,
        );

        const fontSize = 8;
        const doc = new jsPDF({ compressPdf: true });
        if (rcoVoucherDets.issueDate) {
          doc.addImage(stampData, "PNG", 20, 100, 55, 40); // Add image to PDF (x, y, width, height)
          doc.addImage(stampData, "PNG", 140, 185, 55, 40); // Add image to PDF (x, y, width, height)
        }

        //#region Line 1
        var padding = 10;
        var line2Height = 10;
        var lineHeightIncreament = 5;
        doc.setFontSize(fontSize);
        doc.text(
          "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          companyName(applicationId.slice(3, 5)).concat(
            application.sanctionedLoad < 15
              ? "(" +
                  applicationId.slice(3, 8) +
                  "-" +
                  subdivisionName(
                    parseInt(application.subDivisionCode),
                    subDivisions,
                  ) +
                  ")"
              : "(" +
                  applicationId.slice(3, 7) +
                  "-" +
                  divisionName(
                    parseInt(application.divisionCode),
                    subDivisions,
                  ) +
                  ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "RCO Voucher Serial No.: ";
        var text2 = rcoVoucherDets.applicationId;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Voucher Issuance Date: ";
        var text2 = rcoVoucherDets.issueDate
          ? convertDate(rcoVoucherDets.issueDate)
          : "-";
        var text3 = "Application Type: ";
        var text4 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";
        var text5 = "(New Connection, Reconnection etc.): ";
        var text6 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "Reference No.: ";
        var text2 = application.referenceNo ? application.referenceNo : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = application.applicantMobileNo
          ? application.applicantMobileNo
          : "-";
        var text5 = "Connection type: ";
        var text6 = application.connectionCategory
          ? application.connectionCategory
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 7;
        var text1 =
          "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
        var text2 = " ";
        var text3 = " ";

        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        doc.setFontSize(fontSize);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            padding +
            lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text3) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-";
        var text3 = "Sanctioned Load (kW): ";
        var text4 = application.sanctionedLoad
          ? application.sanctionedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "Tariff: ";
        var text4 = application.tariffCode ? application.tariffCode : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "RCO Fee Voucher",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(relativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        //#region Line 14
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `You are hereby informed that your application for reconnection whose particulars are mentioned above has been approved by the system on the following conditions.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 15
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `1. You should deposit the following amounts in the approved bank of the RO Office department within [word1] days from the date of issue of this notice and inform the office with the receipt number and date of your payment.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[word1]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Fixed Charges _______________ PKR. (this amount is to be deposited in the department's approved bank).`;
        var text3 = rcoVoucherDets.fixedChargesAmount
          ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
          : "0";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text3, 35, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[fixedChargesAmount]",
            rcoVoucherDets.fixedChargesAmount
              ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
              : "0",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the RCO fee voucher within the prescribed period, your application form for reconnection will not be considered with the serial number allotted. RCO Fee Voucher thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        // //#region Line 24
        // doc.setFontSize(fontSize);
        // var text1 = `Regards`;
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   "Revenue Office " +
        //   applicationId.slice(3, 7) +
        //   "-" +
        //   divisionName(parseInt(application.divisionCode), subDivisions);
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        var text2 =
          "Account Section" +
          "(" +
          applicationId.slice(3, 7) +
          " - " +
          divisionName(parseInt(application.divisionCode), subDivisions) +
          ") RO MEPCO";
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the RCO Voucher and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var text2 = application.consumerName
          ? application.consumerName
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = `Details of paid amount`;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion
        //#region Line 32
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "3. RCO Fee Voucher No.: ";
        var text2 = rcoVoucherDets.applicationId
          ? rcoVoucherDets.applicationId
          : "-";
        var text3 = "Date: ";
        var text4 = rcoVoucherDets.issueDate
          ? convertDate(rcoVoucherDets.issueDate)
          : "-";
        var text5 = "1. Fixed Charges: ";
        var text6 = rcoVoucherDets.fixedChargesAmount
          ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
          : "0";
        var leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

         //#region Line 33
doc.setFontSize(fontSize);

// fix: don't redeclare same variable name
line2Height = line2Height + lineHeightIncreament;

const refLabel = "4. Reference No.: ";
const refValue = application.referenceNo ? application.referenceNo : "-";

// print label
doc.text(refLabel, padding, line2Height);

// calculate positions
const startX = doc.getTextWidth(refLabel) + padding;
const valueX = startX + lineSpace;

// print value
doc.text(refValue, valueX, line2Height);

// draw underline only for value
doc.line(
  startX,
  line2Height + 1,
  valueX + doc.getTextWidth(refValue) + lineSpace,
  line2Height + 1
);
//#endregion
        
        //#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 =
          application.sanctionedLoad < 15
            ? "                                                                                 "
            : "                                                                                  ";
        // var text1 = application.sanctionedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = "Signature Bank Officer ";
        var leftSpace = 20;
        doc.text(text1, padding, line2Height);
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `1. I/We have submitted the fixed Charges of [fixedChargesAmount] only in the department's approved bank [roBankName] by receipt no. _______________________________________ on date _______________________________.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[fixedChargesAmount]",
            rcoVoucherDets.fixedChargesAmount
              ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
              : "0",
          );
          lineText = lineText.replace(
            "[roBankName]",
            rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated Fee Voucher, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said application is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.addImage(
            getWaterMarkLogo(userCompany),
            "PNG",
            0,
            0,
            doc.internal.pageSize.getWidth(),
            doc.internal.pageSize.getHeight(),
          );
        }

        const pdfBlob = doc.output("blob");
        const pdfDataUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfDataUrl, "_blank");

        //#endregion
      }
    } catch (e) {
      console.log("Unable to generate Master Data Form!");
      console.log(e);
    }
    setViewBackdrop(false);
  };

  const downloadRCOPDF = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "1",
        );
      } catch (e) {
        console.log(e, "error in getting application details");
      }
    }
    try {
      let rcoDets;

      await callAsyncGetRCOAPI(applicationId).then((response) => {
        rcoDets = response;
      });

      let dnDets;
      let boqItems;
      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = response.dnDets;
        boqItems = response.boqItems;
      });

      let application = reconnectionApplications.find(
        (item) => item.applicationId === applicationId,
      );
      let officeCode = application.subDivisionCode.toString();
      let officeName = subdivisionName(parseInt(officeCode), subDivisions);
      let authorizedByName = rcoDets.authorizedByName
        ? rcoDets.authorizedByName
        : "---";
      let authorizedByDesignation = rcoDets.authorizedByDesignation
        ? rcoDets.authorizedByDesignation
        : "---";
      let rcoP2ApprovedBy = rcoDets.rcoP2ApprovedBy
        ? rcoDets.rcoP2ApprovedBy
        : "---";
      let rcoP2ApprovedByDesignation = rcoDets.rcoP2ApprovedByDesignation
        ? rcoDets.rcoP2ApprovedByDesignation
        : "Role";
      let dateOfAuthorization = rcoDets.dateOfAuthorization
        ? new Date(rcoDets.dateOfAuthorization).toLocaleDateString()
        : "---";
      let rcoP2ApprovalDate = rcoDets.rcoP2ApprovalDate
        ? new Date(rcoDets.rcoP2ApprovalDate).toLocaleDateString()
        : "---";
      let part1StampData = printStamp(
        officeCode,
        officeName,
        authorizedByName,
        authorizedByDesignation,
        dateOfAuthorization,
      );
      let part2StampData = printStamp(
        officeCode,
        officeName,
        rcoP2ApprovedBy,
        rcoP2ApprovedByDesignation,
        rcoP2ApprovalDate,
      );

      const fontSize = 9;
      //#region text
      const doc = new jsPDF({ compressPdf: true });
      // Add image to PDF
      if (rcoDets.authorizedByName) {
        doc.addImage(part1StampData, "PNG", 145, 70, 55, 40); // Add image to PDF (x, y, width, height)
      }
      if (rcoDets.rcoP2ApprovedBy) {
        doc.addImage(part2StampData, "PNG", 145, 230, 55, 40); // Add image to PDF (x, y, width, height)
      }
      //#region Line 1
      var padding = 10;
      var line2Height = 10;
      var lineHeightIncreament = 6;
      doc.setFontSize(fontSize);
      doc.text(
        companyName(applicationId.slice(3, 5)),
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 2
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "Service Connection Order (RCO)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 3
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "1. Sub Division: ";
      var text2 = application.subDivisionCode
        ? application.subDivisionCode
            .toString()
            .concat(" / ")
            .concat(subdivisionName(application.subDivisionCode, subDivisions))
        : "-";
      var text3 = "RCO No.: ";
      var text4 = rcoDets.rcoId ? rcoDets.rcoId : "-";
      var text5 = "Creation Date: ";
      var text6 = rcoDets.dateOfAuthorization
        ? convertDate(rcoDets.dateOfAuthorization)
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );
      //#endregion

      //#region Line 4
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 2;
      var text1 = "2. Application No.: ";
      var text2 = application.applicationId ? application.applicationId : "-";
      var text3 = "Date: ";
      var text4 = application.creationDate
        ? convertDate(application.creationDate)
        : "-";
      var text5 = "Tariff: ";
      var text6 = dnDets.tariff ? dnDets.tariff : "-";
      var text7 = rcoDets.fataPata ? rcoDets.fataPata : "-";
      var text8 = rcoDets.urbanRural ? rcoDets.urbanRural : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );
      doc.text(
        text7,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          padding +
          lineSpace * 7,
        line2Height,
      );
      doc.text(
        text8,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 8,
        line2Height,
      );
      //#endregion

      //#region Line 5
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "3. Account No.: ";
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
      var text3 = "Feeder No.: ";
      var text4 = rcoDets.feederNo ? rcoDets.feederNo : "-";
      var text5 = "Batch: ";
      var text6 = rcoDets.batch ? rcoDets.batch : "-";
      var text7 = "Sub Batch: ";
      var text8 = rcoDets.subBatch ? rcoDets.subBatch : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );

      doc.text(
        text7,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          padding +
          lineSpace * 6,
        line2Height,
      );
      doc.text(
        text8,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 7,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 6,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 6 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );

      //#endregion

      //#region Line 6
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `4. Applicant's Name: `;
      var text2 = application.applicantName ? application.applicantName : "-";
      var text3 = "CNIC/NIC/NICOP: ";
      var text4 = application.applicantCNIC ? application.applicantCNIC : "-";
      var leftSpace = 50;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 7
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `5. Address: `;
      var text2 = application.premisesAddress
        ? application.premisesAddress
        : "-";
      var text3 = "Mobile No.: ";
      var text4 = application.applicantMobile
        ? application.applicantMobile
        : "-";
      var leftSpace = 50;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 8
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `6. Service Connection Cost DN No.: `;
      var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
      var text3 = "Issuance Date: ";
      var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var leftSpace = 35;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 9
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `7. Security Deposit DN No.: `;
      var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
      var text3 = "Issuance Date: ";
      var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var leftSpace = 47;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 10
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `8. Amount of Service Connection: `;
      var text2 = dnDets.capitalCostAmount
        ? numberFormatting(dnDets.capitalCostAmount)
        : "-";
      var text3 = "Payment Date: ";
      var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : "-";
      var leftSpace = 52;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 11
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `9. Amount of Security Deposit: `;
      var text2 = dnDets.securityDepositeAmount
        ? numberFormatting(dnDets.securityDepositeAmount)
        : "-";
      var text3 = "Payment Date: ";
      var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : "-";
      var leftSpace = 56.5;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 12
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "10. F. Govt / Autonomous and Local Bodies under Prov. Govt.: ";
      var text2 = rcoDets.fGovt ? rcoDets.fGovt : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 13
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "11. Cantonment Board: ";
      var text2 = rcoDets.cantonmentBoard ? rcoDets.cantonmentBoard : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 14
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "12. Prov. Govt / Autonomous and Local Bodies under Prov Govt.: ";
      var text2 = rcoDets.pGovt ? rcoDets.pGovt : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 15
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "13. Local Bodies: ";
      var text2 = rcoDets.localBodies ? rcoDets.localBodies : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 16
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `14. Authorized By (Name): `;
      var text2 = rcoDets.authorizedByName ? rcoDets.authorizedByName : "-";
      var text3 = "Stamp: ______________________";
      var leftSpace = 62;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      // doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      //#endregion

      //#region Line 17
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      // var text1 = 'Authorization Date: '
      var text1 = " ";
      var text2 = " ";
      // var text2 = rcoDets.dateOfAuthorization ? convertDate(rcoDets.dateOfAuthorization) : '-'
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace + leftSpace,
        line2Height,
      );
      // doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
      //#endregion

      //#region Line 18
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      // var text1 = 'Designation: __________________________'
      var text1 = "  ";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 19
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      // var text1 = 'Stamp: ______________________________'
      var text1 = " ";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 20
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `15. Store Requisition No.: `;
      var text2 = rcoDets.storeRequisitionNo
        ? numberFormatting(rcoDets.storeRequisitionNo)
        : "-";
      var text3 = "Requisition Date: ";
      var text4 = rcoDets.storeRequisitionDate
        ? convertDate(rcoDets.storeRequisitionDate)
        : "-";
      var leftSpace = 56.5;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 21
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "16. Nature as per Standard Classification Code Booklet: ";
      var text2 = dnDets.tariff ? dnDets.tariff : "-";

      doc.text(text1, padding, line2Height);
      doc.text(text2, doc.getTextWidth(text1) + padding, line2Height);
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 22
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `17. Seasonal/Non-Seasonal: `;
      var text2 = rcoDets.seasonalFlag ? rcoDets.seasonalFlag.toString() : "-";
      var text3 = "Sanctioned Load: ";
      var text4 = dnDets.sanctionLoad ? dnDets.sanctionLoad.toString() : "-";
      var leftSpace = 74;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 23
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `18. No. of meters: `;
      var text2 = rcoDets.noOfMeters ? rcoDets.noOfMeters.toString() : "-";
      var text3 = "No. of AC/Centrally Air Conditioned Code: ";
      var text4 = rcoDets.noOfACs ? rcoDets.noOfACs.toString() : "-";
      var leftSpace = 57;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 24
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var leftSpace = 18;
      var text1 = "19. No. of meter sets: ";
      var text2 = rcoDets.noOfMeterSets
        ? rcoDets.noOfMeterSets.toString()
        : "-";
      var text3 = "No. of sub sets: ";
      var text4 = rcoDets.noOfSubSets ? rcoDets.noOfSubSets.toString() : "-";
      var text5 = "No. of supply points: ";
      var text6 = rcoDets.noOfSupplyPoints
        ? rcoDets.noOfSupplyPoints.toString()
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          leftSpace * 2,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace * 2,
        line2Height + 1,
      );
      //#endregion

      //#region Line 25
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "20. Transformer Code: ";
      var text2 = rcoDets.installedTransformerCapacity
        ? rcoDets.installedTransformerCapacity.toString()
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 26
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "21. Meter Id: ";
      var text2 = rcoDets.meterId ? rcoDets.meterId.toString() : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 27
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "22. Meter Number: ";
      var text2 = rcoDets.meterNo ? rcoDets.meterNo.toString() : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 28
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "23. Location Code: ";
      var text2 = rcoDets.locationCode ? rcoDets.locationCode.toString() : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 29
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "24. Meter Code: ";
      var text2 = rcoDets.meterCode ? rcoDets.meterCode.toString() : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 30
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "25. Manufacturer Code: ";
      var text2 = rcoDets.manufacturerCode
        ? rcoDets.manufacturerCode.toString()
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 31
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "26. Multiplying Factor:: ";
      var text2 = rcoDets.multiplyingFactor
        ? rcoDets.multiplyingFactor.toString()
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 32
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "27. Meter Range: ";
      var text2 = rcoDets.meterRange ? rcoDets.meterRange.toString() : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 33
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "28. Meter Reading: ";
      var text2 = rcoDets.meterReading ? rcoDets.meterReading.toString() : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 34
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "Note: Where sets are more than one give information (18 to 25) of remaining set on reverse.",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 35
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `29. Date of Connection: `;
      var text2 = rcoDets.dateOfReConnection
        ? convertDate(rcoDets.dateOfReConnection)
        : "-";
      var text3 = "Cp-79 item No.: ";
      var text4 = rcoDets.cp78ItemNo ? rcoDets.cp78ItemNo.toString() : "-";
      var leftSpace = 56.5;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      // //#region Line 36 // Removed by Shafiq sb
      // var line2Height = line2Height + lineHeightIncreament
      // var lineSpace = 10
      // var leftSpace = 35
      // var text1 = '30. Meter Rent: '
      // var text2 = dnDets.meterRent ? numberFormatting(dnDets.meterRent) : '-'
      // var text3 = 'Service Rent: '
      // var text4 = dnDets.serviceRent ? numberFormatting(dnDets.serviceRent) : '-'
      // var text5 = rcoDets.tieUpNonTieUp ? rcoDets.tieUpNonTieUp === 0 ? 'Non-Tie Up' : 'Tie Up' : '-'

      // doc.text(text1, padding, line2Height);
      // doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      // doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
      // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
      // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

      // doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      // //#endregion

      //#region Line 37
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "31. Signature of Consumer in Token of Installation of Connection: ____________________________________________________ ";

      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 38
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "32. Signature of Consumer in Token of Receipt of Meter Reading Card: ________________________________________________ ";

      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 39
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "33. Seal on the meter: ";
      var text2 = rcoDets.sealOnMeter ? rcoDets.sealOnMeter : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 40
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "34. Seal on the box: ";
      var text2 = rcoDets.sealOnBox ? rcoDets.sealOnBox : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 41
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "34-A. Security Slip / Price Bond No.: ";
      var text2 = rcoDets.securitySlipOrPriceBondNo
        ? rcoDets.securitySlipOrPriceBondNo.toString()
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 42
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "35. Connection Installed By: ";
      var text2 = rcoDets.connectionInstallerName
        ? rcoDets.connectionInstallerName
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 43
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "Signature: __________________________";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 44
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "Designation: ________________________";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 45
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "Stamp: ____________________________";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 46
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "UserName: ";

      doc.text(text1, padding, line2Height);
      doc.text(userId, padding + doc.getTextWidth(text1), line2Height);
      //#endregion

      //#endregion

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);

      // Open the PDF in a new tab
      window.open(pdfDataUrl, "_blank");
    } catch (e) {
      console.log("Unable to generate Master Data Form!", e);
    }
    setViewBackdrop(false);
  };

  const downloadMasterData = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "1",
        );
        console.log("calling sub diviison code");
      } catch (e) {
        console.log(e, "Error getting application info");
      }
    }

    try {
      let dnDets, boqItems, rcoDets, masterDataFormDets;

      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = response.dnDets;
        boqItems = response.boqItems;
      });

      await callAsyncGetRCOAPI(applicationId).then((response) => {
        rcoDets = response;
      });

      await callAsyncGetCP136API(applicationId).then((response) => {
        masterDataFormDets = response;
      });

      //#region text
      const doc = new jsPDF({ compressPdf: true });
      doc.setFontSize(10);
      doc.text(
        "MASTER DATA ADDITION / CHANGE FORM",
        doc.internal.pageSize.getWidth() / 2,
        10,
        {
          align: "center",
        },
      );
      doc.text(
        application.connectionType != "Domestic" &&
          application.connectionType != "Commercial"
          ? "(For MDI Consumer Only)"
          : "(For General Consumer Only)",
        doc.internal.pageSize.getWidth() / 2,
        15,
        {
          align: "center",
        },
      );
      doc.setFontSize(8);
      doc.text(
        "Name & Address of Consumer",
        doc.internal.pageSize.getWidth() / 2,
        100,
        {
          align: "center",
        },
      );
      doc.setFontSize(8);
      doc.text("Meter Information", doc.internal.pageSize.getWidth() / 2, 140, {
        align: "center",
      });
      if (phase != "Single Phase" && phase != "3 Phase") {
        doc.text(
          "Reading Information",
          doc.internal.pageSize.getWidth() / 2,
          180,
          {
            align: "center",
          },
        );
      }
      doc.setFontSize(8);
      doc.text("Reason: Reconnection", 20, 240, {});
      //#endregion

      // Set default properties for the table
      const tableProps1 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      // const header = [[{ colSpan: 3, content: 'Reference Number' }, { rowSpan: 2, content: 'Sub Batch' }, { rowSpan: 2, content: 'Tariff Code' }, { colSpan: 2, content: 'Application Registration' }, { colSpan: 2, content: 'Security Deposit' }]];

      const header1 = [
        [
          { colSpan: 3, content: ["Reference Number"] },
          { colSpan: 1, rowSpan: 2, content: ["Sub Batch"] },
          { rowSpan: 2, content: ["Tariff Code"] },
          { colSpan: 2, content: "Application Registration" },
          { colSpan: 2, content: "Security Deposit" },
        ],
      ];

      const data1 = [
        [
          "Batch #",
          "Sub Div.",
          "Account Number",
          "",
          "",
          "Number",
          "Date",
          "Amount",
          "Date",
        ],
        [
          dnDets.batchNo ? dnDets.batchNo : "-",
          application.subDivisionCode
            ? application.subDivisionCode.toString()
            : "-",
          dnDets.consumerAccountNo ? dnDets.consumerAccountNo.toString() : "-",
          rcoDets.subBatch ? rcoDets.subBatch.toString() : "-",
          dnDets.tariff ? dnDets.tariff.toString().slice(0, 7) : "-",
          dnDets.tariff
            ? dnDets.tariff
                .toString()
                .slice(0, 1)
                .concat(application.applicationId.slice(4))
            : "-",
          application.creationDate
            ? convertDate(application.creationDate)
            : "-",
          dnDets.securityDepositeAmount
            ? numberFormatting(dnDets.securityDepositeAmount)
            : "-",
          dnDets.issueDate ? convertDate(dnDets.issueDate) : "-",
        ],
      ];

      doc.autoTable({
        startY: 20,
        head: header1,
        body: data1,
        theme: "grid",
        ...tableProps1,
      });

      // Set default properties for the table
      const tableProps2 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header2 = [
        [
          { rowSpan: 2, content: ["Date of Connection"] },
          { rowSpan: 2, content: ["Sanctioned Load"] },
          { colSpan: 8, content: ["Codes"] },
        ],
      ];

      const data2 = [
        [
          "",
          "",
          "R/U",
          "F/P",
          "Seasonal",
          "Transformer Code",
          "Electricity Duty",
          "Government Department",
          "Standard Classification",
          "Income Tax",
        ],
        [
          rcoDets.dateOfReConnection,
          rcoDets.sanctionedLoad,
          rcoDets.urbanRural,
          rcoDets.fataPata,
          rcoDets.seasonalFlag,
          rcoDets.installedTransformerCapacity,
          masterDataFormDets.electricityDuty,
          masterDataFormDets.governmentDepartment,
          masterDataFormDets.standardClassificationCode,
          masterDataFormDets.incomeTax,
        ],
      ];

      doc.autoTable({
        startY: 50,
        head: header2,
        body: data2,
        theme: "grid",
        ...tableProps2,
      });

      // Set default properties for the tables
      const tableProps3 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellWidth: 30,
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header3 = [["National Identity Card No."]];
      const data3 = [[application.applicantCNIC]];

      doc.autoTable({
        head: header3,
        startY: 80,
        body: data3,
        theme: "grid",
        tableWidth: 80,
        ...tableProps3,
      });

      // Set default properties for the tables
      const tableProps4 = {
        margin: { top: 20, right: 20, bottom: 20, left: 140 },
        align: "right",
        cellWidth: 30,
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header4 = [["Store Requisition No.", "Date"]];
      const data4 = [
        [rcoDets.storeRequisitionNo, convertDate(rcoDets.rcoCreationDate)],
      ];

      doc.autoTable({
        head: header4,
        startY: 80,
        body: data4,
        theme: "grid",
        tableWidth: 50,
        ...tableProps4,
      });

      // Set default properties for the table
      const tableProps5 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellHeight: 10,
        cellWidth: 5,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header5 = [
        ["Name", { colSpan: 3, content: [application.applicantName] }],
      ];

      const data5 = [
        ["Address", { colSpan: 3, content: [application.premisesAddress] }],
        [
          "Cell No.",
          application.applicantMobile,
          "Email Address",
          application.applicantEmail,
        ],
        [
          sodowo(application.applicantRelationType),
          application.applicantRelativeName
            ? application.applicantRelativeName
            : "-",
          "NTN",
          application.NTN ? application.NTN : "-",
        ],
      ];

      doc.autoTable({
        startY: 105,
        head: header5,
        body: data5,
        theme: "grid",
        ...tableProps5,
      });

      if (phase === "Single Phase") {
        // Set default properties for the table
        const tableProps6 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };
        const header6 = [
          [
            "Feeder Code",
            "Meter Number",
            "Location Code",
            "Manufacturer Code",
            "Meter Code",
            "Meter Range",
            "Initial Meter Reading",
          ],
        ];

        const data6 = [
          [
            rcoDets.feederNo,
            rcoDets.meterNo,
            rcoDets.locationCode ? rcoDets.locationCode : "-",
            rcoDets.meterNo.slice(0, 2),
            rcoDets.meterCode1 ? rcoDets.meterCode1 : "-",
            rcoDets.meterRange ? rcoDets.meterRange : "-",
            rcoDets.meterReading,
          ],
        ];

        doc.autoTable({
          startY: 145,
          head: header6,
          body: data6,
          theme: "grid",
          ...tableProps6,
        });
      } else if (phase === "3 Phase") {
        // Set default properties for the table
        const tableProps6 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };
        const header6 = [
          [
            { rowSpan: 2, content: ["Feeder Code"] },
            { rowSpan: 2, content: ["MSN"] },
            { rowSpan: 2, content: ["Location Code"] },
            { rowSpan: 2, content: ["Manufacturer Code"] },
            { colSpan: 2, content: ["Meter Code"] },
            { rowSpan: 2, content: ["Meter Range"] },
            { colSpan: 2, content: ["Initial Meter Reading (kWh)"] },
          ],
        ];

        const data6 = [
          ["", "", "", "", "Peak", "Off Peak", "", "Peak", "Off Peak"],
          [
            rcoDets.feederNo,
            rcoDets.meterNo,
            rcoDets.locationCode ? rcoDets.locationCode : "-",
            rcoDets.meterNo.slice(0, 2),
            rcoDets.meterCode1 ? rcoDets.meterCode1 : "-",
            rcoDets.meterCode2 ? rcoDets.meterCode2 : "-",
            rcoDets.meterRange ? rcoDets.meterRange : "-",
            rcoDets.threePhasePeak,
            rcoDets.threePhaseOffPeak,
          ],
        ];

        doc.autoTable({
          startY: 145,
          head: header6,
          body: data6,
          theme: "grid",
          ...tableProps6,
        });
      } else {
        const tableProps6 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };

        const header6 = [
          [
            { rowSpan: 2, content: ["Feeder Code"] },
            { rowSpan: 2, content: ["MSN"] },
            { rowSpan: 2, content: ["Location Code"] },
            { rowSpan: 2, content: ["Manufacturer Code"] },
            { colSpan: 2, content: ["Meter Code"] },
            { rowSpan: 2, content: ["Meter Range"] },
          ],
        ];

        const data6 = [
          ["", "", "", "", "Peak", "Off Peak", ""],
          [
            rcoDets.feederNo,
            rcoDets.meterNo,
            rcoDets.locationCode ? rcoDets.locationCode : "-",
            rcoDets.meterNo.slice(0, 2),
            rcoDets.meterCode1 ? rcoDets.meterCode1 : "-",
            rcoDets.meterCode2 ? rcoDets.meterCode2 : "-",
            rcoDets.meterRange ? rcoDets.meterRange : "-",
          ],
        ];

        doc.autoTable({
          startY: 145,
          head: header6,
          body: data6,
          theme: "grid",
          ...tableProps6,
        });

        const tableProps7 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };

        const header7 = [
          [
            { colSpan: 2, content: ["kWh"] },
            { colSpan: 2, content: ["kVARh"] },
            { rowSpan: 2, content: ["MDI"] },
            { rowSpan: 2, content: ["No. of MDI Resets"] },
            { rowSpan: 2, content: ["Multiplying Factor"] },
          ],
        ];

        const data7 = [
          ["Peak", "Off Peak", "Peak", "Off Peak", "", "", ""],
          [
            rcoDets.threePhasePeakKWH,
            rcoDets.threePhaseOffPeakKWH,
            rcoDets.threePhasePeakKVARH,
            rcoDets.threePhaseOffPeakKVARH,
            rcoDets.mdi,
            rcoDets.noOfMDIreset,
            rcoDets.multiplyingFactor
              ? rcoDets.multiplyingFactor.toString()
              : "-",
          ],
        ];

        doc.autoTable({
          startY: 185,
          head: header7,
          body: data7,
          theme: "grid",
          ...tableProps7,
        });
      }

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }
      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);

      // Open the PDF in a new tab
      window.open(pdfDataUrl, "_blank");
    } catch (e) {
      console.log("Unable to generate Master Data Form!", e);
      console.log(e);
    }
    setViewBackdrop(false);
  };

  const getAmountText = (amount) => {
    if (amount == null || amount === "" || amount === undefined) return "0";
    const num = parseFloat(amount);
    return isNaN(num) ? "0" : numberFormatting(num);
  };

  const formatPdfAmount = (value) => {
    const num = Number(value) || 0; // convert safely
    return Math.round(num).toLocaleString();
  };

  const downloadEFile = async (application) => {
    setViewBackdrop(true);
    try {
      let applicationId = application.applicationId;
      let DiscoCode = application.companyCode.toString();

      let rcoVoucherDets;
      let rcoVoucherExpiryFlag;

      // ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¡ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¡ GET DOCUMENTS FROM YOUR NEW API
      const applicationDocs = await callAsyncGetDocumentsAPI(applicationId);

      if (!applicationDocs) {
        console.log("No documents found");
        return;
      }
      if (application.applicationProgressId >= 3) {
        await callAsyncGetRCOFeeVoucherAPI(applicationId).then((response) => {
          rcoVoucherDets = response.rcoVoucherDets;
          rcoVoucherExpiryFlag = response.rcoVoucherExpiryFlag;
        });
      }

      // ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¡ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¡ CALL E-FILE API TO GET eFileData
      const eFileTableData = await callEfileAPI(applicationId, application);

      let paidDemandNoteImage = "";
      let dnDets = null;
      let boqItems = [];

      // Only call Demand Note API if application has reached step 4 or higher
      if (
        application.applicationProgressId >= 6 &&
        application.isDiscAboveAYear === true
      ) {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: application.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          const response = await fetch(
            cfpBaseUrl + "rco/getDemandNoteData",
            requestOptions,
          );

          const result = await response.json();

          if (
            result.status === "200" &&
            result.data &&
            result.data.length > 0
          ) {
            dnDets = normalizeDnAmounts(result.data[0] || {});
            paidDemandNoteImage = dnDets.paidDNImage || "";
            boqItems = result.BoQitems;
          } else {
            console.log("Demand Note not issued or not paid yet");
          }
        } catch (error) {
          console.error("Error fetching Demand Note data:", error);
        }
      } else {
        console.log("Application progress < 4 skipping Demand Note fetch");
      }

      // Read all document URLs safely
      const copyOfApplicantCNICFront = applicationDocs.applicantCNICFront || "";
      const copyOfApplicantCNICBack = applicationDocs.applicantCNICBack || "";
      const copyOfPaidRCOFeeImg = rcoVoucherDets?.rcoFeePaidImage || "";
      const copyOfPaidArrearsImg = applicationDocs?.paidBillImage || "";

      let CNICFrontImg = "";
      let CNICBackImg = "";
      let rcoFeePaidImg = "";
      let paidDNImg = "";
      let arrearsPaidImg = "";
      if (copyOfApplicantCNICFront?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfApplicantCNICFront);
        CNICFrontImg = img;
      } else {
        CNICFrontImg = copyOfApplicantCNICFront;
      }

      if (copyOfApplicantCNICBack?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfApplicantCNICBack);
        CNICBackImg = img;
      } else {
        CNICBackImg = copyOfApplicantCNICBack;
      }

      if (copyOfPaidRCOFeeImg?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfPaidRCOFeeImg);
        rcoFeePaidImg = img;
      } else {
        rcoFeePaidImg = copyOfPaidRCOFeeImg;
      }

      if (paidDemandNoteImage?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(paidDemandNoteImage);
        paidDNImg = img;
      } else {
        paidDNImg = paidDemandNoteImage;
      }

      if (copyOfPaidArrearsImg?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfPaidArrearsImg);
        arrearsPaidImg = img;
      } else {
        arrearsPaidImg = copyOfPaidArrearsImg;
      }
      const doc = new jsPDF({ compressPdf: true });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight,
        );

        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        height += 10;
        const detailLeftX = padding;
        const detailRightX = pageWidth - 95;
        const detailValueGap = 3;

        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", detailLeftX, height);
        doc.text(
          applicationId,
          detailLeftX + doc.getTextWidth("Application Id: ") + detailValueGap,
          height,
        );

        doc.text("Name: ", detailRightX, height);
        doc.text(
          application.consumerName || "-",
          detailRightX + doc.getTextWidth("Name: ") + detailValueGap,
          height,
        );

        height += 10;
        doc.text("Load: ", detailLeftX, height);
        doc.text(
          application.sanctionedLoad != null
            ? String(application.sanctionedLoad)
            : "-",
          detailLeftX + doc.getTextWidth("Load: ") + detailValueGap,
          height,
        );

        doc.text("Tariff: ", detailRightX, height);
        doc.text(
          application.tariffDesc || application.tariff || "-",
          detailRightX + doc.getTextWidth("Tariff: ") + detailValueGap,
          height,
        );

        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5;
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (doc, documentData, startHeight) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.rect(rectX, startHeight, rectWidth, rectHeight);

        const fileType = documentData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = documentData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = documentData.slice(17, 19);
        }

        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        if (extension.startsWith("jp")) {
          doc.addImage(documentData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(documentData, "png", xPos, yPos, cardWidth, cardHeight);
        }
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234,
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const fileType = cnicData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = cnicData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = cnicData.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(cnicData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(cnicData, "png", xPos, yPos, cardWidth, cardHeight);
        }

        return yPos + cardHeight;
      };

      // FIRST PAGE - Application Summary
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", pageWidth - 50, 5, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let height = 25;
      const padding = 10;
      const leftMargin = 50;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      height += 8;

      doc.text("Document Type: ", padding, height);
      doc.text("Reconnection", padding + leftMargin, height);
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      height += 6;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus,
        ),
        padding + leftMargin,
        height,
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.creationDate ? convertDate(application.creationDate) : "-",
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      height += 6;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        application.subDivisionCode
          ? subdivisionName(parseInt(application.subDivisionCode), subDivisions)
          : "-",
        padding + leftMargin,
        height,
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionCategory ? application.connectionCategory : "-",
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      height += 6;
      doc.text("Phase / Load: ", padding, height);
      doc.text(
        application.sanctionedLoad ? application.sanctionedLoad : "-",
        padding + leftMargin,
        height,
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      height += 20;
      let rectWidth = 195;
      let rectHeight = 10;
      let rectX = (pageWidth - rectWidth) / 2;

      doc.setFillColor(200, 200, 200);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Applicant Particulars", pageWidth / 2, height, {
        align: "center",
      });

      height += 6;
      rectHeight = 30;
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      const extraPadding = 5;

      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(
        application.consumerName ? application.consumerName : "-",
        padding + 70,
        height,
      );

      height += 6;
      doc.text("CNIC:", padding + extraPadding, height);
      doc.text(
        application.consumerCNIC ? application.consumerCNIC : "-",
        padding + 70,
        height,
      );

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(
        application.consumerAddress ? application.consumerAddress : "-",
        padding + 70,
        height,
      );

      height += 6;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(
        application.applicantMobileNo ? application.applicantMobileNo : "-",
        padding + 70,
        height,
      );

      // Add spacing before Application Summary section
      height += 15;
      rectHeight = 10;

      doc.setFillColor(199, 199, 199);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Application Summary", pageWidth / 2, height, {
        align: "center",
      });

      doc.setFontSize(12);
      height += 3.5;

      const summaryTableProps = {
        margin: { left: rectX, right: rectX },
        startY: height,
        tableWidth: rectWidth,
        styles: {
          fontSize: 11,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          minCellHeight: 10,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 11,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
        },
        alternateRowStyles: {
          fillColor: [235, 235, 235],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 },
          1: { halign: "center", cellWidth: 40 },
          2: { halign: "center", cellWidth: 35 },
          3: { halign: "center", cellWidth: 30 },
          4: { halign: "center", cellWidth: 65 },
        },
        theme: "plain",
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
      };

      const summaryData = [];

      // Check if eFileResult exists and has data
      if (eFileTableData && eFileTableData.length > 0) {
        // Keep API order (already sorted by lastModificationDate DESC), then remove repeated steps.
        const sortedData = [...eFileTableData];
        const seenSteps = new Set();
        const uniqueStepRows = sortedData.filter((row) => {
          const stepKey = (row.stepName || "").trim().toLowerCase();
          if (!stepKey || seenSteps.has(stepKey)) return false;
          seenSteps.add(stepKey);
          return true;
        });

        let srNumber = uniqueStepRows.length;

        for (let i = 0; i < uniqueStepRows.length; i++) {
          const row = uniqueStepRows[i];

          // If applicationProgressId is 1, use "Application Submitted." as remarks
          const remarksToShow =
            row.applicationProgressId === 1
              ? "Application Submitted."
              : row.remarks || "";

          summaryData.push([
            srNumber.toString(),
            row.stepName || "",
            row.processedBy || "",
            convertDatewithTimeWithoutSecond(row.date).slice(0, 11),
            remarksToShow,
          ]);

          srNumber--;
        }
      }
      // Draw the table
      doc.autoTable({
        head: [["Sr.", "Step", "Processed By", "Date", "Remarks"]],
        body: summaryData,
        ...summaryTableProps,
      });

      // ADD OTHER DOCUMENTS ON NEW PAGES
      if (CNICFrontImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Front",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, CNICFrontImg, contentHeight, rectHeight);
      }

      if (CNICBackImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Back",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, CNICBackImg, contentHeight, rectHeight);
      }

      if (application.applicationProgressId >= 3 && arrearsPaidImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Paid Arrears Img",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, arrearsPaidImg, contentHeight, rectHeight);
      }

      if (rcoFeePaidImg !== "" && application.applicationProgressId >= 2) {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Paid RCO Fee Voucher",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, rcoFeePaidImg, contentHeight, rectHeight);
      }


      if (application.applicationProgressId >= 3) {
        // Fetch RCO Voucher data (same as in downloadRCOFeePDF)

        // Only add the voucher if data exists and not expired (or even if expired ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ as per original logic)
        if (rcoVoucherDets) {
          doc.addPage(); // New page for RCO Voucher at the end

          //#region text
          // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
          let officeCode = application.divisionCode.toString();
          let officeName = divisionName(parseInt(officeCode), subDivisions);
          let authorizedByName = rcoVoucherDets.approvedByDesignation;
          let authorizedByDesignation = rcoVoucherDets.rcoFeeVoucherApprovedBy
            ? rcoVoucherDets.rcoFeeVoucherApprovedBy
            : "-";
          let dateToPrint = rcoVoucherDets.issueDate
            ? numberFormatting(new Date(rcoVoucherDets.issueDate))
            : "---";
          let stampData = printStamp(
            officeCode,
            officeName,
            authorizedByName,
            authorizedByDesignation,
            dateToPrint,
          );

          const fontSize = 8;
          if (rcoVoucherDets.issueDate) {
            doc.addImage(stampData, "PNG", 20, 100, 55, 40); // Add image to PDF (x, y, width, height)
            doc.addImage(stampData, "PNG", 140, 185, 55, 40); // Add image to PDF (x, y, width, height)
          }

          //#region Line 1
          var line2Height = 10;
          var lineHeightIncreament = 5;
          doc.setFont("helvetica", "normal"); 
          doc.setFontSize(fontSize);
          doc.text(
            "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
            padding,
            line2Height,
            {},
          );
          doc.text(
            companyName(applicationId.slice(3, 5)).concat(
              application.sanctionedLoad < 15
                ? "(" +
                    applicationId.slice(3, 8) +
                    "-" +
                    subdivisionName(
                      parseInt(application.subDivisionCode),
                      subDivisions,
                    ) +
                    ")"
                : "(" +
                    applicationId.slice(3, 7) +
                    "-" +
                    divisionName(
                      parseInt(application.divisionCode),
                      subDivisions,
                    ) +
                    ")",
            ),
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 2
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "(Department of Electricity)",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 3
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 12;
          var text1 = "RCO Voucher Serial No.: ";
          var text2 = rcoVoucherDets.applicationId;
          var text3 = "Application Id: ";
          var text4 = applicationId;
          var text5 = "Apply Date: ";
          var text6 = convertDate(application.creationDate);

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5,
            line2Height,
          );
          //#endregion

          //#region Line 4
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 3.35;
          var text1 = "Voucher Issuance Date: ";
          var text2 = rcoVoucherDets.issueDate
            ? convertDate(rcoVoucherDets.issueDate)
            : "-";
          var text3 = "Application Type: ";
          var text4 = application.applicationType
            ? applicationName(application.applicationType)
            : "-";
          var text5 = "(New Connection, Reconnection etc.): ";
          var text6 = application.applicationType
            ? applicationName(application.applicationType)
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              doc.getTextWidth(text6) +
              lineSpace * 2,
            line2Height + 1,
          );
          //#endregion

          //#region Line 5
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "Reference No.: ";
          var text2 = application.referenceNo ? application.referenceNo : "-";
          var text3 = "Consumer Mobile No.: ";
          var text4 = application.applicantMobileNo
            ? application.applicantMobileNo
            : "-";
          var text5 = "Connection type: ";
          var text6 = application.connectionCategory
            ? application.connectionCategory
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              doc.getTextWidth(text6) +
              lineSpace * 2,
            line2Height + 1,
          );
          //#endregion

          //#region Line 6
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 7;
          var text1 =
            "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
          var text2 = " ";
          var text3 = " ";

          doc.setFontSize(6);
          doc.text(text1, padding, line2Height);
          doc.setFontSize(fontSize);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );

          //#endregion

          //#region Line 7
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 22.25;
          var text1 = `Department's approved Bank name: `;
          var text2 = rcoVoucherDets.roBankName
            ? rcoVoucherDets.roBankName
            : "-";
          var text3 = "Sanctioned Load (kW): ";
          var text4 = application.sanctionedLoad
            ? application.sanctionedLoad.toString()
            : "|";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 8
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 22;
          var text1 = `Department's Revenue Officer: `;
          var text2 = divisionName(
            parseInt(application.divisionCode),
            subDivisions,
          );
          var text3 = "Tariff: ";
          var text4 = application.tariffCode ? application.tariffCode : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 10
          var line2Height = line2Height + lineHeightIncreament;

          doc.text(
            "RCO Fee Voucher",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 11
          var line2Height = line2Height + lineHeightIncreament;

          doc.text(
            "(Notification of Approval Application Under Guarantee)",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 12
          var line2Height = line2Height + lineHeightIncreament;

          doc.text(
            `Applicant's part`,
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 13
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 16;
          var text1 = `Mr. / Mrs.`;
          var text2 = application.consumerName
            ? application.consumerName
                .concat(" | ")
                .concat(application.consumerAddress)
            : "|";
          var text3 = ``;

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.setFontSize(6);
          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          //#endregion

          //#region Line 14
          lineHeightIncreament = 4;
          var line2Height = line2Height + lineHeightIncreament;
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var text1 = `You are hereby informed that your application for reconnection whose particulars are mentioned above has been approved by the system on the following conditions.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            doc.text(lines[i], padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          //#region Line 15
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var noOfDays = "30";
          var text1 = `1. You should deposit the following amounts in the approved bank of the RO Office department within [word1] days from the date of issue of this notice and inform the office with the receipt number and date of your payment.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace("[word1]", noOfDays);
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          //#region Line 16
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var noOfDays = "30";
          var text1 = `A. Ree Connection Fee as per CSM ______________ PKR. (this amount is to be deposited in the department's approved bank).`;
          var text2 = rcoVoucherDets.rcoFeeAmount
            ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
            : "0";
          var lines = doc.splitTextToSize(text1, maxWidth);
          doc.setFont("helvetica", "bold");
          doc.text(text2, 60, line2Height);
          doc.setFont("helvetica", "normal");
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace(
              "[rcoFeeAmount]",
              rcoVoucherDets.rcoFeeAmount
                ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
                : "0",
            );
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }

          //#endregion

          //#region Line 22
          doc.text(
            `(Irrelevant should be cut down)`,
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 23
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var noOfMonth = "1";
          var text1 = `If you do not comply with the above conditions in response to the RCO fee voucher within the prescribed period, your application form for reconnection will not be considered with the serial number allotted. RCO Fee Voucher thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          // //#region Line 24
          // doc.setFontSize(fontSize);
          // var text1 = `Regards`;
          // var spaceLeft = 100;
          // doc.text(text1, padding + spaceLeft, line2Height);
          // //#endregion

          // //#region Line 25
          // doc.setFontSize(fontSize);
          // var line2Height = line2Height + lineHeightIncreament;
          // var text1 =
          //   "Revenue Office " +
          //   applicationId.slice(3, 7) +
          //   "-" +
          //   divisionName(parseInt(application.divisionCode), subDivisions);
          // doc.text(text1, padding + spaceLeft, line2Height);
          // //#endregion

          //#region Line 26
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var text1 = "Signature Bank Officer: ";
          var text2 =
            "Account Section" +
            "(" +
            applicationId.slice(3, 7) +
            " - " +
            divisionName(parseInt(application.divisionCode), subDivisions) +
            ") RO MEPCO";
          doc.text(text1, padding, line2Height);
          // doc.text(text2, padding + spaceLeft, line2Height);
          //#endregion

          //#region Line 27
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          spaceLeft = 10;
          var text1 =
            "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
          doc.text(text1, padding + spaceLeft, line2Height);
          //#endregion

          //#region Line 28
          lineHeightIncreament = 5;
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
            padding,
            line2Height,
            {},
          );
          doc.text(
            "For Bank Use Only",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 29
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "(The concerned bank will separate this layer from the RCO Voucher and send it to the revenue officer along with its bank scroll)",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 30
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 16;
          var spaceLeft = 50;

          var text1 = `1. Applicant's Name and Complete address `;
          var text2 = application.consumerName
            ? application.consumerName
                .concat(" | ")
                .concat(application.consumerAddress)
            : "|";
          var text3 = `Details of paid amount`;

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.setFontSize(6);
          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
            line2Height,
          );
          //#endregion

          //#region Line 31
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "2. Application Id: ";
          var text2 = application.applicationId
            ? application.applicationId
            : "-";
          var text3 = "Date: ";
          var text4 = application.creationDate
            ? convertDate(application.creationDate)
            : "-";
          var text5 = "1. Fee Voucher Amount:";
          var text6 = rcoVoucherDets.rcoFeeAmount
            ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
            : "0";
          var leftSpace = 40;

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              leftSpace +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.setFont("helvetica", "bold");
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5 +
              +leftSpace,
            line2Height,
          );
          doc.setFont("helvetica", "normal");
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              leftSpace,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              doc.getTextWidth(text6) +
              lineSpace * 2 +
              leftSpace,
            line2Height + 1,
          );
          //#endregion

          //#region Line 32
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "3. RCO Fee Voucher No.: ";
          var text2 = rcoVoucherDets.applicationId
            ? rcoVoucherDets.applicationId
            : "-";
          var text3 = "Date: ";
          var text4 = rcoVoucherDets.issueDate
            ? convertDate(rcoVoucherDets.issueDate)
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 33
doc.setFontSize(fontSize);

// fix: don't redeclare same variable name
line2Height = line2Height + lineHeightIncreament;

const refLabel = "4. Reference No.: ";
const refValue = application.referenceNo ? application.referenceNo : "-";

// print label
doc.text(refLabel, padding, line2Height);

// calculate positions
const startX = doc.getTextWidth(refLabel) + padding;
const valueX = startX + lineSpace;

// print value
doc.text(refValue, valueX, line2Height);

// draw underline only for value
doc.line(
  startX,
  line2Height + 1,
  valueX + doc.getTextWidth(refValue) + lineSpace,
  line2Height + 1
);
//#endregion
        
          //#region Line 34
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "5. Approved bank name and address:";
          var text2 = rcoVoucherDets.roBankName
            ? rcoVoucherDets.roBankName
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 35
          doc.setFontSize(fontSize);
          var line2Height =
            line2Height + lineHeightIncreament + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 =
            application.sanctionedLoad < 15
              ? "                                                                                 "
              : "                                                                                  ";
          // var text1 = application.sanctionedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
          var text2 = " ";
          var text3 = " ";
          var text4 = " ";
          var text5 = " ";
          var text6 = "Signature Bank Officer ";
          var leftSpace = 20;
          doc.text(text1, padding, line2Height);
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5 +
              +leftSpace,
            line2Height,
          );
          //#endregion

          //#region Line 36
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = " ";
          var text2 = " ";
          var text3 = " ";
          var text4 = " ";
          var text5 = " ";
          var text6 = " ";
          var leftSpace = 10;
          doc.setFontSize(6);
          doc.text(text1, padding, line2Height);
          //#endregion

          //#region Line 37
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          spaceLeft = 10;
          var text1 =
            "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
          doc.text(text1, padding + spaceLeft, line2Height);
          //#endregion

          //#region Line 38
          lineHeightIncreament = 4;
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
            padding,
            line2Height,
            {},
          );
          doc.text(
            `Applicant's Response`,
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 39
          lineHeightIncreament = 4;
          var line2Height = line2Height + lineHeightIncreament;
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var text1 = `1. I/We have submitted the RCO Fee Voucher of [rcoFeeAmount] only in the department's approved bank [roBankName] by receipt no. _______________________________________ on date _______________________________.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace(
              "[rcoFeeAmount]",
              rcoVoucherDets.rcoFeeAmount
                ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
                : "0",
            );
            lineText = lineText.replace(
              "[roBankName]",
              rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-",
            );
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          //#region Line 47
          doc.setFontSize(6);
          lineHeightIncreament = 2;
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
          var text1 =
            "NOTE - Computer generated Fee Voucher, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said application is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
          var lineSpace = 6.6;
          var lines = doc.splitTextToSize(text1, maxWidth);
          for (var i = 0; i < lines.length; i++) {
            doc.text(lines[i], padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion
        }

        if (rcoVoucherDets) {
          doc.addPage(); // New page for RCO Voucher at the end

          //#region text
          // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
          let officeCode = application.divisionCode.toString();
          let officeName = divisionName(parseInt(officeCode), subDivisions);
          let authorizedByName = rcoVoucherDets.approvedByDesignation;
          let authorizedByDesignation = rcoVoucherDets.rcoFeeVoucherApprovedBy
            ? rcoVoucherDets.rcoFeeVoucherApprovedBy
            : "-";
          let dateToPrint = rcoVoucherDets.issueDate
            ? numberFormatting(new Date(rcoVoucherDets.issueDate))
            : "---";
          let stampData = printStamp(
            officeCode,
            officeName,
            authorizedByName,
            authorizedByDesignation,
            dateToPrint,
          );

          const fontSize = 8;
          if (rcoVoucherDets.issueDate) {
            doc.addImage(stampData, "PNG", 20, 100, 55, 40); // Add image to PDF (x, y, width, height)
            doc.addImage(stampData, "PNG", 140, 185, 55, 40); // Add image to PDF (x, y, width, height)
          }

          //#region Line 1
          var line2Height = 10;
          var lineHeightIncreament = 5;
          doc.setFont("helvetica", "normal"); 
          doc.setFontSize(fontSize);
          doc.text(
            "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
            padding,
            line2Height,
            {},
          );
          doc.text(
            companyName(applicationId.slice(3, 5)).concat(
              application.sanctionedLoad < 15
                ? "(" +
                    applicationId.slice(3, 8) +
                    "-" +
                    subdivisionName(
                      parseInt(application.subDivisionCode),
                      subDivisions,
                    ) +
                    ")"
                : "(" +
                    applicationId.slice(3, 7) +
                    "-" +
                    divisionName(
                      parseInt(application.divisionCode),
                      subDivisions,
                    ) +
                    ")",
            ),
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 2
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "(Department of Electricity)",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 3
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 12;
          var text1 = "RCO Voucher Serial No.: ";
          var text2 = rcoVoucherDets.applicationId;
          var text3 = "Application Id: ";
          var text4 = applicationId;
          var text5 = "Apply Date: ";
          var text6 = convertDate(application.creationDate);

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              doc.getTextWidth(text6) +
              lineSpace * 2,
            line2Height + 1,
          );
          //#endregion

          //#region Line 4
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 3.35;
          var text1 = "Voucher Issuance Date: ";
          var text2 = rcoVoucherDets.issueDate
            ? convertDate(rcoVoucherDets.issueDate)
            : "-";
          var text3 = "Application Type: ";
          var text4 = application.applicationType
            ? applicationName(application.applicationType)
            : "-";
          var text5 = "(New Connection, Reconnection etc.): ";
          var text6 = application.applicationType
            ? applicationName(application.applicationType)
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              doc.getTextWidth(text6) +
              lineSpace * 2,
            line2Height + 1,
          );
          //#endregion

          //#region Line 5
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "Reference No.: ";
          var text2 = application.referenceNo ? application.referenceNo : "-";
          var text3 = "Consumer Mobile No.: ";
          var text4 = application.applicantMobileNo
            ? application.applicantMobileNo
            : "-";
          var text5 = "Connection type: ";
          var text6 = application.connectionCategory
            ? application.connectionCategory
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              doc.getTextWidth(text6) +
              lineSpace * 2,
            line2Height + 1,
          );
          //#endregion

          //#region Line 6
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 7;
          var text1 =
            "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
          var text2 = " ";
          var text3 = " ";

          doc.setFontSize(6);
          doc.text(text1, padding, line2Height);
          doc.setFontSize(fontSize);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );

          //#endregion

          //#region Line 7
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 22.25;
          var text1 = `Department's approved Bank name: `;
          var text2 = rcoVoucherDets.roBankName
            ? rcoVoucherDets.roBankName
            : "-";
          var text3 = "Sanctioned Load (kW): ";
          var text4 = application.sanctionedLoad
            ? application.sanctionedLoad.toString()
            : "|";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 8
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 22;
          var text1 = `Department's Revenue Officer: `;
          var text2 = divisionName(
            parseInt(application.divisionCode),
            subDivisions,
          );
          var text3 = "Tariff: ";
          var text4 = application.tariffCode ? application.tariffCode : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 10
          var line2Height = line2Height + lineHeightIncreament;

          doc.text(
            "RCO Fee Voucher",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 11
          var line2Height = line2Height + lineHeightIncreament;

          doc.text(
            "(Notification of Approval Application Under Guarantee)",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 12
          var line2Height = line2Height + lineHeightIncreament;

          doc.text(
            `Applicant's part`,
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 13
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 16;
          var text1 = `Mr. / Mrs.`;
          var text2 = application.consumerName
            ? application.consumerName
                .concat(" | ")
                .concat(application.consumerAddress)
            : "|";
          var text3 = ``;

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.setFontSize(6);
          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          //#endregion

          //#region Line 14
          lineHeightIncreament = 4;
          var line2Height = line2Height + lineHeightIncreament;
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var text1 = `You are hereby informed that your application for reconnection whose particulars are mentioned above has been approved by the system on the following conditions.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            doc.text(lines[i], padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          //#region Line 15
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var noOfDays = "30";
          var text1 = `1. You should deposit the following amounts in the approved bank of the RO Office department within [word1] days from the date of issue of this notice and inform the office with the receipt number and date of your payment.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace("[word1]", noOfDays);
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          //#region Line 16
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var noOfDays = "30";
          var text1 = `A. Fixed Charges _______________ PKR. (this amount is to be deposited in the department's approved bank).`;
          var text3 = rcoVoucherDets.fixedChargesAmount
            ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
            : "0";
          var lines = doc.splitTextToSize(text1, maxWidth);
          doc.setFont("helvetica", "bold");
          doc.text(text3, 45, line2Height);
          doc.setFont("helvetica", "normal");
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace(
              "[fixedChargesAmount]",
              rcoVoucherDets.fixedChargesAmount
                ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
                : "0",
            );
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }

          //#endregion         //#region Line 22
          doc.text(
            `(Irrelevant should be cut down)`,
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 23
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var noOfMonth = "1";
          var text1 = `If you do not comply with the above conditions in response to the RCO fee voucher within the prescribed period, your application form for reconnection will not be considered with the serial number allotted. RCO Fee Voucher thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          // //#region Line 24
          // doc.setFontSize(fontSize);
          // var text1 = `Regards`;
          // var spaceLeft = 100;
          // doc.text(text1, padding + spaceLeft, line2Height);
          // //#endregion

          // //#region Line 25
          // doc.setFontSize(fontSize);
          // var line2Height = line2Height + lineHeightIncreament;
          // var text1 =
          //   "Revenue Office " +
          //   applicationId.slice(3, 7) +
          //   "-" +
          //   divisionName(parseInt(application.divisionCode), subDivisions);
          // doc.text(text1, padding + spaceLeft, line2Height);
          // //#endregion

          //#region Line 26
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var text1 = "Signature Bank Officer: ";
          var text2 =
            "Account Section" +
            "(" +
            applicationId.slice(3, 7) +
            " - " +
            divisionName(parseInt(application.divisionCode), subDivisions) +
            ") RO MEPCO";
          doc.text(text1, padding, line2Height);
          // doc.text(text2, padding + spaceLeft, line2Height);
          //#endregion

          //#region Line 27
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          spaceLeft = 10;
          var text1 =
            "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
          doc.text(text1, padding + spaceLeft, line2Height);
          //#endregion

          //#region Line 28
          lineHeightIncreament = 5;
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
            padding,
            line2Height,
            {},
          );
          doc.text(
            "For Bank Use Only",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 29
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "(The concerned bank will separate this layer from the RCO Voucher and send it to the revenue officer along with its bank scroll)",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 30
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 16;
          var spaceLeft = 50;

          var text1 = `1. Applicant's Name and Complete address `;
          var text2 = application.consumerName
            ? application.consumerName
                .concat(" | ")
                .concat(application.consumerAddress)
            : "|";
          var text3 = `Details of paid amount`;

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.setFontSize(6);
          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
            line2Height,
          );
          //#endregion

          //#region Line 31
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "2. Application Id: ";
          var text2 = application.applicationId
            ? application.applicationId
            : "-";
          var text3 = "Date: ";
          var text4 = application.creationDate
            ? convertDate(application.creationDate)
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 32
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "3. RCO Fee Voucher No.: ";
          var text2 = rcoVoucherDets.applicationId
            ? rcoVoucherDets.applicationId
            : "-";
          var text3 = "Date: ";
          var text4 = rcoVoucherDets.issueDate
            ? convertDate(rcoVoucherDets.issueDate)
            : "-";
          var text5 = "1. Fixed Charges: ";
          var text6 = rcoVoucherDets.fixedChargesAmount
            ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
            : "0";
          var leftSpace = 35;

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text3,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height,
          );
          doc.text(
            text4,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 3,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height + 1,
          );

          doc.text(
            text5,
            doc.getTextWidth(text2) +
              doc.getTextWidth(text1) +
              doc.getTextWidth(text3) +
              padding +
              lineSpace * 2 +
              leftSpace +
              (doc.getTextWidth(text4) + lineSpace * 2),
            line2Height,
          );
          doc.setFont("helvetica", "bold");
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5 +
              +leftSpace,
            line2Height,
          );
          doc.setFont("helvetica", "normal");
          doc.line(
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              leftSpace,
            line2Height + 1,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 4 +
              doc.getTextWidth(text6) +
              lineSpace * 2 +
              leftSpace,
            line2Height + 1,
          );
          //#endregion

           //#region Line 33
doc.setFontSize(fontSize);

// fix: don't redeclare same variable name
line2Height = line2Height + lineHeightIncreament;

const refLabel = "4. Reference No.: ";
const refValue = application.referenceNo ? application.referenceNo : "-";

// print label
doc.text(refLabel, padding, line2Height);

// calculate positions
const startX = doc.getTextWidth(refLabel) + padding;
const valueX = startX + lineSpace;

// print value
doc.text(refValue, valueX, line2Height);

// draw underline only for value
doc.line(
  startX,
  line2Height + 1,
  valueX + doc.getTextWidth(refValue) + lineSpace,
  line2Height + 1
);
//#endregion
        
          //#region Line 34
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = "5. Approved bank name and address:";
          var text2 = rcoVoucherDets.roBankName
            ? rcoVoucherDets.roBankName
            : "-";

          doc.text(text1, padding, line2Height);
          doc.text(
            text2,
            doc.getTextWidth(text1) + padding + lineSpace,
            line2Height,
          );
          doc.line(
            doc.getTextWidth(text1) + padding,
            line2Height + 1,
            doc.getTextWidth(text1) +
              padding +
              (doc.getTextWidth(text2) + lineSpace * 2),
            line2Height + 1,
          );
          //#endregion

          //#region Line 35
          doc.setFontSize(fontSize);
          var line2Height =
            line2Height + lineHeightIncreament + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 =
            application.sanctionedLoad < 15
              ? "                                                                                 "
              : "                                                                                  ";
          // var text1 = application.sanctionedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
          var text2 = " ";
          var text3 = " ";
          var text4 = " ";
          var text5 = " ";
          var text6 = "Signature Bank Officer ";
          var leftSpace = 20;
          doc.text(text1, padding, line2Height);
          doc.text(
            text6,
            doc.getTextWidth(text1) +
              doc.getTextWidth(text2) +
              doc.getTextWidth(text3) +
              doc.getTextWidth(text4) +
              doc.getTextWidth(text5) +
              padding +
              lineSpace * 5 +
              +leftSpace,
            line2Height,
          );
          //#endregion

          //#region Line 36
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          var lineSpace = 6.6;
          var text1 = " ";
          var text2 = " ";
          var text3 = " ";
          var text4 = " ";
          var text5 = " ";
          var text6 = " ";
          var leftSpace = 10;
          doc.setFontSize(6);
          doc.text(text1, padding, line2Height);
          //#endregion

          //#region Line 37
          doc.setFontSize(fontSize);
          var line2Height = line2Height + lineHeightIncreament;
          spaceLeft = 10;
          var text1 =
            "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
          doc.text(text1, padding + spaceLeft, line2Height);
          //#endregion

          //#region Line 38
          lineHeightIncreament = 4;
          var line2Height = line2Height + lineHeightIncreament;
          doc.text(
            "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
            padding,
            line2Height,
            {},
          );
          doc.text(
            `Applicant's Response`,
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
          //#endregion

          //#region Line 39
          lineHeightIncreament = 4;
          var line2Height = line2Height + lineHeightIncreament;
          doc.setFontSize(fontSize);
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
          var text1 = `1. I/We have submitted the fixed Charges of [fixedChargesAmount] only in the department's approved bank [roBankName] by receipt no. _______________________________________ on date _______________________________.`;
          var lines = doc.splitTextToSize(text1, maxWidth);
          // Iterate through each line and add it to the PDF
          for (var i = 0; i < lines.length; i++) {
            var lineText = lines[i].replace(
              "[fixedChargesAmount]",
              rcoVoucherDets.fixedChargesAmount
                ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
                : "0",
            );
            lineText = lineText.replace(
              "[roBankName]",
              rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-",
            );
            doc.text(lineText, padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion

          //#region Line 47
          doc.setFontSize(6);
          lineHeightIncreament = 2;
          var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
          var text1 =
            "NOTE - Computer generated Fee Voucher, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said application is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
          var lineSpace = 6.6;
          var lines = doc.splitTextToSize(text1, maxWidth);
          for (var i = 0; i < lines.length; i++) {
            doc.text(lines[i], padding, line2Height);
            line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
          }
          //#endregion
        }
      }

      if (
        application.applicationProgressId >= 7 &&
        paidDNImg !== "" &&
        application.isDiscAboveAYear === true
      ) {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Paid Demand Note",
        );
        await addDocumentContent(doc, paidDNImg, contentHeight);
      }
      // ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¡ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¡ ADD DEMAND NOTE CONTENT ONLY IF CONDITIONS ARE MET
      if (
        dnDets &&
        dnDets.approvedFlag == 1 &&
        application.applicationProgressId > 4 &&
        application.isDiscAboveAYear === true
      ) {
        doc.addPage();
        var line2Height = 10;
        var lineHeightIncreament = 5;
        // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
        let officeCode = application.subDivisionCode.toString();
        let officeName = subdivisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
        let authorizedByDesignation = dnDets.approvedByDesignation
          ? dnDets.approvedByDesignation
          : "Role";
        let dateToPrint = dnDets.approvedDate
          ? numberFormatting(new Date(dnDets.approvedDate))
          : "---";
        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint,
        );

        const fontSize = 8;
        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 200, 55, 40); // Add image to PDF (x, y, width, height)
          doc.addImage(stampData, "PNG", 140, 265, 55, 40); // Add image to PDF (x, y, width, height)
        }

        //#region Line 1
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "normal");
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          companyName(applicationId.slice(3, 5)).concat(
            application.sanctionedLoad < 15
              ? "(" +
                  applicationId.slice(3, 8) +
                  "-" +
                  subdivisionName(
                    parseInt(application.subDivisionCode),
                    subDivisions,
                  ) +
                  ")"
              : "(" +
                  applicationId.slice(3, 7) +
                  "-" +
                  divisionName(
                    parseInt(application.divisionCode),
                    subDivisions,
                  ) +
                  ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Application Type: ";
        var text4 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";
        var text5 = "(New Connection, Reconnection etc.): ";
        var text6 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "New Alloated Reference No.: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = application.applicantMobileNo
          ? application.applicantMobileNo
          : "-";
        var text5 = "Connection type: ";
        var text6 = application.connectionCategory
          ? application.connectionCategory
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 7;
        var text1 =
          "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
        var text2 = "Type of Industry / Factory:";
        var text3 = dnDets.industryFactoryType
          ? dnDets.industryFactoryType
          : "-";

        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        doc.setFontSize(fontSize);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            padding +
            lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text3) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = dnDets.bankName ? dnDets.bankName : "-";
        var text3 = "Required Load (kW): ";
        var text4 = application.sanctionedLoad
          ? application.sanctionedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "Tariff: ";
        var text4 = dnDets.tariff ? dnDets.tariff : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 9

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(relativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.setFont("helvetica", "normal");
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        //#region Line 14
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "normal");
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the department.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 15
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "normal");
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of your payment.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[word1]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;
        var text2 = dnDets.capitalCostAmount
          ? numberFormatting(dnDets.capitalCostAmount)
          : "";
        var text3 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text2, 90, line2Height);
        doc.text(text3, 130, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            dnDets.capitalCostAmount
              ? numberFormatting(dnDets.capitalCostAmount)
              : "",
          );
          lineText = lineText.replace(
            "[securityCost]",
            dnDets.securityDepositeAmount
              ? numberFormatting(dnDets.securityDepositeAmount)
              : "",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }

        //#endregion

        //#region Line 17
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 18
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 19
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfDays]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 20
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `3. Since you have not provided your purchased meter to the department for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 21
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        doc.setTextColor(220, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(24);
        doc.text(
          "NOT VALID FOR BANKS",
          doc.internal.pageSize.getWidth() / 2,
          145,
          {
            align: "center",
            angle: 320,
          },
        );
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(fontSize);
        
        // //#region Line 24
        // doc.setFontSize(fontSize);
        // var text1 = `Regards`;
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   application.sanctionedLoad < 15
        //     ? "Sub-Division Office " +
        //       applicationId.slice(3, 8) +
        //       "-" +
        //       subdivisionName(
        //         parseInt(application.subDivisionCode),
        //         subDivisions,
        //       ) +
        //       " SDO " +
        //       companyShortName(DiscoCode)
        //     : "Division Office " +
        //       applicationId.slice(3, 7) +
        //       " - " +
        //       divisionName(parseInt(application.divisionCode), subDivisions) +
        //       " XEN MEPCO";
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        var text2 =
          application.sanctionedLoad < 15
            ? "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 8) +
              " - " +
              subdivisionName(
                parseInt(application.subDivisionCode),
                subDivisions,
              ) +
              ") SDO " +
              companyShortName(DiscoCode)
            : "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 7) +
              " - " +
              divisionName(parseInt(application.divisionCode), subDivisions) +
              ") XEN MEPCO";
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var bankRelationType = application.applicantRelationType;
        var bankRelationTypeText =
          bankRelationType == 1 || bankRelationType == "S/O"
            ? "S/O"
            : bankRelationType == 2 || bankRelationType == "D/O"
              ? "D/O"
              : bankRelationType == 3 || bankRelationType == "W/O"
                ? "W/O"
                : bankRelationType == 4 || bankRelationType == "C/O"
                  ? "C/O"
                  : "";
        var bankRelativePart = application.applicantRelativeName
          ? ` ${bankRelationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(bankRelativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = `Details of paid amount`;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        var text5 = "1. Service Connection:";
        var text6 = dnDets.capitalCostAmount
          ? numberFormatting(dnDets.capitalCostAmount)
          : "-";
        var leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 32
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "3. Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Date: ";
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text5 = "2. Security: ";
        var text6 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "-";
        var leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 33
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "4. Account No. for acquisition connection: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = " ";
        var text4 = " ";
        var text5 = "3. Grid Share / Feeder Rehab. Charges:";
        var text6 = dnDets.amountOfGridSharing
          ? numberFormatting(dnDets.amountOfGridSharing)
              .concat(" / ")
              .concat(
                dnDets.amountOfFeederRehab
                  ? numberFormatting(dnDets.amountOfFeederRehab)
                  : "-",
              )
          : "-"
              .concat(" / ")
              .concat(
                dnDets.amountOfFeederRehab
                  ? numberFormatting(dnDets.amountOfFeederRehab)
                  : "-",
              );
        var leftSpace = 10;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = dnDets.bankName ? dnDets.bankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 =
          application.sanctionedLoad < 15
            ? "                                                                                 "
            : "                                                                                  ";
        // var text1 = application.sanctionedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = "Signature Bank Officer ";
        var leftSpace = 20;
        doc.text(text1, padding, line2Height);
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            numberFormatting(dnDets.capitalCostAmount),
          );
          lineText = lineText.replace(
            "[securityCost]",
            numberFormatting(dnDets.securityDepositeAmount),
          );
          lineText = lineText.replace(
            "[bankName]",
            dnDets.bankName ? dnDets.bankName : "-",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 40
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 41
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 42
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 43
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 44
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Application Id: ";
        var text4 = applicationId ? applicationId : "-";
        var text5 = "Application Form No.: ";
        var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 45
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Amount to be paid: ";
        var text4 =
          dnDets.capitalCostAmount || dnDets.securityDepositeAmount
            ? numberFormatting(
                getCapitalSecurityTotal(
                  dnDets.capitalCostAmount,
                  dnDets.securityDepositeAmount,
                ),
              )
            : "-";
        var text5 = " ";
        var text6 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 46
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament / 2;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = application.sanctionedLoad < 15 ? " " : " ";
        var leftSpace = 110;
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament;
        }
      }

      if (
        application.applicationProgressId >= 6 &&
        application.isDiscAboveAYear === true &&
        boqItems.length >= 1
      ) {
        doc.addPage();
        height = 10;
        if (boqItems.length >= 1) {
          const smallLogoCodes = [
            "12",
            "13",
            "11",
            "16",
            "26",
            "27",
            "48",
            "59",
          ];

          const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
          const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;

          const logoX = (pageWidth - logoWidth) / 2;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight,
          );

          var increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          const detailLeftXItems = padding;
          const detailRightXItems = pageWidth - 95;
          const detailValueGapItems = 3;

          doc.text("Application Id: ", detailLeftXItems, height);
          doc.text(
            applicationId,
            detailLeftXItems +
              doc.getTextWidth("Application Id: ") +
              detailValueGapItems,
            height,
          );
          const applicantNameItems =
            application?.consumerName ||
            application?.applicantName ||
            application?.ownerName ||
            "-";
          doc.text("Name: ", detailRightXItems, height);
          doc.text(
            applicantNameItems,
            detailRightXItems + doc.getTextWidth("Name: ") + detailValueGapItems,
            height,
          );

          height += increment;
          doc.text("Load: ", detailLeftXItems, height);
          doc.text(
            application?.sanctionedLoad != null
              ? String(application.sanctionedLoad)
              : "-",
            detailLeftXItems + doc.getTextWidth("Load: ") + detailValueGapItems,
            height,
          );

          doc.text("Tariff: ", detailRightXItems, height);
          doc.text(
            application?.tariffDesc || application?.tariff || "-",
            detailRightXItems + doc.getTextWidth("Tariff: ") + detailValueGapItems,
            height,
          );
          height += increment;

          // Draw header rectangle
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Items List", pageWidth / 2, height, { align: "center" });

          height += 3.5;
          const itemsTableStartY = height + 1;
          rectHeight = 230;
          doc.rect(rectX, height, rectWidth, rectHeight);

          // Table setup
          const boqTableProps = {
            margin: { top: 0, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 1,
            lineColor: "#000",
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              fontSize: 11,
              fontStyle: "bold",
              halign: "left",
              valign: "middle",
            },
            styles: {
              fontSize: 11,
              fontStyle: "normal",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
            },
            alternateRowStyles: { fillColor: [235, 235, 235] },
          };

          const boqHeaders = [
            ["Sr.", "Item Name", "Unit", "Qty", "Rate", "Amount"],
          ];
          const boqData = [];
          let itemsTotal = 0;
          const materialsList = await callMaterials(applicationId, token);
          for (let i = 0; i < boqItems.length; i++) {
            const rowData = boqItems[i];

            // Match BOQ item with material list using item_Code
            const item = materialsList.find(
              (mat) => String(mat.item_Code) === String(rowData.itemCode),
            );
            if (!item) {
              console.warn(
                `No matching item found for itemCode: ${rowData.itemCode}`,
              );
              continue; // skip this row
            }

            const serialNo = i + 1;
            const itemName = item.item_Name;
            const unit = item.item_Unit;
            const qty = numberFormatting(rowData.qty);
            const rate = numberFormatting(item.item_Amount);
            const amount = numberFormatting(rowData.qty * item.item_Amount);
            itemsTotal += rowData.qty * item.item_Amount;

            const row = [
              serialNo.toString(),
              itemName,
              unit,
              qty,
              rate,
              amount,
            ];
            boqData.push(row);
          }

          // Generate PDF table
          doc.autoTable({
            startY: itemsTableStartY,
            head: boqHeaders,
            body: boqData,
            theme: "grid",
            ...boqTableProps,
          });

          // Add page for Service Cost Estimate
          doc.addPage();
          height = 10;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight,
          );

          increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          const detailLeftXService = padding;
          const detailRightXService = pageWidth - 95;
          const detailValueGapService = 3;

          doc.text("Application Id: ", detailLeftXService, height);
          doc.text(
            applicationId,
            detailLeftXService +
              doc.getTextWidth("Application Id: ") +
              detailValueGapService,
            height,
          );

          const applicantNameHeader =
            application.consumerName || "-";

          doc.text("Name: ", detailRightXService, height);
          doc.text(
            String(applicantNameHeader),
            detailRightXService +
              doc.getTextWidth("Name: ") +
              detailValueGapService,
            height,
          );

          height += increment;
          doc.text("Load: ", detailLeftXService, height);
          doc.text(
            application.sanctionedLoad != null
              ? String(application.sanctionedLoad)
              : "-",
            detailLeftXService +
              doc.getTextWidth("Load: ") +
              detailValueGapService,
            height,
          );

          doc.text("Tariff: ", detailRightXService, height);
          doc.text(
            application.tariffDesc || application.tariff || "-",
            detailRightXService +
              doc.getTextWidth("Tariff: ") +
              detailValueGapService,
            height,
          );
          height += increment;

          // Header for Service Cost Estimate
          rectWidth = 195;
          rectHeight = 10;
          rectX = (pageWidth - rectWidth) / 2;
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Service Cost Estimate", pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;

          const fmt = (value) => `${formatPdfAmount(Number(value) || 0)}.00 /-`;

          const itemsTotalValue = Number(itemsTotal) || 0;
          const roundedItemsTotal = roundAmountValue(itemsTotalValue);
          const localStoreCharges = Math.floor(
            (roundedItemsTotal * 12 + 50) / 100,
          );
          const localInstallationCharges = Math.floor(
            ((roundedItemsTotal + localStoreCharges) * 8 + 50) / 100,
          );
          const gridSharing = Number(dnDets.amountOfGridSharing) || 0;
          const feederRehab = Number(dnDets.amountOfFeederRehab) || 0;
          const civilWork = Number(dnDets.civilWorkCharges) || 0;
          const metering = Number(dnDets.fixedChargesOfMetering) || 0;
          const miscCharges = Number(dnDets.miscellaneousCharges) || 0;
          const lessCost = Number(dnDets.lessTheCost) || 0;
          const securityDeposit =
            Number(dnDets.securityDepositeAmount || dnDets.securityDepositAmount) ||
            0;

          const subtotalA = roundedItemsTotal + localStoreCharges;
          const subtotalB = sumRoundedAmounts([
            localInstallationCharges,
            gridSharing,
            feederRehab,
          ]);
          const subtotalC = sumRoundedAmounts([civilWork, miscCharges]);
          const subtotalD = sumRoundedAmounts([metering]);

          const grossTotal = subtotalA + subtotalB + subtotalC + subtotalD;
          const netTotal = sumRoundedAmounts([
            roundedItemsTotal,
            localStoreCharges,
            localInstallationCharges,
            gridSharing,
            feederRehab,
            civilWork,
            metering,
            miscCharges,
            -lessCost,
          ]);
          const grandTotal = sumRoundedAmounts([netTotal, securityDeposit]);

          const sectionHeader = (title) => {
            doc.setFillColor(233, 233, 233);
            doc.rect(padding, height - 5, pageWidth - padding * 2, 7, "F");
            doc.setFont("helvetica", "bold");
            doc.setTextColor(44, 62, 80);
            doc.text(title, padding + 3, height);
            doc.setTextColor(0, 0, 0);
            height += 8;
          };

          const drawLine = (label, amount, isBold = false) => {
            const labelX = padding + 12;
            const amountX = pageWidth - padding - 4;
            doc.setFont("helvetica", isBold ? "bold" : "normal");
            doc.text(label, labelX, height);
            doc.setDrawColor(190, 190, 190);
            doc.setLineDash([1, 1], 0);
            doc.line(labelX + 46, height - 1, amountX - 35, height - 1);
            doc.setLineDash([], 0);
            doc.text(fmt(amount), amountX, height, { align: "right" });
            height += 6;
          };

          sectionHeader("A. Material & Store Cost");
          drawLine("Items Total Amount", roundedItemsTotal);
          drawLine("Store Charges (12%)", localStoreCharges);
          drawLine("Subtotal (A)", subtotalA, true);

          sectionHeader("B. Installation & Technical Cost");
          drawLine("Installation Charges (8%)", localInstallationCharges);
          drawLine("Grid Sharing Cost", gridSharing);
          drawLine("Feeder Rehab Charges", feederRehab);
          drawLine("Subtotal (B)", subtotalB, true);

          sectionHeader("C. Civil & Miscellaneous");
          drawLine("Civil Work Charges", civilWork);
          drawLine("Misc. Charges", miscCharges);
          drawLine("Subtotal (C)", subtotalC, true);

          sectionHeader("D. Other Charges");
          drawLine("Fixed Charges of Metering", metering);
          drawLine("Subtotal (D)", subtotalD, true);

          height += 1;
          doc.setDrawColor(150, 150, 150);
          doc.line(padding, height, pageWidth - padding, height);
          height += 6;

          doc.setFont("helvetica", "bold");
          doc.text("Gross Total (A+B+C+D)", padding + 3, height);
          doc.text(fmt(grossTotal), pageWidth - padding - 4, height, { align: "right" });
          height += 6;

          doc.setTextColor(160, 30, 30);
          doc.text("Less:", padding + 3, height);
          doc.setTextColor(0, 0, 0);
          doc.text("Cost Adjustment", padding + 18, height);
          doc.text(`-${fmt(lessCost)}`, pageWidth - padding - 4, height, {
            align: "right",
          });
          height += 6;

          doc.setFillColor(236, 248, 236);
          doc.rect(padding, height - 5, pageWidth - padding * 2, 8, "F");
          doc.setTextColor(22, 120, 55);
          doc.setFont("helvetica", "bold");
          doc.text("Net Total", padding + 3, height);
          doc.text(fmt(netTotal), pageWidth - padding - 4, height, {
            align: "right",
          });
          doc.setTextColor(0, 0, 0);
          height += 6;

          doc.setFont("helvetica", "bold");
          doc.text("Security Deposit", padding + 3, height);
          doc.text(fmt(securityDeposit), pageWidth - padding - 4, height, {
            align: "right",
          });
          height += 7;

          doc.setFillColor(236, 248, 236);
          doc.rect(padding, height - 5, pageWidth - padding * 2, 8, "F");
          doc.setTextColor(22, 120, 55);
          doc.setFont("helvetica", "bold");
          doc.text("GRAND TOTAL PAYABLE", padding + 3, height);
          doc.text(fmt(grandTotal), pageWidth - padding - 4, height, {
            align: "right",
          });
          doc.setTextColor(0, 0, 0);

          console.log("PDF Generation Complete with BOQ Items");
        }
      }

      // === END OF RCO VOUCHER ADDITION ===
      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
        
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
      }

      doc.setFontSize(8);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const pageNumberY = doc.internal.pageSize.getHeight() - 10;
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          { align: "center" },
        );
      }

      const pdfBlob = doc.output("blob");
      const fileName = `${applicationId}-E-File.pdf`;
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL + '#' + fileName, fileName);

      setEFileData([]);
    } catch (e) {
      console.log(e);
    } finally {
      setViewBackdrop(false);
    }
  };

  const handleEditIconClick = () => {
    editBasicInfoFormik.values.iv_applicant_name = dialogRowData.consumerName;
    editBasicInfoFormik.values.iv_applicant_cnic = dialogRowData.consumerCNIC;
    editBasicInfoFormik.values.iv_applicant_phone =
      dialogRowData.applicantMobileNo;
    editBasicInfoFormik.values.iv_applicant_email =
      dialogRowData.applicantEmail;
    editBasicInfoFormik.values.iv_relative_name =
      dialogRowData.applicantRelativeName;
    editBasicInfoFormik.values.iv_owner_name = dialogRowData.ownerName;
    editBasicInfoFormik.values.iv_owner_cnic = dialogRowData.ownerCNIC;
    editBasicInfoFormik.values.iv_owner_phone = dialogRowData.ownerMobile;
    editBasicInfoFormik.values.iv_owner_email = dialogRowData.ownerEmail;
    editBasicInfoFormik.values.iv_house = dialogRowData.houseNo;
    editBasicInfoFormik.values.iv_street = dialogRowData.streetNo;
    editBasicInfoFormik.values.iv_sector_block_phase_mohala =
      dialogRowData.sectorBlockPhaseMohalah;
    editBasicInfoFormik.values.iv_town_tehsil = dialogRowData.townTehsil;
    editBasicInfoFormik.values.iv_city_district = dialogRowData.cityDistrict;
    editBasicInfoFormik.values.iv_chak_street = dialogRowData.chakStreet;
    editBasicInfoFormik.values.iv_village = dialogRowData.village;
    setShowEditPopup(true);
  };

  //#endregion

  //#region formiks
  const appliedLoadFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_applied_load: Yup.number()
        .min(
          dialogRowData.sanctionedLoad,
          "New load can not be less than previous load.",
        )
        .max(1000, "Applied load can not be more than 1000kW.")
        .required("Enter applied load."),
    }),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("appliedLoad", appliedLoadFormik.values.iv_applied_load);
      formdata.append("lastModifiedBy", userId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "electricityNewConnection/updateAppliedLoad",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            let nCApplications = reconnectionApplications;
            setReconnectionApplications(nCApplications);
            callChangeObjectionStatus(2, "Field Objection Removed");
          } else {
            // console.log(result.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const referToFieldFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_refer_to_subdivision: Yup.mixed().required("Select the option."),
      iv_exempt_rco_fee: Yup.mixed().required("Select the option."),
      iv_exampt_rco_remarks: Yup.string().when("iv_exempt_rco_fee", {
        is: (iv_exempt_rco_fee) => iv_exempt_rco_fee == 1,
        then: Yup.string().required("Enter remarks for rco fee examption."),
        otherwise: Yup.string().optional(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      let progId = null;
      let remarks = "";

      if (values.iv_exempt_rco_fee == 1) {
        progId = 10;
        remarks = "Meter will be installed with RCO fee.";
      } else {
        if (values.iv_refer_to_subdivision == 1) {
          progId = 4;
          remarks = "Refered to Sub division";
        } else {
          progId = 8;
          remarks = "RCO Fee Voucher created.";
        }
      }

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: progId,
        objectionStatus: 0,
        lastModifiedBy: userId,
        remarks: remarks,
        isReferedToFeildSurvey: values.iv_refer_to_subdivision,
        exemptRcoFee: values.iv_exempt_rco_fee,
        exemptRcoRemarks: values.iv_exempt_rco_fee,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/refereToFeildSurvey", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == 200) {
            resetForm();
            handleClose();
          } else {
            setError(result.message);
          }
        })
        .catch((error) => console.error(error));
    },
  });

  const refNoAllocationFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_grid_sharing_cost: Yup.mixed().when("gridFlag", {
        is: (gridFlag) => gridFlag === true,
        then: Yup.number()
          .typeError("Enter value in numbers.")
          .required("Enter grid sharing cost.")
          .min(1, "Cost cannot be less than 1"),
        otherwise: Yup.mixed()
          .test(
            "is-valid",
            "Enter value in numbers or enter '0'.",
            (value) => value === "0" || !isNaN(Number(value)),
          )
          .optional('Enter value in numbers or enter "0".'),
      }),
      iv_feeder_rehab_charges: Yup.mixed().when("feederRehabFlag", {
        is: (feederRehabFlag) => feederRehabFlag === true,
        then: Yup.number()
          .typeError("Enter value in numbers.")
          .required("Enter feeder rehab cost.")
          .min(1, "Cost cannot be less than 1"),
        otherwise: Yup.mixed()
          .test(
            "is-valid",
            "Enter value in numbers or enter '0'.",
            (value) => value === "0" || !isNaN(Number(value)),
          )
          .optional('Enter value in numbers or enter "0".'),
      }),
      iv_civil_work_charges: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_fixed_charges_of_metering: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_miscellaneous_charges: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_less_the_cost: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_feeder_no: Yup.mixed().required("Select feeder!"),
      iv_sub_batch: Yup.mixed().required("Select sub batch."),
      iv_batch: Yup.mixed().required("Select batch."),
      iv_reference_to_allot: Yup.string()
        .required("Enter reference no. to allot.")
        .min(7, `Reference no. can't be < 12 digits.`)
        .max(7, `Reference no. can't > 12 digits.`)
        .matches(/^[0-9]+$/, "Enter reference no. as 01234567891234"),
      iv_industry_factory_type: Yup.string().when("connectionType", {
        is: () =>
          (dialogRowData.connectionCategory === "Industrial" &&
            industryFlag === true) ||
          (dialogRowData.connectionCategory === "industrial" &&
            industryFlag === true),
        then: Yup.string().required("Please enter industry / factory type."),
        otherwise: Yup.string().optional(),
      }),
      iv_items_array: Yup.mixed().optional(),
      iv_fata_pata: Yup.mixed().optional("Select FATA / PATA!"),
      iv_rural_urban: Yup.mixed().required("Select Urban / Rural!"),
      iv_fgovt: Yup.string().optional(
        "Select Federal Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_cantonment_board: Yup.string().optional("Select Cantonment Board"),
      iv_pgovt: Yup.string().optional(
        "Select Provincial Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_govt_dept_code: Yup.string().when(["iv_pgovt", "iv_fgovt"], {
        is: (iv_pgovt, iv_fgovt) => Boolean(iv_pgovt || iv_fgovt),
        then: Yup.string().required("Select Govt. Department Code."),
        otherwise: Yup.string().optional(),
      }),
      iv_local_bodies: Yup.string().optional("Select Local Bodies"),
    }),
    onSubmit: async (values, { resetForm }) => {
      //#region If Distance < 40
      if (fieldFormik.values.iv_distance === 1) {
        var formdata = new FormData();
        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("consumerAccountNo", values.iv_reference_to_allot);
        formdata.append("batchNo", values.iv_batch);
        formdata.append("feederNo", values.iv_feeder_no);
        formdata.append("subBatch", values.iv_sub_batch);
        formdata.append("tariff", tariff);
        formdata.append("bankName", bankName);
        formdata.append("industryFactoryType", values.iv_industry_factory_type);
        formdata.append(
          "connectionAccountNo",
          values.iv_batch
            .concat(partialValue)
            .concat(values.iv_reference_to_allot),
        );
        formdata.append("meterRent", 0); // Removed by Shafiq Sb
        formdata.append("serviceRent", 0); // Removed by Shafiq Sb
        formdata.append("sanctionLoad", dialogRowData.sanctionedLoad);
        formdata.append("filledBy", userId);
        formdata.append("filledFlag", 1);
        formdata.append("amountOfGridSharing", values.iv_grid_sharing_cost);
        formdata.append("amountOfFeederRehab", values.iv_feeder_rehab_charges);
        formdata.append("civilWorkCharges", civilWorkCharges);
        formdata.append("fixedChargesOfMetering", fixedChargesOfMetering);
        formdata.append("miscellaneousCharges", miscellaneousCharges);
        formdata.append("lessTheCost", lessTheCost);
        formdata.append("urbanRural", values.iv_rural_urban);
        formdata.append("fataPata", values.iv_fata_pata);
        formdata.append("fGovt", values.iv_fgovt);
        formdata.append("cantonmentBoard", values.iv_cantonment_board);
        formdata.append("pGovt", values.iv_pgovt);
        formdata.append("localBodies", values.iv_local_bodies);
        formdata.append(
          "governmentDepartmentCode",
          values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
            ? values.iv_govt_dept_code
            : "",
        );

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "demandNotice/refNosAllocation",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              if (!dnDetails.filledFlag) {
                //In case of filling
                resetForm();
                setGridFlag(false);
                setFeederRehabFlag(false);
                setBankName();
              } else if (
                dnDetails &&
                dnDetails.filledFlag &&
                dnDetails.filledFlag === 1
              ) {
                //In case of approval
                if (dialogRowData.objectionStatus === 2) {
                  callResetObjectionStatus(dialogRowData.applicationId);
                }
                setNewConnectionPopup(true);
                callApproveFieldAPI(dialogRowData.applicationId);
                setGridFlag(false);
                setFeederRehabFlag(false);
                resetForm();
                setBankName();
              }
            }
            handleClose();
          })
          .catch((error) => console.log("error", error));
      }
      //#endregion

      //#region If Distance > 40
      else if (fieldFormik.values.iv_distance == 0) {
        let arrayOfItems = [];
        itemsArray.forEach((item) => {
          let itemObject = {};
          itemObject.itemCode = item.itemCode;
          itemObject.Id = item.Id.toString();
          itemObject.qty = item.qty;
          arrayOfItems.push(itemObject);
        });

        var formdata = new FormData();

        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("consumerAccountNo", values.iv_reference_to_allot);
        formdata.append("batchNo", values.iv_batch);
        formdata.append("tariff", tariff);
        formdata.append("feederNo", values.iv_feeder_no);
        formdata.append("subBatch", values.iv_sub_batch);
        formdata.append("bankName", bankName);
        formdata.append("industryFactoryType", values.iv_industry_factory_type);
        formdata.append(
          "connectionAccountNo",
          values.iv_batch
            .concat(partialValue)
            .concat(values.iv_reference_to_allot),
        );
        formdata.append("meterRent", 0); // Removed by Shafiq Sb
        formdata.append("serviceRent", 0); // Removed by Shafiq Sb
        formdata.append("sanctionLoad", dialogRowData.sanctionedLoad);
        formdata.append("filledBy", userId);
        formdata.append("filledFlag", 1);
        formdata.append("amountOfGridSharing", values.iv_grid_sharing_cost);
        formdata.append("amountOfFeederRehab", values.iv_feeder_rehab_charges);
        formdata.append("civilWorkCharges", civilWorkCharges);
        formdata.append("fixedChargesOfMetering", fixedChargesOfMetering);
        formdata.append("miscellaneousCharges", miscellaneousCharges);
        formdata.append("lessTheCost", lessTheCost);
        formdata.append("urbanRural", values.iv_rural_urban);
        formdata.append("fataPata", values.iv_fata_pata);
        formdata.append("fGovt", values.iv_fgovt);
        formdata.append("cantonmentBoard", values.iv_cantonment_board);
        formdata.append("pGovt", values.iv_pgovt);
        formdata.append("localBodies", values.iv_local_bodies);
        formdata.append(
          "governmentDepartmentCode",
          values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
            ? values.iv_govt_dept_code
            : "",
        );

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        let requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "demandNotice/refNosAllocation",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              // rcoPart1Formik.handleSubmit();
              if (!dnDetails.filledFlag) {
                //In case of filling
                //#region Boq InsertAPI
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", token);
                var raw = JSON.stringify({
                  applicationId: dialogRowData.applicationId,
                  array: arrayOfItems,
                });
                var requestOptions = {
                  method: "POST",
                  headers: myHeaders,
                  body: raw,
                  redirect: "follow",
                };

                fetch(cfpBaseUrl + "demandNotice/insertBOQ", requestOptions)
                  .then((response) => response.json())
                  .then((result) => {
                    if (result.status === "200") {
                      setItemsArray([]);
                      setItemsAmount();
                      setStoreCharges();
                      setInstallationCharges();
                      setGridFlag(false);
                      setFeederRehabFlag(false);
                      resetForm();
                      setBankName();
                      setTotalCharges(0);
                    } else {
                      // console.log(result.message)
                    }
                  })
                  .catch((error) => {
                    console.log("Error in Boq Submission!", error);
                  });
                //#endregion
              } else if (
                dnDetails &&
                dnDetails.filledFlag &&
                dnDetails.filledFlag === 1
              ) {
                //In case of approval
                if (arrayOfItems.length) {
                  //#region Boq UpdateAPI
                  let myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  myHeaders.append("Authorization", token);
                  let raw = JSON.stringify({
                    applicationId: dialogRowData.applicationId,
                    array: arrayOfItems,
                  });

                  let requestOptions = {
                    method: "PUT",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  fetch(cfpBaseUrl + "demandNotice/updateBoq", requestOptions)
                    .then((response) => response.json())
                    .then((result) => {
                      if (result.status === "200") {
                        setItemsArray([]);
                        setItemsAmount();
                        setStoreCharges();
                        setInstallationCharges();
                        setGridFlag(false);
                        setFeederRehabFlag(false);
                        resetForm();
                        setBankName();
                        setTotalCharges(0);
                        callApproveFieldAPI(dialogRowData.applicationId);
                      } else {
                        console.log("Error in BOQ");
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                  //#endregion
                } else {
                  //#region net meter
                  setItemsArray([]);
                  setItemsAmount();
                  setStoreCharges();
                  setInstallationCharges();
                  setGridFlag(false);
                  setFeederRehabFlag(false);
                  resetForm();
                  setBankName();
                  setTotalCharges(0);
                  callApproveFieldAPI(dialogRowData.applicationId);
                }
              }
              // console.log(result.message)
            } else {
              // console.log(result.message)
            }
          })
          .catch((error) => {
            console.log("Error in Field Verification!", error);
          });
      }
      //#endregion
    },
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_objection_Type: Yup.string().required("Enter reason for rejection."),
      // iv_objection_Descripton: Yup.string().optional("Enter reason for rejection."),
    }),
    onSubmit: async (values, { resetForm }) => {
      callChangeObjectionStatus(
        1,
        values.iv_objection_Type,
        values.iv_objection_Type,
      );
      resetForm();
    },
  });

  const dnPymentReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_receipt_image: Yup.mixed().required(
        "Upload paid demand notice receipt image.",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();

      formdata.append("applicationNo", dialogRowData.applicationId);
      formdata.append("demandNoticeNo", dnDetails.demandNoticeNo);
      formdata.append("uploadedBy", userId);
      formdata.append("paidDNImage", dnReceiptImageThumbnail);
      formdata.append("paymentMethod", "1");
      formdata.append("paymentDate", values.iv_payment_date);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/insertPaidDNImage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callChangeProgressIdAPI(
              6,
              "Demand Notice Paid",
              "Demand Notice Paid",
            );
            resetForm();
            setDnReceiptImage();
            setDnReceiptImageThumbnail();
            setRcoPopUp(true);
          }
        })
        .catch((error) => console.log("error", error));
    },
  });

  const rcoFeeReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_rco_fee_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_rco_fee_receipt_image: Yup.mixed().required(
        "Upload paid RCO fee receipt image.",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 4,
          objectionStatus: 0,
          remarks: "RCO fee voucher uploaded.",
          remarksDetail: "RCO fee voucher uploaded Successfully.",
          submittedThrough: portalName,
          rcoFeePaidImage: rcoFeeReceiptImageThumbnail,
          rcoFeePaymentDate: values.iv_rco_fee_payment_date,
          lastModifiedBy: "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "rco/uploadPaidRCOFeeVoucher",
          requestOptions,
        );

        const result = await response.json();

        if (result?.status === "200") {
          setSnackbar({
            open: true,
            message: result?.message || "Approved successfully",
            severity: "success",
          });

          resetForm();
          setRcoFeeReceiptImage();
          setRcoFeeReceiptImageThumbnail();
          setRcoFeeReceiptImageError();
          handleClose();
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        console.error("Upload RCO Fee Error:", error);

        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false);
      }
    },
  });

  const dnReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_dn_fee_payment_date: Yup.date()
        .nullable()
        .typeError("Invalid payment date")
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_dn_receipt_image: Yup.mixed().required(
        "Upload paid DN receipt image.",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setViewBackdrop(true);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 8,
          objectionStatus: 0,
          remarks: "DN uploaded.",
          remarksDetail: "DN uploaded.",
          submittedThrough: portalName,
          paymentDate: values.iv_dn_fee_payment_date,
          paidDNImage: dnReceiptImageThumbnail,
          lastModifiedBy: "",
          uploadedBy: "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "rco/uploadPaidDemandNote",
          requestOptions,
        );

        const result = await response.json();

        if (result?.status === "200") {
          setSnackbar({
            open: true,
            message: result?.message || "Approved successfully",
            severity: "success",
          });

          resetForm();
          setDnReceiptImage(null);
          setDnReceiptImageThumbnail(null);
          setDnReceiptImageError(null);
          handleClose();
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        console.error("Upload DN Receipt Error:", error);

        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false);
      }
    },
  });

  const fieldItemFormik = useFormik({
    initialValues: {
      iv_fieldItemId: "",
      iv_fieldItemQty: "",
      iv_fieldItemRate: "",
      iv_fieldItemUnit: "",
      iv_fieldItemAmount: "",
      iv_items_array: itemsArray,
    },
    validationSchema: Yup.object().shape({
      iv_fieldItemId: Yup.mixed().required("Select the item from list."),
      iv_fieldItemQty: Yup.number()
        .typeError("Qty must be a number.")
        .integer("Qty must be a whole number.")
        .min(1, "Qty must be greater than 0.")
        .required("Enter qty."),
      iv_fieldItemRate: Yup.string().optional(),
      iv_fieldItemUnit: Yup.string().optional(),
      iv_fieldItemAmount: Yup.string().optional(),
    }),

    onSubmit: (values, { resetForm }) => {
      let itemToBeAdded = {};
      let arrayOfItems = [...itemsArray];

      const qty = Number(values.iv_fieldItemQty);
      const rate = Number(values.iv_fieldItemRate);

      if (isNaN(qty) || qty <= 0) return;
      if (isNaN(rate) || rate < 0) return;

      itemToBeAdded.item_Code = values.iv_fieldItemId;

      let alreadyPresent = arrayOfItems.find(
        (item) =>
          String(item.item_Code).trim().toLowerCase() ===
          String(itemToBeAdded.item_Code).trim().toLowerCase(),
      );

      if (alreadyPresent) {
        const index = arrayOfItems.findIndex(
          (item) =>
            String(item.item_Code).trim().toLowerCase() ===
            String(itemToBeAdded.item_Code).trim().toLowerCase(),
        );
        arrayOfItems[index].qty = arrayOfItems[index].qty + qty;
        arrayOfItems[index].amount =
          arrayOfItems[index].qty * arrayOfItems[index].rate;
      } else {
        let it = allMaterialList.find(
          (item) =>
            String(item.item_Code || item.Item_Code)
              .trim()
              .toLowerCase() ===
            String(itemToBeAdded.item_Code).trim().toLowerCase(),
        );

        if (it) {
          itemToBeAdded.item_Code = it.item_Code || it.Item_Code;
          itemToBeAdded.item_Name = it.item_Name || it.Item_Name;
          itemToBeAdded.unit = it.item_Unit || it.Item_Unit;
          itemToBeAdded.rate = it.item_Amount || it.Item_Amount;
        } else return;

        itemToBeAdded.qty = qty;
        itemToBeAdded.amount = qty * itemToBeAdded.rate;
        arrayOfItems.push(itemToBeAdded);
      }

      const { totalAmountofItems, store_charges, installation_charges } =
        calculateCharges(arrayOfItems);

      const total_charges =
        totalAmountofItems + store_charges + installation_charges;

      setItemsAmount(totalAmountofItems);
      setStoreCharges(store_charges);
      setInstallationCharges(installation_charges);
      setTotalCharges(total_charges);
      setItemsArray(arrayOfItems);

      resetForm();
    },
  });

  const rcoPart1Formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_fata_pata: Yup.mixed().optional("Select FATA / PATA!"),
      iv_rural_urban: Yup.mixed().required("Select Urban / Rural!"),
      iv_fgovt: Yup.string().optional(
        "Select Federal Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_cantonment_board: Yup.string().optional("Select Cantonment Board"),
      iv_pgovt: Yup.string().optional(
        "Select Provincial Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_govt_dept_code: Yup.string().when(["iv_pgovt", "iv_fgovt"], {
        is: (iv_pgovt, iv_fgovt) => Boolean(iv_pgovt || iv_fgovt),
        then: Yup.string().required("Select Govt. Department Code."),
        otherwise: Yup.string().optional(),
      }),
      iv_local_bodies: Yup.string().optional("Select Local Bodies"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      let formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("rcoId", rcoDetails.rcoId);
      formdata.append("urbanRural", values.iv_rural_urban);
      formdata.append("fataPata", values.iv_fata_pata);
      formdata.append("feederNo", refNoAllocationFormik.values.iv_feeder_no);
      formdata.append("batch", refNoAllocationFormik.values.iv_batch);
      formdata.append("subBatch", refNoAllocationFormik.values.iv_sub_batch);
      formdata.append("fGovt", values.iv_fgovt);
      formdata.append("cantonmentBoard", values.iv_cantonment_board);
      formdata.append("pGovt", values.iv_pgovt);
      formdata.append("localBodies", values.iv_local_bodies);
      formdata.append("rcoP1FilledBy", userId);
      formdata.append(
        "consumerAccountNo",
        refNoAllocationFormik.values.iv_reference_to_allot,
      );
      formdata.append("rcoP1FillFlag", 1);
      formdata.append(
        "governmentDepartmentCode",
        values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
          ? values.iv_govt_dept_code
          : "",
      );

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/rcoDataInsertP1", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            if (
              rcoDetails.rcoP1FillFlag === null ||
              rcoDetails.rcoP1FillFlag === 0 ||
              rcoDetails.rcoP1FillFlag === ""
            ) {
              resetForm();
              handleClose();
            } else {
              // resetForm()
              // callRCOApprovePart1API(rcoDetails.rcoId)
              // callChangeProgressIdAPI(8, "RCO Issued", "RCO Issued")
              // setOpen(false)
            }
          } else {
            // console.log(result.message)
          }
        })
        .catch((error) => console.log(error));
      setViewBackdrop(false);
    },
  });

  const rcoPart2Formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_store_requisition_no: Yup.string().when("dialogRowData", {
        is: () => isOneYearOld(dialogRowData.disconnectionDate),
        then: Yup.string()
          .required("Enter store requisition no.")
          .min(6, "SRN should be 6 digits.")
          .max(6, "SRN should be 6 digits.")
          .matches(
            /^[1-9][0-9]{5}$/,
            "SRN should be a 6-digit number and cannot start with 0.",
          ),
        otherwise: Yup.string().optional(),
      }),
      iv_store_requisition_date: Yup.date().when("dialogRowData", {
        is: () => isOneYearOld(dialogRowData.disconnectionDate),
        then: Yup.date()
          .max(new Date(), "Requisition date must be in the past.")
          .required("Enter requisition date."),
        otherwise: Yup.date().optional(),
      }),
      iv_sanctioned_load: Yup.number()
        .when([], {
          is: () => dialogRowData.connectionCategory === "Domestic",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(1000, "Residential Maximum Load 1000kW.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionCategory === "Commercial",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(5000, "Commercial Maximum Load 5000kW.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionCategory === "Industrial",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionCategory === "Agriculture",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () =>
            [
              "Tubewell",
              "Temporary",
              "GeneralServices",
              "Electrification",
              "StreetLight",
              "CorporateCompany",
            ].includes(dialogRowData.connectionCategory),
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .optional("Enter sanctioned load."),
        })
        .optional("Enter sanctioned load."),
      iv_seasonal_flag: Yup.mixed().when("phase", {
        is: () => phase != "Single Phase" || phase != "3 Phase",
        then: Yup.mixed().required("Select seasonal / non seasonal value."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_range: Yup.number("Range should be a number.")
  .min(4, "Range can't be less than 4.")
  .max(8, "Range can't be greater than 8.")
  .required("Enter meter range."),
      iv_meter_code1: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase", // Apply validations if phase is 'Three Phase'
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            },
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            },
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            },
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits,
              );
            },
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            },
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            },
          )
          .required("Enter meter code."),
        otherwise: Yup.string()
          .oneOf(
            ["000002", "050502"],
            "For Single Phase, the meter code must be 000002.",
          )
          .required("Enter meter code."),
      }),
      iv_meter_code2: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            },
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            },
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            },
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits,
              );
            },
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            },
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            },
          )
          .required("Enter meter code."),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_transformer_code: Yup.string().optional(),
      iv_location_code: Yup.mixed().required("Select location."),
      iv_manufacturer_code: Yup.string().required("Select Manufacturer."),
      iv_meter_serial_no: Yup.string()
        .required("Enter meter number.")
        .min(7, "Meter no. should be 7 digits.")
        .max(15, "Meter no. should be 15 digits.")
        .matches(/^[0-9]+$/, "Meter no. should be number only.")
        .when("iv_manufacturer_code", (iv_manufacturer_code, schema) => {
          return schema.test(
            "starts-with-manufacturer-code",
            "Meter number should start with the manufacturer code.",
            (value) =>
              value && value.startsWith(iv_manufacturer_code.toString()),
          );
        }),
      iv_meter_reading: Yup.string().when("phase", {
        is: () => phase === "Single Phase",
        then: Yup.string()
          .max(9, "Meter reading can not be more than 999999999.")
          .min(1, "Meter reading can not be less than 1.")
          .required("Enter meter reading.")
          .matches(/^[0-9]+$/, "Enter meter reading in numbers."),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_off_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter off peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_off_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional(),
      }),
      iv_date_of_connection: Yup.date()
        .max(new Date(), "Connection date must be in the past.")
        .required("Enter connection date."),
      iv_connection_installer_name: Yup.string()
        .required("Enter installed by name.")
        .max(30, "Name should be less than 30 characters."),
      iv_installed_meter_image: Yup.string().optional("Upload meter image."),
      iv_meter_type: Yup.mixed().required("Select meter type!"),
      iv_ct_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Nom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "ct-standard-values",
            "The CT Nom must be 100, 200, 300, 400, 600, 800, 1000.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const ctNom = parseInt(value, 10);
              return [100, 200, 300, 400, 600, 800, 1000].includes(ctNom);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_ct_denom: Yup.string().when("phase", {
        is: (phase) => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Denom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Denom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "CT Denom must be less than CT Nom.",
            function (value) {
              const { iv_ct_nom } = this.parent; // Access sibling field
              if (!iv_ct_nom || !value) return true; // Skip validation if either value is missing
              return (
                (iv_ct_nom == 1 && value == 1) ||
                parseInt(value, 10) < parseInt(iv_ct_nom, 10)
              );
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Nom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "PT Denom must be less than PT Nom.",
            function (value) {
              const { iv_pt_nom } = this.parent; // Access sibling field
              if (!iv_pt_nom || !value) return true; // Skip validation if either value is missing
              return parseInt(value, 10) >= parseInt(iv_pt_nom, 10);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Denom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_mdi: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter PT Denom.")
          .matches(/^[1-9]\d*$/, "Enter PT Denom in numbers greater than 0.")
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_no_of_mdi_resets: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .max(5, "No. of MDI reset can not be more than 99999.")
          .min(1, "No. of MDI reset can not be less than 1.")
          .required("Enter No. of MDI reset.")
          .matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
        otherwise: Yup.string().optional().nullable(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId,
        objectionStatus: dialogRowData.objectionStatus,
        lastModifiedBy: userId,
        remarks: "Meter Installed",
        urbanRural: "",
        fataPata: "",
        feederNo: "",
        batch: "",
        subBatch: "",
        fGovt: "",
        governmentDepartmentCode: "",
        cantonmentBoard: "",
        pGovt: "",
        localBodies: "",
        authorizedByName: "",
        authorizedByDesignation: "",
        dateOfAuthorization: "2024-01-01T00:00:00",
        storeRequisitionNo: values.iv_store_requisition_no,
        storeRequisitionDate: values.iv_store_requisition_date
          ? values.iv_store_requisition_date
          : null,
        seasonalFlag: 0,
        sanctionedLoad: 0.0,
        noOfACs: "",
        noOfMeters: "",
        noOfMeterSets: "",
        noOfSubSets: "",
        noOfSupplyPoints: "",
        installedTransformerCapacity: values.iv_transformer_code,
        meterId: values.iv_meter_id,
        meterNo: values.iv_meter_serial_no,
        locationCode: values.iv_location_code,
        meterCode1: values.iv_meter_code1,
        meterCode2: values.iv_meter_code2,
        manufacturerCode: values.iv_manufacturer_code,
        multiplyingFactor: calculateMF(
          values.iv_ct_nom,
          values.iv_ct_denom,
          values.iv_pt_nom,
          values.iv_pt_denom,
        ),
        meterRange: values.iv_meter_range,
        meterReading: phase === "Single Phase" ? values.iv_meter_reading : "",
        dateOfReConnection: values.iv_date_of_connection,
        cp78ItemNo: "",
        tieUpNonTieUp: "",
        sealOnMeter: "",
        sealOnBox: "",
        securitySlipOrPriceBondNo: "",
        connectionInstallerName: values.iv_connection_installer_name,
        rcoP2FilledBy: userId,
        rcoP2FillingDate: "",
        rcoP2FillFlag: 1,
        installedMeterImage: installedMeterImageThumbnail,
        meterType: values.iv_meter_type,
        threePhasePeak:
          phase === "3 Phase" ? values.iv_meter_reading_peak_kwh : "",
        threePhaseOffPeak:
          phase === "3 Phase" ? values.iv_meter_reading_off_peak_kwh : "",
        mdi: phase != "Single Phase" && phase != "3 Phase" ? values.iv_mdi : "",
        noOfMdiReset:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_no_of_mdi_resets
            : "",
        ct:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_nom / values.iv_ct_denom
            : "",
        ctD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_denom
            : "",
        ctN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_ct_nom : "",
        pt:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_nom / values.iv_pt_denom
            : "",
        ptD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_denom
            : "",
        ptN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_pt_nom : "",
        threePhasePeakKvarh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kvarh
            : "",
        threePhaseOffPeakKvarh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kwh
            : "",
        threePhasePeakKwh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kwh
            : "",
        threePhaseOffPeakKwh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kwh
            : "",
      });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        body: raw,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/submitRCOMeterInfo", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            // if (rcoDetails.rcoP2FillFlag === null || rcoDetails.rcoP2FillFlag === 0) {
            //   resetForm()
            //   handleClose()
            // }
            // else {
            resetForm();
            callRCOApprovePart2API(rcoDetails.rcoId);
            setRcoPopUp(true);
            // }
          } else {
            // console.log(result.message)
          }
        })
        .catch((error) => console.log(error));
    },
  });

  const masterDataFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_govt_dept: Yup.mixed().required("Select Govt Dept."),
      iv_ed_code: Yup.mixed().required("Select Electricity Duty code."),
      iv_standard_classification_code: Yup.mixed().required(
        "Select Std. classification code.",
      ),
      iv_income_tax: Yup.mixed().required("Select Income tax value."),
    }),

    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 12,
          objectionStatus: 0,
          remarks: "Completed",
          remarksDetail: "Completed",
          governmentDepartmentCode: values.iv_govt_dept,
          EDCode: values.iv_ed_code,
          stdClassCode: values.iv_standard_classification_code,
          incomeTax: values.iv_income_tax,
        });

        const response = await fetch(
          cfpBaseUrl + "rco/processReadyForBilling",
          {
            method: "POST",
            headers: myHeaders,
            body: raw,
          },
        );

        const result = await response.json();

        if (result?.status === 200 || result?.status === "200") {
          setShowCP138ButtonInResponseModal(false);
          setSnackbar({
            open: true,
            message: result?.message || "Approved successfully",
            severity: "success",
          });

          resetForm();
        } else if (result?.status === 400 || result?.status === "400") {
          setResponseMessage("");
          setResponseMessageError(result?.message || "Something went wrong");
          setShowCP138ButtonInResponseModal(true);
          setOpenResponseModal(true);
        } else {
          setShowCP138ButtonInResponseModal(false);
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        console.error("Ready for Billing Error:", error);
        setShowCP138ButtonInResponseModal(false);
        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false); 
      }
    },
  });

  const arearBillDocumentFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_arear_paid_bill_document: Yup.mixed().required(
        "Upload arrears paid bill document!",
      ),
      iv_arear_paid_bill_date: Yup.string().required(
        "Enter date on which arrears are paid!",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      var raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        paidBillDate: values.iv_arear_paid_bill_date,
        paidBillImage: arearPaidBillDocumentThumbnail,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "comman/updateENCArearPaidBillImage",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callChangeObjectionStatus(
              0,
              "Arrears Objection Removed",
              "Arrears Paid by consumer",
            );
            callChangeProgressIdAPI(
              3,
              "Arrears Verified.",
              "Arrears Verified.",
              "",
              dialogRowData.applicationId,
            );
            resetForm();
            handleClose();
          } else {
            // console.log(result.message)
          }
        })
        .catch((error) => console.log(error));
    },
  });

  const editBasicInfoFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_applicant_name: Yup.string().required("Enter applicant name."),
      iv_applicant_cnic: Yup.string().required("Enter applicant CNIC."),
      iv_applicant_phone: Yup.string().required("Enter applicant phone no."),
      iv_applicant_email: Yup.string().optional("Enter applicant email."),
      iv_address: Yup.string().optional("Enter applicant address."),
      iv_relative_name: Yup.string().required("Enter relative name."),
      iv_owner_name: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: Yup.string().required("Enter owner name."),
        otherwise: Yup.string().optional(),
      }),
      iv_owner_cnic: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: Yup.string().required("Enter owner CNIC."),
        otherwise: Yup.string().optional(),
      }),
      iv_owner_phone: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: Yup.string().required("Enter owner phone no."),
        otherwise: Yup.string().optional(),
      }),
      iv_owner_email: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: Yup.string().optional("Enter owner email."),
        otherwise: Yup.string().optional(),
      }),
      iv_city_district: Yup.string()
        .required("Please select a city.")
        .oneOf(cities ? cities : [], "Please select a valid option"),
      // Urban
      iv_house: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Urban",
        then: Yup.string()
          .matches(
            /^[a-zA-Z0-9\s]*$/,
            "House must be alphanumeric characters only.",
          )
          .max(50, "House must be less than 50 character")
          .required("Enter house."),
        otherwise: Yup.string(),
      }),
      iv_street: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Urban",
        then: Yup.string()
          .matches(
            /^[a-zA-Z0-9\s]*$/,
            "Street must be alphanumeric characters only.",
          )
          .max(50, "Street must be less than 50 character")
          .required("Enter street."),
        otherwise: Yup.string(),
      }),
      iv_sector_block_phase_mohala: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Urban",
        then: Yup.string()
          .max(50, "Sector/Block must be less than 50 character")
          .required("Please enter sector/block."),
        otherwise: Yup.string(),
      }),
      iv_town_tehsil: Yup.string()
        .max(50, "Town / Tehsil must be less than 50 character")
        .required("Please enter town."),
      // Rural
      iv_chak_street: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Rural",
        then: Yup.string()
          .max(50, "Chak / Street must be less than 50 character")
          .required("Please enter chak / street."),
        otherwise: Yup.string(),
      }),
      iv_village: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Rural",
        then: Yup.string()
          .max(50, "Village must be less than 50 character")
          .required("Please enter village."),
        otherwise: Yup.string(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("applicantName", values.iv_applicant_name);
      formdata.append("applicantCNIC", values.iv_applicant_cnic);
      formdata.append("applicantEmail", values.iv_applicant_email);
      formdata.append("applicantMobile", values.iv_applicant_phone);
      formdata.append(
        "applicantRelationType",
        dialogRowData.applicantRelationType,
      );
      formdata.append("applicantRelativeName", values.iv_relative_name);
      if (
        dialogRowData.applicantStatus === "Owner" ||
        dialogRowData.applicantStatus === "owner"
      ) {
        formdata.append("ownerName", values.iv_applicant_name);
        formdata.append("ownerCNIC", values.iv_applicant_cnic);
        formdata.append("ownerMobile", values.iv_applicant_phone);
        formdata.append("ownerEmail", values.iv_applicant_email);
      } else if (
        dialogRowData.applicantStatus === "Tenant" ||
        dialogRowData.applicantStatus === "tenant"
      ) {
        formdata.append("ownerName", values.iv_owner_name);
        formdata.append("ownerCNIC", values.iv_owner_cnic);
        formdata.append("ownerMobile", values.iv_owner_phone);
        formdata.append("ownerEmail", values.iv_owner_email);
      }
      formdata.append("houseNo", values.iv_house);
      formdata.append("streetNo", values.iv_street);
      formdata.append(
        "sectorBlockPhaseMohalah",
        values.iv_sector_block_phase_mohala,
      );
      formdata.append("chakStreet", values.iv_chak_street);
      formdata.append("village", values.iv_village);
      formdata.append("townTehsil", values.iv_town_tehsil);
      formdata.append("cityDistrict", values.iv_city_district);
      if (
        dialogRowData.areaType === "Urban" ||
        dialogRowData.areaType === "urban"
      ) {
        formdata.append(
          "premisesAddress",
          values.iv_house.concat(
            " " +
              values.iv_street +
              " ," +
              values.iv_sector_block_phase_mohala +
              " ," +
              values.iv_town_tehsil +
              " ," +
              values.iv_city_district,
          ),
        );
      }
      if (
        dialogRowData.areaType === "Rural" ||
        dialogRowData.areaType === "rural"
      ) {
        formdata.append(
          "premisesAddress",
          values.iv_chak_street.concat(
            " " +
              values.iv_village +
              " ," +
              values.iv_town_tehsil +
              " ," +
              values.iv_city_district,
          ),
        );
      }
      formdata.append("lastModifiedBy", userId);
      formdata.append("remarks", "Applicant Info Updated.");
      formdata.append("remarksDetail", "");

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl +
          "electricityNewConnection/updateNewConnectionApplicantInfo",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            resetForm();
            setShowEditPopup(false);
            handleClose();
          }
        })
        .catch((error) => console.error(error));
      setViewBackdrop(false);
    },
  });
  //#endregion

  //#region useEffects

  useEffect(() => {
    callTariffList();
  }, []);

  useEffect(() => {
    if (
      dialogRowData?.applicationId &&
      dialogRowData.applicationProgressId === 5
    ) {
      callMaterials(dialogRowData.applicationId);
    }
  }, [dialogRowData?.applicationId, dialogRowData?.applicationProgressId]);

  // useEffect(() => {
  //   if (dialogRowData) {
  //     if (!dialogRowData.isNetBillPaid && (!dialogRowData.isReferedToFeildSurvey || !isReferedToFeildSurvey)) {
  //       setRcoStatusBarArray(RCOStatusBarArrayWithArrearsVerificationAndWithOutReferedToFieldVerification)
  //     } else if (dialogRowData.isNetBillPaid && (!dialogRowData.isReferedToFeildSurvey || !isReferedToFeildSurvey)) {
  //       setRcoStatusBarArray(RCOStatusBarArrayWithOutArrearsVerificationAndWithOutReferedToFieldVerification)
  //     } else if (dialogRowData.isNetBillPaid && (dialogRowData.isReferedToFeildSurvey || isReferedToFeildSurvey)) {
  //       setRcoStatusBarArray(RCOStatusBarArrayWithOutArrearsVerificationAndWithOutReferedToFieldVerification)
  //     }
  //   }
  // }, [isReferedToFeildSurvey, dialogRowData])

  useEffect(() => {
    if (reconnectionApplications && allTariffList) {
      apiToDataGridConversionNormal();
    }
  }, [allTariffList, reconnectionApplications]);

  useEffect(() => {
    if (reconnectionApplicationsOverDue && allTariffList) {
      apiToDataGridConversionOverdue();
    }
  }, [allTariffList, reconnectionApplicationsOverDue]);

  useEffect(() => {
    if (
      dialogRowData?.connectionCategory &&
      refNoAllocationFormik.values.iv_batch
    ) {
      if (
        dialogRowData.connectionCategory == "Domestic" ||
        dialogRowData.connectionCategory == "Commercial"
      ) {
        if (
          batchArrayIndustrial.includes(refNoAllocationFormik.values.iv_batch)
        ) {
          setBatchError(
            dialogRowData.connectionCategory +
              " connection should have batch in " +
              batchArrayGeneralString,
          );
        } else {
          setBatchError(null);
        }
      } else {
        if (batchArrayGeneral.includes(refNoAllocationFormik.values.iv_batch)) {
          setBatchError(
            dialogRowData.connectionCategory +
              " connection should have batch in " +
              batchArrayIndustrialString,
          );
        } else {
          setBatchError(null);
        }
      }
    }
  }, [
    dialogRowData?.connectionCategory,
    refNoAllocationFormik.values.iv_batch,
  ]);

  // useEffect(() => {
  //   if (referenceNumberToAllot) {
  //     console.log(referenceNumberToAllot.length, "Reference number to allot")
  //     if (referenceNumberToAllot.length === 7) {
  //       refNoAllocationFormik.values.iv_reference_to_allot = partialValue + referenceNumberToAllot
  //       console.log(fieldFormik.values.iv_reference_to_allot, 'Ref Ini value')
  //     }
  //     else {
  //       refNoAllocationFormik.values.iv_reference_to_allot = partialValue
  //     }
  //   }
  // }, [referenceNumberToAllot])

  useEffect(() => {
    const checkRefNo = async () => {
      if (
        refNoAllocationFormik.values.iv_batch &&
        refNoAllocationFormik.values.iv_reference_to_allot
      ) {
        let refNo = refNoAllocationFormik.values.iv_batch
          .concat(partialValue)
          .concat(refNoAllocationFormik.values.iv_reference_to_allot);
        if (refNo.length === 14) {
          setViewBackdrop(true);
          let apiResponse = await dBillAPI(token, refNo);
          if (apiResponse.status) {
            setRefNoAlreadyAllocatedError("Reference No. already allocated!");
          } else {
            setRefNoAlreadyAllocatedError("");
          }
          setViewBackdrop(false);
        }
      }
    };
    checkRefNo();
  }, [
    refNoAllocationFormik.values.iv_batch,
    refNoAllocationFormik.values.iv_reference_to_allot,
  ]);

  useEffect(() => {
    if (dialogRowData?.subDivisionCode) {
      setPartialValue(dialogRowData.subDivisionCode);
    }
  }, [dialogRowData?.subDivisionCode]);

  useEffect(() => {
    const { iv_fieldItemId } = fieldItemFormik.values;

    if (iv_fieldItemId && allMaterialList?.length > 0) {
      const item = allMaterialList.find(
        (it) =>
          String(it.item_Code || it.Item_Code)
            .trim()
            .toLowerCase() === String(iv_fieldItemId).trim().toLowerCase(),
      );

      if (item) {
        fieldItemFormik.setFieldValue(
          "iv_fieldItemRate",
          item.item_Amount || item.Item_Amount || "",
        );
        fieldItemFormik.setFieldValue(
          "iv_fieldItemUnit",
          item.item_Unit || item.Item_Unit || "",
        );
      } else {
        fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
        fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
      }
    }
  }, [fieldItemFormik.values.iv_fieldItemId, allMaterialList]);

  useEffect(() => {
    if (foundId && foundId !== "") {
      setFoundInNc(foundId);
    }
  }, [foundId]);

  useLayoutEffect(() => {
    if (foundInNc) {
      handleRowClick(foundInNc);
    }
  }, [foundInNc]);

  useEffect(() => {
    const totalCost = sumRoundedAmounts([
      itemsAmount,
      storeCharges,
      installationCharges,
      gridSharingCost,
      feederRehabilitationCharges,
      civilWorkCharges,
      fixedChargesOfMetering,
      miscellaneousCharges,
      -(lessTheCost || 0),
    ]);

    setGrandTotalCharges(totalCost);
  }, [
    itemsAmount,
    storeCharges,
    installationCharges,
    gridSharingCost,
    feederRehabilitationCharges,
    civilWorkCharges,
    fixedChargesOfMetering,
    miscellaneousCharges,
    lessTheCost,
  ]);

  //#endregion

  useImperativeHandle(ref, () => ({
    handleRowClick,
  }));

  const calculateMF = (ctNom, ctDenom, ptNom, ptDenom) => {
    let mf = (ctNom / ctDenom) * (ptNom / ptDenom);
    return mf;
  };

  const [uploadedImages, setUploadedImages] = useState([]);
  const [thumbnails, setThumbnails] = useState([]); // Base64 previews
  const [errors, setErrors] = useState([]); // Validation errors
  const shouldShowCp138Button =
    showCP138ButtonInResponseModal ||
    /print\s*cp-?138/i.test(responseMessageError || responseMessage || "");

  const handleImageUpload = async (event, index) => {
    await handleFileUpload(
      event,
      () => {}, // No additional handleChange logic required
      (renamedFile) => {
        const updatedImages = [...uploadedImages];
        updatedImages[index] = renamedFile;
        setUploadedImages(updatedImages);
      },
      (error) => {
        const updatedErrors = [...errors];
        updatedErrors[index] = error;
        setErrors(updatedErrors);
      },
      (thumbnail) => {
        const updatedThumbnails = [...thumbnails];
        updatedThumbnails[index] = thumbnail;
        setThumbnails(updatedThumbnails);
      },
      `image_${index + 1}.${event.target.files[0]?.name.split(".").pop()}`,
    );
  };

  const handleRemoveImage = (index) => {
    const updatedImages = [...uploadedImages];
    const updatedThumbnails = [...thumbnails];
    const updatedErrors = [...errors];

    updatedImages[index] = null;
    updatedThumbnails[index] = null;
    updatedErrors[index] = "";

    setUploadedImages(updatedImages);
    setThumbnails(updatedThumbnails);
    setErrors(updatedErrors);
  };

  const location = useLocation();
  const currentPath = location.pathname;

  const tblColumnsArrears = [
    {
      field: "refNo",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Reference No.",
      align: "center",
      headerStyle: { ...tableStyle.headerStyle, width: "3000px" },
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "arrearsAmount",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Arrears",
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "netBillAmount",
      headerName: "Net Bill",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "billingMonth",
      type: "text",
      headerName: "Bill Month",
      sortable: false,
      filterable: false,
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
  ];

  const arrearPaymentReceiptFormik = useFormik({
    initialValues: {
      iv_arrear_paid_bill_document: "",
      iv_arrear_payment_date: "",
      iv_remarks_detail: "",
    },

    validationSchema: Yup.object().shape({
      iv_arrear_paid_bill_document: Yup.mixed().required(
        "Upload Paid Bill receipt image.",
      ),
      iv_arrear_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),

      iv_remarks_detail: Yup.string()
        .trim()
        .min(10, "Remarks must be at least 10 characters")
        .required("Remarks details are required!"),
    }),

    onSubmit: (values) => {
      callArrearVerificationAPI(
        dialogRowData.applicationId,
        dialogRowData.applicationProgressId + 1,
        0,
        "RCO Fee Voucher Approved..",
        values.iv_remarks_detail,
        arrearAmount,
        values.iv_arrear_payment_date,
        billMonth,
        arearPaidBillDocumentThumbnail,
      );
    },
  });

  const arrearPaymentObjectionReceiptFormik = useFormik({
    initialValues: {
      iv_obj_arrear_paid_bill_document: "",
      iv__obj_arrear_payment_date: "",
      iv_obj_remarks_detail: "",
    },

    validationSchema: Yup.object().shape({
      iv_obj_arrear_paid_bill_document: Yup.mixed().required(
        "Upload Paid Bill receipt image.",
      ),
      iv__obj_arrear_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),

      iv_obj_remarks_detail: Yup.string()
        .trim()
        .min(10, "Remarks must be at least 10 characters")
        .required("Remarks details are required!"),
    }),

    onSubmit: (values) => {
      callArrearVerificationAPI(
        dialogRowData.applicationId,
        dialogRowData.applicationProgressId + 1,
        0,
        "RCO Fee Voucher Approved..",
        values.iv_obj_remarks_detail,
        arrearAmount,
        values.iv__obj_arrear_payment_date,
        billMonth,
        arearPaidBillDocumentThumbnail,
      );
    },
  });

  const meterInstallationFormik = useFormik({
    initialValues: {
      iv_installed_meter_img: "",
      iv_installed_meter_date: "",
    },

    validationSchema: Yup.object().shape({
      iv_installed_meter_img: Yup.mixed()
        .required("Meter image is required.")
        .test("file-present", "Meter image is required.", (value) => !!value),
      iv_installed_meter_date: Yup.date()
        .max(new Date(), "Installation date must be in the past!")
        .required("Installation date is required!"),
    }),

    onSubmit: async (values) => {
      try {
        setViewBackdrop(true);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          objectionStatus: 0,
          applicationProgressId: 10,
          remarks: "RCO Meter Installed.",
          remarksDetail: "RCO Meter Installed.",
          submittedThrough: portalName,
          storeRequisitionNo: null,
          storeRequisitionDate: null,
          meterReinstalledAt: values.iv_installed_meter_date,
          reinstalledMeterImage: installedMeterImgThumbnail,
          meterProfile: disconnectedMeterDetails,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "rco/processRCOMeterProfileWithinAYear",
          requestOptions,
        );

        const result = await response.json();

        if (result.status == 200) {
          setSnackbar({
            open: true,
            message: result.message,
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message: result.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        console.error("API Error:", error);
        setSnackbar({
          open: true,
          message: "Failed to submit data",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false); // Hide loader
      }
    },
  });

  const callArrearVerificationAPI = async (
    applicationId,
    applicationProgresId,
    objectionStatuss,
    remarks,
    remarksDetails,
    arrearsAmount,
    arrearsPaymentDate,
    arrearsMonth,
    paidBillImage,
  ) => {
    // console.log(
    //   applicationId,
    //   applicationProgresId,
    //   objectionStatuss,
    //   remarks,
    //   remarksDetails,
    //   arrearAmount,
    //   billMonth,
    //   arrearsImg,
    //   arrearPaidReceiptImageThumbnail,
    //   arrearAmount,
    //   "arrear verification api call"
    // );

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgresId,
      objectionStatus: objectionStatuss,
      remarks: remarks,
      remarksDetail: remarksDetails,
      arrearsAmount: arrearsAmount,
      arrearsPaymentDate: arrearsPaymentDate,
      arrearsMonth: arrearsMonth,
      paidBillImage: arrearsAmount > 0 ? paidBillImage : "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    try {
      const response = await fetch(
        cfpBaseUrl + "rco/processRCOFeeVoucher",
        requestOptions,
      );
      const result = await response.json();

      if (result.status === "200") {
        handleClose();
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
        setPaymentStatus("");
        setBillMonth("");
        setArrearAmount("");
      } else {
        handleClose();
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Something went wrong! Please try again.",
        severity: "error",
      });
      setOpenResponseModal(true);
    }
  };

  const processRCOFeeVoucher = async (type, remarksDetail = null) => {
    const isApprove = type === "approve";

    // Start Loader
    setViewBackdrop(true);

    const payload = {
      applicationId: rcoFeeVoucherDetails?.applicationId,
      applicationProgressId: isApprove ? 4 : 3,
      objectionStatus: isApprove ? 0 : 1,
      remarks: isApprove
        ? "RCO Fee Voucher Approved."
        : "RCO Fee Voucher Rejected.",
      remarksDetail: isApprove
        ? "RCO Fee Voucher Approved Successfully."
        : remarksDetail,
    };

    try {
      const response = await fetch(cfpBaseUrl + "rco/processRCOFeeVoucher", {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      // Stop loader here because we WILL show snackbar
      setViewBackdrop(false);

      if (result.status == 200) {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }

      return result;
    } catch (error) {
      console.error(error);

      // Stop loader on error
      setViewBackdrop(false);

      setSnackbar({
        open: true,
        message: "Something went wrong!",
        severity: "error",
      });
    }
  };

  const RCOFeeVoucherVerification = async (type, remarksDetail) => {
    const isApprove = type === "approve";
    let applicationProgressId = 3;

    if (dialogRowData?.isDiscAboveAYear && isApprove) {
      applicationProgressId = 5;
    } else if (!dialogRowData?.isDiscAboveAYear && isApprove) {
      applicationProgressId = 9;
    }

    const payload = {
      applicationId: rcoFeeVoucherDetails?.applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: isApprove ? 0 : 1,
      remarks: isApprove
        ? "RCO fee voucher verified."
        : "RCO fee voucher rejected.",
      remarksDetail: remarksDetail,
    };

    try {
      setViewBackdrop(true);

      const response = await fetch(
        cfpBaseUrl + "rco/verifyOrRejectPaidRCOFeeVoucher",
        {
          method: "POST",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      // Stop loader before showing snackbar
      setViewBackdrop(false);

      if (result.status == 200) {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }

      return result;
    } catch (error) {
      console.error(error);

      // Stop loader here also
      setViewBackdrop(false);

      setSnackbar({
        open: true,
        message: "Something went wrong!",
        severity: "error",
      });
    }
  };

  const DNFeeVoucherVerification = async (type, remarksDetail) => {
    const isApprove = type === "approve";
    let applicationProgressId = isApprove ? 9 : 7;

    const payload = {
      applicationId: dnApproveStep?.applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: isApprove ? 0 : 1,
      remarks: isApprove ? "DN Payment Verified." : "DN Payment rejected.",
      remarksDetail: remarksDetail,
    };

    try {
      setViewBackdrop(true);

      const response = await fetch(
        cfpBaseUrl + "rco/verifyOrRejectPaidDemandNote",
        {
          method: "POST",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      // Stop loader before showing snackbar
      setViewBackdrop(false);

      if (result.status == 200) {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }

      return result;
    } catch (error) {
      console.error(error);

      // Stop loader here also
      setViewBackdrop(false);

      setSnackbar({
        open: true,
        message: "Something went wrong!",
        severity: "error",
      });
    }
  };

  const onPressViewActivityLog = async () => {
    if (dialogRowData.applicationProgressId >= 3) {
      callAsyncGetDocumentsAPI(dialogRowData.applicationId);
    }
    await callEfileAPI(dialogRowData.applicationId, dialogRowData);
  };

  const minDistance = 41;

  const fieldFormik = useFormik({
    initialValues,
    validationSchema: Yup.lazy((values) => {
      if (values.iv_objection_Type !== "No Issue") {
        return Yup.object().shape({
          iv_objection_Type: Yup.string().required(
            "Enter reason for rejection.",
          ),
        });
      }
      return Yup.object().shape({
        iv_objection_Type: Yup.string().required("Enter reason for rejection."),
        iv_coverage_area: Yup.number()
          .typeError("Enter value in numbers.")
          .required("Enter area (Marla).")
          .min(3, "Minimum area is 3"),
        iv_grid_sharing_cost: Yup.number().when([], {
          is: () => gridFlag === true,
          then: Yup.number()
            .typeError("Enter value in numbers.")
            .required("Enter grid sharing cost.")
            .min(1, "Cost cannot be less than 1"),
          otherwise: Yup.number()
            .test(
              "is-valid",
              "Enter value in numbers or enter '0'.",
              (value) => value === "0" || !isNaN(Number(value)),
            )
            .optional(),
        }),
        iv_feeder_rehab_charges: Yup.number().when([], {
          is: () => feederRehabFlag === true,
          then: Yup.number()
            .typeError("Enter value in numbers.")
            .required("Enter feeder rehab cost.")
            .min(1, "Cost cannot be less than 1"),
          otherwise: Yup.number()
            .test(
              "is-valid",
              "Enter value in numbers or enter '0'.",
              (value) => value === "0" || !isNaN(Number(value)),
            )
            .optional(),
        }),
        iv_sketch_diagram: Yup.mixed().when(["iv_distance"], {
          is: (iv_distance) =>
            iv_distance == 0 &&
            (dialogRowData.applicationId.slice(3, 5) == "13" ||
              dialogRowData.applicationId.slice(3, 5) == "15" ||
              dialogRowData.applicationId.slice(3, 5) == "14"),
          then: Yup.mixed().required("Upload the sketch diagram."),
          otherwise: Yup.mixed().optional(),
        }),
        iv_meter_type: Yup.mixed().required("Select meter type!"),
        iv_rural_urban: Yup.mixed().required("Select Urban / Rural!"),
      });
    }),
    onSubmit: async (values, { resetForm }) => {
      setInstallRefNo(values.installedMeterRefNos);
      setEstimateDistance(values.iv_estimated_distance);
      setMeterAlreadyInstalled(values.iv_no_of_meters_already_installed);
      setShowBoq(false);

      // Check if BOQ items are required for applicationId '13' or iv_distance == 0
      if (
        values.iv_distance == 0 &&
        boqItems.length == 0 &&
        values.iv_objection_Type === "No Issue"
      ) {
        setErrormessageBoqEstimation("Please add BOQ items before submitting.");
        return;
      }
      setErrormessageBoqEstimation("");

      if (
        values.iv_distance == 0 &&
        !sketchDiagramThumbnail &&
        dialogRowData.applicationId.slice(3, 5) !== "13" &&
        values.iv_objection_Type === "No Issue"
      ) {
        setSketchDiagramError(
          "Upload the Sketch Diagram in JPG, PNG or PDF format.",
        );
        return;
      }

      if (values.iv_objection_Type != "No Issue") {
        let applicationProgressId = dialogRowData.applicationProgressId;
        let objectionStatus = 1;
        let remarks = values.iv_objection_Type;

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 5,
          remarks: remarks,
          objectionStatus: objectionStatus,
          meterType: "",
          tariff: "",
          sanctionLoad: "",
          urbanRural: dialogRowData.areaType,
          amountOfGridSharing: "",
          amountOfFeederRehab: "",
          civilWorkCharges: "",
          fixedChargesOfMetering: "",
          miscellaneousCharges: "",
          lessTheCost: "",
          capitalCostAmount: "",
          securityDepositAmount: "",
          isLTLWI40Flag: 1,
          estDistanceInMeter: "40",
          sketchDiagram: "",
          areaMarla: areaTypeValue,
          noOfMeterInstalled: 0,
          surveyedBy: "",
          installedMeterRefNo: [],
          submittedThrough: "e-Operation",
          BoQItems: [],
          bankName: bankName,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl + "rco/saveFieldSurveyAndCostEstimateForRCO",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setViewBackdrop(false);
              setShowCostEstimation(false);
              setErrormessageCostEstimation("");
              handleClose();
              setSnackbar({
                open: true,
                message: result?.message || "Saved successfully",
                severity: "success",
              });
            } else {
              setViewBackdrop(false);
              setErrormessageCostEstimation(result.message);
              setSnackbar({
                open: true,
                message: result?.message || "Something went wrong",
                severity: "error",
              });
            }
          })
          .catch((error) => console.error(error));
      } else {
        if (
          dialogRowData?.applicationId?.slice(3, 5) === "14" &&
          values.iv_meter_type == 1 &&
          !values.iv_select_cable &&
          values.iv_distance != 0
        ) {
          fieldFormik.setFieldTouched("iv_select_cable", true);
          fieldFormik.setFieldError("iv_select_cable", "Select cable!");
          return;
        }
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          urbanRural: values.iv_rural_urban,
          tariff: dialogRowData.tariffDesc,
          connectionType: dialogRowData.connectionCategory,
          isDistatanceIn40M: values.iv_distance,
          meterType: values.iv_meter_type,
          amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
          amountOfFeederRehab: feederRehabilitationCharges
            ? feederRehabilitationCharges
            : 0,
          sanctionLoad:
            values.iv_rural_urban === "R" && dialogRowData.sanctionedLoad < 2
              ? 2
              : values.iv_rural_urban === "U" &&
                  dialogRowData.sanctionedLoad < 3
                ? 3
                : dialogRowData.sanctionedLoad,
          civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
          fixedChargesOfMetering: fixedChargesOfMetering
            ? fixedChargesOfMetering
            : 0,
          miscellaneousCharges: miscellaneousCharges ? miscellaneousCharges : 0,
          lessTheCost: lessTheCost ? lessTheCost : 0,
          estDistanceInMeter:
            values.iv_distance == 1
              ? values.iv_estimated_distance_yes
              : values.iv_estimated_distance,
          itemCode:
            dialogRowData?.applicationId?.slice(3, 5) === "14"
              ? Number(values.iv_select_cable)
              : 0,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(cfpBaseUrl + "rco/costEstimationForRCO", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status == "200") {
              setViewBackdrop(false);
              setShowCostEstimation(true);
              setCostEstimationForNC(result.data[0]);
              setErrormessageCostEstimation("");
            } else if (result.status == "400") {
              setViewBackdrop(false);
              setErrormessageCostEstimation(result.message);
            }
          })
          .catch((error) => console.error(error, "error"));
      }

      setMeterTypeValue(values.iv_meter_type);
      setAreaType(values.iv_coverage_area);
      setUrbanRural(values.iv_rural_urban);
    },
  });

  const dnRejectFormik = useFormik({
    initialValues: {
      reasonType: "",
      remarks: "",
    },
    validationSchema: Yup.object({
      reasonType: Yup.string().required("Please select a reason."),
      remarks: Yup.string()
        .required("Remarks are required.")
        .min(10, "Remarks must be at least 10 characters long."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setViewBackdrop(true);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          objectionStatus: 0,
          applicationProgressId: values.reasonType,
          remarks: `Revert to ${values.reasonType == 5 ? "Cost Estimation" : ""}`,
          remarksDetail: values.remarks,
          submittedThrough: portalName,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "rco/revertApplication",
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        setDnRejectModalOpen(false);
        resetForm();
        handleClose();
      } catch (error) {
        console.error("Error rejecting demand note:", error);
        // Optional: Show error notification to user
        // showErrorNotification("Failed to reject demand note. Please try again.");
      } finally {
        setViewBackdrop(false);
      }
    },
  });
  useEffect(() => {
    if (
      fieldFormik.values.iv_distance == 0 &&
      fieldFormik.values.iv_objection_Type == "No Issue"
    ) {
      fieldFormik.validateField("iv_sketch_diagram");
    }
  }, [fieldFormik.values.iv_distance]);

  // Removed duplicate useEffect - already handled at line 15975 with better dependency
  // useEffect(() => {
  //   setPartialValue(dialogRowData.subDivisionCode);
  // }, [dialogRowData]);

  // useEffect(() => {
  //   const { iv_fieldItemId } = fieldItemFormik.values;

  //   if (iv_fieldItemId && allMaterialList?.length > 0) {

  //     const item = allMaterialList.find(
  //       (it) =>
  //         String(it.item_Code || it.Item_Code)
  //           .trim()
  //           .toLowerCase() === String(iv_fieldItemId).trim().toLowerCase()
  //     );

  //     if (item) {
  //       fieldItemFormik.setFieldValue(
  //         "iv_fieldItemRate",
  //         item.item_Amount || item.Item_Amount || ""
  //       );
  //       fieldItemFormik.setFieldValue(
  //         "iv_fieldItemUnit",
  //         item.item_Unit || item.Item_Unit || ""
  //       );
  //     } else {
  //       fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
  //       fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
  //     }
  //   }
  // }, [fieldItemFormik.values.iv_fieldItemId, allMaterialList]);

  // Removed duplicate useEffects - these are already defined at lines 16009-16066
  // useEffect(() => {
  //   if (foundId && foundId !== "") {
  //     setFoundInNc(foundId);
  //   }
  // }, [foundId]);

  // useLayoutEffect(() => {
  //   if (foundInNc) {
  //     handleRowClick(foundInNc);
  //   }
  // }, [foundInNc]);

  // useEffect(() => {
  //   let totalCost = totalCharges;
  //   ... (total cost calculation) ...
  //   setGrandTotalCharges(totalCost);
  // }, [...]);

  useEffect(() => {
    if (
      govtDeptCodesFromlocalStorage &&
      govtDeptCodesFromlocalStorage.length > 0
    ) {
      setGovtDeptCodes(govtDeptCodesFromlocalStorage);
    }
  }, [govtDeptCodesFromlocalStorage]);
  useEffect(() => {
    if (
      getClassificationCodesFromlocalStorage &&
      getClassificationCodesFromlocalStorage.length > 0
    ) {
      setStandardClassificationCodes(getClassificationCodesFromlocalStorage);
    }
  }, [getClassificationCodesFromlocalStorage]);

  //#endregion

  useImperativeHandle(ref, () => ({
    handleRowClick,
  }));

  const handleCostEstimationClose = () => {
    setShowCostEstimation(false);
  };

  useEffect(() => {}, [arrearsDetailsRefno]);

  const onPressCostEstimationConfirm = () => {
    const roundedCapitalCostAmount = sumRoundedAmounts([
      itemsAmount || costEstimationForNC?.estimatedCapitalCost,
      gridSharingCost,
      storeCharges,
      installationCharges,
      feederRehabilitationCharges,
      civilWorkCharges,
      fixedChargesOfMetering,
      miscellaneousCharges,
      -(lessTheCost || 0),
    ]);

    if (distance == 1) {
      const apiData = allMaterialList || [];
      const appCode = dialogRowData.applicationId.slice(3, 5);
      const load = dialogRowData.sanctionedLoad;
      const distanceFlag = fieldFormik.values.iv_distance;
      const estDistance = fieldFormik.values.iv_estimated_distance_yes;

      let selectedItems = [];
      let BoQItems = []; 

      // Helper function
      const getBoqItems = (selectedItems) => {
        return selectedItems.map((item) => {
          const material = apiData.find(
            (m) => String(m.item_Code).trim() === String(item.itemCode).trim(),
          );
          const amount = material ? material.item_Amount * item.qty : 0;

          return {
            qty: item.qty.toString(),
            itemCode: item.itemCode,
            itemAmount: amount.toFixed(2),
          };
        });
      };

      // --- All logic in one place
      if (appCode === "13" && distanceFlag == 1) {
        // --- Case 1: Load < 4, Distance 1ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ20
        if (load < 4 && estDistance >= 1 && estDistance <= 20) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030003061" },
            { qty: 20, itemCode: "000000000030000335" },
          ];
        }
        // --- Case 2: Load < 4, Distance 21ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ40
        else if (load < 4 && estDistance >= 21 && estDistance <= 40) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030003061" },
            { qty: 40, itemCode: "000000000030000335" },
          ];
        }
        // --- Case 3: Load > 3, Distance 1ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ20
        else if (load > 3 && estDistance >= 1 && estDistance <= 20) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030001901" },
            { qty: 20, itemCode: "000000000030000335" },
          ];
        }
        // --- Case 4: Load > 3, Distance 21ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ40
        else if (load > 3 && estDistance >= 21 && estDistance <= 40) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030001901" },
            { qty: 40, itemCode: "000000000030000335" },
          ];
        }

        // --- Generate BoQItems
        if (selectedItems.length > 0) {
          BoQItems = getBoqItems(selectedItems);
          setBoqItems(BoQItems);
        }
      }


      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const installedMeterRefNo =
        installRefNo.length !== 0
          ? installRefNo.map((item) => ({
              installedRefNo: item || "",
            }))
          : [];

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: 6,
        remarks: "Field surveyed and Cost estimated.",
        objectionStatus: 0,
        meterType: meterTypeValue,
        tariff: dialogRowData.tariffDesc,
        sanctionLoad: dialogRowData.sanctionedLoad,
        urbanRural: urbanRuralValue,
        amountOfGridSharing: costEstimationForNC?.amountOfGridSharing
          ? costEstimationForNC?.amountOfGridSharing
          : 0,
        amountOfFeederRehab: costEstimationForNC?.amountOfFeederRehab
          ? costEstimationForNC?.amountOfFeederRehab
          : 0,
        civilWorkCharges: costEstimationForNC?.civilWorkCharges
          ? costEstimationForNC?.civilWorkCharges
          : 0,
        fixedChargesOfMetering: costEstimationForNC?.fixedChargesOfMetering
          ? costEstimationForNC?.fixedChargesOfMetering
          : 0,
        miscellaneousCharges: costEstimationForNC?.miscellaneousCharges
          ? costEstimationForNC?.miscellaneousCharges
          : 0,
        lessTheCost: costEstimationForNC?.lessTheCost
          ? costEstimationForNC?.lessTheCost
          : 0,
        capitalCostAmount: roundedCapitalCostAmount,
        securityDepositAmount: costEstimationForNC?.estimatedSecurityAmount
          ? costEstimationForNC?.estimatedSecurityAmount
          : 0,
        isLTLWI40Flag: 1,
        estDistanceInMeter:
          fieldFormik.values.iv_distance == 1
            ? fieldFormik.values.iv_estimated_distance_yes
            : fieldFormik.values.iv_estimated_distance_no,
        sketchDiagram: "",
        areaMarla: areaTypeValue,
        noOfMeterInstalled: meterAlreadyInstalled ? meterAlreadyInstalled : 0,
        surveyedBy: "",
        installedMeterRefNo: installedMeterRefNo,
        submittedThrough: "e-Operation",
        BoQItems: BoQItems ? BoQItems : [],
        bankName: bankName,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "rco/saveFieldSurveyAndCostEstimateForRCO",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            setShowCostEstimation(false);
            setErrormessageCostEstimation("");
            // resetForm()
            handleClose();
          } else {
            setViewBackdrop(false);
            setErrormessageCostEstimation(result.message);
          }
        })
        .catch((error) => console.error(error));
    } else {
      const capitalCostAmnt =
        (itemsAmount || 0) +
        (storeCharges || 0) +
        (installationCharges || 0) +
        (civilWorkCharges || 0) +
        (fixedChargesOfMetering || 0) +
        (miscellaneousCharges || 0) -
        (lessTheCost || 0);
      const BoQItems = itemsArray.map((item) => ({
        qty: String(item.qty),
        itemCode: String(item.item_Code),
        itemAmount: String(item.amount),
      }));

      setBoqItems(BoQItems);

      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const installedMeterRefNo =
        installRefNo.length !== 0
          ? installRefNo.map((item) => ({
              installedRefNo: item || "",
            }))
          : [];

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: 6,
        remarks: "Field surveyed and Cost estimated.",
        objectionStatus: 0,
        meterType: meterTypeValue,
        tariff: dialogRowData.tariffDesc,
        sanctionLoad: dialogRowData.sanctionedLoad,
        urbanRural: urbanRuralValue,
        amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
        amountOfFeederRehab: feederRehabilitationCharges
          ? feederRehabilitationCharges
          : 0,
        civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
        fixedChargesOfMetering: fixedChargesOfMetering
          ? fixedChargesOfMetering
          : 0,
        miscellaneousCharges: miscellaneousCharges ? miscellaneousCharges : 0,
        lessTheCost: lessTheCost ? lessTheCost : 0,
        capitalCostAmount: roundedCapitalCostAmount,
        securityDepositAmount: costEstimationForNC?.estimatedSecurityAmount
          ? costEstimationForNC?.estimatedSecurityAmount
          : 0,
        isLTLWI40Flag: 0,
        estDistanceInMeter: estimateDistance,
        sketchDiagram: sketchDiagramThumbnail ? sketchDiagramThumbnail : "",
        areaMarla: areaTypeValue,
        noOfMeterInstalled: meterAlreadyInstalled ? meterAlreadyInstalled : 0,
        surveyedBy: "",
        installedMeterRefNo: installedMeterRefNo,
        submittedThrough: "e-Operation",
        BoQItems: BoQItems,
        bankName: bankName,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "rco/saveFieldSurveyAndCostEstimateForRCO",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            setShowCostEstimation(false);
            setErrormessageCostEstimation("");
            // resetForm()
            handleClose();
          } else {
            setViewBackdrop(false);
            // setShowCostEstimation(false)
            setErrormessageCostEstimation(result.message);
          }
        })
        .catch((error) => console.error(error));
    }
  };

  const onSaveCostEstimationConfirm = () => {
    setErrormessageBoqEstimation("");
    setShowBoq(false);
    const BoQItems = itemsArray.map((item) => ({
      qty: String(item.qty),
      itemCode: String(item.item_Code),
      itemAmount: String(item.amount),
    }));
    setBoqItems(BoQItems);
    // }
  };

  const onPressAddPrepare = useCallback(() => {
    setShowBoq(true);
  }, []);

  useEffect(() => {
    // hide BOQ
    if (
      fieldFormik.values.iv_distance === 0 &&
      dialogRowData.applicationProgressId === 3
    ) {
      setShowBoq(false);
    }

    const isFesco = dialogRowData?.applicationId?.slice(3, 5) === "13";
    const newDistance = 41;

    if (fieldFormik.values.iv_estimated_distance !== newDistance) {
      fieldFormik.setFieldValue("iv_estimated_distance", newDistance);
    }
  }, [
    fieldFormik.values.iv_distance,
    dialogRowData.applicationId,
    dialogRowData.applicationProgressId,
  ]);

  useEffect(() => {
    // Only set iv_distance to null if objection type changed AND it's not already null
    if (
      fieldFormik.values.iv_objection_Type !== "No Issue" &&
      fieldFormik.values.iv_distance !== null
    ) {
      fieldFormik.setFieldValue("iv_distance", null);
    }
  }, [fieldFormik.values.iv_objection_Type]);

  // useEffect(() => {
  //   callMaterials()
  // }, [])

  // useEffect(() => {
  //   const count = fieldFormik.values.iv_no_of_meters_already_installed || 0;
  //   fieldFormik.setFieldValue(
  //     "installedMeterRefNos",
  //     Array(count).fill("")
  //   );
  // }, [fieldFormik.values.iv_no_of_meters_already_installed]);

  useEffect(() => {
    const count = fieldFormik.values.iv_no_of_meters_already_installed;
    const currentArray = fieldFormik.values.installedMeterRefNos || [];

    if (count > 0) {
      // Only update if the array length doesn't match
      if (currentArray.length !== count) {
        const newArray = Array(count)
          .fill("")
          .map((_, i) => currentArray[i] || "");
        fieldFormik.setFieldValue("installedMeterRefNos", newArray);
      }
    } else {
      // Only update if the array is not already empty
      if (currentArray.length > 0) {
        fieldFormik.setFieldValue("installedMeterRefNos", []);
      }
    }
  }, [fieldFormik.values.iv_no_of_meters_already_installed]);

  useEffect(() => {
    if (!boqItems || boqItems.length === 0) {
      // Only reset values if they're not already 0 to prevent unnecessary updates
      if (gridSharingCost !== 0) {
        fieldFormik.setFieldValue("iv_grid_sharing_cost", 0);
        setGridSharingCost(0);
      }
      if (feederRehabilitationCharges !== 0) {
        fieldFormik.setFieldValue("iv_feeder_rehab_charges", 0);
        setFeederRehabilitationCharges(0);
      }
      if (civilWorkCharges !== 0) {
        fieldFormik.setFieldValue("iv_civil_work_charges", 0);
        setCivilWorkCharges(0);
      }
      if (miscellaneousCharges !== 0) {
        fieldFormik.setFieldValue("iv_miscellaneous_charges", 0);
        setMiscellaneousCharges(0);
      }
      if (fixedChargesOfMetering !== 0) {
        fieldFormik.setFieldValue("iv_fixed_charges_of_metering", 0);
        setFixedChargesOfMetering(0);
      }
      if (lessTheCost !== 0) {
        fieldFormik.setFieldValue("iv_less_the_cost", 0);
        setLessTheCost(0);
      }
    }
  }, [boqItems]);

  useEffect(() => {
    const currentEstDistance = fieldFormik.values.iv_estimated_distance_yes;
    if (fieldFormik.values.iv_distance == 1 && currentEstDistance !== 1) {
      fieldFormik.setFieldValue("iv_estimated_distance_yes", 1);
    } else if (
      fieldFormik.values.iv_distance == 0 &&
      currentEstDistance !== 41
    ) {
      fieldFormik.setFieldValue("iv_estimated_distance_yes", 41);
    }
  }, [fieldFormik.values.iv_distance]);
  const callAssignmentAPI = async (applicationId, wfId) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        assignedTo: wfId,
        lastModifiedBy: userId,
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "workForce/assignToEmployee", requestOptions)
        .then(async (response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            let res = await response.json();
            alert(res.message);
          }
        })
        .then((result) => {
          // setLinemanAllocationSubPopUp(false)
          alert(result.message);
        })
        .catch((error) => console.error(error));
    } catch (e) {}
    setLinemanAllocationSubPopUp(false);
    setViewBackdrop(false);
  };

  const PaidArrearsImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "PaidArrearsImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        arrearPaymentReceiptFormik.handleChange,
        setArearPaidBillDocument,
        setArearPaidBillDocumentError,
        setArearPaidBillDocumentThumbnail,
        newFileName,
      );
    }
  };

  const OBJPaidArrearsImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "PaidArrearsImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        arrearPaymentObjectionReceiptFormik.handleChange,
        setArearPaidBillDocument,
        setArearPaidBillDocumentError,
        setArearPaidBillDocumentThumbnail,
        newFileName,
      );
    }
  };

  useEffect(() => {
    return () => {
      // Cleanup blob URL if exists
      if (
        installedMeterImgThumbnail &&
        installedMeterImgThumbnail.startsWith("blob:")
      ) {
        URL.revokeObjectURL(installedMeterImgThumbnail);
      }
    };
  }, [installedMeterImgThumbnail]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";

    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const getNormalizedTariffName = (tariffCode, allTariffList) => {
    if (!tariffCode || !Array.isArray(allTariffList)) return "";

    const tariff = allTariffList.find(
      (t) => String(t.tariffCode) === String(tariffCode),
    );

    return tariff?.tariffName?.replace(/[^A-Za-z0-9]/g, "").toUpperCase() || "";
  };

  const handleOpenImg = () => setOpenImgDialog(true);
  const handleCloseImg = () => setOpenImgDialog(false);
  const handleOpenImgDN = () => setOpenImgDialogDN(true);
  const handleCloseImgDN = () => setOpenImgDialogDN(false);

  const DNApproveAPI = async (
    Token,
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks,
    portalName,
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", Token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: objectionStatus,
      remarks: remarks,
      remarksDetail: remarks,
      submittedThrough: portalName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    try {
      const response = await fetch(
        cfpBaseUrl + "rco/approveDemandNote",
        requestOptions,
      );
      const result = await response.json();

      if (result.status === "200") {
        setResponseMessage(result.message);
        setResponseType("success");
      } else {
        setResponseMessageError(result.message || "Unexpected error occurred.");
        setResponseType("error");
      }

      setOpenResponseModal(true);
      handleClose();
    } catch (error) {
      setResponseMessageError("Something went wrong. Please try again.");
      setResponseType("error");
      setOpenResponseModal(true);
    } finally {
      setViewBackdrop(false);
    }
  };

  const scoPart2Formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      // iv_store_requisition_no: Yup.string()
      //   .required('Enter store requisition no.')
      //   .min(6, 'SRN should be 6 digits.')
      //   .max(6, 'SRN should be 6 digits.')
      //   .matches(/^[1-9][0-9]{5}$/, "SRN should be a 6-digit number and cannot start with 0."),
      // iv_store_requisition_date: Yup.date().max(new Date(), 'Requisition date must be in the past.').required('Enter requisition date.'),
      // iv_store_requisition_no: Yup.string()
      //   .required("Store Requisition No. is required")
      //   .length(6, "Must be 6 digits"),
      // iv_store_requisition_no: Yup.string()
      //   .when("$scoP2FillFlag", {
      //     is: 13, // agar flag 13 hai
      //     then: (schema) => schema.required("Store Requisition No. is required"),
      //     otherwise: (schema) =>
      //       schema
      //         .required("Store Requisition No. is required")
      //         .length(6, "Must be 6 digits"),
      //   }),

      iv_store_requisition_no: Yup.string()
        .required("Store Requisition No. is required")
        .test(
          "check-iv_store_requisition_no",
          "Store Requisition No. must be 8 digits",
          function (value) {
            const { dialogRowData } = this.options.context;
            const appId = dialogRowData?.applicationId || "";
            const status = dialogRowData?.status; // assuming status is in dialogRowData

            if (appId.slice(3, 5) === "13") {
              return true;
            }

            // agar Approved case hai to 6-digit check apply karo
            if (status === "Approved") {
              return !!value && value.length === 8;
            }
            return true;
          },
        ),

      iv_store_requisition_date: dialogRowData?.storeRequisitionDate
        ? Yup.string()
        : Yup.string().required("Store Requisition Date is required"),
      // iv_sanctioned_load: Yup.number()
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Domestic",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(1000, "Residential Maximum Load 1000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Commercial",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(5000, "Commercial Maximum Load 5000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Industrial",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Agriculture",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(5000, "Applied load cannot be more than 5000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () =>
      //       [
      //         "Tubewell",
      //         "Temporary",
      //         "GeneralServices",
      //         "Electrification",
      //         "StreetLight",
      //         "CorporateCompany",
      //       ].includes(dialogRowData.connectionCategory),
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(5000, "Applied load cannot be more than 5000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .required("Enter sanctioned load."),
      iv_seasonal_flag: Yup.mixed().when("phase", {
        is: () => phase != "Single Phase" || phase != "3 Phase",
        then: Yup.mixed().required("Select seasonal / non seasonal value."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_range: Yup.number("Range should be a number.")
  .min(4, "Range can't be less than 4.")
  .max(8, "Range can't be greater than 8.")
  .required("Enter meter range."),
      iv_meter_code1: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase", // Apply validations if phase is 'Three Phase'
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            },
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            },
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            },
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits,
              );
            },
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            },
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            },
          )
          .required("Enter meter code."),
        otherwise: Yup.string()
          .oneOf(
            ["000002", "050502"],
            "For Single Phase, the meter code must be 000002.",
          )
          .required("Enter meter code."),
      }),
      iv_meter_code2: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            },
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            },
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            },
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits,
              );
            },
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            },
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            },
          )
          .required("Enter meter code."),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_transformer_code: Yup.string()
        .matches(/^\d*$/, "Transformer code must contain digits only.")
        .optional(),
      iv_transformer_refNo: Yup.string().when("$userCompany", {
        is: (val) => val !== "13",
        then: Yup.string()
          .required("Transformer reference no is required.")
          .matches(
            /^\d{14}$/,
            "Enter 14 digit transformer reference no as 01234567891234",
          ),
        otherwise: Yup.string()
          .matches(
            /^\d{14}$/,
            "Enter 14 digit transformer reference no as 01234567891234",
          )
          .optional(),
      }),

      iv_location_code: Yup.mixed().required("Select location."),
      iv_manufacturer_code: Yup.string().required("Select Manufacturer."),
      iv_meter_serial_no: Yup.string()
        .required("Enter meter serial no.")
        .matches(/^\d+$/, "Meter serial no. should contain digits only.")
        .test(
          "validate-first-2-digits",
          "First 2 digits must be between 01-55.",
          (value) => {
            if (!value || value.length < 2) return true; // Skip if less than 2 digits
            const first2Digits = parseInt(value.substring(0, 2), 10);
            return first2Digits >= 1 && first2Digits <= 55;
          }
        )
        .test(
          "validate-3rd-4th-digits",
          "3rd and 4th digits must be 97, 98 or 99.",
          (value) => {
            if (!value || value.length < 4) return true; // Skip if less than 4 digits
            const digits3and4 = value.substring(2, 4);
            return digits3and4 === "97" || digits3and4 === "98" || digits3and4 === "99";
          }
        )
        .length(10, "Meter serial no. should be exactly 10 digits."),

      iv_sim_number: Yup.string()
        .required("Enter SIM number.")
        .matches( 
          /^03\d{9}$/,
          "SIM number must start with 03 and be 11 digits.",
        ),

      iv_sim_ID: Yup.string()
        .required("Enter SIM ID.")
        .matches(/^\d+$/, "SIM ID must contain digits only.")
        .min(18, "SIM ID should be at least 18 digits.")
        .max(20, "SIM ID should not exceed 20 digits."),

      iv_meter_reading: Yup.string().when("phase", {
        is: () => phase === "Single Phase",
        then: Yup.string()
          .max(9, "Meter reading can not be more than 999999999.")
          .min(1, "Meter reading can not be less than 1.")
          .required("Enter meter reading.")
          .matches(/^[0-9]+$/, "Enter meter reading in numbers."),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter off peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_date_of_connection: Yup.date()
        .max(new Date(), "Connection date must be in the past.")
        .required("Enter connection date."),
      iv_connection_installer_name: Yup.string()
        .required("Enter installed by name.")
        .max(30, "Name should be less than 30 characters."),
      iv_installed_meter_image: Yup.mixed().required("Upload meter image."),
      // iv_meter_typee: Yup.mixed().required("Select meter type!"),
      iv_ct_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Nom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "ct-standard-values",
            "The CT Nom must be 100, 200, 300, 400, 600, 800, 1000.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const ctNom = parseInt(value, 10);
              return [100, 200, 300, 400, 600, 800, 1000].includes(ctNom);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_ct_denom: Yup.string().when("phase", {
        is: (phase) => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Denom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Denom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "CT Denom must be less than CT Nom.",
            function (value) {
              const { iv_ct_nom } = this.parent; // Access sibling field
              if (!iv_ct_nom || !value) return true; // Skip validation if either value is missing
              return (
                (iv_ct_nom == 1 && value == 1) ||
                parseInt(value, 10) < parseInt(iv_ct_nom, 10)
              );
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Nom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "PT Denom must be less than PT Nom.",
            function (value) {
              const { iv_pt_nom } = this.parent; // Access sibling field
              if (!iv_pt_nom || !value) return true; // Skip validation if either value is missing
              return parseInt(value, 10) >= parseInt(iv_pt_nom, 10);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Denom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_mdi: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter PT Denom.")
          .matches(/^[1-9]\d*$/, "Enter PT Denom in numbers greater than 0.")
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_no_of_mdi_resets: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .max(5, "No. of MDI reset can not be more than 99999.")
          .min(1, "No. of MDI reset can not be less than 1.")
          .required("Enter No. of MDI reset.")
          .matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
        otherwise: Yup.string().optional().nullable(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      try {
        if (!installedMeterImageThumbnail) {
          setInstalledMeterImageError(
            "Upload the Installed meter image in JPG, PNG.",
          );
          return;
        }

        let applicationProgressId = dialogRowData.applicationProgressId;
        let remarks = "Meter Installed on premises.";

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: applicationProgressId + 1,
          remarks: remarks,
          submittedThrough: portalName,
          objectionStatus: 0,

          rcoP2FillFlag: 1,
          rcoP2ApprovalFlag: null,
          rcoP2ApprovedByDesignation: null,
          authorizedByName: null,
          authorizedByDesignation: null,

          storeRequisitionNo: values.iv_store_requisition_no,
          storeRequisitionDate: values.iv_store_requisition_date,
          seasonalFlag: values.iv_seasonal_flag,
          senctionLoad: values.iv_sanctioned_load,
          installedTransformerCapacity: values.iv_transformer_code,

          meterNo: values.iv_meter_serial_no,
          locationCode: values.iv_location_code,
          meterCode1: values.iv_meter_code1,
          meterCode2: values.iv_meter_code2,
          manufacturerCode: values.iv_manufacturer_code,

          multiplyingFactor:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? calculateMF(
                  values.iv_ct_nom,
                  values.iv_ct_denom,
                  values.iv_pt_nom,
                  values.iv_pt_denom,
                )
              : "",

          meterRange: values.iv_meter_range,
          meterReading: phase === "Single Phase" ? values.iv_meter_reading : "",

          dateOfReConnection: values.iv_date_of_connection,
          installedMeterImage: installedMeterImageThumbnail,

          cT:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_ct_nom / values.iv_ct_denom
              : "",
          cTD:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_ct_denom
              : "",
          cTN:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_ct_nom
              : "",

          pT:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_pt_nom / values.iv_pt_denom
              : "",
          pTD:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_pt_denom
              : "",
          pTN:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_pt_nom
              : "",

          threePhasePeakKVARH:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_meter_reading_peak_kvarh
              : "",
          threePhaseOffPeakKVARH:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_meter_reading_off_peak_kvarh
              : "",
          threePhasePeakKWH:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_meter_reading_peak_kwh
              : "",
          threePhaseOffPeakKWH:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_meter_reading_off_peak_kwh
              : "",

          connectionInstallerName: values.iv_connection_installer_name,

          threePhasePeak:
            phase === "3 Phase" ? values.iv_meter_reading_peak_kwh : "",
          threePhaseOffPeak:
            phase === "3 Phase" ? values.iv_meter_reading_off_peak_kwh : "",

          mdi:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_mdi
              : "",
          noOfMDIreset:
            phase !== "Single Phase" && phase !== "3 Phase"
              ? values.iv_no_of_mdi_resets
              : "",

          simId: values.iv_sim_ID,
          simNumber: values.iv_sim_number,
          transformerRefNo: values.iv_transformer_refNo,
        });

        const response = await fetch(
          cfpBaseUrl + "rco/processRCOMeterProfileAboveAYear",
          {
            method: "POST",
            headers: myHeaders,
            body: raw,
          },
        );

        const result = await response.json();

        if (result?.status === "200" || result?.status === 200) {
          resetForm();
          handleClose();

          setSnackbar({
            open: true,
            message: result?.message || "Meter installed successfully",
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        console.error("SCO Part-2 Error:", error);
        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false); 
      }
    },
  });

  const handleBatchEditClick = () => {
    setShowUpdateBatchPopup(true);
  };
  return (
    <>
      <ServiceDashboardTables
        enabled={props.showTable && currentPath === "/reconnection-table"}
        isLoadingNormal={isLoad}
        isLoadingOverdue={isLoadd}
        normalTitle={`Reconnection ( ${numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )`}
        overdueCount={numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
        normalColumns={tblColumns}
        overdueColumns={tblColumnsOverDue}
        normalData={reconnectionApplicationsToDataGrid}
        overdueData={reconnectionApplicationsOverDueToDataGrid}
        onRowClick={handleRowClick}
        mobileFields={["applicationId", "applicantName", "applicationStatusId"]}
        showCompanyFilter={code == 10}
        companies={companies}
        selectedOfficeCode={selectedOfficeCode}
        onOfficeCodeChange={setSelectedOfficeCode}
        normalTableProps={{
          firstPage: handleFirstPageNormal,
          lastPage: handleLastPageNormal,
          totalPages: totalPagesNormal,
          totalRecords: totalRecordsNormal,
          currentPage: currentPageNormal,
          handleFilterDateFrom: handleDateFromFilterNormal,
          handleFilterDateTo: handleDateToFilterNormal,
          resetDateFilter: handleResetDateFilterNormal,
          handleFilterProgressId: handleProgressIdFilterNormal,
          handleFilterObjectionStatus: handleObjectionStatusFilterNormal,
          resetProgressIdFilter: handleResetProgressIdFilterNormal,
          resetObjectionStatusFilter: handleResetObjectionStatusFilterNormal,
          nextPage: handleNextPageNormal,
          previousPage: handlePreviousPageNormal,
        }}
        overdueTableProps={{
          firstPage: handleFirstPageOverdue,
          nextPage: handleNextPageOverdue,
          previousPage: handlePreviousPageOverdue,
          lastPage: handleLastPageOverdue,
          handleFilterDateFrom: handleDateFromFilterOverdue,
          handleFilterDateTo: handleDateToFilterOverdue,
          resetDateFilter: handleResetDateFilterOverdue,
          resetProgressIdFilter: handleResetProgressIdFilterOverdue,
          resetObjectionStatusFilter: handleResetObjectionStatusFilterOverdue,
          handleFilterProgressId: handleProgressIdFilterOverdue,
          handleFilterObjectionStatus: handleObjectionStatusFilterOverdue,
          totalPages: totalPagesOverdue,
          totalRecords: totalRecordsOverdue,
          currentPage: currentPageOverdue,
        }}
      />

      {/* Main Popup */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"false"}
        className="main-dialog"
      >
        <DialogTitle className="dialog-title">
          <Grid container spacing={1} className="headercontainer">
            <Grid item lg={0.5}></Grid>
            <Grid item lg={11} className="applicationTitleGrid">
              <Typography className="applicationTitleText">
                Reconnection -
                <span style={{ marginLeft: "1%", color: "white" }}>
                  {dialogRowData.applicationProgressId === 0 &&
                    " Document Uploading"}
                  {dialogRowData.applicationProgressId === 1 &&
                    " Document Verification"}
                  {dialogRowData.applicationProgressId === 2 &&
                    " RCO Fee Approval"}
                  {dialogRowData.applicationProgressId === 3 &&
                    " RCO Fee Submission"}
                  {dialogRowData.applicationProgressId === 4 &&
                    " RCO Fee Verification"}
                  {dialogRowData.applicationProgressId === 5 && " Field Survey"}
                  {dialogRowData.applicationProgressId === 6 && " DN Approval"}
                  {dialogRowData.applicationProgressId === 7 &&
                    " DN Submission"}
                  {dialogRowData.applicationProgressId === 8 &&
                    " DN Payment Verification"}
                  {dialogRowData.applicationProgressId === 9 &&
                    " Meter Installation"}
                  {dialogRowData.applicationProgressId === 10 &&
                    " Forward To RO"}
                  {dialogRowData.applicationProgressId === 11 &&
                    " Ready For Billing"}
                  {dialogRowData.applicationProgressId === 12 &&
                    " Application Completed"}
                </span>
              </Typography>
            </Grid>
            <Grid item lg={0.25} sx={{ marginTop: "0.5%" }}>
              <PrintIcon
                onClick={() => downloadEFile(dialogRowData)}
                sx={{ cursor: "pointer", color: "white" }}
              />
            </Grid>
            <Grid item lg={0.25} className="closeIcon">
              <CloseIcon
                id="clearPopup"
                onClick={handleClose}
                sx={{ color: "white" }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "white" }}>
          <DialogContentText component="div" className="dialog-content">
            <Grid container spacing={1} className="headercontainer">
              <Grid item lg={12} className="status-bar">
                <StepProgressBar
                  array={rcoStatusBarArray}
                  applicationProgressId={dialogRowData.applicationProgressId}
                  skippedSteps={
                    // dialogRowData.isDiscAboveAYear === false
                    dialogRowData.isSecurityRequired === false &&
                    dialogRowData.isDiscAboveAYear === false
                      ? [5, 6, 7, 8] // skip these steps
                      : [] // otherwise skip none
                  }
                  openDetailsPopUp={() => {}}
                  pageName="Reconnection"
                />
              </Grid>
              <Grid item lg={12} className="application-details">
                <Grid container spacing={1} className="first-row">
                  <Grid item lg={1.33} className="first-row-item">
                    <p className="prop-title">Application Id</p>
                    <p className="prop-detail">
                      {dialogRowData.applicationId
                        ? dialogRowData.applicationId
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2.66} className="first-row-item">
                    <p className="prop-title">Applicant Name</p>
                    <p className="prop-detail">
                      {dialogRowData.consumerName
                        ? dialogRowData.consumerName
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.33} className="first-row-item">
                    <p className="prop-title">Applicant CNIC</p>
                    <p className="prop-detail">
                      {dialogRowData.consumerCNIC
                        ? dialogRowData.consumerCNIC
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2.5} className="first-row-item">
                    <p className="prop-title">Father Name</p>
                    <p className="prop-detail">
                      {dialogRowData.consumerFatherName
                        ? dialogRowData.consumerFatherName
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Sanct. Load(kW)</p>
                    <p className="prop-detail">
                      {dialogRowData.sanctionedLoad
                        ? dialogRowData.sanctionedLoad
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Connection Type</p>
                    <p className="prop-detail">
                      {dialogRowData.connectionCategory
                        ? dialogRowData.connectionCategory
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Meter Type</p>
                    <p className="prop-detail">
                      {dialogRowData.meterType ? dialogRowData.meterType : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Tariff</p>
                    <p className="prop-detail">
                      {dialogRowData.tariffDesc
                        ? dialogRowData.tariffDesc
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
                <Grid container spacing={1} className="second-row">
                  <Grid item lg={1.33} className="second-row-item">
                    <p className="prop-title">Subdivision</p>
                    <p className="prop-detail">
                      {subdivisionName(
                        dialogRowData.subDivisionCode,
                        subDivisions,
                      )}
                    </p>
                  </Grid>
                  <Grid item lg={1.33} className="second-row-item">
                    <p className="prop-title">Ref. No.</p>
                    <p className="prop-detail">
                      {dialogRowData.referenceNo
                        ? dialogRowData.referenceNo
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.33} className="second-row-item">
                    <p className="prop-title">Consumer Id.</p>
                    <p className="prop-detail">
                      {dialogRowData.customerId
                        ? dialogRowData.customerId
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.33} className="second-row-item">
                    <p className="prop-title">Phone No.</p>
                    <p className="prop-detail">
                      {dialogRowData.applicantMobileNo
                        ? dialogRowData.applicantMobileNo
                        : "-"}
                    </p>
                  </Grid>

                  <Grid item lg={4} className="second-row-item">
                    <p className="prop-title">Address</p>
                    <p className="prop-detail">
                      {dialogRowData.consumerAddress
                        ? dialogRowData.consumerAddress
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.4} className="second-row-item">
                    <p className="prop-title">Disconnection Date</p>
                    <p className="prop-detail">
                      {dialogRowData.disconnectionDate
                        ? convertDateDDMMYY(dialogRowData.disconnectionDate)
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.13} className="second-row-item">
                    <p className="prop-title">Area Type</p>
                    <p className="prop-detail">
                      {dialogRowData.areaType
                        ? dialogRowData.areaType === "U"
                          ? "Urban"
                          : dialogRowData.areaType === "R" && "Rural"
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className="processing-summary">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <h2 style={{ margin: 0, fontSize: 22 }}>Activity Log</h2>
                </div>

                {viewDropBackForEfile ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <CircularProgress size={30} />
                  </div>
                ) : eFileData && eFileData.length > 0 ? (
                  <ProcessingSummaryTableForCoa
                    key={tableDataProcessingSummary.length}
                    data={tableDataProcessingSummary}
                    columns={tableColumnsProcessingSummary}
                    openDetailsPopUp={(fullRow) => {
                      openDetailsPopUp(fullRow._raw);
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <button
                      onClick={onPressViewActivityLog}
                      type="submit"
                      className="view-button"
                      style={{
                        marginBottom: "10px",
                        backgroundColor: "#003971",
                        borderRadius: "20px",
                        color: "white",
                        padding: "12px 25px",
                      }}
                    >
                       Load Activity
                      Log
                    </button>
                  </div>
                )}
              </Grid>
              <Grid item className="action-form">
                <div className="fields">
                  {dialogRowData.applicationProgressId === 0 ? (
                    <>
                      <h3 className="step-title">Documents Pending</h3>
                      <div className="description-box">
                        <p className="group-description">
                          <InfoIcon className="icon" />
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                          )
                            ? "To process application, some documents are yet to be provided by the customer. If available, you can upload the remaining documents by clicking below button."
                            : "To process application, some documents are yet to be provided by the customer."}
                        </p>
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 1 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Document Verification",
                    ) ? (
                      <>
                        <h3 className="step-title">Attached Documents</h3>
                        <Grid
                          className="document-verification-container"
                          container
                          spacing={1}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: "1%",
                            padding: "2%",
                          }}
                        >
                          {error && (
                            <Error
                              error={error}
                              onClose={errorCloses}
                              backgroundColor="#FFC0CB"
                              textColor="#bb0303"
                              iconColor="#bb0303"
                            />
                          )}
                          {(dialogRowData.applicantCNICFront ||
                            dialogRowData.applicantCNICBack) && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: getDocumentBackGroundColor(
                                    flag_applicantCNICFront,
                                  ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!copyOfApplicantCNICVerifyPopUp) {
                                        setCopyOfApplicantCNICVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {dialogRowData.applicantCNICFront &&
                                    dialogRowData.applicantCNICFront.slice(
                                      0,
                                      6,
                                    ) == "data:i" ? (
                                      <Base64Image
                                        data={dialogRowData.applicantCNICFront}
                                        width="80"
                                      />
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {dialogRowData.applicantCNICBack &&
                                    dialogRowData.applicantCNICBack.slice(
                                      0,
                                      6,
                                    ) === "data:i" ? (
                                      flag_applicantCNICFront === 1 ||
                                      flag_applicantCNICBack === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.applicantCNICBack
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-120px",
                                              marginTop: "-30px",
                                            }}
                                          />
                                        </>
                                      ) : flag_applicantCNICFront === -1 ||
                                        flag_applicantCNICBack === -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.applicantCNICBack
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-120px",
                                              marginTop: "-30px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.applicantCNICBack}
                                          width="80"
                                        />
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {copyOfApplicantCNICVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          copyOfApplicantCNICVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hideCopyOfApplicantCNICVerifyAlert
                                        }
                                        documentName="Applicant CNIC"
                                        documentImage={
                                          dialogRowData.applicantCNICFront
                                        }
                                        backDocumentImage={
                                          dialogRowData.applicantCNICBack
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.applicantCNICFront
                                        }
                                        documentFlag={
                                          dialogRowData.applicantCNICFrontFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          applicantCNICBackObjectionRemarks
                                        }
                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                        flag_document={flag_applicantCNICFront}
                                        flag_documentBack={
                                          flag_applicantCNICBack
                                        }
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Applicant's CNIC.</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </>
                    ) : (
                      <>
                        <h3 className="step-title">Documents Verification</h3>
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" /> Document verification
                            is in process by the Customer Service Lead.
                          </p>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 1 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Documents Objection</h3>
                      <Grid
                        className="document-verification-container"
                        container
                        spacing={1}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        {(dialogRowData.applicantCNICFront ||
                          dialogRowData.applicantCNICBack) && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(
                                  flag_applicantCNICFront,
                                ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Applicant's CNIC.</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!copyOfApplicantCNICVerifyPopUp) {
                                      setCopyOfApplicantCNICVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                  }}
                                >
                                  {dialogRowData.applicantCNICFront &&
                                  dialogRowData.applicantCNICFront.slice(
                                    0,
                                    6,
                                  ) == "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.applicantCNICFront}
                                      width="80"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {dialogRowData.applicantCNICBack &&
                                  dialogRowData.applicantCNICBack.slice(0, 6) ==
                                    "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.applicantCNICBack}
                                      width="80"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {copyOfApplicantCNICVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={
                                        copyOfApplicantCNICVerifyPopUp
                                      }
                                      hideDocVerifyPopup={
                                        hideCopyOfApplicantCNICVerifyAlert
                                      }
                                      documentName="Applicant CNIC"
                                      documentImage={
                                        dialogRowData.applicantCNICFront
                                      }
                                      backDocumentImage={
                                        dialogRowData.applicantCNICBack
                                      }
                                      width={400}
                                      document={
                                        dialogRowData.applicantCNICFront
                                      }
                                      documentFlag={
                                        dialogRowData.applicantCNICFrontFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        applicantCNICFrontObjectionRemarks
                                      }
                                      titleToUpdateFlag="copyOfApplicantCNIC"
                                      flag_document={flag_applicantCNICFront}
                                      flag_documentBack={flag_applicantCNICBack}
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>RCO Fee Approval</h4>
                        </Grid>
                        {paymentStatus === "Arrear exists" && (
                          <Grid item lg={1}>
                            <Button
                              variant="outlined"
                              onClick={() =>
                                downloadBill(dialogRowData.referenceNo)
                              }
                              sx={{
                                backgroundColor: "white",
                                cursor: "pointer",
                                border: "1px solid #006ad1",
                                boxShadow: "none",
                                width: "5%",
                              }}
                            >
                              <PrintIcon
                                sx={{ color: "#006ad1", marginLeft: "1%" }}
                              />{" "}
                              Bill{" "}
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "RCO Fee Voucher Approval",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          <Grid
                            container
                            className="dn-payment-submission-container"
                          >
                            {/* <Grid item lg={3} className="item">
                              <Typography className="title">
                                Issue Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.issueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Due Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.dueDate)
                                  : "-"}
                              </Typography>
                            </Grid> */}
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Fixed Charges
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.fixedChargesAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">RCO Fee</Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.rcoFeeAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Total Fee
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount ||
                                rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      Number(
                                        rcoFeeVoucherDetails?.fixedChargesAmount ||
                                          0,
                                      ) +
                                        Number(
                                          rcoFeeVoucherDetails?.rcoFeeAmount ||
                                            0,
                                        ),
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>

                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Name
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankName
                                  ? rcoFeeVoucherDetails.roBankName
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account No
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountNo
                                  ? rcoFeeVoucherDetails.roBankAccountNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account Title
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountTitle
                                  ? rcoFeeVoucherDetails.roBankAccountTitle
                                  : "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            className="field-survey-container"
                            spacing={3}
                          >
                            {!paymentStatus && (
                              <>
                                <Grid
                                  item
                                  lg={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <button
                                    onClick={() => referenceApi(dialogRowData)}
                                    style={{
                                      backgroundColor: "#003971",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "10px 40px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                    className="view-button"
                                  >
                                    Check Arrears
                                  </button>
                                </Grid>
                              </>
                            )}

                            {paymentStatus && (
                              <Grid
                                item
                                lg={12}
                                sx={{
                                  textAlign: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    color:
                                      paymentStatus === "No arrear exists"
                                        ? "green"
                                        : "red",
                                    fontSize: "28px",
                                  }}
                                >
                                  {paymentStatus}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Arrear Amount
                                  </Typography>
                                  <Typography className="value">
                                    {arrearAmount
                                      ? numberFormatting(arrearAmount)
                                      : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Bill Month
                                  </Typography>
                                  <Typography className="value">
                                    {billMonth ? convertDate(billMonth) : "-"}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                {/* ======================= UPLOAD RECEIPT ======================= */}
                                <Grid item lg={3} className="item">
                                  <Typography className="title">
                                    Paid Bill Receipt
                                  </Typography>

                                  {arearPaidBillDocument ? (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      sx={{ width: "100%" }}
                                      startIcon={
                                        <CloseIcon
                                          sx={{ color: "red" }}
                                          onClick={() => {
                                            setArearPaidBillDocument("");
                                            setArearPaidBillDocumentThumbnail(
                                              "",
                                            );

                                            arrearPaymentReceiptFormik.setFieldValue(
                                              "iv_arrear_paid_bill_document",
                                              "",
                                            );

                                            arrearPaymentReceiptFormik.setFieldTouched(
                                              "iv_arrear_paid_bill_document",
                                              true,
                                              true,
                                            );
                                          }}
                                        />
                                      }
                                    >
                                      {arearPaidBillDocumentThumbnail && (
                                        <>
                                          {arearPaidBillDocumentThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={
                                                arearPaidBillDocumentThumbnail
                                              }
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : arearPaidBillDocumentThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : null}
                                        </>
                                      )}
                                    </Button>
                                  ) : (
                                    <>
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<FileUploadOutlinedIcon />}
                                        sx={{
                                          padding: "2%",
                                          width: "100%",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        Upload
                                        <input
                                          hidden
                                          accept={documentExtensions}
                                          id="iv_arrear_paid_bill_document"
                                          name="iv_arrear_paid_bill_document"
                                          type="file"
                                          onChange={PaidArrearsImage}
                                        />
                                      </Button>
                                    </>
                                  )}

                                  <Box className="form-error">
                                    {arearPaidBillDocumentError
                                      ? arearPaidBillDocumentError
                                      : null}
                                  </Box>
                                  <Box
                                    className="form-error"
                                    sx={{
                                      color: "red",
                                      fontSize: "0.85rem",
                                    }}
                                  >
                                    {arrearPaymentReceiptFormik.errors
                                      .iv_arrear_paid_bill_document &&
                                    arrearPaymentReceiptFormik.touched
                                      .iv_arrear_paid_bill_document
                                      ? arrearPaymentReceiptFormik.errors
                                          .iv_arrear_paid_bill_document
                                      : null}
                                  </Box>
                                </Grid>

                                {/* ======================= PAYMENT DATE ======================= */}
                                <Grid
                                  item
                                  lg={2}
                                  sx={{ marginTop: "1%", marginLeft: "5px" }}
                                >
                                  <Typography className="fieldLabel">
                                    Payment Date
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv_arrear_payment_date_field"
                                    name="iv_arrear_payment_date"
                                    type="date"
                                    value={
                                      arrearPaymentReceiptFormik.values
                                        .iv_arrear_payment_date
                                    }
                                    onChange={
                                      arrearPaymentReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                      "& .MuiInputBase-root": {
                                        cursor: "pointer",
                                      },
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById(
                                          "iv_arrear_payment_date_field",
                                        )
                                        ?.showPicker?.()
                                    }
                                    inputProps={{
                                      max: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                    }}
                                  />

                                  {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Show date error */}
                                  <Box sx={{ color: "red" }}>
                                    {arrearPaymentReceiptFormik.touched
                                      .iv_arrear_payment_date &&
                                    arrearPaymentReceiptFormik.errors
                                      .iv_arrear_payment_date
                                      ? arrearPaymentReceiptFormik.errors
                                          .iv_arrear_payment_date
                                      : null}
                                  </Box>
                                </Grid>

                                {/* ======================= REMARK DETAILS ======================= */}
                                <Grid
                                  item
                                  lg={3}
                                  className="item"
                                  sx={{ marginTop: "1%", marginLeft: "5px" }}
                                >
                                  <Typography className="fieldLabel">
                                    Remarks Details
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv_remarks_detail"
                                    name="iv_remarks_detail"
                                    placeholder="Enter remarks..."
                                    value={
                                      arrearPaymentReceiptFormik.values
                                        .iv_remarks_detail
                                    }
                                    onChange={
                                      arrearPaymentReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                    }}
                                  />

                                  {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Error same style as others */}
                                  <Box
                                    sx={{
                                      color: "red",
                                      fontSize: "0.85rem",
                                      mt: 0.5,
                                    }}
                                  >
                                    {arrearPaymentReceiptFormik.touched
                                      .iv_remarks_detail &&
                                    arrearPaymentReceiptFormik.errors
                                      .iv_remarks_detail
                                      ? arrearPaymentReceiptFormik.errors
                                          .iv_remarks_detail
                                      : null}
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>RCO Fee Approval</h4>
                        </Grid>
                        {paymentStatus === "Arrear exists" && (
                          <Grid item lg={1}>
                            <Button
                              variant="outlined"
                              onClick={() =>
                                downloadBill(dialogRowData.referenceNo)
                              }
                              sx={{
                                backgroundColor: "white",
                                cursor: "pointer",
                                border: "1px solid #006ad1",
                                boxShadow: "none",
                                width: "5%",
                              }}
                            >
                              <PrintIcon
                                sx={{ color: "#006ad1", marginLeft: "1%" }}
                              />{" "}
                              Bill{" "}
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "RCO Fee Voucher Approval",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          <Grid
                            container
                            className="dn-payment-submission-container"
                          >
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Issue Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.issueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Due Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.dueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Fixed Charges
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.fixedChargesAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">RCO Fee</Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.rcoFeeAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Total Fee
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount ||
                                rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      Number(
                                        rcoFeeVoucherDetails?.fixedChargesAmount ||
                                          0,
                                      ) +
                                        Number(
                                          rcoFeeVoucherDetails?.rcoFeeAmount ||
                                            0,
                                        ),
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>

                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Name
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankName
                                  ? rcoFeeVoucherDetails.roBankName
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account No
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountNo
                                  ? rcoFeeVoucherDetails.roBankAccountNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account Title
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountTitle
                                  ? rcoFeeVoucherDetails.roBankAccountTitle
                                  : "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            className="field-survey-container"
                            spacing={3}
                          >
                            {!paymentStatus && (
                              <>
                                <Grid
                                  item
                                  lg={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <button
                                    onClick={() => referenceApi(dialogRowData)}
                                    style={{
                                      backgroundColor: "#003971",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "10px 40px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                    className="view-button"
                                  >
                                    Check Arrears
                                  </button>
                                </Grid>
                              </>
                            )}

                            {paymentStatus && (
                              <Grid
                                item
                                lg={12}
                                sx={{
                                  textAlign: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    color:
                                      paymentStatus === "No arrear exists"
                                        ? "green"
                                        : "red",
                                    fontSize: "28px",
                                  }}
                                >
                                  {paymentStatus}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Arrear Amount
                                  </Typography>
                                  <Typography className="value">
                                    {arrearAmount
                                      ? numberFormatting(arrearAmount)
                                      : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Bill Month
                                  </Typography>
                                  <Typography className="value">
                                    {billMonth ? convertDate(billMonth) : "-"}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                {/* ======================= UPLOAD RECEIPT ======================= */}
                                <Grid item lg={3} className="item">
                                  <Typography className="title">
                                    Paid Bill Receipt
                                  </Typography>

                                  {arearPaidBillDocument ? (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      sx={{ width: "100%" }}
                                      startIcon={
                                        <CloseIcon
                                          sx={{ color: "red" }}
                                          onClick={() => {
                                            setArearPaidBillDocument("");
                                            setArearPaidBillDocumentThumbnail(
                                              "",
                                            );

                                            arrearPaymentObjectionReceiptFormik.setFieldValue(
                                              "iv_obj_arrear_paid_bill_document",
                                              "",
                                            );

                                            arrearPaymentObjectionReceiptFormik.setFieldTouched(
                                              "iv_obj_arrear_paid_bill_document",
                                              true,
                                              true,
                                            );
                                          }}
                                        />
                                      }
                                    >
                                      {arearPaidBillDocumentThumbnail && (
                                        <>
                                          {arearPaidBillDocumentThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={
                                                arearPaidBillDocumentThumbnail
                                              }
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : arearPaidBillDocumentThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : null}
                                        </>
                                      )}
                                    </Button>
                                  ) : (
                                    <>
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<FileUploadOutlinedIcon />}
                                        sx={{
                                          padding: "2%",
                                          width: "100%",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        Upload
                                        <input
                                          hidden
                                          accept={documentExtensions}
                                          id="iv_obj_arrear_paid_bill_document"
                                          name="iv_obj_arrear_paid_bill_document"
                                          type="file"
                                          onChange={OBJPaidArrearsImage}
                                        />
                                      </Button>
                                    </>
                                  )}

                                  <Box className="form-error">
                                    {arearPaidBillDocumentError
                                      ? arearPaidBillDocumentError
                                      : null}
                                  </Box>
                                  <Box
                                    className="form-error"
                                    sx={{
                                      color: "red",
                                      fontSize: "0.85rem",
                                    }}
                                  >
                                    {arrearPaymentObjectionReceiptFormik.errors
                                      .iv_obj_arrear_paid_bill_document &&
                                    arrearPaymentObjectionReceiptFormik.touched
                                      .iv_obj_arrear_paid_bill_document
                                      ? arrearPaymentObjectionReceiptFormik
                                          .errors
                                          .iv_obj_arrear_paid_bill_document
                                      : null}
                                  </Box>
                                </Grid>

                                {/* ======================= PAYMENT DATE ======================= */}
                                <Grid
                                  item
                                  lg={2}
                                  sx={{ marginTop: "1%", marginLeft: "5px" }}
                                >
                                  <Typography className="fieldLabel">
                                    Payment Date
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv__obj_arrear_payment_date_field"
                                    name="iv__obj_arrear_payment_date"
                                    type="date"
                                    value={
                                      arrearPaymentObjectionReceiptFormik.values
                                        .iv__obj_arrear_payment_date
                                    }
                                    onChange={
                                      arrearPaymentObjectionReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentObjectionReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                      "& .MuiInputBase-root": {
                                        cursor: "pointer",
                                      },
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById(
                                          "iv__obj_arrear_payment_date_field",
                                        )
                                        ?.showPicker?.()
                                    }
                                    inputProps={{
                                      max: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                    }}
                                  />

                                  {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Show date error */}
                                  <Box sx={{ color: "red" }}>
                                    {arrearPaymentObjectionReceiptFormik.touched
                                      .iv__obj_arrear_payment_date &&
                                    arrearPaymentObjectionReceiptFormik.errors
                                      .iv__obj_arrear_payment_date
                                      ? arrearPaymentObjectionReceiptFormik
                                          .errors.iv__obj_arrear_payment_date
                                      : null}
                                  </Box>
                                </Grid>

                                {/* ======================= REMARK DETAILS ======================= */}
                                <Grid
                                  item
                                  lg={3}
                                  className="item"
                                  sx={{ marginTop: "1%", marginLeft: "5px" }}
                                >
                                  <Typography className="fieldLabel">
                                    Remarks Details
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv_obj_remarks_detail"
                                    name="iv_obj_remarks_detail"
                                    placeholder="Enter remarks..."
                                    value={
                                      arrearPaymentObjectionReceiptFormik.values
                                        .iv_obj_remarks_detail
                                    }
                                    onChange={
                                      arrearPaymentObjectionReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentObjectionReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                    }}
                                  />

                                  {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Error same style as others */}
                                  <Box
                                    sx={{
                                      color: "red",
                                      fontSize: "0.85rem",
                                      mt: 0.5,
                                    }}
                                  >
                                    {arrearPaymentObjectionReceiptFormik.touched
                                      .iv_obj_remarks_detail &&
                                    arrearPaymentObjectionReceiptFormik.errors
                                      .iv_obj_remarks_detail
                                      ? arrearPaymentObjectionReceiptFormik
                                          .errors.iv_obj_remarks_detail
                                      : null}
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                          marginBottom: "1%",
                          padding: "0.5%",
                        }}
                      >
                        <h4
                          style={{
                            margin: 0,
                          }}
                        >
                          RCO Fee Submission
                        </h4>
                        <div style={{ display: "flex", gap: "15px" }}>
                          <Button
                            variant="outlined"
                            onClick={() => downloadRCOFeePDF(dialogRowData)}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "auto",
                              minWidth: "5%",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            RCO Fee Voucher{" "}
                          </Button>

                          <Button
                            variant="outlined"
                            onClick={() =>
                              downloadFixedChargesPDF(dialogRowData)
                            }
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "auto",
                              minWidth: "5%",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            Fixed Charges Voucher{" "}
                          </Button>

                          <Button
                            variant="outlined"
                            onClick={() =>
                              downloadBill(dialogRowData.referenceNo)
                            }
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "auto",
                              minWidth: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            Bill{" "}
                          </Button>
                        </div>
                      </div>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "RCO Fee Voucher Submission",
                      ) ? (
                        <>
                          <Grid
                            container
                            className="dn-payment-submission-container"
                          >
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Issue Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.issueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Due Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.dueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Fixed Charges
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.fixedChargesAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">RCO Fee</Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.rcoFeeAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Total Fee
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount ||
                                rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      Number(
                                        rcoFeeVoucherDetails?.fixedChargesAmount ||
                                          0,
                                      ) +
                                        Number(
                                          rcoFeeVoucherDetails?.rcoFeeAmount ||
                                            0,
                                        ),
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>

                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Name
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankName
                                  ? rcoFeeVoucherDetails.roBankName
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account No
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountNo
                                  ? rcoFeeVoucherDetails.roBankAccountNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account Title
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountTitle
                                  ? rcoFeeVoucherDetails.roBankAccountTitle
                                  : "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "15px",
                              padding: "15px",
                            }}
                          >
                            <Grid
                              item
                              style={{ marginTop: "1%", width: "20%" }}
                            >
                              <Typography
                                className="fieldLabel"
                                sx={{
                                  paddingTop: "10px",
                                  paddingBottom: "2%",
                                }}
                              >
                                Receipt Image
                              </Typography>
                              {rcoFeeReceiptImage ? (
                                <>
                                  <Button
                                    varient="outlined"
                                    component="label"
                                    startIcon={
                                      <CloseIcon
                                        sx={{ color: "red" }}
                                        onClick={() => {
                                          setRcoFeeReceiptImage("");
                                          setRcoFeeReceiptImageThumbnail("");

                                          rcoFeeReceiptFormik.setFieldValue(
                                            "iv_rco_fee_receipt_image",
                                            "",
                                          );

                                          rcoFeeReceiptFormik.setFieldTouched(
                                            "iv_rco_fee_receipt_image",
                                            true,
                                            true,
                                          );
                                        }}
                                      />
                                    }
                                  >
                                    {rcoFeeReceiptImageThumbnail && (
                                      <>
                                        {rcoFeeReceiptImageThumbnail.startsWith(
                                          "data:image/",
                                        ) ? (
                                          <img
                                            src={rcoFeeReceiptImageThumbnail}
                                            alt="arear Paid receipt"
                                            width="80"
                                          />
                                        ) : rcoFeeReceiptImageThumbnail.startsWith(
                                            "data:application/pdf",
                                          ) ? (
                                          <img
                                            src={pdfIcon}
                                            alt="arear Paid receipt"
                                            width="80"
                                          />
                                        ) : null}
                                      </>
                                    )}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                    sx={{
                                      padding: "4%",
                                      width: "100%",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Upload
                                    <input
                                      hidden
                                      accept={documentExtensions}
                                      id="iv_rco_fee_receipt_image"
                                      name="iv_rco_fee_receipt_image"
                                      type="file"
                                      onChange={RcoFeeReceiptImage}
                                    />
                                  </Button>
                                </>
                              )}
                              <Box className="form-error" sx={{ color: "red" }}>
                                {rcoFeeReceiptFormik.errors
                                  .iv_rco_fee_receipt_image &&
                                rcoFeeReceiptFormik.touched
                                  .iv_rco_fee_receipt_image
                                  ? rcoFeeReceiptFormik.errors
                                      .iv_rco_fee_receipt_image
                                  : null}
                              </Box>
                            </Grid>
                            <Grid
                              item
                              style={{ marginTop: "1%", width: "20%" }}
                            >
                              <Typography
                                className="fieldLabel"
                                sx={{
                                  paddingTop: "10px",
                                  paddingBottom: "2%",
                                }}
                              >
                                Payment Date
                              </Typography>
                              <input
                                name="iv_rco_fee_payment_date"
                                value={
                                  rcoFeeReceiptFormik.values
                                    .iv_rco_fee_payment_date
                                }
                                onChange={rcoFeeReceiptFormik.handleChange}
                                onBlur={rcoFeeReceiptFormik.handleBlur}
                                type="date"
                                className="fieldReferenceNo"
                                style={{
                                  width: "200px",
                                  height: "30px",
                                  padding: "4px",
                                }}
                                min={
                                  rcoFeeVoucherDetails.issueDate
                                    ? rcoFeeVoucherDetails.issueDate.slice(
                                        0,
                                        10,
                                      )
                                    : ""
                                }
                                max={
                                  rcoFeeVoucherDetails.dueDate
                                    ? new Date().toISOString().split("T")[0] <=
                                      rcoFeeVoucherDetails.dueDate.slice(0, 10)
                                      ? new Date().toISOString().split("T")[0]
                                      : rcoFeeVoucherDetails.dueDate.slice(
                                          0,
                                          10,
                                        )
                                    : ""
                                }
                              />
                              <Box className="form-error" sx={{ color: "red" }}>
                                {rcoFeeReceiptFormik.errors
                                  .iv_rco_fee_payment_date &&
                                rcoFeeReceiptFormik.touched
                                  .iv_rco_fee_payment_date
                                  ? rcoFeeReceiptFormik.errors
                                      .iv_rco_fee_payment_date
                                  : null}
                              </Box>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "1%",
                          padding: "0.5%",
                        }}
                      >
                        <h4
                          style={{
                            margin: 0,
                          }}
                        >
                          RCO Fee Submission
                        </h4>
                        <div style={{ display: "flex", gap: "15px" }}>
                          <Button
                            variant="outlined"
                            onClick={() => downloadRCOFeePDF(dialogRowData)}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "auto",
                              minWidth: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            RCO Fee Voucher{" "}
                          </Button>

                          <Button
                            variant="outlined"
                            onClick={() =>
                              downloadFixedChargesPDF(dialogRowData)
                            }
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "auto",
                              minWidth: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            Fixed Charges Voucher{" "}
                          </Button>

                          <Button
                            variant="outlined"
                            onClick={() =>
                              downloadBill(dialogRowData.referenceNo)
                            }
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "auto",
                              minWidth: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            Bill{" "}
                          </Button>
                        </div>
                      </div>

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "RCO Fee Voucher Submission",
                      ) ? (
                        <>
                          <Grid
                            container
                            className="dn-payment-submission-container"
                          >
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Issue Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.issueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Due Date
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails
                                  ? convertDate(rcoFeeVoucherDetails.dueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Fixed Charges
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.fixedChargesAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">RCO Fee</Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      rcoFeeVoucherDetails.rcoFeeAmount,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Total Fee
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.fixedChargesAmount ||
                                rcoFeeVoucherDetails?.rcoFeeAmount
                                  ? numberFormatting(
                                      Number(
                                        rcoFeeVoucherDetails?.fixedChargesAmount ||
                                          0,
                                      ) +
                                        Number(
                                          rcoFeeVoucherDetails?.rcoFeeAmount ||
                                            0,
                                        ),
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>

                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Name
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankName
                                  ? rcoFeeVoucherDetails.roBankName
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account No
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountNo
                                  ? rcoFeeVoucherDetails.roBankAccountNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Bank Account Title
                              </Typography>
                              <Typography className="value">
                                {rcoFeeVoucherDetails?.roBankAccountTitle
                                  ? rcoFeeVoucherDetails.roBankAccountTitle
                                  : "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "15px",
                              padding: "15px",
                            }}
                          >
                            <Grid
                              item
                              style={{ marginTop: "1%", width: "20%" }}
                            >
                              <Typography
                                className="fieldLabel"
                                sx={{
                                  paddingTop: "10px",
                                  paddingBottom: "2%",
                                }}
                              >
                                Receipt Image
                              </Typography>
                              {rcoFeeReceiptImage ? (
                                <>
                                  <Button
                                    varient="outlined"
                                    component="label"
                                    startIcon={
                                      <CloseIcon
                                        sx={{ color: "red" }}
                                        onClick={() => {
                                          setRcoFeeReceiptImage("");
                                        }}
                                      />
                                    }
                                  >
                                    {rcoFeeReceiptImageThumbnail && (
                                      <>
                                        {rcoFeeReceiptImageThumbnail.startsWith(
                                          "data:image/",
                                        ) ? (
                                          <img
                                            src={rcoFeeReceiptImageThumbnail}
                                            alt="arear Paid receipt"
                                            width="80"
                                          />
                                        ) : rcoFeeReceiptImageThumbnail.startsWith(
                                            "data:application/pdf",
                                          ) ? (
                                          <img
                                            src={pdfIcon}
                                            alt="arear Paid receipt"
                                            width="80"
                                          />
                                        ) : null}
                                      </>
                                    )}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                    sx={{
                                      padding: "4%",
                                      width: "100%",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Upload
                                    <input
                                      hidden
                                      accept={documentExtensions}
                                      id="iv_rco_fee_receipt_image"
                                      name="iv_rco_fee_receipt_image"
                                      type="file"
                                      onChange={RcoFeeReceiptImage}
                                    />
                                  </Button>
                                </>
                              )}
                              <Box className="form-error" sx={{ color: "red" }}>
                                {rcoFeeReceiptFormik.errors
                                  .iv_rco_fee_receipt_image &&
                                rcoFeeReceiptFormik.touched
                                  .iv_rco_fee_receipt_image
                                  ? rcoFeeReceiptFormik.errors
                                      .iv_rco_fee_receipt_image
                                  : null}
                              </Box>
                            </Grid>
                            <Grid
                              item
                              style={{ marginTop: "1%", width: "20%" }}
                            >
                              <Typography
                                className="fieldLabel"
                                sx={{
                                  paddingTop: "10px",
                                  paddingBottom: "2%",
                                }}
                              >
                                Payment Date
                              </Typography>
                              <input
                                name="iv_rco_fee_payment_date"
                                value={
                                  rcoFeeReceiptFormik.values
                                    .iv_rco_fee_payment_date
                                }
                                onChange={rcoFeeReceiptFormik.handleChange}
                                onBlur={rcoFeeReceiptFormik.handleBlur}
                                type="date"
                                className="fieldReferenceNo"
                                style={{
                                  width: "200px",
                                  height: "30px",
                                  padding: "4px",
                                }}
                                min={
                                  rcoFeeVoucherDetails.issueDate
                                    ? rcoFeeVoucherDetails.issueDate.slice(
                                        0,
                                        10,
                                      )
                                    : ""
                                }
                                max={
                                  rcoFeeVoucherDetails.dueDate
                                    ? new Date().toISOString().split("T")[0] <=
                                      rcoFeeVoucherDetails.dueDate.slice(0, 10)
                                      ? new Date().toISOString().split("T")[0]
                                      : rcoFeeVoucherDetails.dueDate.slice(
                                          0,
                                          10,
                                        )
                                    : ""
                                }
                              />
                              <Box className="form-error" sx={{ color: "red" }}>
                                {rcoFeeReceiptFormik.errors
                                  .iv_rco_fee_payment_date &&
                                rcoFeeReceiptFormik.touched
                                  .iv_rco_fee_payment_date
                                  ? rcoFeeReceiptFormik.errors
                                      .iv_rco_fee_payment_date
                                  : null}
                              </Box>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 4 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <h3 className="step-title">RCO Fee Verification</h3>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "RCO Fee Payment Verification",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <Grid container className="paidDnContainer">
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              RCO Fee Voucher No.
                            </Typography>
                            <Typography className="value">
                              {dialogRowData.applicationId}
                            </Typography>
                          </Grid>
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Reference No.
                            </Typography>
                            <Typography className="value">
                              {dialogRowData.referenceNo
                                ? dialogRowData.referenceNo
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Fix Charges
                            </Typography>
                            <Typography className="value">
                              {rcoFeeVoucherDetails.fixedChargesAmount
                                ? numberFormatting(
                                    rcoFeeVoucherDetails.fixedChargesAmount,
                                  )
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={3} className="item">
                            <Typography className="title">RCO Fee</Typography>
                            <Typography className="value">
                              {rcoFeeVoucherDetails.rcoFeeAmount
                                ? numberFormatting(
                                    rcoFeeVoucherDetails.rcoFeeAmount,
                                  )
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={3} className="item">
                            <Typography className="title">Total Fee</Typography>
                            <Typography className="value">
                              {rcoFeeVoucherDetails?.fixedChargesAmount ||
                              rcoFeeVoucherDetails?.rcoFeeAmount
                                ? numberFormatting(
                                    Number(
                                      rcoFeeVoucherDetails?.fixedChargesAmount ||
                                        0,
                                    ) +
                                      Number(
                                        rcoFeeVoucherDetails?.rcoFeeAmount || 0,
                                      ),
                                  )
                                : "-"}
                            </Typography>
                          </Grid>

                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Payment Date
                            </Typography>
                            <Typography className="value">
                              {rcoFeeVoucherDetails.rcoFeePaymentDate
                                ? convertDateDDMMYY(
                                    rcoFeeVoucherDetails.rcoFeePaymentDate,
                                  )
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={12}></Grid>
                          <Grid item lg={4} className="item">
                            <Typography className="title">
                              Paid RCO Fee Voucher
                            </Typography>
                            <Grid
                              container
                              onClick={handleOpenImg}
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(0),
                                borderRadius: "10px",
                                height: "250px",
                                width: "100%",
                              }}
                              className="docContainer"
                            >
                              <img
                                src={paidRCOFeeVoucherImg}
                                alt="Cnic Front"
                                style={{ width: "100%", height: "100%" }}
                              ></img>
                            </Grid>
                          </Grid>
                          <Grid item lg={4} className="item">
                            <Typography className="title">
                              Customer ID. Front
                            </Typography>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(0),
                                borderRadius: "10px",
                                height: "250px",
                                width: "100%",
                              }}
                              className="docContainer"
                            >
                              <img
                                src={frontImg}
                                alt="Cnic Front"
                                style={{ width: "100%", height: "100%" }}
                              ></img>
                            </Grid>
                          </Grid>
                          <Grid item lg={4} className="item">
                            <Typography className="title">
                              Customer ID. Back
                            </Typography>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(0),
                                borderRadius: "10px",
                                height: "250px",
                                width: "100%",
                              }}
                              className="docContainer"
                            >
                              <img
                                src={backImg}
                                alt="Cnic Back"
                                style={{ width: "100%", height: "100%" }}
                              ></img>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                        }}
                      >
                        <h4 style={{ textAlign: "center", width: "100%" }}>
                          Field Survey
                        </h4>
                      </div>
                      {fieldSurveyError && (
                        <div
                          style={{
                            backgroundColor: "#FFF3F3",
                            display: "flex",
                            flexDirection: "row",

                            width: "100%",
                            padding: "1%",

                            justifyContent: "space-between",
                            marginBottom: "1%",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#FFF3F3",
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "1%",
                              width: "100%",
                              padding: "1%",
                              alignItems: "center",
                            }}
                          >
                            <ErrorIcon
                              style={{ color: "#bb0303", marginRight: "1%" }}
                            />

                            <p
                              style={{
                                color: "#bb0303",
                              }}
                            >
                              {fieldSurveyError}
                            </p>
                          </div>
                          <CloseIcon
                            onClick={errorCloses}
                            style={{
                              color: "#bb0303",
                              marginRight: "2%",
                              marginTop: "1%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      )}
                      {errormessageCostEstimation && (
                        <>
                          <div
                            style={{
                              backgroundColor: "#FFF3F3",
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                              padding: "1%",
                              justifyContent: "space-between",
                              marginBottom: "1%",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#FFF3F3",
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "1%",
                                width: "100%",
                                padding: "1%",
                                alignItems: "center",
                              }}
                            >
                              <ErrorIcon
                                style={{
                                  color: "#bb0303",
                                  marginRight: "1%",
                                }}
                              />
                              <p
                                style={{
                                  color: "#bb0303",
                                }}
                              >
                                {errormessageCostEstimation}
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Field Survey",
                      ) &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <Grid
                          container
                          spacing={0.5}
                          className="field-survey-container"
                        >
                          <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                            <Typography className="fieldLabel">
                              Site Observation
                            </Typography>
                            <Select
                              value={fieldFormik.values.iv_objection_Type}
                              onChange={fieldFormik.handleChange}
                              onBlur={fieldFormik.handleBlur}
                              className="fieldBatch"
                              name="iv_objection_Type"
                              id="iv_objection_Type"
                              sx={{ width: "95%" }}
                            >
                              {dialogRowData.applicationProgressId === 5
                                ? fieldObjections.map((option) => (
                                    <MenuItem key={option} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))
                                : null}
                            </Select>
                            <Box className="from-Error">
                              {fieldFormik.errors.iv_objection_Type &&
                              fieldFormik.touched.iv_objection_Type
                                ? fieldFormik.errors.iv_objection_Type
                                : null}
                            </Box>
                          </Grid>
                          {fieldFormik.values.iv_objection_Type ===
                            "No Issue" && (
                            <>
                              <Grid item lg={2} sx={{ marginTop: "20px" }}>
                                <Typography className="fieldLabel">
                                  Tariff
                                </Typography>
                                <TextField
                                  fullWidth
                                  // label="Tariff"
                                  name="iv_tariff_desc"
                                  className="fieldBatch"
                                  value={
                                    fieldFormik.values.iv_tariff_desc || ""
                                  }
                                  disabled
                                  size="small"
                                />

                                <Box className="form-error">
                                  {fieldFormik.errors.iv_tariff_desc &&
                                  fieldFormik.touched.iv_tariff_desc
                                    ? fieldFormik.errors.iv_tariff_desc
                                    : null}
                                </Box>
                              </Grid>
                              <Grid item lg={1.5} sx={{ marginTop: "2%" }}>
                                <Typography className="fieldLabel">
                                  Area (Marla)
                                </Typography>
                                <TextField
                                  size="small"
                                  value={
                                    fieldFormik.values.iv_coverage_area !==
                                    undefined
                                      ? fieldFormik.values.iv_coverage_area
                                      : ""
                                  }
                                  onChange={(e) => {
                                    const raw = e.target.value || "";
                                    const digits = raw.replace(/\D/g, "");
                                    const val = digits === "" ? "" : parseInt(digits, 10);
                                    fieldFormik.setFieldValue(
                                      "iv_coverage_area",
                                      val
                                    );
                                  }}
                                  onBlur={fieldFormik.handleBlur}
                                  name="iv_coverage_area"
                                  id="iv_coverage_area"
                                  className="fieldBatch"
                                  sx={{
                                    width: "95%",
                                    '& .MuiInputBase-root': { height: 35 },
                                  }}
                                  inputProps={{ inputMode: "numeric", pattern: "\\d*", min: 3 }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            const curr = parseInt(
                                              fieldFormik.values.iv_coverage_area
                                            );
                                            const current = isNaN(curr) ? 3 : curr;
                                            const next = current - 1 >= 3 ? current - 1 : 3;
                                            fieldFormik.setFieldValue(
                                              "iv_coverage_area",
                                              next
                                            );
                                          }}
                                        >
                                          <RemoveIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            const curr = parseInt(
                                              fieldFormik.values.iv_coverage_area
                                            );
                                            const current = isNaN(curr) ? 3 : curr;
                                            fieldFormik.setFieldValue(
                                              "iv_coverage_area",
                                              current + 1
                                            );
                                          }}
                                        >
                                          <AddIcon fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <p className="form-error">
                                  {fieldFormik.errors.iv_coverage_area &&
                                  fieldFormik.touched.iv_coverage_area
                                    ? fieldFormik.errors.iv_coverage_area
                                    : null}
                                </p>
                              </Grid>

                              <Grid item lg={3} sx={{ marginTop: "3%" }}>
                                <FormGroup className="radio-group">
                                  <RadioGroup
                                    row
                                    name="iv_rural_urban"
                                    value={fieldFormik.values.iv_rural_urban}
                                    onChange={(e) =>
                                      fieldFormik.setFieldValue(
                                        "iv_rural_urban",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <FormControlLabel
                                      value="U"
                                      control={<Radio />}
                                      label="Urban"
                                    />
                                    <FormControlLabel
                                      value="R"
                                      control={
                                        <Radio
                                          disabled={
                                            !CheckPermissions(
                                              permissions,
                                              "General Services",
                                              "Reconnection",
                                              "Workflow Permissions",
                                              "Meter Installation",
                                            )
                                          }
                                        />
                                      }
                                      label="Rural"
                                    />
                                  </RadioGroup>
                                </FormGroup>

                                <Box className="form-error">
                                  {fieldFormik.errors.iv_rural_urban &&
                                  fieldFormik.touched.iv_rural_urban
                                    ? fieldFormik.errors.iv_rural_urban
                                    : null}
                                </Box>
                              </Grid>
                            </>
                          )}

                          {fieldFormik.values.iv_objection_Type ===
                            "No Issue" && (
                            <>
                              <Grid item lg={12}></Grid>
                              <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                <Typography className="fieldLabel">
                                  {dialogRowData.applicationId.slice(3, 5) ==
                                  "15"
                                    ? "LT Line within 40 meters"
                                    : "Estimate Lumsum ?"}
                                </Typography>
                                <FormControl>
                                  <RadioGroup
                                    defaultValue={
                                      fieldFormik.values.iv_distance
                                    }
                                    value={fieldFormik.values.iv_distance}
                                    name="iv_distance"
                                    onChange={MeterLine}
                                    row
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <FormControlLabel
                                        value={1}
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                          marginLeft: "0px",
                                          marginRight: "10px",
                                          border: "1px solid lightgrey",
                                          marginTop: "2%",
                                        }}
                                        control={<Radio />}
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value={0}
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                          border: "1px solid lightgrey",
                                          textAlign: "right",
                                          marginLeft: "2%",
                                          marginTop: "2%",
                                        }}
                                        control={<Radio />}
                                        label="No"
                                      />
                                    </Box>
                                  </RadioGroup>
                                </FormControl>
                                <p className="form-error">
                                  {fieldFormik.errors.iv_distance &&
                                  fieldFormik.touched.iv_distance
                                    ? fieldFormik.errors.iv_distance
                                    : null}
                                </p>
                              </Grid>
                              <Grid
                                item
                                lg={3.5}
                                sx={{ marginTop: "2%", marginLeft: "1%" }}
                              >
                                <Typography className="fieldLabel">
                                  Meter Type
                                </Typography>
                                <FormControl className="form-control">
                                  <RadioGroup
                                    className="radio-group"
                                    row
                                    name="iv_meter_type"
                                    value={fieldFormik.values.iv_meter_type}
                                    onChange={fieldFormik.handleChange}
                                  >
                                    <FormControlLabel
                                      value="1"
                                      control={<Radio />}
                                      label="Smart"
                                      // disabled={
                                      //   dialogRowData?.applicationId?.slice(
                                      //     3,
                                      //     5,
                                      //   ) !== "14"
                                      // }
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "0px 10px",
                                        borderRadius: "5px",
                                        // marginRight: '10px', // increased slightly
                                        border: "1px solid lightgrey",
                                      }}
                                    />
                                    <FormControlLabel
                                      value="0"
                                      control={<Radio />}
                                      label="Normal"
                                      // disabled={
                                      //   dialogRowData?.applicationId?.slice(
                                      //     3,
                                      //     5,
                                      //   ) !== "14"
                                      // }
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "0px 10px",
                                        borderRadius: "5px",
                                        marginLeft: "10px", // adds small space
                                        border: "1px solid lightgrey",
                                      }}
                                    />
                                  </RadioGroup>
                                </FormControl>

                                {fieldFormik.touched.iv_meter_type &&
                                  fieldFormik.errors.iv_meter_type && (
                                    <p className="form-error">
                                      {fieldFormik.errors.iv_meter_type}
                                    </p>
                                  )}
                              </Grid>

                              {fieldFormik.values.iv_distance == 0 &&
                              dialogRowData?.applicationId?.slice(3, 5) !=
                                "14" ? (
                                <Grid item lg={1.5} sx={{ marginTop: "2%" }}>
                                  <Typography className="fieldLabel">
                                    Est. Distance (m)
                                  </Typography>

                                  <TextField
                                    name="iv_estimated_distance"
                                    value={
                                      fieldFormik.values
                                        .iv_estimated_distance || ""
                                    }
                                    type="number"
                                    sx={{ width: "85%", marginTop: "2%" }}
                                    fullWidth
                                    InputProps={{
                                      inputProps: { min: 0 }, // allow typing freely
                                    }}
                                    onChange={(e) => {
                                      fieldFormik.handleChange(e);
                                    }}
                                    onBlur={(e) => {
                                      const value = e.target.value;

                                      // Allow empty value (user clears field)
                                      if (value === "") {
                                        fieldFormik.setFieldValue(
                                          "iv_estimated_distance",
                                          "",
                                        );
                                        fieldFormik.handleBlur(e);
                                        return;
                                      }

                                      const numericValue = Number(value);

                                      if (
                                        fieldFormik.values.iv_distance == 0 &&
                                        numericValue < 41
                                      ) {
                                        fieldFormik.setFieldValue(
                                          "iv_estimated_distance",
                                          41,
                                        );
                                      }

                                      fieldFormik.handleBlur(e);
                                    }}
                                    className="fieldCoverageMarla1"
                                  />

                                  <p className="form-error">
                                    {fieldFormik.errors.iv_estimated_distance &&
                                    fieldFormik.touched.iv_estimated_distance
                                      ? fieldFormik.errors.iv_estimated_distance
                                      : null}
                                  </p>
                                </Grid>
                              ) : (
                                ((fieldFormik.values.iv_distance == 1 &&
                                  (dialogRowData?.applicationId?.slice(3, 5) ==
                                    "14" ||
                                    dialogRowData?.applicationId?.slice(3, 5) ==
                                      "13")) ||
                                  (fieldFormik.values.iv_distance == 0 &&
                                    dialogRowData?.applicationId?.slice(3, 5) ==
                                      "14")) && (
                                  <Grid item lg={1.5} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      Est. Distance (m)
                                    </Typography>

                                    <TextField
                                      name="iv_estimated_distance_yes"
                                      value={
                                        fieldFormik.values
                                          .iv_estimated_distance_yes || ""
                                      }
                                      type="number"
                                      sx={{ width: "85%", marginTop: "2%" }}
                                      fullWidth
                                      InputProps={{
                                        inputProps: {
                                          min:
                                            fieldFormik.values.iv_distance == 1
                                              ? 1
                                              : undefined,
                                          max:
                                            fieldFormik.values.iv_distance == 1
                                              ? dialogRowData?.appliedLoad < 5
                                                ? 160
                                                : 40
                                              : undefined,
                                        },
                                      }}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        fieldFormik.setFieldValue(
                                          "iv_estimated_distance_yes",
                                          value,
                                        );
                                      }}
                                      onBlur={(e) => {
                                        const value = e.target.value;
                                        if (value === "") return; 

                                        const numericValue = Number(value);
                                        const isDistanceOne =
                                          fieldFormik.values.iv_distance == 1;

                                        if (isDistanceOne) {
                                          const min = 1;
                                          const max =
                                            dialogRowData?.appliedLoad < 5
                                              ? 160
                                              : 40;

                                          if (numericValue < min) {
                                            fieldFormik.setFieldValue(
                                              "iv_estimated_distance_yes",
                                              min,
                                            );
                                            return;
                                          }

                                          if (numericValue > max) {
                                            fieldFormik.setFieldValue(
                                              "iv_estimated_distance_yes",
                                              max,
                                            );
                                            return;
                                          }

                                          fieldFormik.setFieldValue(
                                            "iv_estimated_distance_yes",
                                            numericValue,
                                          );
                                        } else {
                                          if (numericValue < 41) {
                                            fieldFormik.setFieldValue(
                                              "iv_estimated_distance_yes",
                                              41,
                                            );
                                          } else {
                                            fieldFormik.setFieldValue(
                                              "iv_estimated_distance_yes",
                                              numericValue,
                                            );
                                          }
                                        }

                                        fieldFormik.handleBlur(e);
                                      }}
                                      className="fieldCoverageMarla1"
                                    />

                                    <p className="form-error">
                                      {fieldFormik.errors
                                        .iv_estimated_distance_yes &&
                                      fieldFormik.touched
                                        .iv_estimated_distance_yes
                                        ? fieldFormik.errors
                                            .iv_estimated_distance_yes
                                        : null}
                                    </p>
                                  </Grid>
                                )
                              )}
                              {fieldFormik.values.iv_distance == 0 && (
                                <Grid item lg={2} sx={{ marginTop: "2%" }}>
                                  <Typography className="fieldLabel">
                                    Sketch / Diagram
                                  </Typography>
                                  <Box className="form-error">
                                    {fieldFormik.errors.iv_sketch_diagram &&
                                    fieldFormik.touched.iv_sketch_diagram
                                      ? fieldFormik.errors.iv_sketch_diagram
                                      : null}
                                  </Box>
                                  <Box className="form-error">
                                    {sketchDiagramError
                                      ? sketchDiagramError
                                      : null}
                                  </Box>
                                  {sketchDiagramUploaded ? (
                                    <Grid container>
                                      <Grid item sm={6}>
                                        <a
                                          href="#"
                                          onClick={() =>
                                            openBase64Image(
                                              sketchDiagramUploaded,
                                            )
                                          }
                                          target="_blank"
                                          rel="noreferrer"
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginTop: "2%",
                                          }}
                                        >
                                          <img
                                            src={sketchDiagramThumbnail}
                                            alt="Sketch Diagram"
                                            style={{ width: "100%" }}
                                          />
                                        </a>
                                      </Grid>
                                      {
                                        <Grid item sm={6}>
                                          <Button
                                            varient="outlined"
                                            component="label"
                                            startIcon={
                                              <CloseIcon
                                                sx={{ color: "red" }}
                                                onClick={
                                                  clearSketchDiagramSelection
                                                }
                                              />
                                            }
                                            disabled={
                                              dnDetails &&
                                              dnDetails.filledFlag &&
                                              dnDetails.filledFlag === 1 &&
                                              CheckPermissions(
                                                permissions,
                                                "General Services",
                                                "Reconnection",
                                                "Workflow Permissions",
                                                "Field Survey",
                                              )
                                            }
                                          >
                                            Change
                                            <input
                                              hidden
                                              accept={documentExtensions}
                                              id="iv_sketch_diagram"
                                              name="iv_sketch_diagram"
                                              type="file"
                                              onChange={SketchDiagram}
                                            />
                                          </Button>
                                        </Grid>
                                      }
                                    </Grid>
                                  ) : sketchDiagram ? ( 
                                    <>
                                      <Button
                                        varient="contained"
                                        component="label"
                                        startIcon={
                                          <CloseIcon
                                            sx={{ color: "red" }}
                                            onClick={
                                              clearSketchDiagramSelection
                                            }
                                          />
                                        }
                                      >
                                        {sketchDiagramThumbnail && (
                                          <>
                                            {sketchDiagramThumbnail.startsWith(
                                              "data:image/",
                                            ) ? (
                                              <img
                                                src={sketchDiagramThumbnail}
                                                alt="Sketch Diagram"
                                                width="80"
                                              />
                                            ) : sketchDiagramThumbnail.startsWith(
                                                "data:application/pdf",
                                              ) ? (
                                              <img
                                                src={pdfIcon}
                                                alt="Sketch Diagram PDF"
                                                width="80"
                                              />
                                            ) : null}
                                          </>
                                        )}
                                      </Button>
                                    </>
                                  ) : (
                                    <>
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<FileUploadOutlinedIcon />}
                                        sx={{
                                          width: "80%",
                                          backgroundColor: "white",
                                          textTransform: "capitalize",
                                          padding: "6%",
                                        }}
                                      >
                                        Upload
                                        <input
                                          hidden
                                          accept={documentExtensions}
                                          id="iv_sketch_diagram"
                                          name="iv_sketch_diagram"
                                          type="file"
                                          onChange={SketchDiagram}
                                        />
                                      </Button>
                                    </>
                                  )}
                                </Grid>
                              )}

                              {fieldFormik.values.iv_objection_Type ===
                                "No Issue" &&
                                fieldFormik.values.iv_distance == 0 && (
                                  <Grid item lg={2} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      Prepare Estimate
                                    </Typography>
                                    <Button
                                      variant="contained"
                                      fullWidth
                                      component="label"
                                      sx={{ textTransform: "capitalize" }}
                                      startIcon={<AddIcon />}
                                      onClick={() => onPressAddPrepare()}
                                    >
                                      Prepare
                                    </Button>
                                    {errormessageBoqEstimation && (
                                      <Typography
                                        variant="body2"
                                        color="error"
                                        sx={{ mt: 1 }}
                                      >
                                        {errormessageBoqEstimation}
                                      </Typography>
                                    )}
                                  </Grid>
                                )}
                            </>
                          )}
                          {fieldFormik.values.iv_objection_Type ===
                            "No Issue" &&
                            fieldFormik.values.iv_distance != 0 && (
                              <>
                                <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                  <Typography className="fieldLabel">
                                    Grid Sharing Cost applied ?
                                  </Typography>
                                  <FormControl>
                                    <RadioGroup
                                      defaultValue={gridFlag}
                                      value={gridFlag}
                                      onChange={() => {
                                        if (gridFlag) {
                                          setGridFlag(false);
                                        } else {
                                          setGridFlag(true);
                                        }
                                        fieldFormik.values.iv_grid_sharing_cost = 0;
                                        setGridSharingCost();
                                      }}
                                      row
                                    >
                                      <FormControlLabel
                                        value={true}
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 8px",
                                          borderRadius: "5px",
                                          marginLeft: "0px",
                                          marginRight: "5px",
                                          border: "1px solid lightgrey",
                                          marginTop: "2%",
                                        }}
                                        control={<Radio />}
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value={false}
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 8px",
                                          borderRadius: "5px",
                                          marginLeft: "0px",
                                          marginRight: "5px",
                                          border: "1px solid lightgrey",
                                          marginTop: "2%",
                                        }}
                                        control={<Radio />}
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  {gridFlag &&
                                    fieldFormik.values.iv_distance !== 0 && (
                                      <>
                                        <TextField
                                          name="iv_grid_sharing_cost"
                                          value={
                                            fieldFormik.values
                                              .iv_grid_sharing_cost
                                          }
                                          type="number"
                                          sx={{
                                            width: "90%",
                                            marginTop: "4%",
                                          }}
                                          fullWidth
                                          onChange={(e) => {
                                            fieldFormik.handleChange(e);
                                            setGridSharingCost(
                                              Number(e.target.value),
                                            );
                                          }}
                                          onBlur={fieldFormik.handleBlur} 
                                          className="fieldCoverageMarla"
                                          error={Boolean(
                                            fieldFormik.touched
                                              .iv_grid_sharing_cost &&
                                            fieldFormik.errors
                                              .iv_grid_sharing_cost,
                                          )}
                                          helperText={
                                            fieldFormik.touched
                                              .iv_grid_sharing_cost &&
                                            fieldFormik.errors
                                              .iv_grid_sharing_cost
                                          }
                                        />
                                        <p className="form-error">
                                          {fieldFormik.errors
                                            .iv_grid_sharing_cost &&
                                          fieldFormik.touched
                                            .iv_grid_sharing_cost
                                            ? refNoAllocationFormik.errors
                                                .iv_grid_sharing_cost
                                            : null}
                                        </p>
                                      </>
                                    )}
                                </Grid>

                                <Grid
                                  item
                                  lg={3}
                                  sx={{ marginTop: "2%", marginLeft: "1%" }}
                                >
                                  <Typography className="fieldLabel">
                                    Feeder Rehabilitation Charges applied ?
                                  </Typography>
                                  <FormControl>
                                    <RadioGroup
                                      defaultValue={feederRehabFlag}
                                      value={feederRehabFlag}
                                      onChange={() => {
                                        if (feederRehabFlag) {
                                          setFeederRehabFlag(false);
                                        } else {
                                          setFeederRehabFlag(true);
                                        }
                                        fieldFormik.values.iv_feeder_rehab_charges = 0;
                                        setFeederRehabilitationCharges();
                                      }}
                                      row
                                    >
                                      <FormControlLabel
                                        value={true}
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 8px",
                                          borderRadius: "5px",
                                          marginLeft: "0px",
                                          marginRight: "5px",
                                          border: "1px solid lightgrey",
                                          marginTop: "2%",
                                        }}
                                        control={<Radio />}
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value={false}
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 8px",
                                          borderRadius: "5px",
                                          marginLeft: "0px",
                                          marginRight: "5px",
                                          border: "1px solid lightgrey",
                                          marginTop: "2%",
                                        }}
                                        control={<Radio />}
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  {feederRehabFlag &&
                                    fieldFormik.values.iv_distance !== 0 && (
                                      <>
                                        <TextField
                                          name="iv_feeder_rehab_charges"
                                          value={
                                            fieldFormik.values
                                              .iv_feeder_rehab_charges
                                          }
                                          type="number"
                                          fullWidth
                                          sx={{
                                            width: "60%",
                                            marginTop: "4%",
                                          }}
                                          onChange={(e) => {
                                            fieldFormik.handleChange(e);
                                            setFeederRehabilitationCharges(
                                              Number(e.target.value),
                                            );
                                          }}
                                          onBlur={fieldFormik.handleBlur}
                                          className="fieldCoverageMarla"
                                          error={Boolean(
                                            fieldFormik.touched
                                              .iv_feeder_rehab_charges &&
                                            fieldFormik.errors
                                              .iv_feeder_rehab_charges,
                                          )}
                                          helperText={
                                            fieldFormik.touched
                                              .iv_feeder_rehab_charges &&
                                            fieldFormik.errors
                                              .iv_feeder_rehab_charges
                                          }
                                        />
                                        <p className="form-error">
                                          {fieldFormik.errors
                                            .iv_feeder_rehab_charges &&
                                          fieldFormik.touched
                                            .iv_feeder_rehab_charges
                                            ? refNoAllocationFormik.errors
                                                .iv_feeder_rehab_charges
                                            : null}
                                          {fieldFormik.errors
                                            .iv_civil_work_charges &&
                                          fieldFormik.touched
                                            .iv_civil_work_charges
                                            ? refNoAllocationFormik.errors
                                                .iv_civil_work_charges
                                            : null}
                                          {fieldFormik.errors
                                            .iv_fixed_charges_of_metering &&
                                          fieldFormik.touched
                                            .iv_fixed_charges_of_metering
                                            ? refNoAllocationFormik.errors
                                                .iv_fixed_charges_of_metering
                                            : null}
                                          {fieldFormik.errors
                                            .iv_miscellaneous_charges &&
                                          fieldFormik.touched
                                            .iv_miscellaneous_charges
                                            ? refNoAllocationFormik.errors
                                                .iv_miscellaneous_charges
                                            : null}
                                          {fieldFormik.errors
                                            .iv_less_the_cost &&
                                          fieldFormik.touched.iv_less_the_cost
                                            ? refNoAllocationFormik.errors
                                                .iv_less_the_cost
                                            : null}
                                        </p>
                                      </>
                                    )}
                                </Grid>
                              </>
                            )}
                          {dialogRowData?.applicationId?.slice(3, 5) == "14" &&
                            fieldFormik.values.iv_meter_type == 1 &&
                            fieldFormik.values.iv_distance != 0 &&
                            fieldFormik.values.iv_objection_Type ===
                              "No Issue" && (
                              <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                <Typography className="fieldLabel">
                                  Select Cable
                                </Typography>
                                <Select
                                  value={fieldFormik.values.iv_select_cable}
                                  onChange={fieldFormik.handleChange}
                                  onBlur={fieldFormik.handleBlur}
                                  className="fieldBatch"
                                  name="iv_select_cable"
                                  id="iv_select_cable"
                                  sx={{ width: "120%" }}
                                >
                                  {getCableMaterialOptions(allMaterialList).map(
                                    ({ item, cableCode }) => (
                                      <MenuItem
                                        key={cableCode}
                                        value={cableCode}
                                      >
                                        {cableCode} —{" "}
                                        {item.item_Name || item.Item_Name}
                                      </MenuItem>
                                    ),
                                  )}
                                </Select>
                                <Box className="from-Error">
                                  {fieldFormik.touched.iv_select_cable &&
                                    fieldFormik.errors.iv_select_cable && (
                                      <Typography
                                        sx={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {fieldFormik.errors.iv_select_cable}
                                      </Typography>
                                    )}
                                </Box>
                              </Grid>
                            )}
                        </Grid>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                           The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Field Survey Objection</h3>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Field Survey",
                      ) ? (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            {dialogRowData.remarks}{" "}
                          </p>
                        </div>
                      ) : (
                        <>
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              The application has been objected at field survey
                              stage. : {dialogRowData.remarks}{" "}
                            </p>
                          </div>
                          {dialogRowData.remarks ===
                            "Load at site exceeds than applied." &&
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "Reconnection",
                              "Basic Permissions",
                              "Update",
                            ) && (
                              <>
                                <Grid
                                  container
                                  spacing={2}
                                  className="field-survey-container"
                                >
                                  <Grid item lg={3}>
                                    <Typography className="fieldLabel">
                                      Update Applied Load
                                    </Typography>
                                    <TextField
                                      required
                                      type="number"
                                      InputProps={{
                                        inputProps: {
                                          min: dialogRowData.appliedLoad,
                                        },
                                      }}
                                      autoComplete="off"
                                      name="iv_applied_load"
                                      value={
                                        appliedLoadFormik.values.iv_applied_load
                                      }
                                      onChange={appliedLoadFormik.handleChange}
                                      onBlur={appliedLoadFormik.handleBlur}
                                      id="iv_applied_load"
                                      className="fieldReferenceNo"
                                    />
                                    <Box className="form-error">
                                      {appliedLoadFormik.errors
                                        .iv_applied_load &&
                                      appliedLoadFormik.touched.iv_applied_load
                                        ? appliedLoadFormik.errors
                                            .iv_applied_load
                                        : null}
                                    </Box>
                                  </Grid>
                                </Grid>
                              </>
                            )}
                        </>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 6 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Approval</h4>
                        </Grid>
                        <Grid item lg={1}></Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "DN Approval",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {dnApproveStep && (
                            <Grid
                              container
                              spacing={2}
                              className="dn-payment-submission-container"
                            >
                              {(() => {
                                const total = getCapitalSecurityTotal(
                                  dnApproveStep.capitalCostAmount,
                                  dnApproveStep.securityDepositeAmount,
                                );

                                // const fields = [
                                //   { label: "Issue Date", value: dnApproveStep.issueDate ? convertDate(dnApproveStep.issueDate) : null },
                                //   { label: "Due Date", value: dnApproveStep.dueDate ? convertDate(dnApproveStep.dueDate) : null },
                                //   { label: "Bank Name", value: dnApproveStep.bankName },
                                //   { label: "Previous Security Cost", value: parseFloat(dnApproveStep.previousSecurity) || 0 },
                                //   { label: "Current Estimated Security Cost", value: parseFloat(dnApproveStep.securityDepositeAmount) || 0 },
                                //   { label: "Amount of Grid Sharing", value: parseFloat(dnApproveStep.amountOfGridSharing) || 0 },
                                //   { label: "Amount of Feeder Rehab", value: parseFloat(dnApproveStep.amountOfFeederRehab) || 0 },
                                //   { label: "Capital Cost Amount", value: parseFloat(dnApproveStep.capitalCostAmount) || 0 },
                                //   { label: "Civil Work Charges", value: parseFloat(dnApproveStep.civilWorkCharges) || 0 },
                                //   { label: "Fixed Charges Of Metering", value: parseFloat(dnApproveStep.fixedChargesOfMetering) || 0 },
                                //   { label: "Miscellaneous Charges", value: parseFloat(dnApproveStep.miscellaneousCharges) || 0 },
                                //   { label: "Less the Cost", value: parseFloat(dnApproveStep.lessTheCost) || 0 },
                                //   { label: "Grand Total", value: total },
                                // ];
                                const fields = [
                                  {
                                    label: "Issue Date",
                                    value: dnApproveStep.issueDate
                                      ? convertDate(dnApproveStep.issueDate)
                                      : null,
                                  },
                                  {
                                    label: "Due Date",
                                    value: dnApproveStep.dueDate
                                      ? convertDate(dnApproveStep.dueDate)
                                      : null,
                                  },
                                  {
                                    label: "Bank Name",
                                    value: dnApproveStep.bankName,
                                  },
                                  // {
                                  //   label: "Amount of Grid Sharing",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.amountOfGridSharing,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Amount of Feeder Rehab",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.amountOfFeederRehab,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Civil Work Charges",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.civilWorkCharges,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Fixed Charges Of Metering",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.fixedChargesOfMetering,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Miscellaneous Charges",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.miscellaneousCharges,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Less the Cost",
                                  //   value:
                                  //     parseFloat(dnApproveStep.lessTheCost) ||
                                  //     0,
                                  // },
                                  
                                ];

                                return fields
                                  .filter((item) => {
                                    // Special handling for Issue Date, Due Date, Bank Name
                                    if (
                                      [
                                        "Issue Date",
                                        "Due Date",
                                        "Bank Name",
                                      ].includes(item.label)
                                    ) {
                                      return (
                                        item.value !== null &&
                                        item.value !== undefined &&
                                        item.value !== ""
                                      );
                                    }
                                    // For all other fields: show only when value exists and is non-zero
                                    return (
                                      item.value !== null &&
                                      item.value !== undefined &&
                                      item.value !== "" &&
                                      Number(item.value) !== 0
                                    );
                                  })
                                  .map((item, index) => (
                                    <Grid
                                      item
                                      lg={4}
                                      md={6}
                                      sm={12}
                                      key={index}
                                      className="item"
                                    >
                                      <Typography
                                        className="title"
                                        sx={{
                                          fontWeight: 600,
                                          color:
                                            item.label === "Grand Total (Capital Cost + Security Deposit)"
                                              ? "#1976d2"
                                              : "#333",
                                        }}
                                      >
                                        {item.label}
                                      </Typography>
                                      <Typography
                                        className="value"
                                        sx={
                                          item.label === "Grand Total (Capital Cost + Security Deposit)"
                                            ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                            : { color: "#444" }
                                        }
                                      >
                                        {["Issue Date", "Due Date"].includes(
                                          item.label,
                                        )
                                          ? item.value
                                          : item.label === "Bank Name"
                                            ? item.value
                                            : item.label === "Less the Cost"
                                              ? `-${numberFormatting(
                                                  Math.round(
                                                    Number(item.value) || 0,
                                                  ),
                                                )}`
                                              : numberFormatting(
                                                  Math.round(
                                                    Number(item.value) || 0,
                                                  ),
                                                )}
                                      </Typography>
                                    </Grid>
                                  ))
                                  .concat([
                                    <Grid item lg={4} md={6} sm={12} className="item" key="capital">
                                      <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                        Capital Cost Amount
                                      </Typography>
                                      <Typography className="value" sx={{ color: "#444" }}>
                                        {numberFormatting(
                                          Math.round(Number(dnApproveStep?.capitalCostAmount) || 0),
                                        )}
                                      </Typography>
                                    </Grid>,
                                    <Grid item lg={4} md={6} sm={12} className="item" key="security">
                                      <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                        Security Deposite Amount
                                      </Typography>
                                      <Typography className="value" sx={{ color: "#444" }}>
                                        {numberFormatting(
                                          Math.round(Number(dnApproveStep?.securityDepositeAmount) || 0),
                                        )}
                                      </Typography>
                                    </Grid>,
                                    <Grid item lg={4} md={6} sm={12} className="item" key="grandtotal">
                                      <Typography className="title" sx={{ fontWeight: 600, color: "#1976d2" }}>
                                        Grand Total (Capital Cost + Security Deposit)
                                      </Typography>
                                      <Typography
                                        className="value"
                                        sx={{
                                          backgroundColor: "#1976d2 !important",
                                          color: "#fff !important",
                                          fontSize: "1.1rem",
                                        }}
                                      >
                                        {numberFormatting(Math.round(Number(getCapitalSecurityTotal(dnApproveStep?.capitalCostAmount, dnApproveStep?.securityDepositeAmount)) || 0))}
                                      </Typography>
                                    </Grid>,
                                  ]);
                              })()}
                            </Grid>
                          )}
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                           The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Submission</h4>
                        </Grid>
                        <Grid item lg={1}>
                          <Button
                            variant="outlined"
                            onClick={() => downloadDNPDF(dialogRowData)}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            DN{" "}
                          </Button>
                        </Grid>
                      </Grid>
                      {
                        // CheckPermissions(permissions, 'General Services', 'Change of Name', 'Workflow Permissions', 'DN Approval') &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "DN Submission",
                        ) ? (
                          <>
                            {dnApproveStep && (
                              <Grid
                                container
                                spacing={2}
                                className="dn-payment-submission-container"
                              >
                                {(() => {
                                  const total = getCapitalSecurityTotal(
                                    dnApproveStep.capitalCostAmount,
                                    dnApproveStep.securityDepositeAmount,
                                  );

                                  // const fields = [
                                  //   { label: "Issue Date", value: dnApproveStep.issueDate ? convertDate(dnApproveStep.issueDate) : null },
                                  //   { label: "Due Date", value: dnApproveStep.dueDate ? convertDate(dnApproveStep.dueDate) : null },
                                  //   { label: "Bank Name", value: dnApproveStep.bankName },
                                  //   { label: "Previous Security Cost", value: parseFloat(dnApproveStep.previousSecurity) || 0 },
                                  //   { label: "Current Estimated Security Cost", value: parseFloat(dnApproveStep.securityDepositeAmount) || 0 },
                                  //   { label: "Amount of Grid Sharing", value: parseFloat(dnApproveStep.amountOfGridSharing) || 0 },
                                  //   { label: "Amount of Feeder Rehab", value: parseFloat(dnApproveStep.amountOfFeederRehab) || 0 },
                                  //   { label: "Capital Cost Amount", value: parseFloat(dnApproveStep.capitalCostAmount) || 0 },
                                  //   { label: "Civil Work Charges", value: parseFloat(dnApproveStep.civilWorkCharges) || 0 },
                                  //   { label: "Fixed Charges Of Metering", value: parseFloat(dnApproveStep.fixedChargesOfMetering) || 0 },
                                  //   { label: "Miscellaneous Charges", value: parseFloat(dnApproveStep.miscellaneousCharges) || 0 },
                                  //   { label: "Less the Cost", value: parseFloat(dnApproveStep.lessTheCost) || 0 },
                                  //   { label: "Grand Total", value: total },
                                  // ];
                                  const fields = [
                                    {
                                      label: "Issue Date",
                                      value: dnApproveStep.issueDate
                                        ? convertDate(dnApproveStep.issueDate)
                                        : null,
                                    },
                                    {
                                      label: "Due Date",
                                      value: dnApproveStep.dueDate
                                        ? convertDate(dnApproveStep.dueDate)
                                        : null,
                                    },
                                    {
                                      label: "Bank Name",
                                      value: dnApproveStep.bankName,
                                    },
                                    // {
                                    //   label: "Amount of Grid Sharing",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.amountOfGridSharing,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Amount of Feeder Rehab",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.amountOfFeederRehab,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Civil Work Charges",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.civilWorkCharges,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Fixed Charges Of Metering",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.fixedChargesOfMetering,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Miscellaneous Charges",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.miscellaneousCharges,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Less the Cost",
                                    //   value:
                                    //     parseFloat(dnApproveStep.lessTheCost) ||
                                    //     0,
                                    // },
                                    
                                  ];

                                  return fields
                                    .filter((item) => {
                                      // Special handling for Issue Date, Due Date, Bank Name
                                      if (
                                        [
                                          "Issue Date",
                                          "Due Date",
                                          "Bank Name",
                                        ].includes(item.label)
                                      ) {
                                        return (
                                          item.value !== null &&
                                          item.value !== undefined &&
                                          item.value !== ""
                                        );
                                      }
                                      // For all other fields: show only when value exists and is non-zero
                                      return (
                                        item.value !== null &&
                                        item.value !== undefined &&
                                        item.value !== "" &&
                                        Number(item.value) !== 0
                                      );
                                    })
                                    .map((item, index) => (
                                      <Grid
                                        item
                                        lg={4}
                                        md={6}
                                        sm={12}
                                        key={index}
                                        className="item"
                                      >
                                        <Typography
                                          className="title"
                                          sx={{
                                            fontWeight: 600,
                                            color:
                                              item.label === "Grand Total (Capital Cost + Security Deposit)"
                                                ? "#1976d2"
                                                : "#333",
                                          }}
                                        >
                                          {item.label}
                                        </Typography>
                                        <Typography
                                          className="value"
                                          sx={
                                            item.label === "Grand Total (Capital Cost + Security Deposit)"
                                              ? {
                                                  backgroundColor:
                                                    "#1976d2 !important",
                                                  color: "#fff !important",
                                                  fontSize: "1.1rem",
                                                }
                                              : { color: "#444" }
                                          }
                                        >
                                          {["Issue Date", "Due Date"].includes(
                                            item.label,
                                          )
                                            ? item.value
                                            : item.label === "Bank Name"
                                              ? item.value
                                              : item.label === "Less the Cost"
                                                ? `-${numberFormatting(
                                                    Math.round(
                                                      Number(item.value) || 0,
                                                    ),
                                                  )}`
                                                : numberFormatting(
                                                    Math.round(
                                                      Number(item.value) || 0,
                                                    ),
                                                  )}
                                        </Typography>
                                      </Grid>
                                    ));
                                })()}
                                <Grid item lg={4} md={6} sm={12} className="item">
                                  <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                    Capital Cost Amount
                                  </Typography>
                                  <Typography className="value" sx={{ color: "#444" }}>
                                    {numberFormatting(
                                      Math.round(Number(dnApproveStep?.capitalCostAmount) || 0),
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} md={6} sm={12} className="item">
                                  <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                    Security Deposite Amount
                                  </Typography>
                                  <Typography className="value" sx={{ color: "#444" }}>
                                    {numberFormatting(
                                      Math.round(Number(dnApproveStep?.securityDepositeAmount) || 0),
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} md={6} sm={12} className="item">
                                  <Typography className="title" sx={{ fontWeight: 600, color: "#1976d2" }}>
                                    Grand Total (Capital Cost + Security Deposit)
                                  </Typography>
                                  <Typography
                                    className="value"
                                    sx={{
                                      backgroundColor: "#1976d2 !important",
                                      color: "#fff !important",
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    {numberFormatting(Math.round(Number(getCapitalSecurityTotal(dnApproveStep?.capitalCostAmount, dnApproveStep?.securityDepositeAmount)) || 0))}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )}
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "15px",
                                padding: "15px",
                              }}
                            >
                              <Grid
                                item
                                style={{ marginTop: "1%", width: "20%" }}
                              >
                                <Typography
                                  className="fieldLabel"
                                  sx={{
                                    paddingTop: "10px",
                                    paddingBottom: "2%",
                                  }}
                                >
                                  Receipt Image
                                </Typography>
                                {dnReceiptImage ? (
                                  <>
                                    <Button
                                      varient="outlined"
                                      component="label"
                                      startIcon={
                                        <CloseIcon
                                          sx={{ color: "red" }}
                                          onClick={() => {
                                            setDnReceiptImage("");
                                          }}
                                        />
                                      }
                                    >
                                      {dnReceiptImageThumbnail && (
                                        <>
                                          {dnReceiptImageThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={dnReceiptImageThumbnail}
                                              alt="DN Receipt"
                                              width="80"
                                            />
                                          ) : dnReceiptImageThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="DN Receipt PDF"
                                              width="80"
                                            />
                                          ) : null}
                                        </>
                                      )}
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<FileUploadOutlinedIcon />}
                                      sx={{
                                        padding: "4%",
                                        width: "100%",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      Upload
                                      <input
                                        hidden
                                        accept={documentExtensions}
                                        id="iv_dn_receipt_image"
                                        name="iv_dn_receipt_image"
                                        type="file"
                                        onChange={DnReceiptImage}
                                        onBlur={() =>
                                          dnReceiptFormik.setFieldTouched(
                                            "iv_dn_receipt_image",
                                            true,
                                          )
                                        }
                                      />
                                    </Button>
                                  </>
                                )}
                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {dnReceiptFormik.errors.iv_dn_receipt_image &&
                                  dnReceiptFormik.touched.iv_dn_receipt_image
                                    ? dnReceiptFormik.errors.iv_dn_receipt_image
                                    : null}
                                </Box>
                              </Grid>
                              <Grid
                                item
                                style={{ marginTop: "1%", width: "20%" }}
                              >
                                <Typography
                                  className="fieldLabel"
                                  sx={{
                                    paddingTop: "10px",
                                    paddingBottom: "2%",
                                  }}
                                >
                                  Payment Date
                                </Typography>
                                <input
                                  name="iv_dn_fee_payment_date"
                                  value={
                                    dnReceiptFormik.values
                                      .iv_dn_fee_payment_date
                                  }
                                  onChange={dnReceiptFormik.handleChange}
                                  onBlur={dnReceiptFormik.handleBlur}
                                  type="date"
                                  className="fieldReferenceNo"
                                  style={{
                                    width: "200px",
                                    height: "30px",
                                    padding: "4px",
                                  }}
                                  min={
                                    dnDets.issueDate
                                      ? dnDets.issueDate.slice(0, 10)
                                      : ""
                                  }
                                  max={
                                    dnDets.dueDate
                                      ? new Date()
                                          .toISOString()
                                          .split("T")[0] <=
                                        dnDets.dueDate.slice(0, 10)
                                        ? new Date().toISOString().split("T")[0]
                                        : dnDets.dueDate.slice(0, 10)
                                      : ""
                                  }
                                />
                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {dnReceiptFormik.errors
                                    .iv_dn_fee_payment_date &&
                                  dnReceiptFormik.touched.iv_dn_fee_payment_date
                                    ? dnReceiptFormik.errors
                                        .iv_dn_fee_payment_date
                                    : null}
                                </Box>
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              The application is in process by sanctioning
                            authority.
                            </p>
                          </div>
                        )
                      }
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Objection</h4>
                        </Grid>
                        <Grid item lg={1}>
                          <Button
                            variant="outlined"
                            onClick={() => downloadDNPDF(dialogRowData)}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            DN{" "}
                          </Button>
                        </Grid>
                      </Grid>
                      {
                        // CheckPermissions(permissions, 'General Services', 'Change of Name', 'Workflow Permissions', 'DN Approval') &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "DN Submission",
                        ) ? (
                          <>
                            {dnApproveStep && (
                              <Grid
                                container
                                spacing={2}
                                className="dn-payment-submission-container"
                              >
                                {(() => {
                                  const total = getCapitalSecurityTotal(
                                    dnApproveStep.capitalCostAmount,
                                    dnApproveStep.securityDepositeAmount,
                                  );

                                  // const fields = [
                                  //   { label: "Issue Date", value: dnApproveStep.issueDate ? convertDate(dnApproveStep.issueDate) : null },
                                  //   { label: "Due Date", value: dnApproveStep.dueDate ? convertDate(dnApproveStep.dueDate) : null },
                                  //   { label: "Bank Name", value: dnApproveStep.bankName },
                                  //   { label: "Previous Security Cost", value: parseFloat(dnApproveStep.previousSecurity) || 0 },
                                  //   { label: "Current Estimated Security Cost", value: parseFloat(dnApproveStep.securityDepositeAmount) || 0 },
                                  //   { label: "Amount of Grid Sharing", value: parseFloat(dnApproveStep.amountOfGridSharing) || 0 },
                                  //   { label: "Amount of Feeder Rehab", value: parseFloat(dnApproveStep.amountOfFeederRehab) || 0 },
                                  //   { label: "Capital Cost Amount", value: parseFloat(dnApproveStep.capitalCostAmount) || 0 },
                                  //   { label: "Civil Work Charges", value: parseFloat(dnApproveStep.civilWorkCharges) || 0 },
                                  //   { label: "Fixed Charges Of Metering", value: parseFloat(dnApproveStep.fixedChargesOfMetering) || 0 },
                                  //   { label: "Miscellaneous Charges", value: parseFloat(dnApproveStep.miscellaneousCharges) || 0 },
                                  //   { label: "Less the Cost", value: parseFloat(dnApproveStep.lessTheCost) || 0 },
                                  //   { label: "Grand Total", value: total },
                                  // ];
                                  const fields = [
                                    {
                                      label: "Issue Date",
                                      value: dnApproveStep.issueDate
                                        ? convertDate(dnApproveStep.issueDate)
                                        : null,
                                    },
                                    {
                                      label: "Due Date",
                                      value: dnApproveStep.dueDate
                                        ? convertDate(dnApproveStep.dueDate)
                                        : null,
                                    },
                                    {
                                      label: "Bank Name",
                                      value: dnApproveStep.bankName,
                                    },
                                    // {
                                    //   label: "Amount of Grid Sharing",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.amountOfGridSharing,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Amount of Feeder Rehab",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.amountOfFeederRehab,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Civil Work Charges",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.civilWorkCharges,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Fixed Charges Of Metering",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.fixedChargesOfMetering,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Miscellaneous Charges",
                                    //   value:
                                    //     parseFloat(
                                    //       dnApproveStep.miscellaneousCharges,
                                    //     ) || 0,
                                    // },
                                    // {
                                    //   label: "Less the Cost",
                                    //   value:
                                    //     parseFloat(dnApproveStep.lessTheCost) ||
                                    //     0,
                                    // },
                                    
                                  ];

                                  return fields
                                    .filter((item) => {
                                      // Special handling for Issue Date, Due Date, Bank Name
                                      if (
                                        [
                                          "Issue Date",
                                          "Due Date",
                                          "Bank Name",
                                        ].includes(item.label)
                                      ) {
                                        return (
                                          item.value !== null &&
                                          item.value !== undefined &&
                                          item.value !== ""
                                        );
                                      }
                                      // For all other fields: show only when value exists and is non-zero
                                      return (
                                        item.value !== null &&
                                        item.value !== undefined &&
                                        item.value !== "" &&
                                        Number(item.value) !== 0
                                      );
                                    })
                                    .map((item, index) => (
                                      <Grid
                                        item
                                        lg={4}
                                        md={6}
                                        sm={12}
                                        key={index}
                                        className="item"
                                      >
                                        <Typography
                                          className="title"
                                          sx={{
                                            fontWeight: 600,
                                            color:
                                              item.label === "Grand Total (Capital Cost + Security Deposit)"
                                                ? "#1976d2"
                                                : "#333",
                                          }}
                                        >
                                          {item.label}
                                        </Typography>
                                        <Typography
                                          className="value"
                                          sx={
                                            item.label === "Grand Total (Capital Cost + Security Deposit)"
                                              ? {
                                                  backgroundColor:
                                                    "#1976d2 !important",
                                                  color: "#fff !important",
                                                  fontSize: "1.1rem",
                                                }
                                              : { color: "#444" }
                                          }
                                        >
                                          {["Issue Date", "Due Date"].includes(
                                            item.label,
                                          )
                                            ? item.value
                                            : item.label === "Bank Name"
                                              ? item.value
                                              : item.label === "Less the Cost"
                                                ? `-${numberFormatting(
                                                    Math.round(
                                                      Number(item.value) || 0,
                                                    ),
                                                  )}`
                                                : numberFormatting(
                                                    Math.round(
                                                      Number(item.value) || 0,
                                                    ),
                                                  )}
                                        </Typography>
                                      </Grid>
                                    ));
                                })()}
                                <Grid item lg={4} md={6} sm={12} className="item">
                                  <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                    Capital Cost Amount
                                  </Typography>
                                  <Typography className="value" sx={{ color: "#444" }}>
                                    {numberFormatting(
                                      Math.round(Number(dnApproveStep?.capitalCostAmount) || 0),
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} md={6} sm={12} className="item">
                                  <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                    Security Deposite Amount
                                  </Typography>
                                  <Typography className="value" sx={{ color: "#444" }}>
                                    {numberFormatting(
                                      Math.round(Number(dnApproveStep?.securityDepositeAmount) || 0),
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} md={6} sm={12} className="item">
                                  <Typography className="title" sx={{ fontWeight: 600, color: "#1976d2" }}>
                                    Grand Total (Capital Cost + Security Deposit)
                                  </Typography>
                                  <Typography
                                    className="value"
                                    sx={{
                                      backgroundColor: "#1976d2 !important",
                                      color: "#fff !important",
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    {numberFormatting(Math.round(Number(getCapitalSecurityTotal(dnApproveStep?.capitalCostAmount, dnApproveStep?.securityDepositeAmount)) || 0))}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )}
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "15px",
                                padding: "15px",
                              }}
                            >
                              <Grid
                                item
                                style={{ marginTop: "1%", width: "20%" }}
                              >
                                <Typography
                                  className="fieldLabel"
                                  sx={{
                                    paddingTop: "10px",
                                    paddingBottom: "2%",
                                  }}
                                >
                                  Receipt Image
                                </Typography>
                                {dnReceiptImage ? (
                                  <>
                                    <Button
                                      varient="outlined"
                                      component="label"
                                      startIcon={
                                        <CloseIcon
                                          sx={{ color: "red" }}
                                          onClick={() => {
                                            setDnReceiptImage("");
                                          }}
                                        />
                                      }
                                    >
                                      {dnReceiptImageThumbnail && (
                                        <>
                                          {dnReceiptImageThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={dnReceiptImageThumbnail}
                                              alt="DN Receipt"
                                              width="80"
                                            />
                                          ) : dnReceiptImageThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="DN Receipt PDF"
                                              width="80"
                                            />
                                          ) : null}
                                        </>
                                      )}
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<FileUploadOutlinedIcon />}
                                      sx={{
                                        padding: "4%",
                                        width: "100%",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      Upload
                                      <input
                                        hidden
                                        accept={documentExtensions}
                                        id="iv_dn_receipt_image"
                                        name="iv_dn_receipt_image"
                                        type="file"
                                        onChange={DnReceiptImage}
                                        onBlur={() =>
                                          dnReceiptFormik.setFieldTouched(
                                            "iv_dn_receipt_image",
                                            true,
                                          )
                                        }
                                      />
                                    </Button>
                                  </>
                                )}
                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {dnReceiptFormik.errors.iv_dn_receipt_image &&
                                  dnReceiptFormik.touched.iv_dn_receipt_image
                                    ? dnReceiptFormik.errors.iv_dn_receipt_image
                                    : null}
                                </Box>
                              </Grid>
                              <Grid
                                item
                                style={{ marginTop: "1%", width: "20%" }}
                              >
                                <Typography
                                  className="fieldLabel"
                                  sx={{
                                    paddingTop: "10px",
                                    paddingBottom: "2%",
                                  }}
                                >
                                  Payment Date
                                </Typography>
                                <input
                                  name="iv_dn_fee_payment_date"
                                  value={
                                    dnReceiptFormik.values
                                      .iv_dn_fee_payment_date
                                  }
                                  onChange={dnReceiptFormik.handleChange}
                                  onBlur={dnReceiptFormik.handleBlur}
                                  type="date"
                                  className="fieldReferenceNo"
                                  style={{
                                    width: "200px",
                                    height: "30px",
                                    padding: "4px",
                                  }}
                                  min={
                                    dnDets.issueDate
                                      ? dnDets.issueDate.slice(0, 10)
                                      : ""
                                  }
                                  max={
                                    dnDets.dueDate
                                      ? new Date()
                                          .toISOString()
                                          .split("T")[0] <=
                                        dnDets.dueDate.slice(0, 10)
                                        ? new Date().toISOString().split("T")[0]
                                        : dnDets.dueDate.slice(0, 10)
                                      : ""
                                  }
                                />
                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {dnReceiptFormik.errors
                                    .iv_dn_fee_payment_date &&
                                  dnReceiptFormik.touched.iv_dn_fee_payment_date
                                    ? dnReceiptFormik.errors
                                        .iv_dn_fee_payment_date
                                    : null}
                                </Box>
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              The application is in process by sanctioning
                            authority.
                            </p>
                          </div>
                        )
                      }
                    </>
                  ) : dialogRowData.applicationProgressId === 8 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Payment Verification</h4>
                        </Grid>
                        <Grid item lg={1}>
                          <Button
                            variant="outlined"
                            onClick={() => downloadDNPDF(dialogRowData)}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            DN{" "}
                          </Button>
                        </Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "DN Payment Verification",
                      ) &&
                      // Updated approval eligibility conditions (as requested)
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {dnApproveStep && (
                            <Grid
                              container
                              spacing={2}
                              className="dn-payment-submission-container"
                            >
                              {(() => {
                                const total = getCapitalSecurityTotal(
                                  dnApproveStep.capitalCostAmount,
                                  dnApproveStep.securityDepositeAmount,
                                );

                                // const fields = [
                                //   { label: "Issue Date", value: dnApproveStep.issueDate ? convertDate(dnApproveStep.issueDate) : null },
                                //   { label: "Due Date", value: dnApproveStep.dueDate ? convertDate(dnApproveStep.dueDate) : null },
                                //   { label: "Bank Name", value: dnApproveStep.bankName },
                                //   { label: "Previous Security Cost", value: parseFloat(dnApproveStep.previousSecurity) || 0 },
                                //   { label: "Current Estimated Security Cost", value: parseFloat(dnApproveStep.securityDepositeAmount) || 0 },
                                //   { label: "Amount of Grid Sharing", value: parseFloat(dnApproveStep.amountOfGridSharing) || 0 },
                                //   { label: "Amount of Feeder Rehab", value: parseFloat(dnApproveStep.amountOfFeederRehab) || 0 },
                                //   { label: "Capital Cost Amount", value: parseFloat(dnApproveStep.capitalCostAmount) || 0 },
                                //   { label: "Civil Work Charges", value: parseFloat(dnApproveStep.civilWorkCharges) || 0 },
                                //   { label: "Fixed Charges Of Metering", value: parseFloat(dnApproveStep.fixedChargesOfMetering) || 0 },
                                //   { label: "Miscellaneous Charges", value: parseFloat(dnApproveStep.miscellaneousCharges) || 0 },
                                //   { label: "Less the Cost", value: parseFloat(dnApproveStep.lessTheCost) || 0 },
                                //   { label: "Grand Total", value: total },
                                // ];
                                const fields = [
                                  {
                                    label: "Issue Date",
                                    value: dnApproveStep.issueDate
                                      ? convertDate(dnApproveStep.issueDate)
                                      : null,
                                  },
                                  {
                                    label: "Due Date",
                                    value: dnApproveStep.dueDate
                                      ? convertDate(dnApproveStep.dueDate)
                                      : null,
                                  },
                                  {
                                    label: "Bank Name",
                                    value: dnApproveStep.bankName,
                                  },
                                  // {
                                  //   label: "Amount of Grid Sharing",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.amountOfGridSharing,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Amount of Feeder Rehab",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.amountOfFeederRehab,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Civil Work Charges",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.civilWorkCharges,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Fixed Charges Of Metering",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.fixedChargesOfMetering,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Miscellaneous Charges",
                                  //   value:
                                  //     parseFloat(
                                  //       dnApproveStep.miscellaneousCharges,
                                  //     ) || 0,
                                  // },
                                  // {
                                  //   label: "Less the Cost",
                                  //   value:
                                  //     parseFloat(dnApproveStep.lessTheCost) ||
                                  //     0,
                                  // },
                                  
                                ];

                                return fields
                                  .filter((item) => {
                                    // Special handling for Issue Date, Due Date, Bank Name
                                    if (
                                      [
                                        "Issue Date",
                                        "Due Date",
                                        "Bank Name",
                                      ].includes(item.label)
                                    ) {
                                      return (
                                        item.value !== null &&
                                        item.value !== undefined &&
                                        item.value !== ""
                                      );
                                    }
                                      // For all other fields: show only when value exists and is non-zero
                                    return (
                                      item.value !== null &&
                                      item.value !== undefined &&
                                        item.value !== "" &&
                                        Number(item.value) !== 0
                                    );
                                  })
                                  .map((item, index) => (
                                    <Grid
                                      item
                                      lg={4}
                                      md={6}
                                      sm={12}
                                      key={index}
                                      className="item"
                                    >
                                      <Typography
                                        className="title"
                                        sx={{
                                          fontWeight: 600,
                                          color:
                                            item.label === "Grand Total (Capital Cost + Security Deposit)"
                                              ? "#1976d2"
                                              : "#333",
                                        }}
                                      >
                                        {item.label}
                                      </Typography>
                                      <Typography
                                        className="value"
                                        sx={
                                          item.label === "Grand Total (Capital Cost + Security Deposit)"
                                            ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                            : { color: "#444" }
                                        }
                                      >
                                        {["Issue Date", "Due Date"].includes(
                                          item.label,
                                        )
                                          ? item.value
                                            : item.label === "Bank Name"
                                              ? item.value
                                              : item.label === "Less the Cost"
                                                ? `-${numberFormatting(
                                                    Math.round(
                                                      Number(item.value) || 0,
                                                    ),
                                                  )}`
                                                : numberFormatting(
                                                    Math.round(
                                                      Number(item.value) || 0,
                                                    ),
                                                  )}
                                      </Typography>
                                    </Grid>
                                  ));
                              })()}
                              <Grid item lg={4} md={6} sm={12} className="item">
                                <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                  Capital Cost Amount
                                </Typography>
                                <Typography className="value" sx={{ color: "#444" }}>
                                  {numberFormatting(
                                    Math.round(Number(dnApproveStep?.capitalCostAmount) || 0),
                                  )}
                                </Typography>
                              </Grid>
                              <Grid item lg={4} md={6} sm={12} className="item">
                                <Typography className="title" sx={{ fontWeight: 600, color: "#333" }}>
                                  Security Deposite Amount
                                </Typography>
                                <Typography className="value" sx={{ color: "#444" }}>
                                  {numberFormatting(
                                    Math.round(Number(dnApproveStep?.securityDepositeAmount) || 0),
                                  )}
                                </Typography>
                              </Grid>
                              <Grid item lg={4} md={6} sm={12} className="item">
                                <Typography className="title" sx={{ fontWeight: 600, color: "#1976d2" }}>
                                  Grand Total (Capital Cost + Security Deposit)
                                </Typography>
                                <Typography
                                  className="value"
                                  sx={{
                                    backgroundColor: "#1976d2 !important",
                                    color: "#fff !important",
                                    fontSize: "1.1rem",
                                  }}
                                >
                                  {numberFormatting(Math.round(Number(getCapitalSecurityTotal(dnApproveStep?.capitalCostAmount, dnApproveStep?.securityDepositeAmount)) || 0))}
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                          <Grid container className="paidDnContainer">
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Payment Date
                              </Typography>
                              <Typography className="value">
                                {dnDets.paymentDate
                                  ? convertDateDDMMYY(dnDets.paymentDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={4} className="item">
                              <Typography className="title">
                                Paid DN Image
                              </Typography>
                              <Grid
                                container
                                onClick={handleOpenImgDN}
                                sx={{
                                  backgroundColor:
                                    getDocumentBackGroundColor(0),
                                  borderRadius: "10px",
                                  height: "250px",
                                  width: "100%",
                                }}
                                className="docContainer"
                              >
                                <img
                                  src={paidDNVoucherImg}
                                  alt="Cnic Front"
                                  style={{ width: "100%", height: "100%" }}
                                ></img>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 9 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                        }}
                      >
                        <h4 style={{ textAlign: "center", width: "100%" }}>
                          Meter Installation
                        </h4>
                      </div>

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Meter Installation",
                      ) &&
                      // Load-based permission checks
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        // 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 kW (general 70 permission)
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        // 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        // > 500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {dialogRowData.isDiscAboveAYear === true ? (
                            <Grid
                              container
                              spacing={2}
                              className="field-survey-container"
                            >
                              {/* 1. Store Requisition No */}
                              <Grid item lg={2}>
                                <Typography className="fieldLabel">
                                  Store Requisition No.
                                </Typography>
                                <TextField
                                  fullWidth
                                  className="fieldCoverageMarla"
                                  name="iv_store_requisition_no"
                                  value={
                                    scoPart2Formik.values
                                      .iv_store_requisition_no || ""
                                  }
                                  onChange={(e) => {
                                    const val = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    if (val.length <= 8) {
                                      scoPart2Formik.setFieldValue(
                                        "iv_store_requisition_no",
                                        val,
                                      );
                                    }
                                  }}
                                  onBlur={(e) => {
                                    let val = e.target.value.trim();
                                    if (val) {
                                      val = val.padStart(8, "0");
                                      scoPart2Formik.setFieldValue(
                                        "iv_store_requisition_no",
                                        val,
                                      );
                                    }
                                    scoPart2Formik.handleBlur(e);
                                  }}
                                  inputProps={{ maxLength: 8 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors
                                    .iv_store_requisition_no &&
                                  scoPart2Formik.touched.iv_store_requisition_no
                                    ? scoPart2Formik.errors
                                        .iv_store_requisition_no
                                    : null}
                                </p>
                              </Grid>

                              {/* 2. Store Req. Date */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Store Req. Date
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_store_requisition_date"
                                  className="fieldReferenceNo"
                                  type="date"
                                  value={
                                    scoPart2Formik.values
                                      .iv_store_requisition_date || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  inputProps={{
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                  onBlur={scoPart2Formik.handleBlur}
                                  InputLabelProps={{ shrink: true }}
                                  sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "4px",
                                    "& .MuiInputBase-input": {
                                      backgroundColor: "#fff",
                                    },
                                  }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors
                                    .iv_store_requisition_date &&
                                  scoPart2Formik.touched
                                    .iv_store_requisition_date
                                    ? scoPart2Formik.errors
                                        .iv_store_requisition_date
                                    : null}
                                </p>
                              </Grid>

                              {/* 3. Sanctioned Load */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Sanc. Load (kW)
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_sanctioned_load"
                                  type="number"
                                  className="fieldCoverageMarla"
                                  disabled={true}
                                  value={
                                    scoPart2Formik.values.iv_sanctioned_load ||
                                    ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  InputProps={{ inputProps: { min: 0 } }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_sanctioned_load &&
                                  scoPart2Formik.touched.iv_sanctioned_load
                                    ? scoPart2Formik.errors.iv_sanctioned_load
                                    : null}
                                </p>
                              </Grid>

                              {/* 4. Meter Manufacturer */}
                              <Grid item lg={2}>
                                <Typography className="fieldLabel">
                                  Meter Manufacturer
                                </Typography>
                                <Autocomplete
                                  id="iv_manufacturer_code"
                                  name="iv_manufacturer_code"
                                  value={
                                    manufacturerCode ? manufacturerCode : null
                                  }
                                  options={manufacturesList}
                                  // className='fieldBatch1'
                                  getOptionLabel={(option) =>
                                    option.code
                                      ? `${option.name} ${option.code}`
                                      : ""
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      className="fieldBatch1"
                                      value={inputValue}
                                      onChange={(e) =>
                                        setInputValue(e.target.value)
                                      }
                                      sx={{
                                        height: "10px",
                                        "& .MuiInputBase-input": {
                                          fontSize: "13px",
                                          height: "12px",
                                        },
                                      }}
                                    />
                                  )}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setManufcaturerCode(value);
                                      scoPart2Formik.setFieldValue(
                                        "iv_manufacturer_code",
                                        value.code,
                                      );
                                    }
                                  }}
                                  filterOptions={(options) =>
                                    filterOptions(
                                      options,
                                      { inputValue: debouncedInputValue },
                                      ["code", "name"],
                                    )
                                  }
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_manufacturer_code &&
                                  scoPart2Formik.touched.iv_manufacturer_code
                                    ? scoPart2Formik.errors.iv_manufacturer_code
                                    : null}
                                </p>
                              </Grid>

                              {/* 5. Meter Serial No */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Meter Serial No.
                                </Typography>

                                <TextField
                                  fullWidth
                                  name="iv_meter_serial_no"
                                  className="fieldCoverageMarla"
                                  value={
                                    scoPart2Formik.values.iv_meter_serial_no ||
                                    ""
                                  }
                                  onChange={(e) => {
                                    const digitsOnly = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    scoPart2Formik.setFieldValue(
                                      "iv_meter_serial_no",
                                      digitsOnly,
                                    );
                                  }}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{
                                    maxLength: 10,
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                />

                                <p className="form-error">
                                  {scoPart2Formik.touched.iv_meter_serial_no &&
                                  scoPart2Formik.errors.iv_meter_serial_no
                                    ? scoPart2Formik.errors.iv_meter_serial_no
                                    : null}
                                </p>
                              </Grid>

                              {/* 6. Sim No */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Sim No.
                                </Typography>

                                <TextField
                                  fullWidth
                                  name="iv_sim_number"
                                  className="fieldCoverageMarla"
                                  value={
                                    scoPart2Formik.values.iv_sim_number || ""
                                  }
                                  onChange={(e) => {
                                    const digitsOnly = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    scoPart2Formik.setFieldValue(
                                      "iv_sim_number",
                                      digitsOnly,
                                    );
                                  }}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{
                                    maxLength: 11,
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                />

                                <p className="form-error">
                                  {scoPart2Formik.touched.iv_sim_number &&
                                  scoPart2Formik.errors.iv_sim_number
                                    ? scoPart2Formik.errors.iv_sim_number
                                    : null}
                                </p>
                              </Grid>

                              {/* 7. Sim Id */}
                              <Grid item lg={3}>
                                <Typography className="fieldLabel">
                                  Sim Id.
                                </Typography>

                                <TextField
                                  fullWidth
                                  className="fieldCoverageMarla"
                                  name="iv_sim_ID"
                                  value={scoPart2Formik.values.iv_sim_ID || ""}
                                  onChange={(e) => {
                                    const digitsOnly = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    scoPart2Formik.setFieldValue(
                                      "iv_sim_ID",
                                      digitsOnly,
                                    );
                                  }}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{
                                    maxLength: 20,
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                />

                                <p className="form-error">
                                  {scoPart2Formik.touched.iv_sim_ID &&
                                  scoPart2Formik.errors.iv_sim_ID
                                    ? scoPart2Formik.errors.iv_sim_ID
                                    : null}
                                </p>
                              </Grid>

                              {/* 8. Meter Type */}
                              <Grid item lg={3.1}>
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Meter Type
                                </Typography>
                                <FormControl
                                  disabled
                                  error={
                                    scoPart2Formik.touched.iv_meter_typee &&
                                    Boolean(
                                      scoPart2Formik.errors.iv_meter_typee,
                                    )
                                  }
                                  sx={{ width: "100%" }}
                                >
                                  <RadioGroup
                                    row
                                    className="radio-group"
                                    name="iv_meter_typee"
                                    value={
                                      scoPart2Formik.values.iv_meter_typee ?? ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                    disabled
                                  >
                                    <FormControlLabel
                                      value="1"
                                      control={<Radio />}
                                      label="Smart"
                                    />
                                    <FormControlLabel
                                      value="0"
                                      control={<Radio />}
                                      label="Normal"
                                    />
                                  </RadioGroup>
                                  <Box className="form-error">
                                    {scoPart2Formik.errors.iv_meter_typee &&
                                    scoPart2Formik.touched.iv_meter_typee
                                      ? scoPart2Formik.errors.iv_meter_typee
                                      : null}
                                  </Box>
                                </FormControl>
                              </Grid>

                              {/* 9. Meter Range */}
                              <Grid item lg={1.5}>
                                <Typography className="fieldLabel">
                                  Meter Range
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_meter_range"
                                  className="fieldCoverageMarla"
                                  type="number"
                                  value={
                                    scoPart2Formik.values.iv_meter_range || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ min: 0 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_range &&
                                  scoPart2Formik.touched.iv_meter_range
                                    ? scoPart2Formik.errors.iv_meter_range
                                    : null}
                                </p>
                              </Grid>

                              {/* 10. Meter Code (Off Peak) */}
                              <Grid
                                item
                                lg={phase !== "Single Phase" ? 2 : 1.5}
                              >
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Meter Code{" "}
                                  {phase !== "Single Phase" ? "(Off Peak)" : ""}
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_meter_code1"
                                  className="fieldCoverageMarla"
                                  disabled={phase !== "Single Phase" ? false : true}
                                  value={
                                    scoPart2Formik.values.iv_meter_code1 || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ maxLength: 6 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_code1 &&
                                  scoPart2Formik.touched.iv_meter_code1
                                    ? scoPart2Formik.errors.iv_meter_code1
                                    : null}
                                </p>
                              </Grid>

                              {/* 11. Meter Code (Peak) - only if not single phase */}
                              {phase !== "Single Phase" && (
                                <Grid item lg={2}>
                                  <Typography
                                    className="fieldLabel"
                                    sx={{ fontSize: "16px", color: "#006ad1" }}
                                  >
                                    Meter Code (Peak)
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    name="iv_meter_code2"
                                    className="fieldCoverageMarla"
                                    value={
                                      scoPart2Formik.values.iv_meter_code2 || ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    inputProps={{ maxLength: 6 }}
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_meter_code2 &&
                                    scoPart2Formik.touched.iv_meter_code2
                                      ? scoPart2Formik.errors.iv_meter_code2
                                      : null}
                                  </p>
                                </Grid>
                              )}

                              {/* 12. Seasonal / Non-Seasonal (Industrial only) */}
                              {(dialogRowData?.connectionType?.toLowerCase() ===
                                "industrial" ||
                                dialogRowData?.connectionType ===
                                  "Industrial") && (
                                <Grid item lg={4}>
                                  <Typography className="fieldLabel">
                                    Seasonal / Non-Seasonal
                                  </Typography>
                                  <FormControl
                                    error={
                                      scoPart2Formik.touched.iv_seasonal_flag &&
                                      Boolean(
                                        scoPart2Formik.errors.iv_seasonal_flag,
                                      )
                                    }
                                  >
                                    <RadioGroup
                                      className="radio-group"
                                      row
                                      name="iv_seasonal_flag"
                                      value={
                                        scoPart2Formik.values
                                          .iv_seasonal_flag ?? ""
                                      }
                                      onChange={scoPart2Formik.handleChange}
                                    >
                                      <FormControlLabel
                                        value="1"
                                        control={<Radio />}
                                        label="Seasonal"
                                      />
                                      <FormControlLabel
                                        value="0"
                                        control={<Radio />}
                                        label="Non-Seasonal"
                                      />
                                    </RadioGroup>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_seasonal_flag &&
                                      scoPart2Formik.touched.iv_seasonal_flag
                                        ? scoPart2Formik.errors.iv_seasonal_flag
                                        : null}
                                    </p>
                                  </FormControl>
                                </Grid>
                              )}

                              {/* 13. Installed By */}
                              <Grid item lg={1.7}>
                                <Typography className="fieldLabel">
                                  Installed By
                                </Typography>
                                <TextField
                                  fullWidth
                                  disabled={true}
                                  name="iv_connection_installer_name"
                                  className="fieldCoverageMarla"
                                  value={
                                    scoPart2Formik.values
                                      .iv_connection_installer_name || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors
                                    .iv_connection_installer_name &&
                                  scoPart2Formik.touched
                                    .iv_connection_installer_name
                                    ? scoPart2Formik.errors
                                        .iv_connection_installer_name
                                    : null}
                                </p>
                              </Grid>

                              {/* 14. Installation Date */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Installation Date
                                </Typography>

                                <FormControl
                                  fullWidth
                                  error={
                                    scoPart2Formik.touched
                                      .iv_date_of_connection &&
                                    Boolean(
                                      scoPart2Formik.errors
                                        .iv_date_of_connection,
                                    )
                                  }
                                >
                                  <TextField
                                    name="iv_date_of_connection"
                                    className="fieldReferenceNo"
                                    type="date"
                                    value={
                                      scoPart2Formik.values
                                        .iv_date_of_connection || ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    inputProps={{
                                      min:
                                        dialogRowData?.creationDate?.split(
                                          "T",
                                        )[0] || undefined,
                                      max: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "#fff",
                                      borderRadius: "4px",
                                      "& .MuiInputBase-input": {
                                        backgroundColor: "#fff",
                                      },
                                    }}
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_date_of_connection &&
                                    scoPart2Formik.touched.iv_date_of_connection
                                      ? scoPart2Formik.errors
                                          .iv_date_of_connection
                                      : null}
                                  </p>
                                </FormControl>
                              </Grid>

                              {/* 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ16. Transformer Code & Ref No */}
                              <Grid item lg={1.8}>
                                <Typography className="fieldLabel">
                                  Transformer Code
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_transformer_code"
                                  value={
                                    scoPart2Formik.values.iv_transformer_code ||
                                    ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  className="fieldCoverageMarla"
                                  inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_transformer_code &&
                                  scoPart2Formik.touched.iv_transformer_code
                                    ? scoPart2Formik.errors.iv_transformer_code
                                    : null}
                                </p>
                              </Grid>

                              <Grid item lg={1.8}>
                                <Typography className="fieldLabel">
                                  Transformer Ref No.
                                </Typography>

                                <TextField
                                  fullWidth
                                  name="iv_transformer_refNo"
                                  value={
                                    scoPart2Formik.values
                                      .iv_transformer_refNo || ""
                                  }
                                  onChange={(e) => {
                                    const digitsOnly = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    scoPart2Formik.setFieldValue(
                                      "iv_transformer_refNo",
                                      digitsOnly,
                                    );
                                  }}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{
                                    maxLength: 14,
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                  className="fieldCoverageMarla"
                                />

                                <p className="form-error">
                                  {scoPart2Formik.touched
                                    .iv_transformer_refNo &&
                                  scoPart2Formik.errors.iv_transformer_refNo
                                    ? scoPart2Formik.errors.iv_transformer_refNo
                                    : null}
                                </p>
                              </Grid>

                              {/* 17. Meter Location */}
                              <Grid item lg={7.2}>
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Meter Location
                                </Typography>
                                <FormControl
                                  error={
                                    scoPart2Formik.touched.iv_location_code &&
                                    Boolean(
                                      scoPart2Formik.errors.iv_location_code,
                                    )
                                  }
                                >
                                  <RadioGroup
                                    row
                                    className="radio-group"
                                    name="iv_location_code"
                                    value={
                                      scoPart2Formik.values.iv_location_code ||
                                      ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                  >
                                    <FormControlLabel
                                      value="P"
                                      control={<Radio />}
                                      label="Pole"
                                    />
                                    <FormControlLabel
                                      value="O"
                                      control={<Radio />}
                                      label="Outside"
                                    />
                                    <FormControlLabel
                                      value="I"
                                      control={<Radio />}
                                      label="Inside"
                                    />
                                  </RadioGroup>
                                  <Box className="form-error">
                                    {scoPart2Formik.errors.iv_location_code &&
                                    scoPart2Formik.touched.iv_location_code
                                      ? scoPart2Formik.errors.iv_location_code
                                      : null}
                                  </Box>
                                </FormControl>
                              </Grid>

                              <Grid item lg={2.2}>
                                <Typography className="fieldLabel">
                                  Installed Meter Image
                                </Typography>

                                <Box sx={{ mt: 1 }}>
                                  {scoPart2Formik.values
                                    .iv_installed_meter_image ||
                                  installedMeterImage ? (
                                    <Box
                                      sx={{
                                        position: "relative",
                                        display: "inline-block",
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        background: "#f9f9f9",
                                      }}
                                    >
                                      <img
                                        src={
                                          installedMeterImage // fallback to your preview state
                                        }
                                        alt="Installed Meter Preview"
                                        style={{
                                          maxWidth: "180px",
                                          maxHeight: "180px",
                                          objectFit: "contain",
                                          display: "block",
                                        }}
                                      />

                                      {/* Red cross button */}
                                      <Button
                                        size="small"
                                        color="error"
                                        variant="contained"
                                        sx={{
                                          position: "absolute",
                                          top: 4,
                                          right: 4,
                                          minWidth: "28px",
                                          height: "28px",
                                          p: 0,
                                          borderRadius: "50%",
                                          backgroundColor:
                                            "rgba(211, 47, 47, 0.9)",
                                          "&:hover": {
                                            backgroundColor:
                                              "rgba(211, 47, 47, 1)",
                                          },
                                        }}
                                        onClick={() => {
                                          // Clear both Formik value and preview
                                          scoPart2Formik.setFieldValue(
                                            "iv_installed_meter_image",
                                            "",
                                          );
                                          setInstalledMeterImage(null); // your preview state
                                          setInstalledMeterImageThumbnail?.(""); // if you have thumbnail too
                                        }}
                                      >
                                        <CloseIcon fontSize="small" />
                                      </Button>
                                    </Box>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<FileUploadOutlinedIcon />}
                                      sx={{
                                        textTransform: "none",
                                        borderColor: "#1976d2",
                                        color: "#1976d2",
                                        "&:hover": {
                                          borderColor: "#1565c0",
                                          backgroundColor:
                                            "rgba(25, 118, 210, 0.04)",
                                        },
                                      }}
                                    >
                                      Upload Image
                                      <input
                                        type="file"
                                        hidden
                                        accept="image/jpeg,image/png,image/jpg,.jpeg,.jpg,.png"
                                        onChange={(e) => {
                                          const file = e.target.files?.[0];
                                          if (!file) return;

                                          // Optional: basic validation
                                          if (file.size > 5 * 1024 * 1024) {
                                            // 5MB limit example
                                            alert(
                                              "File is too large (max 5MB)",
                                            );
                                            return;
                                          }

                                          const reader = new FileReader();
                                          reader.onload = () => {
                                            const base64 = reader.result;
                                            setInstalledMeterImage(base64); // preview
                                            setInstalledMeterImageThumbnail?.(
                                              base64,
                                            ); // if separate
                                            scoPart2Formik.setFieldValue(
                                              "iv_installed_meter_image",
                                              base64,
                                            );
                                            // If your backend expects a File object instead of base64:
                                            // scoPart2Formik.setFieldValue('iv_installed_meter_image', file);
                                          };
                                          reader.readAsDataURL(file);

                                          e.target.value = ""; // reset input so same file can be selected again
                                        }}
                                      />
                                    </Button>
                                  )}

                                  {/* Show Formik validation error */}
                                  {scoPart2Formik.touched
                                    .iv_installed_meter_image &&
                                    scoPart2Formik.errors
                                      .iv_installed_meter_image && (
                                      <Typography
                                        color="error"
                                        variant="caption"
                                        sx={{ display: "block", mt: 0.5 }}
                                      >
                                        {
                                          scoPart2Formik.errors
                                            .iv_installed_meter_image
                                        }
                                      </Typography>
                                    )}
                                </Box>
                              </Grid>

                              {/*               Reading Information                */}

                              <Grid
                                item
                                lg={12}
                                className="group-title-item"
                                sx={{ mt: 4, mb: 2 }}
                              >
                                <Typography variant="h6" color="#006ad1">
                                  Reading Information
                                </Typography>
                              </Grid>

                              {phase === "Single Phase" && (
                                <Grid item lg={2.3}>
                                  <Typography className="fieldLabel">
                                    Meter Reading
                                  </Typography>
                                  <TextField
                                    name="iv_meter_reading"
                                    value={
                                      scoPart2Formik.values.iv_meter_reading
                                    }
                                    type="text"
                                    fullWidth
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_meter_reading &&
                                    scoPart2Formik.touched.iv_meter_reading
                                      ? scoPart2Formik.errors.iv_meter_reading
                                      : null}
                                  </p>
                                </Grid>
                              )}
                              {(phase === "3 Phase" ||
                                phase === "MDI (LT)(CT)" ||
                                phase === "MDI (HT)(CT/PT)") && (
                                <>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Peak (kWh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_peak_kwh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_peak_kwh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_peak_kwh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_peak_kwh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_peak_kwh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Off Peak (kWh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_off_peak_kwh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_off_peak_kwh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_off_peak_kwh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_off_peak_kwh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_off_peak_kwh
                                        : null}
                                    </p>
                                  </Grid>
                                </>
                              )}
                              {(phase === "MDI (LT)(CT)" ||
                                phase === "MDI (HT)(CT/PT)") && (
                                <>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Peak (kVARh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_peak_kvarh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_peak_kvarh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_peak_kvarh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_peak_kvarh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_peak_kvarh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Off Peak (kVARh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_off_peak_kvarh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_off_peak_kvarh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_off_peak_kvarh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_off_peak_kvarh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_off_peak_kvarh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      MDI
                                    </Typography>
                                    <TextField
                                      name="iv_mdi"
                                      value={scoPart2Formik.values.iv_mdi}
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_mdi &&
                                      scoPart2Formik.touched.iv_mdi
                                        ? scoPart2Formik.errors.iv_mdi
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      No. of MDI Resets
                                    </Typography>
                                    <TextField
                                      name="iv_no_of_mdi_resets"
                                      value={
                                        scoPart2Formik.values
                                          .iv_no_of_mdi_resets
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_no_of_mdi_resets &&
                                      scoPart2Formik.touched.iv_no_of_mdi_resets
                                        ? scoPart2Formik.errors
                                            .iv_no_of_mdi_resets
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={2}></Grid>
                                  <Grid item lg={2}>
                                    <Typography className="fieldLabel">
                                      CT Ratio
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "3px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Select
                                        sx={{ width: "100%" }}
                                        value={scoPart2Formik.values.iv_ct_nom}
                                        onChange={scoPart2Formik.handleChange}
                                        onBlur={scoPart2Formik.handleBlur}
                                        displayEmpty
                                        className="fieldBatch1"
                                        name="iv_ct_nom"
                                        id="iv_ct_nom"
                                        MenuProps={{
                                          PaperProps: {
                                            style: {
                                              width: 35,
                                            },
                                          },
                                        }}
                                      >
                                        <MenuItem
                                          value=""
                                          sx={{ fontSize: "12px" }}
                                        >
                                          Select CT
                                        </MenuItem>
                                        <MenuItem
                                          value="100"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          100
                                        </MenuItem>
                                        <MenuItem
                                          value="200"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          200
                                        </MenuItem>
                                        <MenuItem
                                          value="300"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          300
                                        </MenuItem>
                                        <MenuItem
                                          value="400"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          400
                                        </MenuItem>
                                        <MenuItem
                                          value="600"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          600
                                        </MenuItem>
                                        <MenuItem
                                          value="800"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          800
                                        </MenuItem>
                                        <MenuItem
                                          value="1000"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          1000
                                        </MenuItem>
                                      </Select>
                                      /
                                      <TextField
                                        name="iv_ct_denom"
                                        value={
                                          scoPart2Formik.values.iv_ct_denom
                                        }
                                        type="text"
                                        autoComplete="off"
                                        fullWidth
                                        disabled={true}
                                        onChange={scoPart2Formik.handleChange}
                                        onBlur={scoPart2Formik.handleBlur}
                                        className="fieldCoverageMarla"
                                      />
                                    </div>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_ct_nom &&
                                      scoPart2Formik.touched.iv_ct_nom
                                        ? scoPart2Formik.errors.iv_ct_nom
                                        : null}
                                    </p>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_ct_denom &&
                                      scoPart2Formik.touched.iv_ct_denom
                                        ? scoPart2Formik.errors.iv_ct_denom
                                        : null}
                                    </p>
                                  </Grid>
                                  {phase != "Single Phase" &&
                                    phase != "3 Phase" &&
                                    phase != "MDI (LT)(CT)" && (
                                      <Grid item lg={2}>
                                        <Typography className="fieldLabel">
                                          PT Ratio
                                        </Typography>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "3px",
                                            alignItems: "center",
                                          }}
                                        >
                                          <TextField
                                            name="iv_pt_nom"
                                            value={
                                              scoPart2Formik.values.iv_pt_nom
                                            }
                                            type="text"
                                            fullWidth
                                            disabled={true}
                                            onChange={
                                              scoPart2Formik.handleChange
                                            }
                                            onBlur={scoPart2Formik.handleBlur}
                                            className="fieldCoverageMarla"
                                          />
                                          /
                                          <TextField
                                            name="iv_pt_denom"
                                            value={
                                              scoPart2Formik.values.iv_pt_denom
                                            }
                                            type="text"
                                            fullWidth
                                            disabled={true}
                                            onChange={
                                              scoPart2Formik.handleChange
                                            }
                                            onBlur={scoPart2Formik.handleBlur}
                                            className="fieldCoverageMarla"
                                          />
                                        </div>
                                        <p className="form-error">
                                          {scoPart2Formik.errors.iv_pt_nom &&
                                          scoPart2Formik.touched.iv_pt_nom
                                            ? scoPart2Formik.errors.iv_pt_nom
                                            : null}
                                        </p>
                                        <p className="form-error">
                                          {scoPart2Formik.errors.iv_pt_denom &&
                                          scoPart2Formik.touched.iv_pt_denom
                                            ? scoPart2Formik.errors.iv_pt_denom
                                            : null}
                                        </p>
                                      </Grid>
                                    )}

                                  <Grid item lg={1}>
                                    <Typography className="fieldLabel">
                                      MF
                                    </Typography>
                                    <input
                                      name="iv_mf"
                                      value={calculateMF(
                                        scoPart2Formik.values.iv_ct_nom,
                                        scoPart2Formik.values.iv_ct_denom,
                                        scoPart2Formik.values.iv_pt_nom,
                                        scoPart2Formik.values.iv_pt_denom,
                                      )}
                                      type="text"
                                      disabled
                                      style={{
                                        backgroundColor: "#006ad1",
                                        color: "white",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "none",
                                        width: "90%",
                                        fontSize: "18px",
                                      }}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          ) : (
                            <>
                              <Box sx={{ m: 2 }}>
                                <TableContainer
                                  component={Paper}
                                  elevation={1}
                                  sx={{
                                    mt: 4,
                                    borderRadius: 2,
                                    overflow: "hidden",
                                  }}
                                >
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow
                                        sx={{
                                          "& th": {
                                            backgroundColor: "#003971",
                                            color: "#fff",
                                            textAlign: "center",
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            border: "1px solid #d6deeb",
                                            whiteSpace: "normal",
                                            lineHeight: 1.3,
                                            px: 1,
                                          },
                                        }}
                                      >
                                        <TableCell>Set No</TableCell>
                                        <TableCell>Meter Type</TableCell>
                                        <TableCell>KVAH / KVARH</TableCell>
                                        <TableCell>Main Subset</TableCell>
                                        <TableCell>Feeder No</TableCell>
                                        <TableCell>Meter No</TableCell>
                                        <TableCell>Location</TableCell>
                                        <TableCell>Manufacturer</TableCell>
                                        <TableCell>Meter Code</TableCell>
                                        <TableCell>MF</TableCell>
                                        <TableCell>Range</TableCell>
                                        <TableCell>Reading</TableCell>
                                        <TableCell>MDI Reset</TableCell>
                                        <TableCell>MDI Cum</TableCell>
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {disconnectedMeterDetails?.length > 0 ? (
                                        disconnectedMeterDetails.map(
                                          (row, index) => (
                                            <TableRow
                                              key={index}
                                              hover
                                              sx={{
                                                "& td": {
                                                  textAlign: "center",
                                                  fontSize: "12.5px",
                                                  border: "1px solid #e3e7ef",
                                                  px: 0.8,
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                },
                                              }}
                                            >
                                              <TableCell>
                                                {row.SET_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.PHASE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.TS_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.FEEDER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.METER_SERIAL_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_LOC_CD ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_MFG_ID_METER ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_MF ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_RANGE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_READING ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.MDI_RESET_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.MDI_CUM_READ ?? "-"}
                                              </TableCell>
                                            </TableRow>
                                          ),
                                        )
                                      ) : (
                                        <TableRow>
                                          <TableCell
                                            colSpan={14}
                                            align="center"
                                            sx={{ py: 3, fontSize: "13px" }}
                                          >
                                            No meter details found
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Box>

                              <Box sx={{ m: 2 }}>
                                <Paper
                                  elevation={1}
                                  sx={{ mt: 4, p: 3, borderRadius: 2 }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      mb: 2,
                                      color: "#003971",
                                      fontSize: "20px",
                                    }}
                                  >
                                    Meter Installation Details
                                  </Typography>

                                  <Grid container spacing={3}>
                                    {/* Installed Meter Image */}
                                    <Grid item xs={12} md={3}>
                                      <Typography
                                        sx={{
                                          mb: 1,
                                          fontSize: "15px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        Installed Meter Image
                                      </Typography>

                                      {meterInstallationFormik.values
                                        .iv_installed_meter_img ? (
                                        <Button
                                          variant="outlined"
                                          sx={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "space-evenly",
                                            alignItems: "center",
                                            px: 2,
                                          }}
                                        >
                                          {installedMeterImgThumbnail && (
                                            <>
                                              {installedMeterImgThumbnail.startsWith(
                                                "data:image/",
                                              ) ? (
                                                <img
                                                  src={
                                                    installedMeterImgThumbnail
                                                  }
                                                  alt="Installed Meter"
                                                  width="80"
                                                />
                                              ) : installedMeterImgThumbnail.startsWith(
                                                  "data:application/pdf",
                                                ) ? (
                                                <img
                                                  src={pdfIcon}
                                                  alt="Installed Meter PDF"
                                                  width="80"
                                                />
                                              ) : null}
                                            </>
                                          )}
                                          <CloseIcon
                                            sx={{
                                              color: "red",
                                              cursor: "pointer",
                                              ml: 2,
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              meterInstallationFormik.setFieldValue(
                                                "iv_installed_meter_img",
                                                null,
                                              );
                                              setInstalledMeterImgThumbnail(
                                                null,
                                              );
                                            }}
                                          />
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          startIcon={<FileUploadOutlinedIcon />}
                                          sx={{
                                            width: "100%",
                                            backgroundColor: "white",
                                          }}
                                        >
                                          Upload
                                          <input
                                            hidden
                                            accept={documentExtensions}
                                            type="file"
                                            onChange={(e) => {
                                              const file = e.target.files?.[0];
                                              if (file) {
                                                meterInstallationFormik.setFieldValue(
                                                  "iv_installed_meter_img",
                                                  file,
                                                );
                                                const reader = new FileReader();
                                                reader.readAsDataURL(file);
                                                reader.onload = () =>
                                                  setInstalledMeterImgThumbnail(
                                                    reader.result,
                                                  );
                                              }
                                            }}
                                          />
                                        </Button>
                                      )}

                                      <Box
                                        sx={{
                                          color: "red",
                                          fontSize: "0.8rem",
                                          mt: 0.5,
                                        }}
                                      >
                                        {meterInstallationFormik.touched
                                          .iv_installed_meter_img &&
                                          meterInstallationFormik.errors
                                            .iv_installed_meter_img}
                                      </Box>
                                    </Grid>

                                    {/* Installation Date */}
                                    <Grid item xs={12} md={3}>
                                      <Typography
                                        sx={{
                                          mb: 1,
                                          fontSize: "15px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        Installation Date
                                      </Typography>

                                      <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        name="iv_installed_meter_date"
                                        value={
                                          meterInstallationFormik.values
                                            .iv_installed_meter_date
                                        }
                                        onChange={
                                          meterInstallationFormik.handleChange
                                        }
                                        onBlur={
                                          meterInstallationFormik.handleBlur
                                        }
                                        inputProps={{
                                          min: dialogRowData?.creationDate
                                            ? dialogRowData.creationDate.split(
                                                "T",
                                              )[0]
                                            : undefined,
                                          max: new Date()
                                            .toISOString()
                                            .split("T")[0],
                                        }}
                                        sx={{ backgroundColor: "white" }}
                                      />

                                      <Box
                                        sx={{
                                          color: "red",
                                          fontSize: "0.8rem",
                                          mt: 0.5,
                                        }}
                                      >
                                        {meterInstallationFormik.touched
                                          .iv_installed_meter_date &&
                                          meterInstallationFormik.errors
                                            .iv_installed_meter_date}
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Box>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 10 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                        }}
                      >
                        <h4 style={{ textAlign: "center", width: "100%" }}>
                          Forward to RO
                        </h4>
                      </div>

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Forward to RO",
                      ) &&
                      // Load-based permission checks
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        // 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 kW (general 70 permission)
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        // 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        // > 500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {dialogRowData.isDiscAboveAYear === true ? (
                            <Grid
                              container
                              spacing={2}
                              className="field-survey-container"
                            >
                              {/* 1. Store Requisition No */}
                              <Grid item lg={2}>
                                <Typography className="fieldLabel">
                                  Store Requisition No.
                                </Typography>
                                <TextField
                                  fullWidth
                                  className="fieldCoverageMarla"
                                  name="iv_store_requisition_no"
                                  value={
                                    scoPart2Formik.values
                                      .iv_store_requisition_no || ""
                                  }
                                  disabled
                                  onChange={(e) => {
                                    const val = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    if (val.length <= 8) {
                                      scoPart2Formik.setFieldValue(
                                        "iv_store_requisition_no",
                                        val,
                                      );
                                    }
                                  }}
                                  onBlur={(e) => {
                                    let val = e.target.value.trim();
                                    if (val) {
                                      val = val.padStart(8, "0");
                                      scoPart2Formik.setFieldValue(
                                        "iv_store_requisition_no",
                                        val,
                                      );
                                    }
                                    scoPart2Formik.handleBlur(e);
                                  }}
                                  inputProps={{ maxLength: 8 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors
                                    .iv_store_requisition_no &&
                                  scoPart2Formik.touched.iv_store_requisition_no
                                    ? scoPart2Formik.errors
                                        .iv_store_requisition_no
                                    : null}
                                </p>
                              </Grid>

                              {/* 2. Store Req. Date */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Store Req. Date
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_store_requisition_date"
                                  className="fieldReferenceNo"
                                  type="date"
                                  disabled
                                  value={
                                    scoPart2Formik.values
                                      .iv_store_requisition_date || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  inputProps={{
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                  onBlur={scoPart2Formik.handleBlur}
                                  InputLabelProps={{ shrink: true }}
                                  sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "4px",
                                    "& .MuiInputBase-input": {
                                      backgroundColor: "#fff",
                                    },
                                  }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors
                                    .iv_store_requisition_date &&
                                  scoPart2Formik.touched
                                    .iv_store_requisition_date
                                    ? scoPart2Formik.errors
                                        .iv_store_requisition_date
                                    : null}
                                </p>
                              </Grid>

                              {/* 3. Sanctioned Load */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Sanc. Load (kW)
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_sanctioned_load"
                                  type="number"
                                  className="fieldCoverageMarla"
                                  disabled={true}
                                  value={
                                    scoPart2Formik.values.iv_sanctioned_load ||
                                    ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  InputProps={{ inputProps: { min: 0 } }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_sanctioned_load &&
                                  scoPart2Formik.touched.iv_sanctioned_load
                                    ? scoPart2Formik.errors.iv_sanctioned_load
                                    : null}
                                </p>
                              </Grid>

                              {/* 4. Meter Manufacturer */}
                              <Grid item lg={2}>
                                <Typography className="fieldLabel">
                                  Meter Manufacturer
                                </Typography>
                                <Autocomplete
                                  id="iv_manufacturer_code"
                                  name="iv_manufacturer_code"
                                  value={
                                    manufacturerCode ? manufacturerCode : null
                                  }
                                  disabled
                                  options={manufacturesList}
                                  // className='fieldBatch1'
                                  getOptionLabel={(option) =>
                                    option.code
                                      ? `${option.name} ${option.code}`
                                      : ""
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      className="fieldBatch1"
                                      value={inputValue}
                                      onChange={(e) =>
                                        setInputValue(e.target.value)
                                      }
                                      sx={{
                                        height: "10px",
                                        "& .MuiInputBase-input": {
                                          fontSize: "13px",
                                          height: "12px",
                                        },
                                      }}
                                    />
                                  )}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setManufcaturerCode(value);
                                      scoPart2Formik.setFieldValue(
                                        "iv_manufacturer_code",
                                        value.code,
                                      );
                                    }
                                  }}
                                  filterOptions={(options) =>
                                    filterOptions(
                                      options,
                                      { inputValue: debouncedInputValue },
                                      ["code", "name"],
                                    )
                                  }
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_manufacturer_code &&
                                  scoPart2Formik.touched.iv_manufacturer_code
                                    ? scoPart2Formik.errors.iv_manufacturer_code
                                    : null}
                                </p>
                              </Grid>

                              {/* 5. Meter Serial No */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Meter Serial No.
                                </Typography>
                                <TextField
                                  fullWidth
                                  disabled
                                  name="iv_meter_serial_no"
                                  className="fieldCoverageMarla"
                                  value={
                                    scoPart2Formik.values.iv_meter_serial_no ||
                                    ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ maxLength: 10 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_serial_no &&
                                  scoPart2Formik.touched.iv_meter_serial_no
                                    ? scoPart2Formik.errors.iv_meter_serial_no
                                    : null}
                                </p>
                              </Grid>

                              {/* 6. Sim No */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Sim No.
                                </Typography>
                                <TextField
                                  fullWidth
                                  disabled
                                  name="iv_sim_number"
                                  className="fieldCoverageMarla"
                                  value={
                                    scoPart2Formik.values.iv_sim_number || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ maxLength: 11 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_sim_number &&
                                  scoPart2Formik.touched.iv_sim_number
                                    ? scoPart2Formik.errors.iv_sim_number
                                    : null}
                                </p>
                              </Grid>

                              {/* 7. Sim Id */}
                              <Grid item lg={3}>
                                <Typography className="fieldLabel">
                                  Sim Id.
                                </Typography>
                                <TextField
                                  fullWidth
                                  disabled
                                  className="fieldCoverageMarla"
                                  name="iv_sim_ID"
                                  value={scoPart2Formik.values.iv_sim_ID || ""}
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ maxLength: 20 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_sim_ID &&
                                  scoPart2Formik.touched.iv_sim_ID
                                    ? scoPart2Formik.errors.iv_sim_ID
                                    : null}
                                </p>
                              </Grid>

                              {/* 8. Meter Type */}
                              <Grid item lg={3.1}>
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Meter Type
                                </Typography>
                                <FormControl
                                  disabled
                                  error={
                                    scoPart2Formik.touched.iv_meter_typee &&
                                    Boolean(
                                      scoPart2Formik.errors.iv_meter_typee,
                                    )
                                  }
                                  sx={{ width: "100%" }}
                                >
                                  <RadioGroup
                                    row
                                    className="radio-group"
                                    name="iv_meter_typee"
                                    value={
                                      scoPart2Formik.values.iv_meter_typee ?? ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                    disabled
                                  >
                                    <FormControlLabel
                                      value="1"
                                      control={<Radio />}
                                      label="Smart"
                                    />
                                    <FormControlLabel
                                      value="0"
                                      control={<Radio />}
                                      label="Normal"
                                    />
                                  </RadioGroup>
                                  <Box className="form-error">
                                    {scoPart2Formik.errors.iv_meter_typee &&
                                    scoPart2Formik.touched.iv_meter_typee
                                      ? scoPart2Formik.errors.iv_meter_typee
                                      : null}
                                  </Box>
                                </FormControl>
                              </Grid>

                              {/* 9. Meter Range */}
                              <Grid item lg={1.5}>
                                <Typography className="fieldLabel">
                                  Meter Range
                                </Typography>
                                <TextField
                                  fullWidth
                                  disabled
                                  name="iv_meter_range"
                                  className="fieldCoverageMarla"
                                  type="number"
                                  value={
                                    scoPart2Formik.values.iv_meter_range || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ min: 0 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_range &&
                                  scoPart2Formik.touched.iv_meter_range
                                    ? scoPart2Formik.errors.iv_meter_range
                                    : null}
                                </p>
                              </Grid>

                              {/* 10. Meter Code (Off Peak) */}
                              <Grid
                                item
                                lg={phase !== "Single Phase" ? 2 : 1.5}
                              >
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Meter Code{" "}
                                  {phase !== "Single Phase" ? "(Off Peak)" : ""}
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_meter_code1"
                                  className="fieldCoverageMarla"
                                  disabled={phase !== 'Single Phase' ? false : true}
                                  value={
                                    scoPart2Formik.values.iv_meter_code1 || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ maxLength: 6 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_code1 &&
                                  scoPart2Formik.touched.iv_meter_code1
                                    ? scoPart2Formik.errors.iv_meter_code1
                                    : null}
                                </p>
                              </Grid>

                              {/* 11. Meter Code (Peak) - only if not single phase */}
                              {phase !== "Single Phase" && (
                                <Grid item lg={2}>
                                  <Typography
                                    className="fieldLabel"
                                    sx={{ fontSize: "16px", color: "#006ad1" }}
                                  >
                                    Meter Code (Peak)
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    disabled
                                    name="iv_meter_code2"
                                    className="fieldCoverageMarla"
                                    value={
                                      scoPart2Formik.values.iv_meter_code2 || ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    inputProps={{ maxLength: 6 }}
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_meter_code2 &&
                                    scoPart2Formik.touched.iv_meter_code2
                                      ? scoPart2Formik.errors.iv_meter_code2
                                      : null}
                                  </p>
                                </Grid>
                              )}

                              {/* 12. Seasonal / Non-Seasonal (Industrial only) */}
                              {(dialogRowData?.connectionType?.toLowerCase() ===
                                "industrial" ||
                                dialogRowData?.connectionType ===
                                  "Industrial") && (
                                <Grid item lg={4}>
                                  <Typography className="fieldLabel">
                                    Seasonal / Non-Seasonal
                                  </Typography>
                                  <FormControl
                                    disabled
                                    error={
                                      scoPart2Formik.touched.iv_seasonal_flag &&
                                      Boolean(
                                        scoPart2Formik.errors.iv_seasonal_flag,
                                      )
                                    }
                                  >
                                    <RadioGroup
                                      className="radio-group"
                                      row
                                      name="iv_seasonal_flag"
                                      value={
                                        scoPart2Formik.values
                                          .iv_seasonal_flag ?? ""
                                      }
                                      onChange={scoPart2Formik.handleChange}
                                    >
                                      <FormControlLabel
                                        value="1"
                                        control={<Radio />}
                                        label="Seasonal"
                                      />
                                      <FormControlLabel
                                        value="0"
                                        control={<Radio />}
                                        label="Non-Seasonal"
                                      />
                                    </RadioGroup>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_seasonal_flag &&
                                      scoPart2Formik.touched.iv_seasonal_flag
                                        ? scoPart2Formik.errors.iv_seasonal_flag
                                        : null}
                                    </p>
                                  </FormControl>
                                </Grid>
                              )}

                              {/* 13. Installed By */}
                              <Grid item lg={1.7}>
                                <Typography className="fieldLabel">
                                  Installed By
                                </Typography>
                                <TextField
                                  fullWidth
                                  disabled={true}
                                  name="iv_connection_installer_name"
                                  className="fieldCoverageMarla"
                                  value={
                                    scoPart2Formik.values
                                      .iv_connection_installer_name || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors
                                    .iv_connection_installer_name &&
                                  scoPart2Formik.touched
                                    .iv_connection_installer_name
                                    ? scoPart2Formik.errors
                                        .iv_connection_installer_name
                                    : null}
                                </p>
                              </Grid>

                              {/* 14. Installation Date */}
                              <Grid item lg={1.6}>
                                <Typography className="fieldLabel">
                                  Installation Date
                                </Typography>

                                <FormControl
                                  fullWidth
                                  error={
                                    scoPart2Formik.touched
                                      .iv_date_of_connection &&
                                    Boolean(
                                      scoPart2Formik.errors
                                        .iv_date_of_connection,
                                    )
                                  }
                                >
                                  <TextField
                                    name="iv_date_of_connection"
                                    disabled
                                    className="fieldReferenceNo"
                                    type="date"
                                    value={
                                      scoPart2Formik.values
                                        .iv_date_of_connection || ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    inputProps={{
                                      min:
                                        dialogRowData?.creationDate?.split(
                                          "T",
                                        )[0] || undefined,
                                      max: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "#fff",
                                      borderRadius: "4px",
                                      "& .MuiInputBase-input": {
                                        backgroundColor: "#fff",
                                      },
                                    }}
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_date_of_connection &&
                                    scoPart2Formik.touched.iv_date_of_connection
                                      ? scoPart2Formik.errors
                                          .iv_date_of_connection
                                      : null}
                                  </p>
                                </FormControl>
                              </Grid>

                              {/* 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ16. Transformer Code & Ref No */}
                              <Grid item lg={1.8}>
                                <Typography className="fieldLabel">
                                  Transformer Code
                                </Typography>
                                <TextField
                                  fullWidth
                                  disabled
                                  name="iv_transformer_code"
                                  value={
                                    scoPart2Formik.values.iv_transformer_code ||
                                    ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  className="fieldCoverageMarla"
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_transformer_code &&
                                  scoPart2Formik.touched.iv_transformer_code
                                    ? scoPart2Formik.errors.iv_transformer_code
                                    : null}
                                </p>
                              </Grid>

                              <Grid item lg={1.8}>
                                <Typography className="fieldLabel">
                                  Transformer Ref No.
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_transformer_refNo"
                                  disabled
                                  value={
                                    scoPart2Formik.values
                                      .iv_transformer_refNo || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ maxLength: 14 }}
                                  className="fieldCoverageMarla"
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_transformer_refNo &&
                                  scoPart2Formik.touched.iv_transformer_refNo
                                    ? scoPart2Formik.errors.iv_transformer_refNo
                                    : null}
                                </p>
                              </Grid>

                              {/* 17. Meter Location */}
                              <Grid item lg={7.2}>
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Meter Location
                                </Typography>
                                <FormControl
                                  disabled
                                  error={
                                    scoPart2Formik.touched.iv_location_code &&
                                    Boolean(
                                      scoPart2Formik.errors.iv_location_code,
                                    )
                                  }
                                >
                                  <RadioGroup
                                    row
                                    className="radio-group"
                                    name="iv_location_code"
                                    value={
                                      scoPart2Formik.values.iv_location_code ||
                                      ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                  >
                                    <FormControlLabel
                                      value="P"
                                      control={<Radio />}
                                      label="Pole"
                                    />
                                    <FormControlLabel
                                      value="O"
                                      control={<Radio />}
                                      label="Outside"
                                    />
                                    <FormControlLabel
                                      value="I"
                                      control={<Radio />}
                                      label="Inside"
                                    />
                                  </RadioGroup>
                                  <Box className="form-error">
                                    {scoPart2Formik.errors.iv_location_code &&
                                    scoPart2Formik.touched.iv_location_code
                                      ? scoPart2Formik.errors.iv_location_code
                                      : null}
                                  </Box>
                                </FormControl>
                              </Grid>

                              <Grid item lg={2.2}>
                                <Typography className="fieldLabel">
                                  Installed Meter Image
                                </Typography>

                                <Box sx={{ mt: 1 }}>
                                  {scoPart2Formik.values
                                    .iv_installed_meter_image ||
                                  installedMeterImage ? (
                                    <>
                                      {/* Clickable preview thumbnail */}
                                      <Box
                                        sx={{
                                          position: "relative",
                                          display: "inline-block",
                                          border: "1px solid #ddd",
                                          borderRadius: "8px",
                                          overflow: "hidden",
                                          background: "#f9f9f9",
                                          cursor: "pointer",
                                          transition: "opacity 0.2s",
                                          "&:hover": { opacity: 0.88 },
                                        }}
                                        onClick={() =>
                                          setImagePreviewOpen(true)
                                        }
                                      >
                                        <img
                                          src={
                                            typeof scoPart2Formik.values
                                              .iv_installed_meter_image ===
                                            "string"
                                              ? scoPart2Formik.values
                                                  .iv_installed_meter_image
                                              : installedMeterImage
                                          }
                                          alt="Installed Meter Preview"
                                          style={{
                                            maxWidth: "180px",
                                            maxHeight: "180px",
                                            objectFit: "contain",
                                            display: "block",
                                          }}
                                        />

                                        {/* Red remove button (still here, but only on thumbnail) */}
                                        <IconButton
                                          size="small"
                                          color="error"
                                          disabled
                                          sx={{
                                            position: "absolute",
                                            top: 4,
                                            right: 4,
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation(); // Prevent opening modal when removing
                                            scoPart2Formik.setFieldValue(
                                              "iv_installed_meter_image",
                                              "",
                                            );
                                            setInstalledMeterImage(null);
                                            setInstalledMeterImageThumbnail?.(
                                              "",
                                            );
                                          }}
                                        >
                                          <CloseIcon fontSize="small" />
                                        </IconButton>
                                      </Box>

                                      <Modal
                                        open={imagePreviewOpen}
                                        onClose={() =>
                                          setImagePreviewOpen(false)
                                        }
                                        aria-labelledby="large-meter-image"
                                        // Makes backdrop click close the modal (already default behavior)
                                      >
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            bgcolor: "background.paper",
                                            boxShadow: 24,
                                            p: 1,
                                            borderRadius: 2,
                                            maxWidth: "96vw",
                                            maxHeight: "96vh",
                                            outline: "none",
                                            overflow: "hidden", // prevent scrollbars if image fits
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <img
                                            src={
                                              typeof scoPart2Formik.values
                                                .iv_installed_meter_image ===
                                              "string"
                                                ? scoPart2Formik.values
                                                    .iv_installed_meter_image
                                                : installedMeterImage
                                            }
                                            alt="Installed Meter - Large View"
                                            style={{
                                              maxWidth: "100%",
                                              maxHeight: "94vh",
                                              objectFit: "contain",
                                              display: "block",
                                            }}
                                            // Optional: double-click to close (some users expect this)
                                            onDoubleClick={() =>
                                              setImagePreviewOpen(false)
                                            }
                                          />
                                        </Box>
                                      </Modal>
                                    </>
                                  ) : (
                                    // Upload button remains unchanged
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<FileUploadOutlinedIcon />}
                                      sx={{
                                        textTransform: "none",
                                        borderColor: "#1976d2",
                                        color: "#1976d2",
                                        "&:hover": {
                                          borderColor: "#1565c0",
                                          backgroundColor:
                                            "rgba(25, 118, 210, 0.04)",
                                        },
                                      }}
                                    >
                                      Upload Image
                                      <input
                                        type="file"
                                        hidden
                                        accept="image/jpeg,image/png,image/jpg,.jpeg,.jpg,.png"
                                        onChange={(e) => {
                                          // ... your existing onChange logic
                                        }}
                                      />
                                    </Button>
                                  )}

                                  {/* Error message unchanged */}
                                  {scoPart2Formik.touched
                                    .iv_installed_meter_image &&
                                    scoPart2Formik.errors
                                      .iv_installed_meter_image && (
                                      <Typography
                                        color="error"
                                        variant="caption"
                                        sx={{ display: "block", mt: 0.5 }}
                                      >
                                        {
                                          scoPart2Formik.errors
                                            .iv_installed_meter_image
                                        }
                                      </Typography>
                                    )}
                                </Box>
                              </Grid>

                              {/*               Reading Information                */}

                              <Grid
                                item
                                lg={12}
                                className="group-title-item"
                                sx={{ mt: 4, mb: 2 }}
                              >
                                <Typography variant="h6" color="#006ad1">
                                  Reading Information
                                </Typography>
                              </Grid>

                              {phase === "Single Phase" && (
                                <Grid item lg={2.3}>
                                  <Typography className="fieldLabel">
                                    Meter Reading
                                  </Typography>
                                  <TextField
                                    disabled
                                    name="iv_meter_reading"
                                    value={
                                      scoPart2Formik.values.iv_meter_reading
                                    }
                                    type="text"
                                    fullWidth
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_meter_reading &&
                                    scoPart2Formik.touched.iv_meter_reading
                                      ? scoPart2Formik.errors.iv_meter_reading
                                      : null}
                                  </p>
                                </Grid>
                              )}
                              {(phase === "3 Phase" ||
                                phase === "MDI (LT)(CT)" ||
                                phase === "MDI (HT)(CT/PT)") && (
                                <>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Peak (kWh)
                                    </Typography>
                                    <TextField
                                      disabled
                                      name="iv_meter_reading_peak_kwh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_peak_kwh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_peak_kwh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_peak_kwh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_peak_kwh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Off Peak (kWh)
                                    </Typography>
                                    <TextField
                                      disabled
                                      name="iv_meter_reading_off_peak_kwh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_off_peak_kwh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_off_peak_kwh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_off_peak_kwh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_off_peak_kwh
                                        : null}
                                    </p>
                                  </Grid>
                                </>
                              )}
                              {(phase === "MDI (LT)(CT)" ||
                                phase === "MDI (HT)(CT/PT)") && (
                                <>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Peak (kVARh)
                                    </Typography>
                                    <TextField
                                      disabled
                                      name="iv_meter_reading_peak_kvarh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_peak_kvarh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_peak_kvarh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_peak_kvarh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_peak_kvarh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Off Peak (kVARh)
                                    </Typography>
                                    <TextField
                                      disabled
                                      name="iv_meter_reading_off_peak_kvarh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_off_peak_kvarh
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_off_peak_kvarh &&
                                      scoPart2Formik.touched
                                        .iv_meter_reading_off_peak_kvarh
                                        ? scoPart2Formik.errors
                                            .iv_meter_reading_off_peak_kvarh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      MDI
                                    </Typography>
                                    <TextField
                                      disabled
                                      name="iv_mdi"
                                      value={scoPart2Formik.values.iv_mdi}
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_mdi &&
                                      scoPart2Formik.touched.iv_mdi
                                        ? scoPart2Formik.errors.iv_mdi
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      No. of MDI Resets
                                    </Typography>
                                    <TextField
                                      disabled
                                      name="iv_no_of_mdi_resets"
                                      value={
                                        scoPart2Formik.values
                                          .iv_no_of_mdi_resets
                                      }
                                      type="text"
                                      fullWidth
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_no_of_mdi_resets &&
                                      scoPart2Formik.touched.iv_no_of_mdi_resets
                                        ? scoPart2Formik.errors
                                            .iv_no_of_mdi_resets
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={2}></Grid>
                                  <Grid item lg={2}>
                                    <Typography className="fieldLabel">
                                      CT Ratio
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "3px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Select
                                        disabled
                                        sx={{ width: "100%" }}
                                        value={scoPart2Formik.values.iv_ct_nom}
                                        onChange={scoPart2Formik.handleChange}
                                        onBlur={scoPart2Formik.handleBlur}
                                        displayEmpty
                                        className="fieldBatch1"
                                        name="iv_ct_nom"
                                        id="iv_ct_nom"
                                        MenuProps={{
                                          PaperProps: {
                                            style: {
                                              width: 35,
                                            },
                                          },
                                        }}
                                      >
                                        <MenuItem
                                          value=""
                                          sx={{ fontSize: "12px" }}
                                        >
                                          Select CT
                                        </MenuItem>
                                        <MenuItem
                                          value="100"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          100
                                        </MenuItem>
                                        <MenuItem
                                          value="200"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          200
                                        </MenuItem>
                                        <MenuItem
                                          value="300"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          300
                                        </MenuItem>
                                        <MenuItem
                                          value="400"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          400
                                        </MenuItem>
                                        <MenuItem
                                          value="600"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          600
                                        </MenuItem>
                                        <MenuItem
                                          value="800"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          800
                                        </MenuItem>
                                        <MenuItem
                                          value="1000"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          1000
                                        </MenuItem>
                                      </Select>
                                      /
                                      <TextField
                                        name="iv_ct_denom"
                                        value={
                                          scoPart2Formik.values.iv_ct_denom
                                        }
                                        type="text"
                                        autoComplete="off"
                                        fullWidth
                                        disabled={true}
                                        onChange={scoPart2Formik.handleChange}
                                        onBlur={scoPart2Formik.handleBlur}
                                        className="fieldCoverageMarla"
                                      />
                                    </div>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_ct_nom &&
                                      scoPart2Formik.touched.iv_ct_nom
                                        ? scoPart2Formik.errors.iv_ct_nom
                                        : null}
                                    </p>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_ct_denom &&
                                      scoPart2Formik.touched.iv_ct_denom
                                        ? scoPart2Formik.errors.iv_ct_denom
                                        : null}
                                    </p>
                                  </Grid>
                                  {phase != "Single Phase" &&
                                    phase != "3 Phase" &&
                                    phase != "MDI (LT)(CT)" && (
                                      <Grid item lg={2}>
                                        <Typography className="fieldLabel">
                                          PT Ratio
                                        </Typography>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "3px",
                                            alignItems: "center",
                                          }}
                                        >
                                          <TextField
                                            name="iv_pt_nom"
                                            value={
                                              scoPart2Formik.values.iv_pt_nom
                                            }
                                            type="text"
                                            fullWidth
                                            disabled={true}
                                            onChange={
                                              scoPart2Formik.handleChange
                                            }
                                            onBlur={scoPart2Formik.handleBlur}
                                            className="fieldCoverageMarla"
                                          />
                                          /
                                          <TextField
                                            name="iv_pt_denom"
                                            value={
                                              scoPart2Formik.values.iv_pt_denom
                                            }
                                            type="text"
                                            fullWidth
                                            disabled={true}
                                            onChange={
                                              scoPart2Formik.handleChange
                                            }
                                            onBlur={scoPart2Formik.handleBlur}
                                            className="fieldCoverageMarla"
                                          />
                                        </div>
                                        <p className="form-error">
                                          {scoPart2Formik.errors.iv_pt_nom &&
                                          scoPart2Formik.touched.iv_pt_nom
                                            ? scoPart2Formik.errors.iv_pt_nom
                                            : null}
                                        </p>
                                        <p className="form-error">
                                          {scoPart2Formik.errors.iv_pt_denom &&
                                          scoPart2Formik.touched.iv_pt_denom
                                            ? scoPart2Formik.errors.iv_pt_denom
                                            : null}
                                        </p>
                                      </Grid>
                                    )}

                                  <Grid item lg={1}>
                                    <Typography className="fieldLabel">
                                      MF
                                    </Typography>
                                    <input
                                      name="iv_mf"
                                      value={calculateMF(
                                        scoPart2Formik.values.iv_ct_nom,
                                        scoPart2Formik.values.iv_ct_denom,
                                        scoPart2Formik.values.iv_pt_nom,
                                        scoPart2Formik.values.iv_pt_denom,
                                      )}
                                      type="text"
                                      disabled
                                      style={{
                                        backgroundColor: "#006ad1",
                                        color: "white",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "none",
                                        width: "90%",
                                        fontSize: "18px",
                                      }}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          ) : (
                            <>
                              <Box sx={{ m: 2 }}>
                                <TableContainer
                                  component={Paper}
                                  elevation={1}
                                  sx={{
                                    mt: 4,
                                    borderRadius: 2,
                                    overflow: "hidden", // ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ disable horizontal scroll
                                  }}
                                >
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow
                                        sx={{
                                          "& th": {
                                            backgroundColor: "#003971",
                                            color: "#fff",
                                            textAlign: "center",
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            border: "1px solid #d6deeb",
                                            whiteSpace: "normal", // allow wrapping
                                            lineHeight: 1.3,
                                            px: 1,
                                          },
                                        }}
                                      >
                                        <TableCell>Set No</TableCell>
                                        <TableCell>Meter Type</TableCell>
                                        <TableCell>KVAH / KVARH</TableCell>
                                        <TableCell>Main Subset</TableCell>
                                        <TableCell>Feeder No</TableCell>
                                        <TableCell>Meter No</TableCell>
                                        <TableCell>Location</TableCell>
                                        <TableCell>Manufacturer</TableCell>
                                        <TableCell>Meter Code</TableCell>
                                        <TableCell>MF</TableCell>
                                        <TableCell>Range</TableCell>
                                        <TableCell>Reading</TableCell>
                                        <TableCell>MDI Reset</TableCell>
                                        <TableCell>MDI Cum</TableCell>
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {disconnectedMeterDetsForROApproval
                                        ?.meterProfile?.length > 0 ? (
                                        disconnectedMeterDetsForROApproval.meterProfile.map(
                                          (row, index) => (
                                            <TableRow
                                              key={index}
                                              hover
                                              sx={{
                                                "& td": {
                                                  textAlign: "center",
                                                  fontSize: "12.5px",
                                                  border: "1px solid #e3e7ef",
                                                  px: 0.8,
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                },
                                              }}
                                            >
                                              <TableCell>
                                                {row.SET_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.PHASE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.TS_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.FEEDER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.METER_SERIAL_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_LOC_CD ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_MFG_ID_METER ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_MF ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_RANGE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_READING ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.MDI_RESET_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.MDI_CUM_READ ?? "-"}
                                              </TableCell>
                                            </TableRow>
                                          ),
                                        )
                                      ) : (
                                        <TableRow>
                                          <TableCell
                                            colSpan={14}
                                            align="center"
                                            sx={{ py: 3 }}
                                          >
                                            No meter details found
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Box>
                              <Box sx={{ m: 2 }}>
                                <Paper
                                  elevation={1}
                                  sx={{ mt: 4, p: 3, borderRadius: 2 }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      mb: 2,
                                      color: "#003971",
                                      fontSize: "20px",
                                    }}
                                  >
                                    Meter Installation Summary
                                  </Typography>

                                  <Grid container spacing={3}>
                                    {/* Installation Date */}
                                    <Grid item xs={12} md={3}>
                                      <Typography
                                        sx={{
                                          mb: 0.5,
                                          fontSize: "15px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        Installation Date
                                      </Typography>

                                      <TextField
                                        fullWidth
                                        size="small"
                                        disabled
                                        value={
                                          disconnectedMeterDetsForROApproval
                                            ?.data?.[0]?.meterReinstalledAt
                                            ? convertDateDDMMYY(
                                                disconnectedMeterDetsForROApproval
                                                  .data[0].meterReinstalledAt,
                                              )
                                            : "-"
                                        }
                                        sx={{ backgroundColor: "#f9fafc" }}
                                      />
                                    </Grid>

                                    {/* Installed Meter Image */}
                                    <Grid item xs={12} md={6}>
                                      <Typography
                                        sx={{
                                          mb: 0.5,
                                          fontSize: "15px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        Installed Meter Image
                                      </Typography>

                                      <Paper
                                        variant="outlined"
                                        sx={{
                                          p: 1,
                                          borderRadius: 2,
                                          height: 260,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          backgroundColor:
                                            getDocumentBackGroundColor(0),
                                        }}
                                      >
                                        <img
                                          src={installedMeterImg}
                                          alt="Installed Meter"
                                          style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </Paper>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Box>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                           The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 11 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      {/* Title */}
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                          alignItems: "center",
                        }}
                      >
                        <h4
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginTop: "0.5%",
                          }}
                        >
                          Ready for Billing
                        </h4>
                      </div>

                      {/* Permission check for Post for Billing */}
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Post for Billing",
                      ) &&
                      /* Load sanctioning & tariff authority checks */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {/* If disconnected more than a year */}
                          {dialogRowData.isDiscAboveAYear ? (
                            <Grid
                              container
                              spacing={2}
                              className="field-survey-container"
                              sx={{}}
                            >
                              <Grid
                                container
                                className="ready-for-billing-cards-container"
                              >
                                <Grid
                                  item
                                  className="connection-information-container"
                                >
                                  <Grid container className="data-container">
                                    <Grid item lg={1.25} className="item">
                                      <Typography className="title">
                                        Tariff
                                      </Typography>
                                      <Typography className="value">
                                        {dialogRowData
                                          ? dialogRowData.tariffDesc
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        App. Id
                                      </Typography>
                                      <Typography className="value">
                                        {dialogRowData
                                          ? dialogRowData.tariffDesc
                                              .slice(0, 1)
                                              .concat(
                                                dialogRowData.applicationId.slice(
                                                  5,
                                                ),
                                              )
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Reg. Date
                                      </Typography>
                                      <Typography className="value">
                                        {dialogRowData
                                          ? convertDate(
                                              dialogRowData.creationDate,
                                            )
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Sec. Dept.
                                      </Typography>
                                      <Typography className="value">
                                        {dnDets.securityDepositeAmount
                                          ? numberFormatting(
                                              dnDets.securityDepositeAmount,
                                            )
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Pay Date
                                      </Typography>
                                      <Typography className="value">
                                        {dnDets
                                          ? convertDate(dnDets.paymentDate)
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.75} className="item">
                                      <Typography className="title">
                                        Conn Date
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.dateOfReConnection
                                          ? convertDate(
                                              scoDetails.dateOfReConnection,
                                            )
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1} className="item">
                                      <Typography className="title">
                                        Sanc. Load
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.senctionLoad
                                          ? scoDetails.senctionLoad
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1} className="item">
                                      <Typography className="title">
                                        R/U
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.urbanRural
                                          ? scoDetails.urbanRural
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1} className="item">
                                      <Typography className="title">
                                        F/P
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.fataPata
                                          ? scoDetails.fataPata
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1} className="item">
                                      <Typography className="title">
                                        Seasonal
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.seasonalFlag
                                          ? scoDetails.seasonalFlag
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Transformer Code
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.installedTransformerCapacity
                                          ? scoDetails.installedTransformerCapacity
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Location Code
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.locationCode
                                          ? scoDetails.locationCode
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Meter Type
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.meterType
                                          ? getMeterType(scoDetails.meterType)
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.75} className="item">
                                      <Typography className="title">
                                        Store Req. No.
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.storeRequisitionNo
                                          ? scoDetails.storeRequisitionNo
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.75} className="item">
                                      <Typography className="title">
                                        Req. Date
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.storeRequisitionDate
                                          ? convertDate(
                                              scoDetails.storeRequisitionDate,
                                            )
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Manufacturer Code
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.manufacturerCode
                                          ? scoDetails.manufacturerCode
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={1.5} className="item">
                                      <Typography className="title">
                                        Meter Serial No.
                                      </Typography>
                                      <Typography className="value">
                                        {scoDetails.meterNo
                                          ? scoDetails.meterNo
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    {phase == "3 Phase" && (
                                      <>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            Peak (kWh)
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.threePhasePeak
                                              ? scoDetails.threePhasePeak
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            Off Peak (kWh)
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.threePhaseOffPeak
                                              ? scoDetails.threePhaseOffPeak
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                      </>
                                    )}
                                    {(phase === "MDI (LT)(CT)" ||
                                      phase === "MDI (HT)(CT/PT)") && (
                                      <>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            Peak (kWh)
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.threePhasePeakKWH
                                              ? scoDetails.threePhasePeakKWH
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            Off Peak (kWh)
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.threePhaseOffPeakKWH
                                              ? scoDetails.threePhaseOffPeakKWH
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            Peak (kVARh)
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.threePhasePeakKVARH
                                              ? scoDetails.threePhasePeakKVARH
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            Off Peak (kVARh)
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.threePhaseOffPeakKVARH
                                              ? scoDetails.threePhaseOffPeakKVARH
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            MDI
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.mdi
                                              ? scoDetails.mdi
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            No. of MDI Resets
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.noOfMDIreset
                                              ? scoDetails.noOfMDIreset
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            CT Ratio
                                          </Typography>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "3px",
                                              alignItems: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              className="value"
                                              style={{ width: "100px" }}
                                            >
                                              {scoDetails.cTN
                                                ? scoDetails.cTN
                                                : "-"}
                                            </Typography>
                                            /
                                            <Typography
                                              className="value"
                                              style={{ width: "100px" }}
                                            >
                                              {scoDetails.cTD
                                                ? scoDetails.cTD
                                                : "-"}
                                            </Typography>
                                          </div>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            PT Ration
                                          </Typography>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "3px",
                                              alignItems: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              className="value"
                                              style={{ width: "100px" }}
                                            >
                                              {scoDetails.pTN
                                                ? scoDetails.pTN
                                                : "-"}
                                            </Typography>
                                            /
                                            <Typography
                                              className="value"
                                              style={{ width: "100px" }}
                                            >
                                              {scoDetails.pTD
                                                ? scoDetails.pTD
                                                : "-"}
                                            </Typography>
                                          </div>
                                        </Grid>
                                        <Grid item lg={1.5} className="item">
                                          <Typography className="title">
                                            MF
                                          </Typography>
                                          <Typography className="value">
                                            {scoDetails.multiplyingFactor
                                              ? scoDetails.multiplyingFactor
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                      </>
                                    )}
                                    {phase === "Single Phase" && (
                                      <Grid item lg={2} className="item">
                                        <Typography className="title">
                                          Initial Reading
                                        </Typography>
                                        <Typography className="value">
                                          {scoDetails.meterReading
                                            ? scoDetails.meterReading
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={2.5} sx={{ marginLeft: "2%" }}>
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Government Department
                                </Typography>
                                <FormControl className="form-control">
                                  <RadioGroup
                                    className="radio-group"
                                    row
                                    name="iv_govt_dept"
                                    value={masterDataFormik.values.iv_govt_dept}
                                    onChange={GovtDept}
                                    disabled={false}
                                  >
                                    <FormControlLabel
                                      value={1}
                                      className="form-control-label"
                                      control={<Radio disabled={false} />}
                                      label="Yes"
                                      name="Yes"
                                      labelPlacement="end"
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "0px 10px",
                                        borderRadius: "5px",
                                        marginLeft: "0px",
                                        marginRight: "5px",
                                        border: "1px solid lightgrey",
                                      }}
                                    />
                                    <FormControlLabel
                                      value={0}
                                      className="form-control-label"
                                      control={<Radio disabled={false} />}
                                      label="No"
                                      name="No"
                                      labelPlacement="end"
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "0px 10px",
                                        borderRadius: "5px",
                                        marginLeft: "0px",
                                        marginRight: "10px",
                                        border: "1px solid lightgrey",
                                      }}
                                    />
                                  </RadioGroup>
                                </FormControl>
                                <Box className="form-error">
                                  {masterDataFormik.errors.iv_govt_dept &&
                                  masterDataFormik.touched.iv_govt_dept
                                    ? masterDataFormik.errors.iv_govt_dept
                                    : null}
                                </Box>
                              </Grid>
                              <Grid item lg={2}>
                                <Typography className="fieldLabel">
                                  Electricity Duty
                                </Typography>
                                <Select
                                  sx={{ width: "100%" }}
                                  value={masterDataFormik.values.iv_ed_code}
                                  onChange={masterDataFormik.handleChange}
                                  onBlur={masterDataFormik.handleBlur}
                                  displayEmpty
                                  className="fieldBatch1"
                                  name="iv_ed_code"
                                  id="iv_ed_code"
                                  MenuProps={{
                                    PaperProps: {
                                      style: {
                                        width: 35,
                                      },
                                    },
                                  }}
                                >
                                  <MenuItem value="" sx={{ fontSize: "12px" }}>
                                    Select ED Code
                                  </MenuItem>
                                  {masterDataFormik.values.iv_govt_dept == 0
                                    ? [0, 1].map((option) => (
                                        <MenuItem
                                          sx={{ fontSize: "12px" }}
                                          key={option}
                                          value={option}
                                        >
                                          {option}
                                        </MenuItem>
                                      ))
                                    : [5, 6].map((option) => (
                                        <MenuItem
                                          sx={{ fontSize: "12px" }}
                                          key={option}
                                          value={option}
                                        >
                                          {option}
                                        </MenuItem>
                                      ))}
                                </Select>
                                <p className="form-error">
                                  {masterDataFormik.errors.iv_ed_code &&
                                  masterDataFormik.touched.iv_ed_code
                                    ? masterDataFormik.errors.iv_ed_code
                                    : null}
                                </p>
                              </Grid>
                              <Grid item lg={4}>
                                <Typography className="fieldLabel">
                                  Std. Class. Code
                                </Typography>
                                <Autocomplete
                                  id="iv_standard_classification_code"
                                  name="iv_standard_classification_code"
                                  value={
                                    standardClassificationCode
                                      ? standardClassificationCode
                                      : null
                                  }
                                  options={standardClassificationCodes}
                                  // className='fieldBatch1'
                                  // getOptionLabel={(option) => option.XCLFM_CODE ? `${option.XCLFM_CODE}${option.XCLFM_DESC}` : ''}
                                  getOptionLabel={(option) =>
                                    option.XCLFM_CODE && option.XCLFM_DESC
                                      ? `${option.XCLFM_CODE} - ${option.XCLFM_DESC}`
                                      : ""
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      className="fieldBatch1"
                                      value={inputValue}
                                      onChange={(e) =>
                                        setInputValue(e.target.value)
                                      }
                                      sx={{
                                        "& .MuiInputBase-input": {
                                          fontSize: "13px",
                                          height: "12px",
                                        },
                                      }}
                                    />
                                  )}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setStandardClassificationCode(value);
                                      masterDataFormik.setFieldValue(
                                        "iv_standard_classification_code",
                                        value.XCLFM_CODE,
                                      );
                                    } else {
                                      // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¡ This runs when user clicks the cross (clear)
                                      setStandardClassificationCode(null);
                                      masterDataFormik.setFieldValue(
                                        "iv_standard_classification_code",
                                        "",
                                      );
                                    }
                                  }}
                                  filterOptions={(options) =>
                                    filterOptions(
                                      options,
                                      { inputValue: debouncedInputValue },
                                      ["XCLFM_CODE", "XCLFM_DESC"],
                                    )
                                  }
                                />
                                <p className="form-error">
                                  {masterDataFormik.errors
                                    .iv_standard_classification_code &&
                                  masterDataFormik.touched
                                    .iv_standard_classification_code
                                    ? masterDataFormik.errors
                                        .iv_standard_classification_code
                                    : null}
                                </p>
                              </Grid>
                              <Grid item lg={3}>
                                <Typography className="fieldLabel">
                                  Income Tax
                                </Typography>
                                <FormControl className="form-control">
                                  <RadioGroup
                                    className="radio-group"
                                    row
                                    name="iv_income_tax"
                                    value={
                                      masterDataFormik.values.iv_income_tax
                                    }
                                    onChange={IncomeTax}
                                  >
                                    <FormControlLabel
                                      value={1}
                                      className="form-control-label"
                                      control={<Radio />}
                                      label="Yes"
                                      name="Yes"
                                      labelPlacement="end"
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "0px 10px",
                                        borderRadius: "5px",
                                        marginLeft: "0px",
                                        marginRight: "10px",
                                        border: "1px solid lightgrey",
                                      }}
                                    />
                                    <FormControlLabel
                                      value={0}
                                      className="form-control-label"
                                      control={<Radio />}
                                      label="No"
                                      name="No"
                                      labelPlacement="end"
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "0px 10px",
                                        borderRadius: "5px",
                                        marginLeft: "0px",
                                        marginRight: "10px",
                                        border: "1px solid lightgrey",
                                      }}
                                    />
                                  </RadioGroup>
                                </FormControl>
                                <Box className="form-error">
                                  {masterDataFormik.errors.iv_income_tax &&
                                  masterDataFormik.touched.iv_income_tax
                                    ? masterDataFormik.errors.iv_income_tax
                                    : null}
                                </Box>
                              </Grid>
                            </Grid>
                          ) : (
                            <>
                              {/* Meter Details Table */}
                              <Box sx={{ m: 2 }}>
                                <TableContainer
                                  component={Paper}
                                  elevation={1}
                                  sx={{ borderRadius: 2, overflow: "hidden" }}
                                >
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow
                                        sx={{
                                          "& th": {
                                            backgroundColor: "#003971",
                                            color: "#fff",
                                            textAlign: "center",
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            border: "1px solid #d6deeb",
                                            whiteSpace: "normal",
                                            lineHeight: 1.3,
                                            px: 1,
                                          },
                                        }}
                                      >
                                        {[
                                          "Set No",
                                          "Meter Type",
                                          "KVAH / KVARH",
                                          "Main Subset",
                                          "Feeder No",
                                          "Meter No",
                                          "Location",
                                          "Manufacturer",
                                          "Meter Code",
                                          "MF",
                                          "Range",
                                          "Reading",
                                          "MDI Reset",
                                          "MDI Cum",
                                        ].map((header, i) => (
                                          <TableCell key={i}>
                                            {header}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {disconnectedMeterDetsForROApproval
                                        ?.meterProfile?.length > 0 ? (
                                        disconnectedMeterDetsForROApproval.meterProfile.map(
                                          (row, index) => (
                                            <TableRow
                                              key={index}
                                              hover
                                              sx={{
                                                "& td": {
                                                  textAlign: "center",
                                                  fontSize: "12.5px",
                                                  border: "1px solid #e3e7ef",
                                                  px: 0.8,
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                },
                                              }}
                                            >
                                              <TableCell>
                                                {row.SET_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.PHASE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.TS_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.FEEDER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.METER_SERIAL_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_LOC_CD ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_MFG_ID_METER ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_CODE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_MF ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_METER_RANGE ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.KWH_READING ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.MDI_RESET_NO ?? "-"}
                                              </TableCell>
                                              <TableCell>
                                                {row.MDI_CUM_READ ?? "-"}
                                              </TableCell>
                                            </TableRow>
                                          ),
                                        )
                                      ) : (
                                        <TableRow>
                                          <TableCell
                                            colSpan={14}
                                            align="center"
                                            sx={{ py: 3 }}
                                          >
                                            No meter details found
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Box>

                              {/* Meter Installation Summary */}
                              <Box sx={{ m: 2 }}>
                                <Paper
                                  elevation={1}
                                  sx={{ p: 3, borderRadius: 2 }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      mb: 2,
                                      color: "#003971",
                                      fontSize: "20px",
                                    }}
                                  >
                                    Meter Installation Summary
                                  </Typography>

                                  <Grid container spacing={3}>
                                    {/* Installation Date */}
                                    <Grid item xs={12} md={3}>
                                      <Typography
                                        sx={{
                                          mb: 0.5,
                                          fontSize: "15px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        Installation Date
                                      </Typography>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        disabled
                                        value={
                                          disconnectedMeterDetsForROApproval
                                            ?.data?.[0]?.meterReinstalledAt
                                            ? convertDateDDMMYY(
                                                disconnectedMeterDetsForROApproval
                                                  .data[0].meterReinstalledAt,
                                              )
                                            : "-"
                                        }
                                        sx={{ backgroundColor: "#f9fafc" }}
                                      />
                                    </Grid>

                                    {/* Installed Meter Image */}
                                    <Grid item xs={12} md={6}>
                                      <Typography
                                        sx={{
                                          mb: 0.5,
                                          fontSize: "15px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        Installed Meter Image
                                      </Typography>
                                      <Paper
                                        variant="outlined"
                                        sx={{
                                          p: 1,
                                          borderRadius: 2,
                                          height: 260,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          backgroundColor:
                                            getDocumentBackGroundColor(0),
                                        }}
                                      >
                                        <img
                                          src={installedMeterImg}
                                          alt="Installed Meter"
                                          style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </Paper>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Box>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 12 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                          alignItems: "center",
                        }}
                      >
                        <h4
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginTop: "0.5%",
                          }}
                        >
                          Application Completed
                        </h4>

                        <Button
                          variant="outlined"
                          onClick={() =>
                            downloadCP138PDF(
                              dialogRowData,
                              disconnectedMeterDetsForROApproval,
                            )
                          }
                          sx={{
                            backgroundColor: "white",
                            cursor: "pointer",
                            border: "1px solid #006ad1",
                            boxShadow: "none",
                            width: "10%",
                          }}
                        >
                          <PrintIcon
                            sx={{ color: "#006ad1", marginLeft: "1%" }}
                          />{" "}
                          CP-138{" "}
                        </Button>
                      </div>
                      <Box
                        sx={{
                          color: "#00B091",
                          marginTop: "2%",
                          backgroundColor: "#DFFFE4",
                          padding: "1%",
                          width: "95%",
                          display: "flex",
                          flexDirection: "row",
                          marginLeft: "1%",
                        }}
                      >
                        <ErrorIcon
                          style={{ color: "#00B091", marginLeft: "1%" }}
                        />
                        <h4
                          style={{
                            marginLeft: "10px",
                            fontSize: "1vw",
                            fontWeight: "normal",
                          }}
                        >
                          {/* Application sent to level-1 (IBS). */}
                          Application Completed.
                        </h4>
                      </Box>
                    </>
                  ) : null}
                </div>
                <div className="actions">
                  {dialogRowData.applicationProgressId === 0 ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Basic Permissions",
                        "Update",
                      ) ? (
                        <button
                          onClick={() =>
                            navigate("/new-connection-update", {
                              state: { dialogRowData },
                            })
                          }
                          className="view-button"
                        >
                          Upload Pending Documents
                        </button>
                      ) : null}
                    </>
                  ) : dialogRowData.applicationProgressId === 1 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Document Verification",
                    ) && (
                      <>
                        {dialogRowData.applicantCNICFrontFlag !== 1 ||
                        dialogRowData.applicantCNICBackFlag !== 1 ? (
                          <>
                            <button
                              disabled={
                                dialogRowData.ApplicantCnicDocumentFronts
                                  ? !flag_applicantCNICFront ||
                                    !flag_applicantCNICBack ||
                                    flag_applicantCNICBack === "2" ||
                                    flag_applicantCNICFront === "2"
                                  : !flag_applicantCNICFront ||
                                    flag_applicantCNICFront === "2"
                              }
                              onClick={() => updateDocumentStatus()}
                              className="view-button"
                              style={{
                                backgroundColor:
                                  flag_applicantCNICFront === -1 ||
                                  flag_applicantCNICBack === -1
                                    ? "#E11B3C"
                                    : "#003971",
                              }}
                            >
                              {flag_applicantCNICFront === -1 ||
                              flag_applicantCNICBack === -1
                                ? "Reject"
                                : "Verify"}
                            </button>
                          </>
                        ) : null}
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 1 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Basic Permissions",
                        "Update",
                      ) ? (
                        <>
                          <button
                            onClick={() => {
                              setOpen(false);
                              navigate("/reconnection-update", {
                                state: { dialogRowData },
                              });
                            }}
                            className="view-button"
                          >
                            Re-Upload Document
                          </button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "RCO Fee Voucher Approval",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <Grid container spacing={2} justifyContent="end">
                          {paymentStatus === "No arrear exists" && (
                            <Grid item>
                              <button
                                className="view-button"
                                onClick={() =>
                                  callArrearVerificationAPI(
                                    dialogRowData.applicationId,
                                    dialogRowData.applicationProgressId + 1,
                                    0,
                                    "RCO Fee Voucher Approved..",
                                    "RCO Fee Voucher Approved..",
                                    0,
                                    "",
                                    null,
                                  )
                                }
                                style={{
                                  backgroundColor: "#003971",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "20px",
                                  padding: "10px 40px",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  width: "100%",
                                }}
                              >
                                Approve
                              </button>
                            </Grid>
                          )}

                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={() =>
                                    callArrearVerificationAPI(
                                      dialogRowData.applicationId,
                                      dialogRowData.applicationProgressId,
                                      1,
                                      "RCO Rejected.",
                                      `RCO Rejected.`,
                                      arrearAmount,
                                      billMonth,
                                      null,
                                    )
                                  }
                                  style={{
                                    backgroundColor: "#e11b3c",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "10px 40px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "100%",
                                  }}
                                >
                                  Reject
                                </button>
                              </Grid>

                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={
                                    arrearPaymentReceiptFormik.handleSubmit
                                  }
                                  style={{
                                    backgroundColor: "#003971",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "10px 40px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "100%",
                                  }}
                                >
                                  Approve
                                </button>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 2 &&
                    dialogRowData.objectionStatus === 1 ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "RCO Fee Voucher Approval",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <Grid container spacing={2} justifyContent="end">
                          {paymentStatus === "No arrear exists" && (
                            <Grid item>
                              <button
                                className="view-button"
                                onClick={() =>
                                  callArrearVerificationAPI(
                                    dialogRowData.applicationId,
                                    dialogRowData.applicationProgressId + 1,
                                    1,
                                    "RCO Fee Voucher Approved..",
                                    "RCO Fee Voucher Approved..",
                                    0,
                                    "",
                                    null,
                                  )
                                }
                                style={{
                                  backgroundColor: "#003971",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "20px",
                                  padding: "10px 40px",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  width: "100%",
                                }}
                              >
                                Approve
                              </button>
                            </Grid>
                          )}

                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={() =>
                                    callArrearVerificationAPI(
                                      dialogRowData.applicationId,
                                      dialogRowData.applicationProgressId,
                                      1,
                                      "RCO Rejected.",
                                      `RCO Rejected.`,
                                      arrearAmount,
                                      billMonth,
                                      null,
                                    )
                                  }
                                  style={{
                                    backgroundColor: "#e11b3c",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "10px 40px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "100%",
                                  }}
                                >
                                  Reject
                                </button>
                              </Grid>

                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={
                                    arrearPaymentObjectionReceiptFormik.handleSubmit
                                  }
                                  style={{
                                    backgroundColor: "#003971",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "10px 40px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "100%",
                                  }}
                                >
                                  Approve
                                </button>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "RCO Fee Voucher Submission",
                    ) && (
                      <>
                        <div>
                          <button
                            className="view-button"
                            onClick={rcoFeeReceiptFormik.handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 3 &&
                    dialogRowData.objectionStatus === 1 ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "RCO Fee Voucher Submission",
                    ) && (
                      <>
                        <div>
                          <button
                            className="view-button"
                            onClick={rcoFeeReceiptFormik.handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 4 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "RCO Fee Payment Verification",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <div>
                          <button
                            onClick={() => {
                              setVoucherActionType("approve");
                              setOpenVoucherActionModal(true);
                            }}
                            className="view-button"
                          >
                            Approve
                          </button>

                          <button
                            onClick={() => {
                              setVoucherActionType("reject");
                              setOpenVoucherActionModal(true);
                            }}
                            className="reject-button"
                            style={{ float: "right", marginRight: "10px" }}
                          >
                            Reject
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 5 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      {dialogRowData.isDiscAboveAYear == true ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "-40px",
                            alignItems: "flex-end",
                            gap: "0px",
                          }}
                        >
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Field Survey",
                          ) &&
                            ((CheckPermissions(
                              permissions,
                              "General Services",
                              "Reconnection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15",
                            ) &&
                              dialogRowData.sanctionedLoad > 0 &&
                              dialogRowData.sanctionedLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Reconnection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1",
                              ) &&
                                getNormalizedTariffName(
                                  dialogRowData.tariffCode,
                                  allTariffList,
                                ).startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Reconnection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2",
                                ) &&
                                  getNormalizedTariffName(
                                    dialogRowData.tariffCode,
                                    allTariffList,
                                  ).startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Reconnection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3",
                                ) &&
                                  getNormalizedTariffName(
                                    dialogRowData.tariffCode,
                                    allTariffList,
                                  ).startsWith("A3")))) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Reconnection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70",
                              ) &&
                                dialogRowData.sanctionedLoad > 0 &&
                                dialogRowData.sanctionedLoad <= 70 &&
                                !["A1", "A2", "A3"].some((code) =>
                                  getNormalizedTariffName(
                                    dialogRowData.tariffCode,
                                    allTariffList,
                                  ).startsWith(code),
                                )) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Reconnection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70",
                              ) &&
                                dialogRowData.sanctionedLoad > 15 &&
                                dialogRowData.sanctionedLoad <= 70) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Reconnection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "500",
                              ) &&
                                dialogRowData.sanctionedLoad > 70 &&
                                dialogRowData.sanctionedLoad <= 500) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Reconnection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "5000",
                              ) &&
                                dialogRowData.sanctionedLoad > 500)) && (
                              <>
                                {fieldFormik.values.iv_objection_Type ===
                                  "No Issue" && (
                                  <button
                                    onClick={() => {
                                      setLinemanAllocationSubPopUp(true);
                                    }}
                                    type="button"
                                    className="view-button"
                                    style={{ marginBottom: "10px" }}
                                  >
                                    Assign To Field Staff
                                  </button>
                                )}

                                <button
                                  onClick={async () => {
                                    await fieldFormik.handleSubmit();
                                  }}
                                  type="button"
                                  className="view-button"
                                  style={{
                                    margin: "0%",
                                    backgroundColor:
                                      fieldFormik.values.iv_objection_Type !==
                                      "No Issue"
                                        ? "red"
                                        : "",
                                  }}
                                >
                                  Submit
                                </button>
                              </>
                            )}
                        </div>
                      ) : (
                        <button
                          onClick={async () => {
                            await fieldFormik.handleSubmit();
                          }}
                          type="button"
                          className="view-button"
                          style={{ margin: "0%" }}
                        >
                          Submit
                        </button>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    dialogRowData.objectionStatus === 1 &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Field Survey",
                    ) &&
                    // Updated approval eligibility conditions (as requested)
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) ? (
                    <>
                      <button
                        onClick={showFieldRejectionRemovalAlert}
                        className="view-button"
                      >
                        Remove Objection
                      </button>
                    </>
                  ) : dialogRowData.applicationProgressId === 6 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "DN Approval",
                      ) &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Reconnection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2",
                            ) &&
                              getNormalizedTariffName(
                                dialogRowData.tariffCode,
                                allTariffList,
                              ).startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Reconnection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3",
                            ) &&
                              getNormalizedTariffName(
                                dialogRowData.tariffCode,
                                allTariffList,
                              ).startsWith("A3")))) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70",
                          ) &&
                            dialogRowData.sanctionedLoad > 0 &&
                            dialogRowData.sanctionedLoad <= 70 &&
                            !["A1", "A2", "A3"].some((code) =>
                              getNormalizedTariffName(
                                dialogRowData.tariffCode,
                                allTariffList,
                              ).startsWith(code),
                            )) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70",
                          ) &&
                            dialogRowData.sanctionedLoad > 15 &&
                            dialogRowData.sanctionedLoad <= 70) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "500",
                          ) &&
                            dialogRowData.sanctionedLoad > 70 &&
                            dialogRowData.sanctionedLoad <= 500) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Reconnection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "5000",
                          ) &&
                            dialogRowData.sanctionedLoad > 500)) && (
                          <div>
                            <button
                              onClick={() => {
                                DNApproveAPI(
                                  token,
                                  dialogRowData.applicationId,
                                  dialogRowData.applicationProgressId + 1,
                                  0,
                                  "Demand Note approved.",
                                  portalName,
                                );
                              }}
                              className="view-button"
                            >
                              Approve
                            </button>

                            <button
                              onClick={() => setDnRejectModalOpen(true)}
                              className="reject-button"
                              style={{ float: "right", marginRight: "10px" }}
                            >
                              Reject
                            </button>
                          </div>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "DN Submission",
                    ) && (
                      <>
                        <div>
                          <button
                            className="view-button"
                            onClick={dnReceiptFormik.handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 7 &&
                    dialogRowData.objectionStatus === 1 ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "DN Submission",
                    ) && (
                      <>
                        <div>
                          <button
                            className="view-button"
                            onClick={dnReceiptFormik.handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 8 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "DN Payment Verification",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <div>
                          <button
                            onClick={() => {
                              setVoucherActionTypeForDN("approve");
                              setOpenVoucherActionModalForDN(true);
                            }}
                            className="view-button"
                          >
                            Approve
                          </button>

                          <button
                            onClick={() => {
                              setVoucherActionTypeForDN("reject");
                              setOpenVoucherActionModalForDN(true);
                            }}
                            className="reject-button"
                            style={{ float: "right", marginRight: "10px" }}
                          >
                            Reject
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 9 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Meter Installation",
                    ) &&
                    // Load-based permission logic
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      // 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 kW (general 70 permission)
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      // 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 kW
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      // > 500 kW
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "-40px",
                          alignItems: "flex-end",
                          gap: "0px",
                        }}
                      >
                        {dialogRowData.isDiscAboveAYear === true ? (
                          <>
                            {/* <button
                              type="button" 
                              onClick={() => setLinemanAllocationSubPopUp(true)}
                              className="view-button"
                              style={{ marginBottom: "-15px" }} // keep if needed for layout
                            >
                              Assign To Field Staff
                            </button> */}

                            <button
                              type="button"
                              onClick={() => scoPart2Formik.handleSubmit()}
                              className="view-button"
                            >
                              Submit
                            </button>
                          </>
                        ) : (
                          <button
                            type="button"
                            className="view-button"
                            onClick={() =>
                              meterInstallationFormik.handleSubmit()
                            }
                          >
                            Submit
                          </button>
                        )}
                      </div>
                    )
                  ) : dialogRowData.applicationProgressId === 10 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Forward to RO",
                    ) &&
                    /* ========== LOAD <= 15 (A1/A2/A3) ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ["A1", "A2", "A3"].some((code) =>
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith(code),
                      )) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <button
                          onClick={() =>
                            callApproveRCOForBilling(
                              dialogRowData.applicationId,
                              dialogRowData.applicationProgressId + 1,
                              0,
                              dialogRowData.isDiscAboveAYear === true
                                ? "SCO Approved."
                                : "RCO Meter Profile verified.",
                              dialogRowData.isDiscAboveAYear === true
                                ? "SCO Approved Successfully."
                                : "RCO Meter Profile verified Successfully.",
                            )
                          }
                          type="submit"
                          className="view-button"
                          style={{ marginLeft: "10px" }}
                        >
                          Approve
                        </button>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 11 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Post for Billing",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Reconnection",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Reconnection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Reconnection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        {dialogRowData.isDiscAboveAYear === true ? (
                          <button
                            onClick={() => {
                              masterDataFormik.handleSubmit();
                            }}
                            type="submit"
                            className="view-button"
                          >
                            Submit
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              callPostedToIBSForBilling(
                                dialogRowData.applicationId,
                                dialogRowData.applicationProgressId + 1,
                                0,
                                "Application post for billing.",
                                "Application post for billing.",
                              )
                            }
                            type="submit"
                            className="view-button"
                            style={{ marginLeft: "10px" }}
                          >
                            Approve
                          </button>
                        )}
                      </>
                    )
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Basic Info Update Dialog */}
      <Dialog
        open={showEditPopup}
        onClose={() => {
          setShowEditPopup(false);
          editBasicInfoFormik.resetForm();
        }}
        fullWidth={true}
        maxWidth="lg"
        className="alert-popups"
      >
        <DialogTitle className="dialog-title">
          Basic Information
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setShowEditPopup(false);
                editBasicInfoFormik.resetForm();
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText component="div" className="dialog-content-text">
            <Typography variant="h3" className="group-title">
              Applicant's Details
            </Typography>
            <div className="field-container">
              <Typography>Name</Typography>
              <TextField
                required
                type="text"
                className="textfield"
                name="iv_applicant_name"
                value={editBasicInfoFormik.values.iv_applicant_name}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_name &&
                editBasicInfoFormik.touched.iv_applicant_name
                  ? editBasicInfoFormik.errors.iv_applicant_name
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>
                {dialogRowData.applicantRelationType === "Father's Name"
                  ? "Father's Name"
                  : "Husband's Name"}
              </Typography>
              <TextField
                required
                type="text"
                name="iv_relative_name"
                value={editBasicInfoFormik.values.iv_relative_name}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_relative_name &&
                editBasicInfoFormik.touched.iv_relative_name
                  ? editBasicInfoFormik.errors.iv_relative_name
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>CNIC</Typography>
              <TextField
                required
                type="text"
                name="iv_applicant_cnic"
                value={editBasicInfoFormik.values.iv_applicant_cnic}
                inputProps={{ maxLength: 13 }}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_cnic &&
                editBasicInfoFormik.touched.iv_applicant_cnic
                  ? editBasicInfoFormik.errors.iv_applicant_cnic
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>Phone No.</Typography>
              <TextField
                required
                type="text"
                name="iv_applicant_phone"
                value={editBasicInfoFormik.values.iv_applicant_phone}
                inputProps={{ maxLength: 11 }}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_phone &&
                editBasicInfoFormik.touched.iv_applicant_phone
                  ? editBasicInfoFormik.errors.iv_applicant_phone
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>Email (optional)</Typography>
              <TextField
                type="email"
                name="iv_applicant_email"
                value={editBasicInfoFormik.values.iv_applicant_email}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_email &&
                editBasicInfoFormik.touched.iv_applicant_email
                  ? editBasicInfoFormik.errors.iv_applicant_email
                  : null}
              </Box>
            </div>
            <Typography variant="h3" className="group-title">
              Address Details
            </Typography>
            {dialogRowData.areaType === "Urban" && (
              <>
                <div className="field-container">
                  <Typography>House / Shop</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_house"
                    value={editBasicInfoFormik.values.iv_house}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_house &&
                    editBasicInfoFormik.touched.iv_house
                      ? editBasicInfoFormik.errors.iv_house
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Street</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_street"
                    value={editBasicInfoFormik.values.iv_street}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_street &&
                    editBasicInfoFormik.touched.iv_street
                      ? editBasicInfoFormik.errors.iv_street
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Sector / Block / Phase / Mohala</Typography>
                  <TextField
                    required
                    type="email"
                    name="iv_sector_block_phase_mohala"
                    value={
                      editBasicInfoFormik.values.iv_sector_block_phase_mohala
                    }
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_sector_block_phase_mohala &&
                    editBasicInfoFormik.touched.iv_sector_block_phase_mohala
                      ? editBasicInfoFormik.errors.iv_sector_block_phase_mohala
                      : null}
                  </Box>
                </div>
              </>
            )}
            {dialogRowData.areaType === "Rural" && (
              <>
                <div className="field-container">
                  <Typography>Basti / Chak / Street</Typography>
                  <TextField
                    required
                    type="email"
                    name="iv_chak_street"
                    value={editBasicInfoFormik.values.iv_chak_street}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_chak_street &&
                    editBasicInfoFormik.touched.iv_chak_street
                      ? editBasicInfoFormik.errors.iv_chak_street
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Village</Typography>
                  <TextField
                    required
                    type="email"
                    name="iv_village"
                    value={editBasicInfoFormik.values.iv_village}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_village &&
                    editBasicInfoFormik.touched.iv_village
                      ? editBasicInfoFormik.errors.iv_village
                      : null}
                  </Box>
                </div>
              </>
            )}
            <div className="field-container">
              <Typography>Town / Tehsil</Typography>
              <TextField
                required
                type="email"
                name="iv_town_tehsil"
                value={editBasicInfoFormik.values.iv_town_tehsil}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_town_tehsil &&
                editBasicInfoFormik.touched.iv_town_tehsil
                  ? editBasicInfoFormik.errors.iv_town_tehsil
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>District / City</Typography>
              <Autocomplete
                id="iv_city_district"
                name="iv_city_district"
                options={cities ? cities : []}
                value={editBasicInfoFormik.values.iv_city_district}
                filterOptions={filterOptionsCityDistrict}
                onChange={(event, newValue) => {
                  if (newValue) {
                    editBasicInfoFormik.handleChange("iv_city_district")(
                      newValue,
                    );
                  }
                }}
                onBlur={editBasicInfoFormik.handleBlur}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    type="text"
                    className="textInputFieldAutoSelect"
                  />
                )}
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_city_district &&
                editBasicInfoFormik.touched.iv_city_district
                  ? editBasicInfoFormik.errors.iv_city_district
                  : null}
              </Box>
            </div>
            {dialogRowData.applicantStatus === "Tenant" && (
              <>
                <Typography variant="h3" className="group-title">
                  Owner's Details
                </Typography>
                <div className="field-container">
                  <Typography>Name</Typography>
                  <TextField
                    required
                    type="text"
                    className="textfield"
                    name="iv_owner_name"
                    value={editBasicInfoFormik.values.iv_owner_name}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_name &&
                    editBasicInfoFormik.touched.iv_owner_name
                      ? editBasicInfoFormik.errors.iv_owner_name
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>CNIC</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_owner_cnic"
                    value={editBasicInfoFormik.values.iv_owner_cnic}
                    inputProps={{ maxLength: 13 }}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_cnic &&
                    editBasicInfoFormik.touched.iv_owner_cnic
                      ? editBasicInfoFormik.errors.iv_owner_cnic
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Phone No.</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_owner_phone"
                    value={editBasicInfoFormik.values.iv_owner_phone}
                    inputProps={{ maxLength: 11 }}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_phone &&
                    editBasicInfoFormik.touched.iv_owner_phone
                      ? editBasicInfoFormik.errors.iv_owner_phone
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Email (optional)</Typography>
                  <TextField
                    type="email"
                    name="iv_owner_email"
                    value={editBasicInfoFormik.values.iv_owner_email}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_email &&
                    editBasicInfoFormik.touched.iv_owner_email
                      ? editBasicInfoFormik.errors.iv_owner_email
                      : null}
                  </Box>
                </div>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="arrearBtn"
            sx={{ width: "15%" }}
            onClick={editBasicInfoFormik.handleSubmit}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Objection Dialog */}
      <Dialog
        open={objectionPopUpOpen}
        onClose={hideObjectionPopup}
        fullWidth={true}
        maxWidth={"sm"}
        className="objectionDialog"
        ref={formik.resetForm}
      >
        <DialogTitle className="objection-dialog-title">
          <Grid container className="objectionheadercontainer">
            <Grid item className="applicationTitleGrid">
              <p className="applicationTitleText">Rejection Reason </p>
            </Grid>
            <Grid item className="closeIcon">
              <CloseIcon id="clearPopup" onClick={hideObjectionPopup} />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="objection-dialog-content">
          <DialogContentText
            component="div"
            className="objection-dialog-content-text"
          >
            <TextField
              type="text"
              name="iv_objection_Type"
              id="iv_objection_Type"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.iv_objection_Type}
              className="objection-input"
            />
            <Box className="from-Error">
              {formik.errors.iv_objection_Type &&
              formik.touched.iv_objection_Type
                ? formik.errors.iv_objection_Type
                : null}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="objection-dialog-action">
          <button
            onClick={() => {
              deleteFieldSurvey(dialogRowData.applicationId);
              setObjectionPopUpOpen(false);
            }}
            type="submit"
            className="submit-button"
          >
            Submit
          </button>
        </DialogActions>
      </Dialog>

      {/* Arrears Rejection Removal Alert */}
      <Dialog
        open={rejectionRemovalAlert}
        onClose={hideRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle className="dialog-title">
          Arrears Verification
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setArearPaidBillDocument("");
                setArearPaidBillDocumentThumbnail("");
                setRejectionRemovalAlert(false);
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          {CheckPermissions(
            permissions,
            "General Services",
            "Reconnection",
            "Workflow Permissions",
            "Arrear Bill Uploading",
          ) ? (
            <>
              <Grid
                container
                item
                lg={12}
                sx={{ display: "flex", flexDirection: "row" }}
              >
                <Grid
                  item
                  lg={4}
                  sx={{
                    marginTop: "2%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "8%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      marginBottom: "1%",
                      color: "#808080",
                    }}
                  >
                    Payment Date
                  </Typography>
                  <input
                    name="iv_arear_paid_bill_date"
                    value={
                      arearBillDocumentFormik.values.iv_arear_paid_bill_date
                    }
                    onChange={arearBillDocumentFormik.handleChange}
                    onBlur={arearBillDocumentFormik.handleBlur}
                    type="date"
                    style={{
                      padding: "10px", // Corrected syntax
                      borderRadius: "5px", // Enclosed in quotes
                      border: "1px solid #ccc", // Corrected syntax and enclosed in quotes
                      marginBottom: "10px",
                      width: "100%", // Corrected syntax and enclosed in quotes
                    }}
                    // min={dnDetails.issueDate.slice(0, 10)}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <Box
                    className="form-error"
                    sx={{ color: "red", marginTop: "1%" }}
                  >
                    {arearBillDocumentFormik.errors.iv_arear_paid_bill_date &&
                    arearBillDocumentFormik.touched.iv_arear_paid_bill_date
                      ? arearBillDocumentFormik.errors.iv_arear_paid_bill_date
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={6} sx={{ marginTop: "2%", marginRight: "8%" }}>
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      marginBottom: "1%",
                      color: "#808080",
                    }}
                  >
                    Paid Bill Image
                  </Typography>
                  {arearPaidBillDocument ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            sx={{ color: "red" }}
                            onClick={() => {
                              setArearPaidBillDocument("");
                            }}
                          />
                        }
                      >
                        {arearPaidBillDocumentThumbnail && (
                          <img
                            src={arearPaidBillDocumentThumbnail}
                            alt="Arear paid bill"
                            width="100"
                          />
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                        sx={{ marginTop: "2%", width: "70%" }}
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_arear_paid_bill_document"
                          name="iv_arear_paid_bill_document"
                          type="file"
                          onChange={ArearPaidBillDocument}
                        />
                      </Button>
                    </>
                  )}
                  <Box
                    className="documentError"
                    sx={{ color: "red", marginTop: "1%" }}
                  >
                    {arearBillDocumentFormik.errors
                      .iv_arear_paid_bill_document &&
                    arearBillDocumentFormik.touched.iv_arear_paid_bill_document
                      ? arearBillDocumentFormik.errors
                          .iv_arear_paid_bill_document
                      : null}
                  </Box>
                </Grid>
              </Grid>
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={arearBillDocumentFormik.handleSubmit}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Field Rejection Removal Alert */}
      <Dialog
        open={fieldRejectionRemovalAlert}
        onClose={hideFieldRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle className="dialog-title">Confirm</DialogTitle>
        <DialogContent>
          {dialogRowData.applicationProgressId === 5 ? (
            <DialogContentText component="div">
              Are you sure you want to remove the field survey objection for
              application id: {dialogRowData.applicationId}?
            </DialogContentText>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            className="confirmButton"
            onClick={() =>
              callChangeObjectionStatus(
                2,
                "Field Objection Removed",
                "Field Objection has been Removed",
              )
            }
          >
            Confirm
          </Button>
          <Button
            className="confirmButton"
            onClick={hideFieldRejectionRemovalAlert}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* DN Payment Rejection Alert */}
      <Dialog
        open={dnPaymentRejectAlert}
        onClose={hideDnPaymentRejectAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure the demand notice payment is un-verified?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              callChangeProgressIdAPI(
                5,
                "DN Payment Submitted",
                "DN Payment Unverified",
              );
              setDnPaymentRejectAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideDnPaymentRejectAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* RCO Part 1 Approval Alert */}
      <Dialog
        open={rcoPart1ApproveAlert}
        onClose={hideRCOPart1ApproveAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure you want to approve the RCO?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              rcoPart1Formik.handleSubmit();
              setRcoPart1ApproveAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideRCOPart1ApproveAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* RCO Part 2 Approval Alert */}
      <Dialog
        open={rcoPart2ApproveAlert}
        onClose={hideRCOPart2ApproveAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure you want to approve the RCO Part-2?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              rcoPart2Formik.handleSubmit();
              setRcoPart2ApproveAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideRCOPart2ApproveAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Documents Verified Sub Pop Up */}
      <Dialog
        open={documentsVerifiedSubPopUp}
        onClose={() => {
          setDocumentsVerifiedSubPopUp(false);
          setHistoryData(null);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">
            Documents{" "}
            {historyData?.applicantCNICFrontFlag === "1"
              ? "Verified"
              : historyData?.applicantCNICFrontFlag === "-1"
                ? "Rejected"
                : historyData?.applicantCNICFrontFlag === "2"
                  ? "Re-Uploaded"
                  : " "}
          </p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setDocumentsVerifiedSubPopUp(false);
              setHistoryData(null);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid
            container
            gap={1}
            className="container"
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor:
                historyData?.applicantCNICFrontFlag === "1"
                  ? "#beeabe"
                  : historyData?.applicantCNICFrontFlag === "-1"
                    ? "#e5959d"
                    : historyData?.applicantCNICFrontFlag === "2"
                      ? "#abada8" // <-- choose a color for "2"
                      : "transparent",
            }}
          >
            {/* Front Image */}
            {popUpfrontImg && (
              <Grid
                item
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "16px",
                }}
              >
                <strong>Front Document Image</strong>
                <img
                  src={popUpfrontImg}
                  alt="Front Document"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "320px",
                    objectFit: "contain",
                    borderRadius: 6,
                    marginTop: "8px",
                  }}
                />
              </Grid>
            )}

            {/* Back Image */}
            {popUpBackImg && (
              <Grid
                item
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "16px",
                }}
              >
                <strong>Back Document Image</strong>
                <img
                  src={popUpBackImg}
                  alt="Back Document"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "320px",
                    objectFit: "contain",
                    borderRadius: 6,
                    marginTop: "8px",
                  }}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions className="dialog-action">
          {historyData && (
            <p className="description">
              Documents{" "}
              {historyData?.applicantCNICFrontFlag === "1"
                ? "Verified"
                : historyData?.applicantCNICFrontFlag === "-1"
                  ? "Objected"
                  : historyData?.applicantCNICFrontFlag === "2"
                    ? "Re-Uploaded"
                    : "Submitted"}{" "}
              by: {historyData?.lastModifiedBy || historyData?.createdBy} on:{" "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : historyData?.creationDate
                  ? convertDatewithTime(historyData.creationDate)
                  : ""}
            </p>
          )}
        </DialogActions>
      </Dialog>

      {/*RCO FEE Voucher Approval Sub Pop Up  */}
      <Dialog
        open={arrearVerifiedSubPopUp}
        onClose={() => {
          setArrearVerifiedSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          RCO Fee{" "}
          {historyData?.objectionStatus === 1 &&
          historyData?.applicationProgressId === 2
            ? "Objection"
            : "Approval"}{" "}
          Details
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setArrearVerifiedSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)", 
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              {/* Row 1 */}
              <div>
                <label className="field-label">Fixed Charges</label>
                <TextField
                  fullWidth
                  value={formatAmountOrNA(historyData.fixedChargesAmount)}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">RCO Fee</label>
                <TextField
                  fullWidth
                  value={formatAmountOrNA(historyData.rcoFeeAmount)}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Total Fee</label>
                <TextField
                  fullWidth
                  value={
                    historyData?.fixedChargesAmount || historyData?.rcoFeeAmount
                      ? formatAmountOrNA(
                          Number(historyData.fixedChargesAmount || 0) +
                            Number(historyData.rcoFeeAmount || 0),
                        )
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 2 */}
              <div>
                <label className="field-label">Bank Name</label>
                <TextField
                  fullWidth
                  value={historyData.roBankName || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Bank Account No</label>
                <TextField
                  fullWidth
                  value={historyData.roBankAccountNo || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Bank Account Title</label>
                <TextField
                  fullWidth
                  value={historyData.roBankAccountTitle || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div style={{ gridColumn: "span 2" }}>
                <label className="field-label">Remarks Details</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {paidArrearImg && (
                <>
                  <div>
                    <label className="field-label">Arrears Amount</label>
                    <TextField
                      fullWidth
                      value={formatAmountOrNA(historyData.arrearsAmount)}
                      InputProps={{ readOnly: true }}
                      size="small"
                      disabled
                    />
                  </div>

                  <div>
                    <label className="field-label">Arrears Month</label>
                    <TextField
                      fullWidth
                      value={
                        convertDateDDMMYY(historyData.arrearsMonth) || "N/A"
                      }
                      InputProps={{ readOnly: true }}
                      size="small"
                      disabled
                    />
                  </div>

                  <div>
                    <label className="field-label">Arrears Payment Date</label>
                    <TextField
                      fullWidth
                      value={
                        convertDateDDMMYY(historyData.arrearsPaymentDate) ||
                        "N/A"
                      }
                      InputProps={{ readOnly: true }}
                      size="small"
                      disabled
                    />
                  </div>
                </>
              )}

              {/* Image Row */}
              {paidArrearImg && (
                <div
                  style={{
                    gridColumn: "1 / -1",
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <strong>Paid Arrears Image</strong>
                  <img
                    src={paidArrearImg}
                    alt="Paid Arrears"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData && (
            <p className="description">
              RCO FEE{" "}
              {historyData?.remarks === "RCO Rejected."
                ? "Objection"
                : "Approval"}{" "}
              by: {historyData?.lastModifiedBy || "-"} on:{" "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : "-"}
            </p>
          )}
        </DialogActions>
      </Dialog>

      {/* RCO FEE Voucher Submission Sub Pop Up */}
      <Dialog
        open={rcoFeeVoucherSubmissionSubPopUp}
        onClose={() => {
          setRcoFeeVoucherSubmissionSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {historyData?.remarks === "RCO fee voucher rejected."
            ? "Paid RCO Fee Voucher Rejected"
            : historyData?.remarks === "RCO fee voucher uploaded."
              ? "RCO Fee Voucher Submission Details"
              : ""}

          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setRcoFeeVoucherSubmissionSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData && (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr", // 3 columns
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              {/* Row 1 */}
              <div>
                <label className="field-label">Fixed Charges</label>
                <TextField
                  fullWidth
                  value={formatAmountOrNA(historyData.fixedChargesAmount)}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">RCO Fee</label>
                <TextField
                  fullWidth
                  value={formatAmountOrNA(historyData.rcoFeeAmount)}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Total Fee</label>
                <TextField
                  fullWidth
                  value={
                    historyData?.fixedChargesAmount || historyData?.rcoFeeAmount
                      ? formatAmountOrNA(
                          Number(historyData?.fixedChargesAmount || 0) +
                            Number(historyData?.rcoFeeAmount || 0),
                        )
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Row 2 */}
              <div>
                <label className="field-label">Bank Name</label>
                <TextField
                  fullWidth
                  value={historyData.roBankName || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Bank Account No</label>
                <TextField
                  fullWidth
                  multiline
                  value={historyData.roBankAccountNo || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Bank Account Title</label>
                <TextField
                  fullWidth
                  value={historyData.roBankAccountTitle || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}
              <div>
                <label className="field-label">RCO Fee Payment Date</label>
                <TextField
                  fullWidth
                  value={
                    convertDateDDMMYY(historyData.rcoFeePaymentDate) || "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Image with Title */}
              {paidRCOFeeImg && (
                <div
                  style={{
                    gridColumn: "1 / -1", // span all 3 columns
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column", // stack title above image
                    alignItems: "center", // center horizontally
                    gap: "8px", // space between title and image
                  }}
                >
                  <strong>Paid RCO Fee Image</strong>
                  <img
                    src={paidRCOFeeImg}
                    alt=""
                    style={{
                      maxWidth: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData && (
            <p className="description">
              RCO Fee Voucher{" "}
              {historyData?.remarks === "RCO fee voucher rejected."
                ? "Rejected"
                : historyData?.remarks === "RCO fee voucher uploaded."
                  ? "Submitted"
                  : ""}
              {" by: "}
              {historyData?.lastModifiedBy || "-"}
              {" on: "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : "-"}
            </p>
          )}
        </DialogActions>
      </Dialog>

      {/* RCO FEE Voucher Verification Sub Pop Up */}
      <Dialog
        open={rcoFeeVoucherVerificationSubPopUp}
        onClose={() => {
          setRcoFeeVoucherVerificationSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {" "}
          {dialogRowData.isDiscAboveAYear === false
            ? "RCO Fee Voucher Verification Details"
            : "DN Payment Verification Details"}
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setRcoFeeVoucherVerificationSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData && dialogRowData.isDiscAboveAYear === false ? (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr", // 3 columns
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              {/* Row 1 */}
              <div>
                <label className="field-label">Fixed Charges</label>
                <TextField
                  fullWidth
                  value={formatAmountOrNA(historyData.fixedChargesAmount)}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">RCO Fee</label>
                <TextField
                  fullWidth
                  value={formatAmountOrNA(historyData.rcoFeeAmount)}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Total Fee</label>
                <TextField
                  fullWidth
                  value={
                    historyData?.fixedChargesAmount || historyData?.rcoFeeAmount
                      ? formatAmountOrNA(
                          Number(historyData?.fixedChargesAmount || 0) +
                            Number(historyData?.rcoFeeAmount || 0),
                        )
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Row 2 */}
              <div>
                <label className="field-label">Bank Name</label>
                <TextField
                  fullWidth
                  value={historyData.roBankName || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Bank Account No</label>
                <TextField
                  fullWidth
                  multiline
                  value={historyData.roBankAccountNo || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Bank Account Title</label>
                <TextField
                  fullWidth
                  value={historyData.roBankAccountTitle || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}
              <div>
                <label className="field-label">RCO Fee Payment Date</label>
                <TextField
                  fullWidth
                  value={
                    convertDateDDMMYY(historyData.rcoFeePaymentDate) || "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Image with Title */}
              {paidRCOFeeImg && (
                <div
                  style={{
                    gridColumn: "1 / -1", // span all 3 columns
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column", // stack title above image
                    alignItems: "center", // center horizontally
                    gap: "8px", // space between title and image
                  }}
                >
                  <strong>Paid RCO Fee Image</strong>
                  <img
                    src={paidRCOFeeImg}
                    alt=""
                    style={{
                      maxWidth: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr", // 3 columns
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
                {/* Final Row */}
                <div>
                  <label className="field-label">Capital Cost Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.capitalCostAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Security Deposite Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.securityDepositeAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Grand Total (Capital Cost + Security Deposit)</label>
                  <TextField
                    fullWidth
                    value={
                      historyData ? formatAmountOrNA(getCapitalSecurityTotal(historyData.capitalCostAmount, historyData.securityDepositeAmount)) : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData?.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData?.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}
              <div>
                <label className="field-label">DN Payment Date</label>
                <TextField
                  fullWidth
                  value={
                    convertDateDDMMYY(historyData?.pdnPaymentDate) || "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Image with Title */}
              {dnPaymentImg && (
                <div
                  style={{
                    gridColumn: "1 / -1", // span all 3 columns
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column", // stack title above image
                    alignItems: "center", // center horizontally
                    gap: "8px", // space between title and image
                  }}
                >
                  <strong>DN Payment Image</strong>
                  <img
                    src={dnPaymentImg}
                    alt=""
                    style={{
                      maxWidth: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData && dialogRowData.isDiscAboveAYear === false ? (
            <p className="description">
              RCO Fee Voucher Verified by: {historyData?.lastModifiedBy}
              {" on: "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData?.lastModificationDate)
                : ""}
            </p>
          ) : (
            <p className="description">
              DN Payment Verified by: {historyData?.lastModifiedBy}
              {" on: "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData?.lastModificationDate)
                : ""}
            </p>
          )}
        </DialogActions>
      </Dialog>

      {/*Field Survey Sub Pop Up  */}
      <Dialog
        open={fieldSurveySubPopUp}
        onClose={() => {
          setFieldSurveySubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {historyData?.objectionStatus === 1 &&
          historyData?.applicationProgressId === 5
            ? "Field Survey Objection"
            : historyData?.objectionStatus === 0 &&
                historyData?.applicationProgressId === 5 &&
                historyData?.remarks == "Revert to Cost Estimation"
              ? "Revert To Field Survey And Cost Estimation"
              : historyData?.objectionStatus === 0 &&
                  historyData?.applicationProgressId === 5 &&
                  historyData?.remarks == "RCO fee voucher verified."
                ? "RCO Fee Verification Details"
                : historyData?.objectionStatus === 0 &&
                    historyData?.applicationProgressId === 5
                  ? "Field Survey Objection Removal"
                  : historyData?.objectionStatus === 0 &&
                      historyData?.applicationProgressId === 6
                    ? "Field Survey And Cost Estimation Submission"
                    : ""}{" "}
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setFieldSurveySubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData &&
            historyData?.applicationProgressId === 5 &&
            historyData?.objectionStatus === 1 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)", 
                  gap: "20px 24px",
                  marginTop: "24px",
                  alignItems: "end",
                }}
              >
                {/* Row 1 */}
                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              </div>
            )}

          {historyData &&
          historyData.applicationProgressId === 5 &&
          historyData.objectionStatus === 0 &&
          historyData.remarks === "Revert to Cost Estimation" ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : historyData &&
            historyData.applicationProgressId === 5 &&
            historyData.objectionStatus === 0 &&
            historyData?.remarks == "RCO fee voucher verified." ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : historyData &&
            historyData.applicationProgressId === 5 &&
            historyData.objectionStatus === 0 ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : null}

          {historyData &&
            historyData?.applicationProgressId === 6 &&
            historyData?.objectionStatus === 0 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)", 
                  gap: "20px 24px",
                  marginTop: "24px",
                  alignItems: "end",
                }}
              >
                {/* Row 1 */}
                <div>
                  <label className="field-label">Grid Sharing Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.amountOfGridSharing)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Feeder Rehab Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.amountOfFeederRehab)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Civil Work Charges</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.civilWorkCharges)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">
                    Fixed Charges Of Metering
                  </label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.fixedChargesOfMetering)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                {/* Row 3 */}

                <div>
                  <label className="field-label">Miscellaneous Charges</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.miscellaneousCharges)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Less The Cost</label>
                  <TextField
                    fullWidth
                    value={formatNegativeAmountOrNA(historyData?.lessTheCost)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <Typography variant="caption" sx={{ color: "#d32f2f", fontSize: "0.9rem", fontWeight: 600 }}>
                    Note: Other charges are already added in Capital Cost Amount.
                  </Typography>
                </div>

                {/* Final Row */}
                <div>
                  <label className="field-label">Capital Cost Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.capitalCostAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Security Deposite Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.securityDepositeAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Grand Total (Capital Cost + Security Deposit)</label>
                  <TextField
                    fullWidth
                    value={
                      historyData ? formatAmountOrNA(getCapitalSecurityTotal(historyData.capitalCostAmount, historyData.securityDepositeAmount)) : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                {/* Row 4 */}

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              </div>
            )}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData &&
            historyData?.applicationProgressId === 5 &&
            historyData?.objectionStatus === 1 && (
              <p className="description">
                Field Survey Objection by: {historyData?.lastModifiedBy || "-"}{" "}
                on:{" "}
                {historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : "-"}
              </p>
            )}

          {historyData &&
          historyData.applicationProgressId === 5 &&
          historyData.objectionStatus === 0 &&
          historyData.remarks === "Revert to Cost Estimation" ? (
            <p className="description">
              Reverted to Cost Estimation by:{" "}
              {historyData?.lastModifiedBy || "-"} on:{" "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : "-"}
            </p>
          ) : historyData &&
            historyData.applicationProgressId === 5 &&
            historyData.objectionStatus === 0 &&
            historyData?.remarks == "RCO fee voucher verified." ? (
            <p className="description">
              RCO Fee Voucher Verified by: {historyData?.lastModifiedBy || "-"}{" "}
              on:{" "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : "-"}
            </p>
          ) : historyData &&
            historyData.applicationProgressId === 5 &&
            historyData.objectionStatus === 0 ? (
            <p className="description">
              Field Survey Objection Removed by:{" "}
              {historyData?.lastModifiedBy || "-"} on:{" "}
              {historyData?.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : "-"}
            </p>
          ) : null}

          {historyData &&
            historyData?.applicationProgressId === 6 &&
            historyData?.objectionStatus === 0 && (
              <p className="description">
                Field Survey And Cost Estimation Saved by:{" "}
                {historyData?.lastModifiedBy || "-"} on:{" "}
                {historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : "-"}
              </p>
            )}
        </DialogActions>
      </Dialog>

      {/*DN Approval Sub Pop Up  */}
      <Dialog
        open={dnApprovalSubPopUp}
        onClose={() => {
          setDnApprovalSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {historyData?.objectionStatus === 0 &&
          historyData?.applicationProgressId === 7
            ? "DN Approval"
            : ""}{" "}
          Details
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setDnApprovalSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData &&
            historyData?.applicationProgressId === 7 &&
            historyData?.objectionStatus === 0 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)", 
                  gap: "20px 24px",
                  marginTop: "24px",
                  alignItems: "end",
                }}
              >
                {/* Final Row */}
                <div>
                  <label className="field-label">Capital Cost Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.capitalCostAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Security Deposite Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.securityDepositeAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Grand Total (Capital Cost + Security Deposit)</label>
                  <TextField
                    fullWidth
                    value={
                      historyData ? formatAmountOrNA(getCapitalSecurityTotal(historyData.capitalCostAmount, historyData.securityDepositeAmount)) : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              </div>
            )}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData &&
            historyData?.applicationProgressId === 7 &&
            historyData?.objectionStatus === 0 && (
              <p className="description">
                DN Approval by: {historyData?.lastModifiedBy || "-"} on: on:{" "}
                {historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : "-"}
              </p>
            )}
        </DialogActions>
      </Dialog>

      {/*DN Submission Sub Pop Up  */}
      <Dialog
        open={dnSubmissionSubPopUp}
        onClose={() => {
          setDnSubmissionSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {historyData?.objectionStatus === 0 &&
          historyData?.applicationProgressId === 8
            ? "DN Submission"
            : historyData?.objectionStatus === 1 &&
                historyData?.applicationProgressId === 7
              ? "DN Rejection"
              : historyData?.objectionStatus === 0 &&
                  historyData?.applicationProgressId === 9
                ? "DN Verification"
                : ""}{" "}
          Details
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setDnSubmissionSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData &&
            historyData?.applicationProgressId === 8 &&
            historyData?.objectionStatus === 0 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)", 
                  gap: "20px 24px",
                  marginTop: "24px",
                  alignItems: "end",
                }}
              >
                {/* Final Row */}
                <div>
                  <label className="field-label">Capital Cost Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.capitalCostAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Security Deposite Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.securityDepositeAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Grand Total (Capital Cost + Security Deposit)</label>
                  <TextField
                    fullWidth
                    value={
                      historyData ? formatAmountOrNA(getCapitalSecurityTotal(historyData.capitalCostAmount, historyData.securityDepositeAmount)) : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Payment Date</label>
                  <TextField
                    fullWidth
                    value={historyData.pdnPaymentDate || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                {/* Image with Title */}
                {dnPaymentImg && (
                  <div
                    style={{
                      gridColumn: "1 / -1", // span all 3 columns
                      marginTop: "24px",
                      display: "flex",
                      flexDirection: "column", // stack title above image
                      alignItems: "center", // center horizontally
                      gap: "8px", // space between title and image
                    }}
                  >
                    <strong>Paid DN Image</strong>
                    <img
                      src={dnPaymentImg}
                      alt=""
                      style={{
                        maxWidth: "100%",
                        maxHeight: "320px",
                        objectFit: "contain",
                        borderRadius: 6,
                      }}
                    />
                  </div>
                )}
              </div>
            )}

          {historyData &&
            historyData?.applicationProgressId === 7 &&
            historyData?.objectionStatus === 1 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)", 
                  gap: "20px 24px",
                  marginTop: "24px",
                  alignItems: "end",
                }}
              >
                {/* Final Row */}
                <div>
                  <label className="field-label">Capital Cost Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.capitalCostAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Security Deposite Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.securityDepositeAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Grand Total (Capital Cost + Security Deposit)</label>
                  <TextField
                    fullWidth
                    value={
                      historyData ? formatAmountOrNA(getCapitalSecurityTotal(historyData.capitalCostAmount, historyData.securityDepositeAmount)) : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Payment Date</label>
                  <TextField
                    fullWidth
                    value={historyData.pdnPaymentDate || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                {/* Image with Title */}
                {dnPaymentImg && (
                  <div
                    style={{
                      gridColumn: "1 / -1", // span all 3 columns
                      marginTop: "24px",
                      display: "flex",
                      flexDirection: "column", // stack title above image
                      alignItems: "center", // center horizontally
                      gap: "8px", // space between title and image
                    }}
                  >
                    <strong>Paid DN Image</strong>
                    <img
                      src={dnPaymentImg}
                      alt=""
                      style={{
                        maxWidth: "100%",
                        maxHeight: "320px",
                        objectFit: "contain",
                        borderRadius: 6,
                      }}
                    />
                  </div>
                )}
              </div>
            )}

          {historyData &&
            historyData?.applicationProgressId === 9 &&
            historyData?.objectionStatus === 0 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)", 
                  gap: "20px 24px",
                  marginTop: "24px",
                  alignItems: "end",
                }}
              >
                {/* Final Row */}
                <div>
                  <label className="field-label">Capital Cost Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.capitalCostAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Security Deposite Amount</label>
                  <TextField
                    fullWidth
                    value={formatAmountOrNA(historyData?.securityDepositeAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Grand Total (Capital Cost + Security Deposit)</label>
                  <TextField
                    fullWidth
                    value={
                      historyData ? formatAmountOrNA(getCapitalSecurityTotal(historyData.capitalCostAmount, historyData.securityDepositeAmount)) : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Payment Date</label>
                  <TextField
                    fullWidth
                    value={historyData.pdnPaymentDate || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                {/* Image with Title */}
                {dnPaymentImg && (
                  <div
                    style={{
                      gridColumn: "1 / -1", // span all 3 columns
                      marginTop: "24px",
                      display: "flex",
                      flexDirection: "column", // stack title above image
                      alignItems: "center", // center horizontally
                      gap: "8px", // space between title and image
                    }}
                  >
                    <strong>Paid DN Image</strong>
                    <img
                      src={dnPaymentImg}
                      alt=""
                      style={{
                        maxWidth: "100%",
                        maxHeight: "320px",
                        objectFit: "contain",
                        borderRadius: 6,
                      }}
                    />
                  </div>
                )}
              </div>
            )}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData &&
            historyData?.applicationProgressId === 8 &&
            historyData?.objectionStatus === 0 && (
              <p className="description">
                DN Submitted by: {historyData?.lastModifiedBy || "-"} on: on:{" "}
                {historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : "-"}
              </p>
            )}

          {historyData &&
            historyData?.applicationProgressId === 7 &&
            historyData?.objectionStatus === 1 && (
              <p className="description">
                DN Rejected by: {historyData?.lastModifiedBy || "-"} on: on:{" "}
                {historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : "-"}
              </p>
            )}

          {historyData &&
            historyData?.applicationProgressId === 9 &&
            historyData?.objectionStatus === 0 && (
              <p className="description">
                DN Verified by: {historyData?.lastModifiedBy || "-"} on: on:{" "}
                {historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : "-"}
              </p>
            )}
        </DialogActions>
      </Dialog>

      {/* Meter Installation Sub Pop Up */}
      <Dialog
        open={meterInstalationSubPopUp}
        onClose={() => {
          setMeterInstalationSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Meter Installation Details
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setMeterInstalationSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData && dialogRowData.isDiscAboveAYear === false ? (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              <div>
                <label className="field-label">Meter Reinstalled At</label>
                <TextField
                  fullWidth
                  value={
                    historyData.meterReinstalledAt
                      ? formatDate(historyData.meterReinstalledAt)
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {reInstalledMeterImg && (
                <div
                  style={{
                    gridColumn: "1 / -1",
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <strong>Reinstalled Meter Image</strong>
                  <img
                    src={reInstalledMeterImg}
                    alt="Reinstalled Meter"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}
            </div>
          ) : historyData ? (
            <>
              <p className="description" style={{ textAlign: "center" }}>
                Meter Re-Installed on{" "}
                {historyData.dateOfReConnection
                  ? historyData.dateOfReConnection
                  : "-"}{" "}
                by {historyData?.connectionInstallerName || "-"}.
              </p>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </>
          ) : null}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData && (
            <p className="description">
              Meter Re-Installed by: {historyData.lastModifiedBy}
              {" on: "}
              {historyData.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : ""}
            </p>
          )}
        </DialogActions>
      </Dialog>

      {/* Forward To RO Sub Pop Up */}
      <Dialog
        open={forwardToROSubPopUp}
        onClose={() => {
          setForwardToROSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Forward To RO Details
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setForwardToROSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData && dialogRowData.isDiscAboveAYear === false ? (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              <div>
                <label className="field-label">Meter Reinstalled At</label>
                <TextField
                  fullWidth
                  value={
                    historyData.meterReinstalledAt
                      ? formatDate(historyData.meterReinstalledAt)
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {reInstalledMeterImg && (
                <div
                  style={{
                    gridColumn: "1 / -1",
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <strong>Reinstalled Meter Image</strong>
                  <img
                    src={reInstalledMeterImg}
                    alt="Reinstalled Meter"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}
            </div>
          ) : historyData ? (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              <div>
                <label className="field-label">Meter Reinstalled At</label>
                <TextField
                  fullWidth
                  value={
                    historyData.dateOfReConnection
                      ? formatDate(historyData.dateOfReConnection)
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">SCO Approved By</label>
                <TextField
                  fullWidth
                  value={historyData.rcoP2ApprovedBy || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : null}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData && (
            <p className="description">
              Forward to RO Approved by: {historyData.lastModifiedBy}
              {" on: "}
              {historyData.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : ""}
            </p>
          )}
        </DialogActions>
      </Dialog>

      {/* Ready For Billing Sub Pop Up */}
      <Dialog
        open={readyForBillingSubPopUp}
        onClose={() => {
          setreadyForBillingSubPopUp(false);
          setHistoryData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Ready For Billing Details
          {/* ÃƒÆ’Ã‚Â¢Ãƒâ€šÃ‚ÂÃƒâ€¦Ã¢â‚¬â„¢ Close Icon */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setreadyForBillingSubPopUp(false);
              setHistoryData(null);
            }}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {historyData && dialogRowData.isDiscAboveAYear === false ? (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr", // 3 columns
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end", // aligns baselines nicely
              }}
            >
              {/* Row 1 - Field */}
              <div>
                <label className="field-label">Meter Reinstalled At</label>
                <TextField
                  fullWidth
                  value={formatDate(historyData.meterReinstalledAt) || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Row 1 - Field */}
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              {/* Row 2 - Image spanning all 3 columns with title */}
              {reInstalledMeterImg && (
                <div
                  style={{
                    gridColumn: "1 / -1", // span all 3 columns
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column", // stack title above image
                    alignItems: "center", // center horizontally
                    gap: "8px", // spacing between title and image
                  }}
                >
                  <strong>Reinstalled Meter Image</strong>
                  <img
                    src={reInstalledMeterImg}
                    alt="Reinstalled Meter"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}
            </div>
          ) : historyData ? (
            <div
              className="history-details-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "20px 24px",
                marginTop: "24px",
                alignItems: "end",
              }}
            >
              <div>
                <label className="field-label">CP-138 Approved At</label>
                <TextField
                  fullWidth
                  value={
                    historyData.cp138FilledAt
                      ? formatDate(historyData.cp138FilledAt)
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">CP-138 Approved By</label>
                <TextField
                  fullWidth
                  value={historyData.cp138FilledBy || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : null}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {historyData && (
            <p className="description">
              Ready For Billing Approved by: {historyData.lastModifiedBy}
              {" on: "}
              {historyData.lastModificationDate
                ? convertDatewithTime(historyData.lastModificationDate)
                : ""}
            </p>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={applicationSubittedPopUp}
        onClose={() => {
          setApplicationSubmittedPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Application Submitted</p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setApplicationSubmittedPopUp(false);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container gap={1} className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Application Id</p>
                <p className=" prop-detail">{dialogRowData.applicationId}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applicant Name</p>
                <p className=" prop-detail">{dialogRowData.consumerName}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applicant CNIC.</p>
                <p className=" prop-detail">{dialogRowData.consumerCNIC}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">
                  {dialogRowData.applicantRelationType
                    ? sodowo(dialogRowData.applicantRelationType)
                    : "-"}
                </p>
                <p className=" prop-detail">
                  {dialogRowData.applicantRelativeName
                    ? dialogRowData.applicantRelativeName
                    : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details1">
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applied Date</p>
                <p className=" prop-detail">
                  {convertDate(dialogRowData.creationDate)}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Subdivision</p>
                <p className=" prop-detail">
                  {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applied Load</p>
                <p className=" prop-detail">{dialogRowData.sanctionedLoad}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Connection Type</p>
                <p className=" prop-detail">
                  {dialogRowData.connectionCategory}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Sub. Through</p>
                <p className=" prop-detail">{dialogRowData.submittedThrough}</p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details">
              <Grid item lg={7} className="first-row-item">
                <p className="prop-title">Applicant Address</p>
                <p className=" prop-detail">{dialogRowData.premisesAddress}</p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Application Submitted by: {dialogRowData.consumerName} on:{" "}
            {convertDatewithTime(dialogRowData.creationDate)}
          </p>
        </DialogActions>
      </Dialog>

      {/* Field Survey Sub Pop Up */}
      <Dialog
        open={fieldSurveyedSubPopUp}
        onClose={() => {
          setFieldSurveyedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Field Surveyed</p>
          <CloseIcon
            id="clearPopup"
            onClick={() => {
              setFieldSurveyedSubPopUp(false);
            }}
            className="closeIcon"
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Dist. within 40m </p>
                <p className="prop-detail" style={{ width: "70%" }}>
                  {fieldSurveyData
                    ? fieldSurveyData.isLTLWI40Flag === 1
                      ? "Yes"
                      : "No"
                    : "-"}
                </p>
              </Grid>
              {fieldSurveyData.isLTLWI40Flag !== 1 && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Est. Distance (m)</p>
                  <p className="prop-detail" style={{ width: "70%" }}>
                    {fieldSurveyData
                      ? fieldSurveyData.estDistanceInMeter
                        ? fieldSurveyData.estDistanceInMeter
                        : "-"
                      : "-"}
                  </p>
                </Grid>
              )}
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Area (Marla) </p>
                <p className="prop-detail" style={{ width: "50%" }}>
                  {fieldSurveyData
                    ? fieldSurveyData.areaMarla
                      ? fieldSurveyData.areaMarla
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">No. of Meters Installed </p>
                <p className="prop-detail" style={{ width: "70%" }}>
                  {fieldSurveyData
                    ? fieldSurveyData.noOfMeterInstalled
                      ? fieldSurveyData.noOfMeterInstalled
                      : "-"
                    : "-"}
                </p>
              </Grid>
              {fieldSurveyData.sketchDiagram && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Sketch Diagram </p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(fieldSurveyData.sketchDiagram)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="image"
                    >
                      <Base64Image
                        data={fieldSurveyData.sketchDiagram}
                        width={80}
                      />
                    </a>
                  </div>
                </Grid>
              )}
            </Grid>
            <Grid item lg={12} className="application-details">
              {fieldSurveyData.noOfMeterInstalled === 0 && (
                <Grid item lg={3}></Grid>
              )}
              {fieldSurveyData.installedMeterRefNos[0].installedMeterRefNo &&
                fieldSurveyData.installedMeterRefNos.map((item, index) => {
                  return (
                    <Grid item lg={3} className="first-row-item">
                      <p className="prop-title">Meter {index + 1} Ref. No. </p>
                      <p className="prop-detail" style={{ width: "79%" }}>
                        {item.installedMeterRefNo}
                      </p>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Field Surveyed by:{" "}
            {eFileData.find((item) => item.remarks == "Field Surveyed")
              ? eFileData.find((item) => item.remarks == "Field Surveyed")
                  .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Field Surveyed")
              ? "(" +
                eFileData.find((item) => item.remarks == "Field Surveyed")
                  .roleName +
                ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Field Surveyed")
              ? convertDatewithTime(
                  eFileData.find((item) => item.remarks == "Field Surveyed")
                    .lastModificationDate,
                )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      {/* Reference No. Allocation Sub Pop Up */}
      <Dialog
        open={referenceNoAllocatedSubPopUp}
        onClose={() => {
          setReferenceNoAllocatedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Reference No. Allocated</p>
          <div>
            <PrintIcon
              onClick={() => downloadDNPDF(dialogRowData)}
              className="printIcon"
            />
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setReferenceNoAllocatedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Demand Notice No. </p>
                <p className="prop-detail">
                  {dnDetails ? dnDetails.demandNoticeNo : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Reference No. </p>
                <p className="prop-detail">
                  {dnDetails ? dnDetails.connectionAccountNo : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">DN Issue Date </p>
                <p className="prop-detail">
                  {dnDetails ? convertDate(dnDetails.issueDate) : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">DN Due Date </p>
                <p className="prop-detail">
                  {dnDetails ? convertDate(dnDetails.dueDate) : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details">
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Capital Cost </p>
                <p className="prop-detail">
                  {dnDetails
                    ? dnDetails.capitalCostAmount
                      ? numberFormatting(dnDetails.capitalCostAmount)
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Security Cost </p>
                <p className="prop-detail">
                  {dnDetails
                    ? dnDetails.securityDepositeAmount
                      ? numberFormatting(dnDetails.securityDepositeAmount)
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Total Cost</p>
                <p className="prop-detail">
                  {dnDetails.capitalCostAmount ||
                  dnDetails.securityDepositeAmount
                    ? numberFormatting(
                        parseInt(dnDetails.capitalCostAmount) +
                          parseInt(dnDetails.securityDepositeAmount) +
                          (!isNaN(parseInt(dnDetails.amountOfGridSharing))
                            ? parseInt(dnDetails.amountOfGridSharing)
                            : 0) +
                          (!isNaN(parseInt(dnDetails.amountOfFeederRehab))
                            ? parseInt(dnDetails.amountOfFeederRehab)
                            : 0),
                      )
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Bank Name</p>
                <p className="prop-detail">
                  {dnDetails ? dnDetails.bankName : "-"}
                </p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Demand Notice Approved by:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? eFileData.find(
                  (item) => item.remarks == "Demand Notice Created",
                ).lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? "(" +
                eFileData.find(
                  (item) => item.remarks == "Demand Notice Created",
                ).roleName +
                ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? convertDatewithTime(
                  eFileData.find(
                    (item) => item.remarks == "Demand Notice Created",
                  ).lastModificationDate,
                )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      {/* DN Payment Submitted Pub Pop Up */}
      <Dialog
        open={dnPaymentSubmittedSubPopUp}
        onClose={() => {
          setDnPaymentSubmittedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">DN Payment Submitted</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setDnPaymentSubmittedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={7} className="application-details">
              <Grid item lg={3.5} className="first-row-item">
                <p className="prop-title">Demand Notice No. </p>
                <p className="prop-detail">
                  {paidDnImageDetails
                    ? paidDnImageDetails.demandNoticeNo
                      ? paidDnImageDetails.demandNoticeNo
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={3.5} className="first-row-item">
                <p className="prop-title">Payment Date </p>
                <p className="prop-detail">
                  {paidDnImageDetails
                    ? paidDnImageDetails.paymentDate
                      ? convertDate(paidDnImageDetails.paymentDate)
                      : "-"
                    : "-"}
                </p>
              </Grid>
              {paidDnImageDetails.paidDNImage && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Paid DN Image </p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(paidDnImageDetails.paidDNImage)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="item"
                    >
                      <Base64Image
                        data={paidDnImageDetails.paidDNImage}
                        width={80}
                      />
                    </a>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Paid Demand Notice Image Uploaded by:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Paid")
              ? eFileData.find((item) => item.remarks == "Demand Notice Paid")
                  .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Paid")
              ? "(" +
                eFileData.find((item) => item.remarks == "Demand Notice Paid")
                  .roleName +
                ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Paid")
              ? convertDatewithTime(
                  eFileData.find((item) => item.remarks == "Demand Notice Paid")
                    .lastModificationDate,
                )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      {/* DN Payment Verified Sub Pop Up */}
      <Dialog
        open={dnPaymentVerifiedSubPopUp}
        onClose={() => {
          setDnPaymentVerifiedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">DN Payment Verified</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setDnPaymentVerifiedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={7} className="application-details">
              <Grid item lg={3.5} className="first-row-item">
                <p className="prop-title">Demand Notice No. </p>
                <p className="prop-detail">
                  {paidDnImageDetails ? paidDnImageDetails.demandNoticeNo : "-"}
                </p>
              </Grid>
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Payment Date </p>
                <p className="prop-detail">
                  {paidDnImageDetails
                    ? convertDate(paidDnImageDetails.paymentDate)
                    : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={6}></Grid>
            <Grid item lg={12} className="application-details">
              {paidDnImageDetails.paidDNImage && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Paid DN Image </p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(paidDnImageDetails.paidDNImage)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="item"
                    >
                      <Base64Image
                        data={paidDnImageDetails.paidDNImage}
                        width={80}
                      />
                    </a>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Demand Notice Payment Verified by:{" "}
            {paidDnImageDetails.paidDNImageVerifiedBy} (CSL) on:{" "}
            {convertDatewithTime(
              paidDnImageDetails.paidDNImageVerifiedDateTime,
            )}
          </p>
        </DialogActions>
      </Dialog>

      {/* Service Connection Order Sub Pop Up */}
      <Dialog
        open={serviceConnectionOrderedSubPopUp}
        onClose={() => {
          setServiceConnectionOrderedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Service Connection Ordered</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setServiceConnectionOrderedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">RCO No. </p>
                <p className="prop-detail">
                  {rcoDetails ? rcoDetails.rcoId : "-"}
                </p>
              </Grid>
              <Grid item lg={1.5} className="first-row-item">
                <p className="prop-title">Feeder Code</p>
                <p className="prop-detail">
                  {rcoDetails ? rcoDetails.feederNo : "-"}
                </p>
              </Grid>
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Feeder Name</p>
                <p className="prop-detail">
                  {rcoDetails ? rcoDetails.feederNo : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">Batch </p>
                <p className="prop-detail">
                  {rcoDetails ? rcoDetails.batch : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">S/Btch. </p>
                <p className="prop-detail">
                  {rcoDetails ? rcoDetails.subBatch : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">R/U </p>
                <p className="prop-detail">
                  {rcoDetails ? rcoDetails.urbanRural : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">F/P </p>
                <p className="prop-detail">
                  {rcoDetails ? rcoDetails.fataPata : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details">
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">F.Gvt./A.&L.Bds./P.Gvt</p>
                <p className="prop-detail">
                  {rcoDetails
                    ? rcoDetails.fGovt
                      ? rcoDetails.fGovt
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Cantonment Board </p>
                <p className="prop-detail">
                  {rcoDetails
                    ? rcoDetails.cantonmentBoard
                      ? rcoDetails.cantonmentBoard
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">P.Gvt./A.&L.Bds./P.Gvt. </p>
                <p className="prop-detail">
                  {rcoDetails
                    ? rcoDetails.pGovt
                      ? rcoDetails.pGovt
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Local Bodies</p>
                <p className="prop-detail">
                  {rcoDetails
                    ? rcoDetails.localBodies
                      ? rcoDetails.localBodies
                      : "-"
                    : "-"}
                </p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Service Connection Order Issued by:{" "}
            {eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? eFileData.find((item) => item.remarks == "DN Payment Verified")
                  .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? "(" +
                eFileData.find((item) => item.remarks == "DN Payment Verified")
                  .roleName +
                ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? convertDatewithTime(
                  eFileData.find(
                    (item) => item.remarks == "DN Payment Verified",
                  ).lastModificationDate,
                )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      {/* Meter Installed Sub Pop Up */}
      <Dialog
        open={meterInstalledSubPopUp}
        onClose={() => {
          setMeterInstalledSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Meter Installed</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setMeterInstalledSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            {rcoDetails.rcoP2FillFlag && (
              <>
                <Grid
                  item
                  lg={12}
                  className="item"
                  style={{ marginBottom: "1%" }}
                >
                  <h3 className="group-title-first">Store Requisition Info</h3>
                </Grid>
                <Grid item lg={12} className="application-details">
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">SR No.</p>
                    <p className="prop-detail">
                      {rcoDetails ? rcoDetails.storeRequisitionNo : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={3} className="first-row-item">
                    <p className="prop-title">SR Date</p>
                    <p className="prop-detail">
                      {rcoDetails ? rcoDetails.storeRequisitionDate : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={3} className="first-row-item">
                    <p className="prop-title">Transformer Code</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.installedTransformerCapacity
                          ? rcoDetails.installedTransformerCapacity
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={3} className="first-row-item">
                    <p className="prop-title">Seasonal / Non Seasonal</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.seasonalFlag === 1
                          ? "Yes"
                          : "No"
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  className="item"
                  style={{ marginBottom: "1%", marginTop: "1%" }}
                >
                  <h3 className="group-title">Meter Info</h3>
                </Grid>
                <Grid item lg={12} className="application-details">
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Meter No.</p>
                    <p className="prop-detail">
                      {rcoDetails ? rcoDetails.meterNo : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Meter Id</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.meterId
                          ? rcoDetails.meterId
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Manuf. Code</p>
                    <p className="prop-detail">
                      {rcoDetails ? rcoDetails.manufacturerCode : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Meter Read.</p>
                    <p className="prop-detail">
                      {rcoDetails ? rcoDetails.meterReading : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Multi. Factor</p>
                    <p className="prop-detail">
                      {rcoDetails ? rcoDetails.multiplyingFactor : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Loc. Code</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.locationCode
                          ? rcoDetails.locationCode
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  className="item"
                  style={{ marginBottom: "1%", marginTop: "1%" }}
                >
                  <h3 className="group-title">Connection Installation Info</h3>
                </Grid>
                <Grid item lg={12} className="application-details">
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Installed By</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.connectionInstallerName
                          ? rcoDetails.connectionInstallerName
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Install. Date</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.dateOfReConnection
                          ? convertDate(rcoDetails.dateOfReConnection)
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Cp-78 Itm. No.</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.cp78ItemNo
                          ? rcoDetails.cp78ItemNo
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Sec. Slp/PB No.</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.securitySlipOrPriceBondNo
                          ? rcoDetails.securitySlipOrPriceBondNo
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">TU. / NTU.</p>
                    <p className="prop-detail">
                      {rcoDetails
                        ? rcoDetails.tieUpNonTieUp
                          ? rcoDetails.tieUpNonTieUp === 0
                            ? "Non-Tie Up"
                            : "Tie Up"
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Meter Installation Verified by:{" "}
            {eFileData.find((item) => item.remarks == "Meter Installed")
              ? eFileData.find((item) => item.remarks == "Meter Installed")
                  .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Meter Installed")
              ? "(" +
                eFileData.find((item) => item.remarks == "Meter Installed")
                  .roleName +
                ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Meter Installed")
              ? convertDatewithTime(
                  eFileData.find((item) => item.remarks == "Meter Installed")
                    .lastModificationDate,
                )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={newConnectionPopup}
        onClose={handleCloses}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            {" "}
            DN Generated
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              {" "}
              Your Demand Note has been generated successfully.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => downloadDNPDF(dialogRowData)}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  padding: "2%",
                  width: "60%",
                }}
              >
                <PrintIcon sx={{ color: "#006ad1" }} />
                Print DN{" "}
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={wrongBatchPopup}
        onClose={() => setBatchError("")}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        sx={{ zIndex: "9999" }}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText
            component="div"
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={batchIcon} alt="batchIcon" width="90px" height="70px" />
            <Typography variant="h6" className="groupTitle">
              {" "}
              Batch Warning
            </Typography>
            <h5 className="applicationSubmit"> {batchError}</h5>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={rcoPopUp}
        onClose={rcoHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          {rcoDetails.rcoP2FillFlag &&
          CheckPermissions(
            permissions,
            "General Services",
            "Reconnection",
            "Workflow Permissions",
            "Meter Installation",
            "RCO Filling",
          ) ? (
            <Typography variant="h6" className="groupTitle">
              RCO Generated
            </Typography>
          ) : (
            <Typography variant="h6" className="groupTitle">
              RCO Generated
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {rcoDetails.rcoP2FillFlag &&
            CheckPermissions(
              permissions,
              "General Services",
              "Reconnection",
              "Workflow Permissions",
              "Meter Installation",
              "RCO Filling",
            ) ? (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            ) : (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            )}
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              {rcoDetails.rcoP2FillFlag &&
              CheckPermissions(
                permissions,
                "General Services",
                "Reconnection",
                "Workflow Permissions",
                "Meter Installation",
                "RCO Filling",
              ) ? (
                <Button
                  variant="outlined"
                  onClick={() => downloadRCOPDF(dialogRowData)}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    padding: "2%",
                    width: "60%",
                  }}
                >
                  <PrintIcon sx={{ color: "#006ad1" }} />
                  Print RCO{" "}
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  onClick={() => downloadRCOPDF(dialogRowData)}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    padding: "2%",
                    width: "60%",
                  }}
                >
                  <PrintIcon sx={{ color: "#006ad1" }} />
                  Print RCO{" "}
                </Button>
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={cpPopUp}
        onClose={cpHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>

          <Typography variant="h6" className="groupTitle">
            Application Completed
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              Your Reconnection Application has been completed successfully.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => downloadMasterData(dialogRowData)}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  padding: "2%",
                  width: "60%",
                }}
              >
                <PrintIcon sx={{ color: "#006ad1" }} />
                {dialogRowData.connectionCategory != "Domestic" &&
                dialogRowData.connectionCategory != "Commercial"
                  ? "Print CP-138"
                  : "Print CP-138"}
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* DN Expiry pop up*/}
      <Dialog
        open={showDnExpiryPopup}
        onClose={() => {
          setShowDnExpiryPopup(false);
        }}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundRedAttached">
            <EventBusyIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            Demand Note Expired
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              Demand Note for below Application ID. is expired.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              {CheckPermissions(
                permissions,
                "General Services",
                "Reconnection",
                "Workflow Permissions",
                "Renew DN",
              ) && (
                <Button
                  variant="outlined"
                  onClick={async () => {
                    await callDemandNoteRenewalAPI(dialogRowData.applicationId);
                    setShowDnExpiryPopup(false);
                  }}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    padding: "2%",
                    width: "60%",
                  }}
                >
                  Renew DN
                </Button>
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* SUCESS OR UNSUCESS MODAL */}
      <Dialog
        open={openResponseModal}
        onClose={() => {
          setOpenResponseModal(false);
          setResponseMessage("");
          setResponseMessageError("");
          setShowCP138ButtonInResponseModal(false);
          arrearPaymentReceiptFormik.values.iv_arrear_paid_bill_document = null;
          arrearPaymentReceiptFormik.values.iv_arrear_payment_date = "";
          arrearPaymentReceiptFormik.values.iv_remarks_detail = "";
          arrearPaymentObjectionReceiptFormik.values.iv_obj_arrear_paid_bill_document =
            null;
          arrearPaymentObjectionReceiptFormik.values.iv__obj_arrear_payment_date =
            "";
          arrearPaymentObjectionReceiptFormik.values.iv_obj_remarks_detail = "";
        }}
        fullWidth={true}
        maxWidth={"sm"}
        className="response-status-modal"
      >
        <DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
          {/* Icon */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
            <Box
              sx={{
                backgroundColor: responseMessageError ? "#fdecea" : "#e6f4ea", // light red or green bg
                border: `2px solid ${
                  responseMessageError ? "#d32f2f" : "#2e7d32"
                }`, // border color
                borderRadius: "50%",
                height: 70,
                width: 70,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {responseMessageError ? (
                <ErrorIcon sx={{ color: "#d32f2f", fontSize: "2.5rem" }} />
              ) : (
                <CheckCircleIcon
                  sx={{ color: "#2e7d32", fontSize: "2.5rem" }}
                />
              )}
            </Box>
            {/* {responseMessageError ? (
                    <Box className="backgroundAttached" >
                    <DoneIcon className="icon" />
                  </Box>
                ) : (
                  <Box className="backgroundAttached" >
                    <ErrorIcon className="icon" />
                  </Box>
                )} */}
          </Box>

          {/* Heading */}
          <Typography
            variant="h6"
            sx={{
              color: responseMessageError ? "red" : "green",
              fontWeight: "bold",
              fontSize: "1.7rem",
            }}
          >
            {responseMessageError ? "Error" : "Success"}
          </Typography>
        </DialogTitle>

        <DialogContent
          sx={{
            minHeight: "100px",
            display: "flex",
            flexDirection: "column", // stack vertically
            alignItems: "center",
            justifyContent: "center",
            gap: 2, // space between message and button
          }}
        >
          <DialogContentText
            component="div"
            sx={{
              color: responseMessageError ? "red" : "#444",
              textAlign: "center",
              fontSize: "1.5rem",
              padding: "0 12px",
            }}
          >
            {responseMessageError || responseMessage}
          </DialogContentText>

          {dialogRowData.applicationProgressId === 2 &&
            responseMessageError && (
              <Button
                onClick={() => {
                  downloadBill(dialogRowData.referenceNo);
                }}
                variant="outlined"
                color="primary"
              >
                Open Your Bill
              </Button>
            )}

          {shouldShowCp138Button && responseMessageError && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                variant="outlined"
                onClick={() =>
                  downloadCP138PDF(
                    dialogRowData,
                    disconnectedMeterDetsForROApproval,
                  )
                }
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  minWidth: "220px",
                }}
              >
                Download CP-138
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      {/* RCO Fee Voucher Rejection Modal */}
      <Dialog
        open={openRejectModal}
        onClose={() => setOpenRejectModal(false)}
        fullWidth
        maxWidth="md" // options: xs, sm, md, lg, xl
        PaperProps={{
          style: { width: "600px", maxWidth: "90%" }, // you can customize exact width
        }}
      >
        <DialogTitle>Reject RCO Fee Voucher</DialogTitle>
        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            processRCOFeeVoucher("reject", values.remarksDetail).then(() => {
              setSubmitting(false);
              setOpenRejectModal(false);
            });
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="remarksDetail"
                  label="Remarks"
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setOpenRejectModal(false)}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* RCO Fee Paid Voucher Rejection/Approval Modal */}
      {/* <Dialog
        open={openVoucherActionModal}
        onClose={() => setOpenVoucherActionModal(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { width: "600px", maxWidth: "90%" } }}
      >
        <DialogTitle>
          {voucherActionType === "approve"
            ? "Approve Paid RCO Fee Voucher"
            : "Reject Paid RCO Fee Voucher"}
        </DialogTitle>

        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            RCOFeeVoucherVerification(
              voucherActionType,
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModal(false);
            });
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="remarksDetail"
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                  InputProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      fontSize: "1rem", // optional
                    },
                  }}
                />
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setOpenVoucherActionModal(false)}
                  variant="contained"
                  sx={{ backgroundColor: "#e11b3c" }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  sx={{ backgroundColor: "#003971" }}
                >
                  {voucherActionType === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog> */}
      <Dialog
        open={openVoucherActionModal}
        onClose={() => setOpenVoucherActionModal(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { width: "600px", maxWidth: "90%" } }}
      >
        <DialogTitle>
          {voucherActionType === "approve"
            ? "Approve Paid RCO Fee Voucher"
            : "Reject Paid RCO Fee Voucher"}
        </DialogTitle>

        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            RCOFeeVoucherVerification(
              voucherActionType,
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModal(false);
            });
          }}
        >
          {({
            isSubmitting,
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
          }) => (
            <Form>
              <DialogContent>
                <TextField
                  name="remarksDetail"
                  placeholder="Enter your remarks here..."
                  value={values.remarksDetail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                  InputProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                />
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setOpenVoucherActionModal(false)}
                  variant="contained"
                  sx={{ backgroundColor: "#e11b3c" }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  sx={{ backgroundColor: "#003971" }}
                >
                  {voucherActionType === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* DN Rejection/Approval Modal */}
      {/* <Dialog
        open={openVoucherActionModalForDN}
        onClose={() => setOpenVoucherActionModalForDN(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { width: "600px", maxWidth: "90%" } }}
      >
        <DialogTitle>
          {voucherActionTypeForDN === "approve" ? "Approve DN" : "Reject DN"}
        </DialogTitle>

        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            DNFeeVoucherVerification(
              voucherActionTypeForDN, // Fix: use correct state variable
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModalForDN(false);
            });
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="remarksDetail"
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                  InputProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                />
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setOpenVoucherActionModalForDN(false)} // Fix: use correct setter
                  variant="contained"
                  sx={{ backgroundColor: "#e11b3c" }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  sx={{ backgroundColor: "#003971" }}
                >
                  {voucherActionTypeForDN === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog> */}
      <Dialog
        open={openVoucherActionModalForDN}
        onClose={() => setOpenVoucherActionModalForDN(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { width: "600px", maxWidth: "90%" } }}
      >
        <DialogTitle>
          {voucherActionTypeForDN === "approve" ? "Approve DN" : "Reject DN"}
        </DialogTitle>

        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            DNFeeVoucherVerification(
              voucherActionTypeForDN,
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModalForDN(false);
            });
          }}
        >
          {({
            isSubmitting,
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
          }) => (
            <Form>
              <DialogContent>
                <TextField
                  name="remarksDetail"
                  label="Remarks"
                  placeholder="Enter your remarks here..."
                  value={values.remarksDetail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                  InputProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                />
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setOpenVoucherActionModalForDN(false)}
                  variant="contained"
                  sx={{ backgroundColor: "#e11b3c" }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  sx={{ backgroundColor: "#003971" }}
                >
                  {voucherActionTypeForDN === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* Assign to field Staff Modal */}
      <Dialog
        open={linemanAllocationSubPopUp}
        onClose={() => {
          setLinemanAllocationSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"sm"}
        className="objectionDialog"
      >
        <DialogTitle className="objection-dialog-title">
          <Grid container className="objectionheadercontainer">
            <Grid item className="applicationTitleGrid">
              <p className="applicationTitleText">Assign To Field Staff </p>
            </Grid>
            <Grid item className="closeIcon">
              <CloseIcon
                id="clearPopup"
                onClick={() => {
                  setLinemanAllocationSubPopUp(false);
                }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="objection-dialog-content">
          <DialogContentText
            component="div"
            className="objection-dialog-content-text"
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                backgroundColor: "white",
              }}
            >
              <thead>
                <tr
                  style={{
                    fontFamily: "Roboto-Medium",
                    backgroundColor: "#f5f5f5",
                    backgroundColor: "white",
                    boxShadow: "3px 3px 6px lightgray",
                  }}
                >
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  ></th>
                  <th
                    style={{
                      width: "20px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Sr.
                  </th>
                  <th
                    style={{
                      width: "200px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Designation
                  </th>
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Mobile No.
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    colSpan="5"
                    style={{ height: "10px", backgroundColor: "transparent" }}
                  ></td>
                </tr>
                {workForceData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #ddd",
                      backgroundColor: index % 2 ? "white" : "#d5e5ff",
                    }}
                  >
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      <input
                        type="radio"
                        name="fieldStaff"
                        value={item.userId}
                        checked={selectedStaffId === item.userId}
                        onChange={() => setSelectedStaffId(item.userId)}
                      />
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {index + 1}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {item.name}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {fieldStaffDesignations.find(
                        (itm) => itm.employeeDesignationId == item.designation,
                      )?.employeeDesignationName || "N/A"}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {item.phoneNo}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="objection-dialog-action">
          <button
            onClick={() => {
              if (selectedStaffId) {
                callAssignmentAPI(dialogRowData.applicationId, selectedStaffId);
              } else {
                alert("Please select a field staff member before assigning.");
              }
            }}
            type="submit"
            className="submit-button"
          >
            Assign
          </button>
        </DialogActions>
      </Dialog>
      {/* Prepare Estimate Modal */}
      <Dialog
        open={showBoq}
        onClose={() => setShowBoq(false)}
        fullWidth
        maxWidth={false}
        className="rejection-removal"
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "1000px",
          },
        }}
      >
        <DialogTitle
          className="dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Prepare Estimate
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                setShowBoq(false);
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>

        <DialogContent sx={{ overflow: "visible", padding: 2 }}>
          {/* {fieldFormik.values.iv_distance == 0 && ( */}
          <Grid container direction="column" spacing={3}>
            <Grid item xs={12} display="flex" justifyContent="center">
              <TableContainer
                component={Paper}
                sx={{ p: 2, maxWidth: 900, width: "100%" }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <Typography className="fieldLabel">Item</Typography>
                    <Autocomplete
                      options={allMaterialList || []}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const code = option.Item_Code || option.item_Code || "";
                        const name = option.Item_Name || option.item_Name || "";
                        return name ? `${code} - ${name}` : code;
                      }}
                      value={
                        (allMaterialList || []).find(
                          (item) =>
                            String(item.Item_Code || item.item_Code)
                              .trim()
                              .toLowerCase() ===
                            String(fieldItemFormik.values.iv_fieldItemId)
                              .trim()
                              .toLowerCase(),
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const rate =
                            newValue.item_Amount || newValue.Item_Amount;
                          const unit = newValue.item_Unit || newValue.Item_Unit;

                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemId",
                            newValue.Item_Code || newValue.item_Code,
                          );
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemRate",
                            rate,
                          );
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemUnit",
                            unit,
                          );
                        } else {
                          fieldItemFormik.setFieldValue("iv_fieldItemId", "");
                          fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
                          fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
                        }
                      }}
                      filterOptions={(options, state) =>
                        options.filter((option) => {
                          const input = state.inputValue.toLowerCase();
                          return (
                            String(option.Item_Code || option.item_Code || "")
                              .toLowerCase()
                              .includes(input) ||
                            String(option.Item_Name || option.item_Name || "")
                              .toLowerCase()
                              .includes(input)
                          );
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Item"
                          size="small"
                          error={
                            fieldItemFormik.touched.iv_fieldItemId &&
                            Boolean(fieldItemFormik.errors.iv_fieldItemId)
                          }
                          helperText={
                            fieldItemFormik.touched.iv_fieldItemId &&
                            fieldItemFormik.errors.iv_fieldItemId
                          }
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 35,
                              minHeight: 35,
                            },
                            "& .MuiInputBase-input": {
                              padding: "0 8px",
                            },
                          }}
                        />
                      )}
                      disableClearable
                      fullWidth
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                    />
                  </Grid>

                  {/* Unit */}
                  <Grid item xs={2}>
                    <Typography className="fieldLabel">Unit</Typography>
                    <TextField
                      name="iv_fieldItemUnit"
                      value={fieldItemFormik.values.iv_fieldItemUnit}
                      fullWidth
                      disabled
                      InputProps={{
                        sx: {
                          height: 35, // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  yahan height control karein
                          textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  text right aligned
                          "& input": {
                            textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  ensure karein ke input ke andar text right me ho
                          },
                        },
                      }}
                    />
                  </Grid>

                  {/* Qty */}
                  <Grid item xs={2}>
                    <Typography className="fieldLabel">Qty</Typography>
                    <TextField
                      name="iv_fieldItemQty"
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                      value={fieldItemFormik.values.iv_fieldItemQty}
                      fullWidth
                      onChange={(e) => {
                        const digitsOnly = e.target.value.replace(/\D/g, "");
                        fieldItemFormik.setFieldValue(
                          "iv_fieldItemQty",
                          digitsOnly,
                        );
                      }}
                      size="small" // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  chhota input
                      onKeyDown={(e) => {
                        // Prevent decimal point, 'e', '+', '-' characters
                        if (
                          e.key === "." ||
                          e.key === "e" ||
                          e.key === "E" ||
                          e.key === "+" ||
                          e.key === "-"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      InputProps={{
                        sx: {
                          height: 35, // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  yahan height control karein
                          textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  text right aligned
                          "& input": {
                            textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  ensure karein ke input ke andar text right me ho
                          },
                        },
                      }}
                    />
                  </Grid>

                  {/* Add Button */}
                  <Grid item xs={2}>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      fullWidth
                      sx={{ height: 35, marginTop: 2 }} // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒâ€šÃ‚Â¹ set height here
                      onClick={fieldItemFormik.handleSubmit}
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </TableContainer>
            </Grid>

            {itemsArray?.length > 0 && (
              <Grid item>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: 250,
                    overflowY: "auto",
                  }}
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr.</TableCell>
                        <TableCell>Item Name</TableCell>
                        <TableCell align="right">Unit</TableCell>
                        <TableCell align="center" sx={{ minWidth: 130 }}>
                          Qty
                        </TableCell>
                        <TableCell align="right">Rate</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemsArray.map((row, index) => (
                        <TableRow key={row.Id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.item_Name}</TableCell>
                          <TableCell align="right">{row.unit}</TableCell>
                          <TableCell align="center" sx={{ minWidth: 130 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(index, -1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                                sx={{ p: 0.5 }}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                              <Typography
                                component="span"
                                sx={{ minWidth: 28, textAlign: "center", fontWeight: 500 }}
                              >
                                {row.qty}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(index, 1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                                sx={{ p: 0.5 }}
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell align="right">
                            {numberFormattingForRCO(row.rate)}
                          </TableCell>
                          <TableCell align="right">
                            {numberFormattingForRCO(row.amount)}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton onClick={() => deleteItem(index)}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            <Grid item>
              <TableContainer component={Paper}>
                {/* <Typography variant="h6" sx={{ mb: 1, p: 1 }}>
                                Charges
                              </Typography> */}
                <Table sx={{ border: "1px solid #ccc" }}>
                  <TableBody>
                    {/* Row 1 */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Items' Total Amount:
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {itemsAmount
                              ? numberFormattingForRCO(itemsAmount.toFixed(0))
                              : "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Store Charges (12%):
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {storeCharges
                              ? numberFormattingForRCO(storeCharges.toFixed(0))
                              : "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 2 */}
                    <TableRow>
                      {/* Installation Charges (read-only value) */}
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Installation Charges (8%):
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {installationCharges
                              ? numberFormattingForRCO(
                                  installationCharges.toFixed(0),
                                )
                              : "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Grid Sharing Cost (input field) */}
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Grid Sharing Cost:
                          </Typography>
                          <TextField
                            name="iv_grid_sharing_cost"
                            value={fieldFormik.values.iv_grid_sharing_cost}
                            type="number"
                            size="small"
                            onChange={(e) => {
                              fieldFormik.handleChange(e);
                              setGridSharingCost(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value),
                              );
                            }}
                            onKeyDown={(e) => {
                              // Prevent decimal point, 'e', '+', '-' characters
                              if (
                                e.key === "." ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+" ||
                                e.key === "-"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 3 */}
                    {/* <TableRow>
                                    <TableCell sx={{ border: "1px solid #ccc" }}>
                                      <Typography className="title">Feeder Rehab Charges</Typography>
                                      <TextField
                                        name="iv_feeder_rehab_charges"
                                        value={fieldFormik.values.iv_feeder_rehab_charges}
                                        type="number"
                                        fullWidth
                                        size="small"
                                        onChange={fieldFormik.handleChange}
                                        onBlur={(e) =>
                                          setFeederRehabilitationCharges(
                                            e.target.value === "" ? 0 : parseInt(e.target.value)
                                          )
                                        }
                                      />
                                    </TableCell>
                                    <TableCell sx={{ border: "1px solid #ccc" }}>
                                      <Typography className="title">Civil Work Charges</Typography>
                                      <TextField
                                        name="iv_civil_work_charges"
                                        value={fieldFormik.values.iv_civil_work_charges}
                                        type="number"
                                        fullWidth
                                        size="small"
                                        onChange={fieldFormik.handleChange}
                                        onBlur={(e) =>
                                          setCivilWorkCharges(e.target.value === "" ? 0 : parseInt(e.target.value))
                                        }
                                      />
                                    </TableCell>
                                  </TableRow> */}

                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Feeder Rehab Charges
                          </Typography>
                          <TextField
                            name="iv_feeder_rehab_charges"
                            value={fieldFormik.values.iv_feeder_rehab_charges}
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setFeederRehabilitationCharges(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value),
                              )
                            }
                            onKeyDown={(e) => {
                              // Prevent decimal point, 'e', '+', '-' characters
                              if (
                                e.key === "." ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+" ||
                                e.key === "-"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            sx={{ flex: 1 }} // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  baaki space yeh lega
                            InputProps={{
                              sx: {
                                height: 25, // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  yahan height control karein
                                textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  text right aligned
                                "& input": {
                                  textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Civil Work Charges
                          </Typography>
                          <TextField
                            name="iv_civil_work_charges"
                            value={fieldFormik.values.iv_civil_work_charges}
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setCivilWorkCharges(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value),
                              )
                            }
                            onKeyDown={(e) => {
                              // Prevent decimal point, 'e', '+', '-' characters
                              if (
                                e.key === "." ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+" ||
                                e.key === "-"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            sx={{ flex: 1 }} // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  yahan bhi same
                            InputProps={{
                              sx: {
                                height: 25, // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  yahan height control karein
                                textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  text right aligned
                                "& input": {
                                  textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 4 */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Misc. Charges
                          </Typography>
                          <TextField
                            name="iv_miscellaneous_charges"
                            value={fieldFormik.values.iv_miscellaneous_charges}
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setMiscellaneousCharges(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value),
                              )
                            }
                            onKeyDown={(e) => {
                              // Prevent decimal point, 'e', '+', '-' characters
                              if (
                                e.key === "." ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+" ||
                                e.key === "-"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            sx={{ flex: 1 }} // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  full remaining space
                            InputProps={{
                              sx: {
                                height: 25, // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  yahan height control karein
                                textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  text right aligned
                                "& input": {
                                  textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Fixed Charges
                          </Typography>
                          <TextField
                            name="iv_fixed_charges_of_metering"
                            value={
                              fieldFormik.values.iv_fixed_charges_of_metering
                            }
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setFixedChargesOfMetering(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value),
                              )
                            }
                            onKeyDown={(e) => {
                              // Prevent decimal point, 'e', '+', '-' characters
                              if (
                                e.key === "." ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+" ||
                                e.key === "-"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            sx={{ flex: 1 }} // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  full remaining space
                            InputProps={{
                              sx: {
                                height: 25, // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  yahan height control karein
                                textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  text right aligned
                                "& input": {
                                  textAlign: "right", // ÃƒÆ’Ã‚Â°Ãƒâ€¦Ã‚Â¸ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“Ãƒâ€¹Ã¢â‚¬Â  ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Less the Cost
                          </Typography>
                          <TextField
                            name="iv_less_the_cost"
                            value={-
                              Math.abs(
                                Number(fieldFormik.values.iv_less_the_cost) || 0,
                              )
                            }
                            type="number"
                            size="small"
                            onChange={(e) => {
                              const val = Math.trunc(Math.abs(Number(e.target.value) || 0));
                              fieldFormik.setFieldValue(
                                "iv_less_the_cost",
                                val,
                              );
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Math.abs(Number(e.target.value) || 0));
                              fieldFormik.setFieldValue(
                                "iv_less_the_cost",
                                val,
                              );
                              setLessTheCost(val);
                            }}
                            onKeyDown={(e) => {
                              // Prevent decimal point, 'e', '+', '-' characters
                              if (
                                e.key === "." ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+" ||
                                e.key === "-"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                "& input": { textAlign: "right" },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell
                        colSpan={2}
                        align="right"
                        sx={{
                          backgroundColor: "#0282ff",
                          border: "1px solid #ccc",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "white",
                            fontSize: "20px",
                          }}
                        >
                          Total:{" "}
                          {grandTotalCharges
                            ? numberFormatting(grandTotalCharges)
                            : "-"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          {/* )} */}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={onSaveCostEstimationConfirm}
          >
            Save Estimate
          </Button>
        </DialogActions>
      </Dialog>

      {/* Show Cost Estimation */}
      <Dialog
        open={showCostEstimation}
        onClose={handleCostEstimationClose}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle
          className="dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Cost Estimation
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                handleCostEstimationClose();
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          {costEstimationForNC ? (
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                backgroundColor: "#fff",
                marginTop: "10px",
              }}
            >
              {/* <Typography variant="h6" gutterBottom>
                              Cost Estimation
                            </Typography> */}

              {/* setItemsAmount(totalAmountofItems);
                                setStoreCharges(store_charges);
                                setInstallationCharges(installation_charges);
                                setTotalCharges(total_charges);
                                setItemsArray(arrayOfItems); */}

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> Items' Total Amount:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {itemsAmount
                      ? Number(itemsAmount.toFixed(0)).toLocaleString()
                      : Number(
                          costEstimationForNC?.estimatedCapitalCost || 0,
                        ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> Store Charges (12%):</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {storeCharges
                      ? Number(storeCharges.toFixed(0)).toLocaleString()
                      : 0}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> Installation Charges (8%):</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {installationCharges
                      ? Number(installationCharges.toFixed(0)).toLocaleString()
                      : 0}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Grid Sharing Cost:</strong>
                  </Typography>
                </Grid>

                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                                      Rs.{" "} */}
                  {/* {!boqItems || boqItems.length === 0
                                        ? 0
                                        : gridSharingCost !== null && gridSharingCost !== undefined && gridSharingCost !== ""
                                          ? Number(gridSharingCost).toLocaleString()
                                          : Number(costEstimationForNC?.amountOfGridSharing || 0).toLocaleString()} */}
                  {/* {Number(costEstimationForNC?.amountOfGridSharing || 0).toLocaleString()} */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {gridSharingCost
                      ? Math.round(Number(gridSharingCost) || 0).toLocaleString()
                      : Math.round(
                          Number(costEstimationForNC?.amountOfGridSharing || 0),
                        ).toLocaleString()}
                  </Typography>
                  {/* </Typography> */}
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Feeder Rehab Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                                      Rs. {Number(costEstimationForNC?.amountOfFeederRehab || 0).toLocaleString()}
                                    </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {feederRehabilitationCharges
                      ? Math.round(
                          Number(feederRehabilitationCharges) || 0,
                        ).toLocaleString()
                      : Math.round(
                          Number(costEstimationForNC?.amountOfFeederRehab || 0),
                        ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Civil Work Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {civilWorkCharges
                      ? Math.round(Number(civilWorkCharges) || 0).toLocaleString()
                      : Math.round(
                          Number(costEstimationForNC?.civilWorkCharges || 0),
                        ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Fixed Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {fixedChargesOfMetering
                      ? Math.round(
                          Number(fixedChargesOfMetering) || 0,
                        ).toLocaleString()
                      : Math.round(
                          Number(costEstimationForNC?.fixedChargesOfMetering || 0),
                        ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Miscellaneous Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                                      Rs. {Number(costEstimationForNC?.miscellaneousCharges || 0).toLocaleString()}
                                    </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {miscellaneousCharges
                      ? Math.round(
                          Number(miscellaneousCharges) || 0,
                        ).toLocaleString()
                      : Math.round(
                          Number(costEstimationForNC?.miscellaneousCharges || 0),
                        ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Less the Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                                      Rs. {Number(costEstimationForNC?.lessTheCost || 0).toLocaleString()}
                                    </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {-Math.round(
                      Number(lessTheCost || costEstimationForNC?.lessTheCost || 0),
                    ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Capital Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {itemsAmount ? (
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold", color: "green" }}
                    >
                      Rs.{" "}
                      {numberFormatting(
                        sumRoundedAmounts([
                          itemsAmount,
                          gridSharingCost,
                          storeCharges,
                          installationCharges,
                          feederRehabilitationCharges,
                          civilWorkCharges,
                          fixedChargesOfMetering,
                          miscellaneousCharges,
                          -(lessTheCost || 0),
                        ]),
                      )}
                    </Typography>
                  ) : (
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold", color: "green" }}
                    >
                      Rs.{" "}
                      {numberFormatting(
                        sumRoundedAmounts([
                          costEstimationForNC?.estimatedCapitalCost,
                          costEstimationForNC?.amountOfGridSharing,
                          costEstimationForNC?.amountOfFeederRehab,
                          costEstimationForNC?.civilWorkCharges,
                          costEstimationForNC?.fixedChargesOfMetering,
                          costEstimationForNC?.miscellaneousCharges,
                          -(costEstimationForNC?.lessTheCost || 0),
                        ]),
                      )}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Security Deposit:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {Math.round(
                      Number(costEstimationForNC?.estimatedSecurityAmount || 0),
                    ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Total Cost Estimation Deposit:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {itemsAmount ? (
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold", color: "green" }}
                    >
                      Rs.{" "}
                      {numberFormatting(
                        sumRoundedAmounts([
                          itemsAmount,
                          gridSharingCost,
                          storeCharges,
                          installationCharges,
                          feederRehabilitationCharges,
                          civilWorkCharges,
                          fixedChargesOfMetering,
                          miscellaneousCharges,
                          -(lessTheCost || 0),
                          costEstimationForNC?.estimatedSecurityAmount,
                        ]),
                      )}
                    </Typography>
                  ) : (
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold", color: "green" }}
                    >
                      Rs.{" "}
                      {numberFormatting(
                        sumRoundedAmounts([
                          costEstimationForNC?.estimatedCapitalCost,
                          costEstimationForNC?.amountOfGridSharing,
                          costEstimationForNC?.amountOfFeederRehab,
                          costEstimationForNC?.civilWorkCharges,
                          costEstimationForNC?.fixedChargesOfMetering,
                          costEstimationForNC?.miscellaneousCharges,
                          -(costEstimationForNC?.lessTheCost || 0),
                          costEstimationForNC?.estimatedSecurityAmount,
                        ]),
                      )}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Typography variant="body2">Loading cost details...</Typography>
          )}
        </DialogContent>
        {errormessageCostEstimation ? (
          <Typography
            style={{
              // border: "1px solid #ddd",
              // borderRadius: "12px",
              paddingLeft: "20px",
              paddingBottom: "20px",
              color: "red",
              // boxShadow: ,
              // backgroundColor: "red",
              // marginTop: "10px"
            }}
          >
            {errormessageCostEstimation}
          </Typography>
        ) : null}

        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={onPressCostEstimationConfirm}
          >
            Save Cost Estimation
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={snackbar.open}
        onClose={() => {
    if (snackbar.severity === "success") {
      setSnackbar({ ...snackbar, open: false });
      handleClose();
    } else {
      setSnackbar({ ...snackbar, open: false });
    }
  }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            textAlign: "center",
            padding: 2,
          },
        }}
      >
        <IconButton
         onClose={() => {
    if (snackbar.severity === "success") {
      setSnackbar({ ...snackbar, open: false });
      handleClose();
    } else {
      setSnackbar({ ...snackbar, open: false });
    }
  }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          {/* <CloseIcon /> */}
        </IconButton>

        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              py: 2,
            }}
          >
            {snackbar.severity === "success" ? (
              <CheckCircleIcon
                sx={{
                  fontSize: "2.5rem",
                  color: "#2e7d32",
                }}
              />
            ) : (
              <ErrorIcon
                sx={{
                  fontSize: "2.5rem",
                  color: "#d32f2f",
                }}
              />
            )}

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: snackbar.severity === "success" ? "#2e7d32" : "#d32f2f",
              }}
            >
              {snackbar.severity === "success" ? "Success!" : "Error!"}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: snackbar.severity === "success" ? "#444" : "red",
                px: 2,
                fontSize: "1.5rem",
              }}
            >
              {snackbar.message}
            </Typography>
            {snackbar.message === "RCO fee voucher approved." ? (
              <>
                <Button
                  variant="outlined"
                  onClick={() =>
                    downloadRCOFeePDF(dialogRowData, rcoFeeVoucherDetails)
                  }
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    width: "auto",
                    minWidth: "5%",
                    whiteSpace: "nowrap",
                  }}
                >
                  <PrintIcon sx={{ color: "#006ad1", mr: 1 }} />
                  RCO Fee Voucher
                </Button>

                <Button
                  variant="outlined"
                  onClick={() =>
                    downloadFixedChargesPDF(dialogRowData, rcoFeeVoucherDetails)
                  }
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    width: "auto",
                    minWidth: "5%",
                    whiteSpace: "nowrap",
                  }}
                >
                  <PrintIcon sx={{ color: "#006ad1", mr: 1 }} />
                  Fixed Charges Voucher
                </Button>

                <Button
                  variant="outlined"
                  onClick={() => downloadBill(dialogRowData.referenceNo)}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    width: "auto",
                    minWidth: "5%",
                  }}
                >
                  <PrintIcon sx={{ color: "#006ad1", marginLeft: "1%" }} />{" "}
                  Bill{" "}
                </Button>
              </>
            ) : snackbar.message ===
              "Application completed. Print CP-138 for further processing." ? (
              <Button
                variant="outlined"
                onClick={() =>
                  downloadCP138PDF(
                    dialogRowData,
                    disconnectedMeterDetsForROApproval,
                  )
                }
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  width: "50%",
                }}
              >
                <PrintIcon sx={{ color: "#006ad1", marginLeft: "1%" }} />{" "}
                CP-138{" "}
              </Button>
            ) : (
              ""
            )}
          </Box>
        </DialogContent>
      </Dialog>

      {/* PAID RCO Fee Voucher Image Dialog */}
      <Dialog
        open={openImgDialog}
        onClose={handleCloseImg}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Paid RCO Fee Voucher
          <IconButton
            aria-label="close"
            onClick={handleCloseImg}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <img
            src={paidRCOFeeVoucherImg}
            alt="Paid RCO Fee Voucher"
            style={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        </DialogContent>
      </Dialog>

      {/* DN Image Dialog */}
      <Dialog
        open={openImgDialogDN}
        onClose={handleCloseImgDN}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Paid DN Image
          <IconButton
            aria-label="close"
            onClick={handleCloseImgDN}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <img
            src={paidDNVoucherImg}
            alt="Paid DN voucher preview"
            style={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        </DialogContent>
      </Dialog>

      {/* DN Rejection Modal FOR REMARLS */}
      <Dialog
        open={dnRejectModalOpen}
        onClose={() => {
          setDnRejectModalOpen(false);
          dnRejectFormik.resetForm();
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(to bottom, #2c5ab3, #87a4d6)",
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            fontSize: "1.25rem",
            py: 1.5,
            // borderTopLeftRadius: "10px",
            // borderTopRightRadius: "10px",
          }}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ ml: 1 }}>
            Reject Demand Notice
          </Typography>

          <IconButton
            aria-label="close"
            onClick={() => {
              setDnRejectModalOpen(false);
              dnRejectFormik.resetForm();
            }}
            size="small"
            sx={{
              color: "white",
              mr: 1,
              "&:hover": { color: "#f5f5f5" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            dnRejectFormik.handleSubmit();
          }}
        >
          <DialogContent>
            <Box mt={1}>
              <Typography variant="body1" gutterBottom>
                Select Reason:
              </Typography>

              <TextField
                select
                id="reasonType"
                name="reasonType"
                fullWidth
                size="small"
                variant="outlined"
                value={dnRejectFormik.values.reasonType}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.reasonType &&
                  Boolean(dnRejectFormik.errors.reasonType)
                }
                helperText={
                  dnRejectFormik.touched.reasonType &&
                  dnRejectFormik.errors.reasonType
                }
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "black" },
                    "&:hover fieldset": { borderColor: "black" },
                    "&.Mui-focused fieldset": { borderColor: "black" },
                  },
                }}
              >
                <MenuItem value="">Select reason</MenuItem>
                <MenuItem value="5">Field Survey & Cost Estimation</MenuItem>
                {/* <MenuItem value="2">Arrear Verification</MenuItem>
                      <MenuItem value="1">Documents Verification</MenuItem> */}
              </TextField>

              <Typography variant="body1" gutterBottom>
                Please provide a reason for rejection:
              </Typography>

              <TextField
                id="remarks"
                name="remarks"
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                placeholder="Enter your remarks here..."
                value={dnRejectFormik.values.remarks}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.remarks &&
                  Boolean(dnRejectFormik.errors.remarks)
                }
                helperText={
                  dnRejectFormik.touched.remarks &&
                  dnRejectFormik.errors.remarks
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "black" },
                    "&:hover fieldset": { borderColor: "black" },
                    "&.Mui-focused fieldset": { borderColor: "black" },
                  },
                }}
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => {
                setDnRejectModalOpen(false);
                dnRejectFormik.resetForm();
              }}
              variant="outlined"
              color="primary"
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="error">
              Reject
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
});

export default Reconnectiontable;















